export const provinciasArgentinas = [
  { value: "", title: "PROVINCIA *" },
  { value: "Buenos Aires", title: "Buenos Aires" },
  { value: "C.A.B.A.", title: "C.A.B.A." },
  { value: "Catamarca", title: "Catamarca" },
  { value: "Chaco", title: "Chaco" },
  { value: "Chubut", title: "Chubut" },
  { value: "Córdoba", title: "Córdoba" },
  { value: "Corrientes", title: "Corrientes" },
  { value: "Entre Ríos", title: "Entre Ríos" },
  { value: "Formosa", title: "Formosa" },
  { value: "Jujuy", title: "Jujuy" },
  { value: "La Pampa", title: "La Pampa" },
  { value: "La Rioja", title: "La Rioja" },
  { value: "Mendoza", title: "Mendoza" },
  { value: "Misiones", title: "Misiones" },
  { value: "Neuquén", title: "Neuquén" },
  { value: "Río Negro", title: "Río Negro" },
  { value: "Salta", title: "Salta" },
  { value: "San Juan", title: "San Juan" },
  { value: "San Luis", title: "San Luis" },
  { value: "Santa Cruz", title: "Santa Cruz" },
  { value: "Santa Fe", title: "Santa Fe" },
  { value: "Santiago del Estero", title: "Santiago del Estero" },
  { value: "Tierra del Fuego", title: "Tierra del Fuego" },
  { value: "Tucumán", title: "Tucumán" }
];

export const localidadesPorProvincia = [
  {
    "nombre": "Buenos Aires",
    "localidades": [
      "VILLA SANTOS TESEI",
      "HURLINGHAM",
      "WILLIAM C. MORRIS",
      "EL ARBOLITO",
      "LOS BARRILES",
      "COLONIA LA PERLA",
      "SARASA",
      "PEARSON",
      "COLON",
      "KILOMETRO 404",
      "VILLA CACIQUE",
      "EL SAUCE",
      "BARKER",
      "BENITO JUAREZ",
      "CORONEL RODOLFO BUNGE",
      "LOPEZ",
      "SAN ANTONIO",
      "EL LUCHADOR",
      "LA TINTA",
      "TEDIN URIBURU",
      "CRUCE MUÑOZ",
      "VILLA ALFREDO FORTABAT",
      "CUARTEL II - AEROPUERTO",
      "ESPIGAS",
      "RECALDE",
      "CAMPO ELSSIRY",
      "EL PORVENIR",
      "SIERRAS BAYAS",
      "OLAVARRIA",
      "CHACRAS DE PIBUEL",
      "VIRGEN DE LA LOMA",
      "SAN PEDRO",
      "CALERA AVELLANEDA",
      "EL MIRADOR",
      "SAN QUILCO",
      "COLONIA SAN MIGUEL",
      "SIERRA CHICA",
      "LAS PIEDRITAS",
      "VILLA LA SERRANIA",
      "ITURREGUI",
      "VILLA MONICA",
      "BLANCAGRANDE",
      "CERRO SOTUYO",
      "COLONIA HINOJO",
      "MAPIS",
      "CAMPO BELGRANO",
      "VILLA ARRIETA",
      "BLANCA CHICA",
      "SAN GREGORIO",
      "ROCHA",
      "HINOJO",
      "COLONIA NIEVAS",
      "LA PARDA",
      "SAN JACINTO",
      "LA PROVIDENCIA",
      "SANTA LUISA",
      "POURTALE",
      "LA MODERNA",
      "SAN ANTONIO",
      "LA CARMELITA",
      "LOS CHILENOS",
      "CAMPO STRIEBECK",
      "ADROGUE",
      "JOSE MARMOL",
      "SAN JOSE",
      "RAFAEL CALZADA",
      "CLAYPOLE",
      "MINISTRO RIVADAVIA",
      "BURZACO",
      "MALVINAS ARGENTINAS",
      "GLEW",
      "LONGCHAMPS",
      "DON ORIONE",
      "SAN FRANCISCO SOLANO",
      "TORTUGUITAS",
      "DEL VISO",
      "JOSE C. PAZ",
      "LA VIGIA",
      "LA VUELTA",
      "ROBERTO CANO",
      "SANTA FELISA",
      "LA SOLEDAD",
      "LA CALDERA",
      "LOS INDIOS",
      "LA CONCEPCION",
      "LA ROJERA",
      "LA BEBA",
      "BARRIO LAS MARGARITAS",
      "LAS CARABELAS",
      "LAS POLVAREDAS",
      "LA VUELTA CHICA",
      "HUNTER",
      "VILLA MANUEL POMAR",
      "LA TIGRA",
      "ROJAS",
      "ESTACION SOL DE MAYO",
      "RAFAEL OBLIGADO",
      "VILLA PARQUE CECIR",
      "LA VERDE",
      "SAN BASILIO",
      "CALLE ANGOSTA",
      "NEWTON",
      "SAN MARTIN",
      "CHAS",
      "GENERAL BELGRANO",
      "LA VERDE",
      "GORCHS",
      "EL DESCANSO",
      "COLONIA EL SALADO",
      "RUTA 5 KM 132",
      "SUIPACHA",
      "GENERAL RIVAS",
      "LOS CARDALES",
      "CUARTEL VIII",
      "ESTACION LA NEGRA",
      "LA DULCE",
      "CUARTEL IX",
      "CUARTEL IV",
      "GARRIDO",
      "LAVALLE",
      "EL EDEN",
      "LA LOMA",
      "PIERES",
      "EL MORO",
      "LA GUITARRA",
      "NAPALEOFU",
      "LA ALIANZA",
      "SANTA MARIA",
      "EL PAMPERO",
      "PUERTA DEL DIABLO",
      "LA FLORESTA",
      "ARENAS VERDES",
      "LA MALACARA",
      "SAN PASCUAL",
      "DOS NACIONES",
      "SAN MANUEL",
      "LA PROVIDENCIA",
      "LAS TOSCAS",
      "LAS NUTRIAS",
      "LAHORE",
      "TOME Y TRAIGA",
      "LOBERIA",
      "EL LENGUARAZ",
      "LA BODEGA",
      "TAMANGUEYU",
      "LICENCIADO MATIENZO",
      "SAN ANTONIO",
      "MOROMAR",
      "CAÑADA SECA",
      "SAN GENARO",
      "LOS LAURELES",
      "MASSEY",
      "ESTANCIA EL MERIDIANO",
      "GENERAL VILLEGAS",
      "COLONIA LA BELITA",
      "LA JOSEFA",
      "GONDRA",
      "VILLA CICLON",
      "MOORES",
      "CAMPOS FRIA",
      "PICHINCHA",
      "DRABBLE",
      "EL RECAO",
      "SAN JOSE",
      "ESCUELA AGRARIA",
      "FORTIN REPUBLICA",
      "LA MARGARITA",
      "ESTACION MILLACO",
      "VILLA SABOYA",
      "EL DIA",
      "CUARTEL II",
      "CORONEL CHARLONE",
      "PIEDRITAS",
      "VILLA SAUZE",
      "LA CATALINA",
      "SANTA ELEODORA",
      "TAMBEROS UNIDOS",
      "LOS ANGELES",
      "EMILIO V. BUNGE",
      "BANDERALO",
      "VOLTA",
      "CAMPESINOS UNIDOS",
      "SANTA REGINA",
      "LA TRADICION",
      "CANNING",
      "LUIS GUILLON",
      "9 DE ABRIL",
      "MONTE GRANDE",
      "EL JAGUEL",
      "LOS CERRILLOS",
      "FUNKE",
      "SAN MIGUEL DEL MONTE",
      "LA ELINA",
      "SAN GENARO",
      "ABBOTT",
      "SANTA MARIA",
      "EL ROSARIO",
      "EL SIASGO",
      "ZENON VIDELA DORNA",
      "GOYENECHE",
      "SAN MARCELO",
      "EL DORADO",
      "LA COSTA",
      "MAHON",
      "TRES LOMAS",
      "EL PANTANOSO",
      "SAN SILVERIO",
      "LOS CARDOS",
      "BALCARCE",
      "LA SARA",
      "EL GLIPTODONTE",
      "TRES ESQUINAS",
      "ALELUYA",
      "BOSCH",
      "COLONIA BALCARCE",
      "SAN SIMON",
      "BELLA VISTA",
      "EL CAPRICHO",
      "JUAN VICENTY",
      "EL VOLCAN",
      "ESQ DE LAHITTE",
      "CUARTEL III",
      "LOS PINOS",
      "RAMOS OTERO",
      "LA ESPERANZA",
      "CINCO CERROS",
      "EL PARQUE",
      "LA PALOMA",
      "ESTACION LA ALBORADA",
      "LLANOS",
      "SAN AGUSTIN",
      "CABAÑA SAN JUAN",
      "LA DELIA",
      "NAPALEOFU",
      "VILLA LAGUNA LA BRAVA",
      "SAN ALBERTO",
      "EL VIGILANTE",
      "EL CERRO",
      "EL VERANO",
      "LA ADELA",
      "PUERTA DEL ABRA",
      "LA LATA",
      "GUERNICA",
      "BARRIO AMERICA UNIDA",
      "LA CENTRAL",
      "CUARTEL VII",
      "KENNY",
      "LA CRIOLLA",
      "ESCOBEDO",
      "TATAY",
      "CUARTEL VI",
      "TRES SARGENTOS",
      "PUEBLO GOUIN",
      "CARMEN DE ARECO",
      "EX-SANTAMARINA",
      "CUARTEL I",
      "SAN FERMIN",
      "COCHICO",
      "LA FLORIDA",
      "LA FLORA",
      "SATURNO",
      "FORTIN PAUNERO",
      "LA LEGUA",
      "GARRE",
      "GUAMINI",
      "ARROYO VENADO",
      "FATRALO",
      "CASEY",
      "VICTORINO DE LA PLAZA",
      "EL GAUCHITO",
      "LAGUNA ALSINA",
      "LA CUADRADA",
      "LA NEVADA",
      "LA ATREVIDA",
      "ALAMOS",
      "CASBAS",
      "LA MARIA",
      "LA INDIANA",
      "LOS ANGELES",
      "LA TABLADA",
      "LA DELIA",
      "SAN PATRICIO",
      "MEMBRILLAR",
      "LAS CAÑAS",
      "CUARTEL I",
      "CHACABUCO",
      "COLIQUEO",
      "INGENIERO SILVEYRA",
      "RAWSON",
      "RUTA NACIONAL 7 KM 205",
      "MEDANOS BLANCOS",
      "CASTILLA",
      "CUARTEL IV",
      "O'HIGGINS",
      "EL TEJADO",
      "CIRCUNSCRIPCION I SERIE H",
      "LA VERDE",
      "SAUCE VERDE",
      "SAN VICENTE",
      "LA VICTORIA",
      "CUCHA CUCHA",
      "CAMET",
      "SANTA ISABEL",
      "SIERRA DE LOS PADRES",
      "BARRIO SANTA  PAULA",
      "LAGUNA DE LOS PADRES",
      "ESTACION CAMET",
      "LA BRAVA",
      "EL DORADO",
      "BARRIO EL CASAL",
      "COLONIA BARRAGAN",
      "ESTACION CHAPADMALAL",
      "LOMA ALTA",
      "LA PEREGRINA",
      "LAS DOS MARIAS",
      "MAR DEL PLATA",
      "QUINTAS DE PERALTA RAMOS",
      "BARRIO LA GLORIA",
      "CHAPADMALAL",
      "LAS HERMANAS",
      "BARRIO EL COYUNCO",
      "EL SIGLO",
      "BARRIO COLINAS VERDES",
      "BARRIO EL BOQUERON",
      "BATAN",
      "EL MARQUESADO",
      "PUNTA MOGOTES",
      "VILLA ASTOLFI",
      "MAQUINISTA F. SAVIO (OESTE)",
      "TORTUGUITAS",
      "LOS CACHORROS",
      "ROBERTO DE VICENZO",
      "LA LONJA",
      "FATIMA",
      "MANZONE",
      "PILAR",
      "BARRIO PARQUE ALMIRANTE IRIZAR",
      "MANZANARES",
      "DEL VISO",
      "SANTA TERESA",
      "ZELAYA",
      "PRESIDENTE DERQUI",
      "VILLA ROSA",
      "CLUB DE CAMPO LARENA - LOS QUINCHOS",
      "DOS HERMANOS",
      "COLONIA GENERAL PINTO",
      "LOS CALLEJONES",
      "DUSSAUD",
      "VILLA FRANCIA",
      "EL PEREGRINO",
      "SANTA ANGELA",
      "GENERAL PINTO",
      "VILLA ROTH",
      "LA MARGARITA",
      "GERMANIA",
      "PAZOS KANKI",
      "PERISEE",
      "GUNTHER",
      "COLONIA SAN RICARDO",
      "FLORIDA",
      "LA LUCILA",
      "MUNRO",
      "OLIVOS",
      "VILLA ADELINA",
      "VILLA MARTELLI",
      "FLORIDA OESTE",
      "VICENTE LOPEZ",
      "CARAPACHAY",
      "LONKOY",
      "EL MODELO",
      "LOS ZORZALES",
      "TRELLES",
      "MEDALAND",
      "LA FLORIDA",
      "LA FELICIDAD",
      "GENERAL JUAN MADARIAGA",
      "INVERNADAS",
      "BARRIO KENNEDY",
      "COLONIA TIO DOMINGO",
      "JUAN CHICO",
      "EL CARDALITO",
      "SANTA LA VICTORIA",
      "SANTA YOLA",
      "MACEDO",
      "NUEVA GRANADA",
      "DEL CARRIL",
      "EMILIANO REYNOSO",
      "SALADILLO NORTE",
      "SAN BLAS",
      "DAMAS DE LA MISERICORDIA",
      "ACUÑA",
      "ALVAREZ DE TOLEDO",
      "LOS GUAYCOS",
      "LA CAMPANA",
      "CAZON",
      "SAN BENITO",
      "LA GARITA",
      "EL ARENAL DEL CARMEN",
      "POLVAREDAS",
      "EL NARANJO",
      "LA FORTUNA",
      "MARIA ANTONIETA",
      "RENACO",
      "EL PUENTE",
      "ATUCHA",
      "EL MANGRULLO",
      "BLAQUIER",
      "LA ARGENTINA",
      "LA MARGARITA",
      "LA BLANQUEADA",
      "CUARTEL I",
      "CAMPO VELA",
      "SAN PEDRO",
      "LA BARRANCOSA",
      "SALADILLO",
      "CHOSOICO-ALGARRO",
      "LEJARRAGA",
      "COLONIA SAN ENRIQUE",
      "ARGERICH",
      "LOS ACEBOS",
      "SAN JOSE",
      "COLONIA CRAICO",
      "EL ALBA",
      "SALINA LAS BARRANCAS",
      "JUAN COUSTE",
      "COLONIA LEJARRETA",
      "LOTE 39",
      "ISLA VERDE",
      "EL CHARA",
      "SANTA CATALINA",
      "TENIENTE ORIGONE",
      "PEDRO LURO",
      "LAS MASCOTAS",
      "LA SELVA",
      "MAYOR BURATOVICH",
      "HILARIO ASCASUBI",
      "COLONIA RINCON DE LA ESPUELA",
      "NICOLAS LEVALLE",
      "BELLA VISTA",
      "COLONIA LA MERCED",
      "EL ZORRO",
      "COUNTRY LOS MEDANOS",
      "EL FORTIN",
      "MONTE PAQUETE",
      "MEDANOS",
      "LA MASCOTA",
      "LA JULITA",
      "COLONIA MASTRANGELO",
      "EL REDUCTO",
      "LOS ALFALFARES",
      "LOS SURGENTES",
      "MONTES DE OCA",
      "LAS ISLETAS",
      "COLONIA SAN ADOLFO",
      "COLONIA ESPIE",
      "LA CARLOTA",
      "VILLA SARITA",
      "LA ESTRELLA",
      "LAS FLORES",
      "LAS CANALETAS",
      "VILLA JARDIN",
      "EL ESPINILLO",
      "ALMACEN DE BASSO",
      "SANTA LUCIA",
      "DEL PARDO",
      "VILLA LEANDRA",
      "OBLIGADO",
      "LOS MATADEROS",
      "COLEGIALES",
      "RIO TALA",
      "LA TOSQUERA",
      "TABLAS",
      "EL CENTRO",
      "SAN PEDRO",
      "GOBERNADOR CASTRO",
      "PUEBLO DOYLE",
      "EL CANTABRICO",
      "BELADRICH",
      "EL IDEAL",
      "INGENIERO MONETA",
      "LA CELINA",
      "LA BOLSA",
      "LA BUENA MOZA",
      "LA MATILDE",
      "EL DESCANSO",
      "BAJO TALA",
      "EL CALEU",
      "LA VERONICA",
      "SANTA ROSA",
      "SANTA FORTUNA",
      "SAN JUAN",
      "LA UNION",
      "LA ESPERANZA",
      "SAN BERNARDO",
      "LA P0STA",
      "LABARDEN",
      "EL SAUCE",
      "LA QUINUA",
      "LAS ACACIAS",
      "GENERAL GUIDO",
      "ACASSUSO",
      "SAN ISIDRO",
      "VILLA ADELINA",
      "BOULOGNE SUR MER",
      "BECCAR",
      "MARTINEZ",
      "ISLAS",
      "GENERAL PACHECO",
      "DON TORCUATO ESTE",
      "DIQUE LUJAN",
      "LOS TRONCOS DEL TALAR",
      "RINCON DE MILBERG",
      "RICARDO ROJAS",
      "TIGRE",
      "DON TORCUATO OESTE",
      "EL TALAR",
      "BENAVIDEZ",
      "TRES BOCAS",
      "ALMACEN AROSA",
      "ABETHUR",
      "LAS TORTUGAS",
      "EL MANANTIAL",
      "LOS ALTOS VERDES",
      "LA REDUCCION",
      "LA INDIA MUERTA",
      "EL TRIANGULO",
      "CENTRO GUERRERO",
      "LA CALIFORNIA",
      "EL CALLEJON",
      "LA CORINA",
      "CERRO DE LA GLORIA (CANAL 15)",
      "EL ARAZA",
      "LOS MOLLES",
      "LA SALADA",
      "CASTELLI",
      "SAN CAYETANO",
      "OCHANDIO",
      "LA GAMA",
      "COLONIA RIVADAVIA",
      "VAGNOLI",
      "EL PINO",
      "EL CARRETERO",
      "CRISTIANO MUERTO",
      "EL INDIO",
      "BALNEARIO SAN CAYETANO",
      "VALERIA DEL MAR",
      "CARILO",
      "OSTENDE",
      "PINAMAR",
      "LAS TUNAS",
      "BERUTTI",
      "NUEVA CASTILLA",
      "FRANCISCO DE VITORIA",
      "TRENQUE LAUQUEN",
      "EL CORRENTINO",
      "COLONIA MARTIN FIERRO",
      "GIRODIAS",
      "LA MARIA",
      "SAN EDUARDO",
      "LAS GUASQUITAS",
      "ELVIRA",
      "FRANCISCO MAGNANO",
      "PRIMERA JUNTA",
      "MAYA",
      "MARI LAUQUEN",
      "COLONIA MANUEL 1°",
      "CORAZZI",
      "SAN PEDRO",
      "LA ATALAYA",
      "TRONGE",
      "COLONIA EL MATE",
      "LERTORA",
      "DUHAU",
      "LA ZANJA",
      "LA CANDELARIA",
      "SANTA CATALINA",
      "LA CARRETA",
      "30 DE AGOSTO",
      "COLONIA SANTA ANA",
      "LOS CHAÑARES",
      "APARICIO",
      "CUARTEL II",
      "LAS CORTADERAS",
      "EL PERDIDO",
      "LOS JUNCOS",
      "ZUBIARRE",
      "LA AURORA",
      "EL CALFIAO",
      "LA RUTA",
      "NICOLAS DESCALZI",
      "EL ZORRO",
      "CENTRO URQUIZA",
      "FARO",
      "EL LUCERO",
      "LA GLORIA",
      "CORONEL DORREGO",
      "LOMA CHATA",
      "GIL",
      "SAN ROMAN",
      "ORIENTE",
      "CALVO",
      "BALNEARIO MARISOL",
      "IRENE",
      "LA LUNA",
      "DIQUE N° 1",
      "ENSENADA",
      "PUNTA LARA",
      "VILLA CATELA",
      "ISLA SANTIAGO (OESTE)",
      "VILLA GRISOLIA",
      "PLA",
      "CORONEL SEGUI",
      "LARREA",
      "BAUDRIX",
      "VILLA MARIA",
      "ALBERTI",
      "MECHITA",
      "PRESIDENTE QUINTANA",
      "VILLA ORTIZ",
      "CUARTEL VI",
      "EL RECUERDO",
      "CUARTEL V",
      "LOMAS DE ZAMORA",
      "BANFIELD",
      "LLAVALLOL",
      "VILLA FIORITO",
      "TEMPERLEY",
      "VILLA CENTENARIO",
      "TURDERA",
      "BARRIO LOS PIONEROS",
      "LOMAS DEL RIO LUJAN",
      "EL MOREJON",
      "ESTACION ESPERIMENTAL DELTA DEL PARANA",
      "BLONDEAU",
      "CHACRAS DEL RIO LUJAN",
      "ALTO LOS CARDALES",
      "LA GRANJA",
      "CAMPANA",
      "ISLA TALAVERA",
      "SAN JOSE DE OTAMENDI",
      "MIRAMAR",
      "LAS PIEDRITAS",
      "LA BALLENERA",
      "ESTANCIA LA TOTO",
      "COMANDANTE NICANOR OTAMENDI",
      "MECHONGUE",
      "LA REFORMA",
      "LA EUFEMIA",
      "MAR DEL SUR",
      "CENTINELA DEL MAR",
      "AEROPUERTO INTERNACIONAL EZEIZA",
      "JOSE MARIA EZEIZA",
      "TRISTAN SUAREZ",
      "LA UNION",
      "CANNING",
      "CARLOS SPEGAZZINI",
      "EL PORVENIR",
      "BELLA VISTA",
      "CAMPO DE MAYO",
      "MUÑIZ",
      "SAN MIGUEL",
      "LA POROTA",
      "COLONIA LAPIN",
      "DELFIN HUERGO",
      "LEUBUCO",
      "VILLA MARGARITA",
      "LA CONQUISTA",
      "LA SAL",
      "ESTACION LA CONCEPCION",
      "COLONIA SAN MIGUEL ARCANGEL",
      "SAN MARCOS",
      "ARTURO VATTEONE",
      "THAMES",
      "COLONIA LEVEN",
      "AVESTRUZ",
      "MASALLE",
      "TRES LAGUNAS",
      "LA PALA",
      "SANTA ANITA",
      "RIVERA",
      "CANONIGO GORRITI",
      "ESTEBAN AGUSTIN GASCON",
      "ARANO",
      "ESPARTILLAR",
      "CARHUE",
      "LAGO EPECUEN",
      "YUTUYACO",
      "MAZA",
      "EL CORTAPIE",
      "DUFAUR",
      "LAS ENCADENADAS",
      "LOS CERRITOS",
      "LAS LOMAS",
      "ARROYO CORTO",
      "LA NORMA",
      "ABRA DEL HINOJO",
      "LAS MARIAS",
      "ALTA VISTA",
      "SAAVEDRA",
      "ESPARTILLAR (E)",
      "GOYENA",
      "LA COLONIA NUEVA",
      "COLONIA SAN PEDRO",
      "PIGUE",
      "COLONIA SAN MARTIN",
      "SAN FRANCISCO",
      "LA HISPANO ARGENTINA",
      "EL POLEO",
      "LOS FACHINALES",
      "MAULEON",
      "LA SORTIJA",
      "JUAN E. BARRA",
      "LA EMMA",
      "EL LUCERO",
      "ALZAGA",
      "ADOLFO GONZALES CHAVES",
      "VASQUEZ",
      "SANTA CLARA",
      "SANTA MARIA",
      "CHAPAR",
      "DE LA GARMA",
      "LOMA HERMOSA",
      "MARTIN CORONADO",
      "SANTOS LUGARES",
      "11 DE SEPTIEMBRE",
      "CIUDADELA",
      "VILLA BOSCH (EST. JUAN MARIA BOSCH)",
      "PABLO PODESTA",
      "JOSE INGENIEROS",
      "CASEROS",
      "EL LIBERTADOR",
      "CHURRUCA",
      "REMEDIOS DE ESCALADA",
      "VILLA RAFFO",
      "SAENZ PEÑA",
      "CIUDAD JARDIN LOMAS DEL PALOMAR",
      "LA VALEROSA",
      "AZCUENAGA",
      "SOLIS",
      "VILLA SAN ALBERTO",
      "CAMPO VAZQUEZ",
      "VILLA ESPIL",
      "EL CONDOR",
      "LOS MANUELES",
      "LA FLORIDA",
      "LA PRIMAVERA",
      "SAN ANDRES DE GILES",
      "SAN ALBERTO",
      "TUYUTI",
      "LA AMALIA",
      "CULULLU",
      "HEAVY",
      "FRANKLIN",
      "VILLA RUIZ",
      "SALLIQUELO",
      "QUENUMA",
      "POSADA DE LOS LAGOS",
      "CORONEL BRANDSEN",
      "JEPPENER",
      "CLUB DE CAMPO LAS MALVINAS",
      "LA PARADA",
      "CAMPO PORTU",
      "BARRIO LOS BOSQUECITOS",
      "BARRIO PARQUE LAS ACACIAS",
      "OLIDEN",
      "CUARTEL II",
      "BARRIO LAS GOLONDRINAS",
      "CAMPOS DE ROCA",
      "GOBERNADOR OBLIGADO",
      "RUTA 29 KM 2",
      "ALTAMIRANO",
      "LA POSADA",
      "BUCHANAN",
      "BARRIO EL MIRADOR",
      "EL CHAJA",
      "LA PEPITA",
      "GOMEZ",
      "SAMBOROMBON",
      "MONTE HERMOSO",
      "BALNEARIO SAUCE GRANDE",
      "LA ADELA",
      "PUELCHES",
      "COLONIA 17",
      "LOS AGRARIOS",
      "COLONIA MORENO",
      "INGENIERO THOMPSON",
      "LA GRANDE DEL SUD",
      "PEHUELCHES",
      "TRES LOMAS",
      "SAN ANTONIO DE PADUA",
      "LIBERTAD",
      "MERLO",
      "MARIANO ACOSTA",
      "PONTEVEDRA",
      "BERNAL OESTE",
      "DON BOSCO",
      "BERNAL",
      "QUILMES OESTE",
      "VILLA LA FLORIDA",
      "EZPELETA OESTE",
      "SAN FRANCISCO SOLANO",
      "EZPELETA",
      "QUILMES",
      "CAMPO TOYOS",
      "LA ORIENTAL",
      "COLONIA SAN LUIS",
      "AGUSTINA",
      "CAMPO MAIPU",
      "BLANDENGUES",
      "CAMPO CAMICCIA",
      "BALNEARIO LAGUNA DE GOMEZ",
      "AGUSTIN ROCA",
      "A. ROCA",
      "JUNIN",
      "LA AGRARIA",
      "LAS MERCEDES",
      "SAFORCADA",
      "FORTIN TIBURCIO",
      "CAMPO LA CRUZ",
      "CERRITO COLORADO",
      "RINCON DEL CARPINCHO",
      "SANTA ROSA",
      "MORSE",
      "LAPLACETTE",
      "CAMPO BALESTRASET",
      "ESTACION PEREYRA",
      "GUILLERMO ENRIQUE HUDSON",
      "PEREYRA",
      "EL PATO",
      "JUAN MARIA GUTIERREZ",
      "RANELAGH",
      "VILLA ESPAÑA",
      "PLATANOS",
      "BERAZATEGUI",
      "BERAZATEGUI OESTE",
      "CARLOS TOMAS SOURIGUES",
      "BRAGADO",
      "SANTA ROSA",
      "CUARTEL II",
      "OLASCOAGA",
      "ASAMBLEA",
      "EL MATACO",
      "MECHITA",
      "SANTO DOMINGO",
      "RAUCH NUEVO",
      "LA CRIOLLA",
      "LA BLANQUEDA",
      "LA LIMPIA",
      "MAXIMO FERNANDEZ",
      "COMODORO PY",
      "CAMPO DE RIANO",
      "WARNES",
      "IRALA",
      "GENERAL O'BRIEN",
      "RAUCH VIEJO",
      "LA MARIA",
      "VIEYTES",
      "EL PINO",
      "LA CLELIA",
      "SAN MARTIN",
      "MAGDALENA",
      "ATALAYA",
      "CAMPO FERRO",
      "ROBERTO J. PAYRO",
      "GUTIERREZ",
      "LOS NARANJOS",
      "JULIO ARDITI",
      "JOSE FERRARI",
      "SAN JOSE",
      "GENERAL MANSILLA",
      "VERGARA",
      "EL DESTINO",
      "UNIDAD PENAL MAGDALENA",
      "MALAGAMBA",
      "LA MATRACA",
      "EL MORO",
      "BELLA VISTA",
      "HENDERSON",
      "CORACEROS",
      "CAMPO MONCANI",
      "MARIA LUCILA",
      "BERSEE",
      "HERRERA VEGAS",
      "COLONIA LA BEBA",
      "EL BARRANCOSO",
      "EL TAURO",
      "ESTANCIA EL MOLINO",
      "ESTANCIA BALBUENA",
      "CARMEN DE PATAGONES",
      "COLONIA LOS ALAMOS",
      "ZONA RURAL DE JOSE B CASAS",
      "JUAN A. PRADERE",
      "BAHIA SAN BLAS",
      "COLONIA LA DELFINA",
      "MERIDIANO V",
      "COLONIA MIGLIORI",
      "COLONIA EL GUANACO",
      "COLONIA 7 DE MARZO",
      "ESTANCIA SAN LUIS",
      "VILLALONGA",
      "COLONIA LA GRACIELA",
      "STROEDER",
      "COLONIA EL MOLINO",
      "EMILIO LAMARCA",
      "JOSE B. CASAS",
      "CARDENAL CAGLIERO",
      "IGARZABAL",
      "COLONIA BARGA",
      "COLONIA SAN LUIS",
      "COLONIA SAN FRANCISCO",
      "VILLA LYNCH",
      "KILOMETRO 900",
      "LANUS ESTE",
      "VALENTIN ALSINA",
      "REMEDIOS DE ESCALADA DE SAN MARTIN",
      "MONTE CHINGOLO",
      "GERLI",
      "LANUS OESTE",
      "EL SOLITO",
      "BARRIO LOMAS ALTAS",
      "LOS JAGÑELES",
      "PUERTA DEL DIABLO",
      "LA JUANITA",
      "DON CIPRIANO",
      "LIBRES DEL SUD",
      "VILLA PARQUE GIRADO",
      "LA HORQUETA",
      "CUATRO DE FEBRERO",
      "9 DE JULIO",
      "VIVERO NACIONAL",
      "LA GRANJA",
      "CHASCOMUS",
      "LAGUNA VITEL",
      "LOS CERRILLOS",
      "ESTANCIA EL COATI",
      "EL RECREO",
      "LA CORONA",
      "GANDARA",
      "SAN NICANOR",
      "VALLE SANTA ANTA",
      "BARRIO SAN CAYETANO",
      "COMANDANTE GIRIBONE",
      "SAN GREGORIO",
      "ESTANCIA SAN CEFERINO",
      "ADELA",
      "EL BOTE",
      "JUANCHO",
      "MANANTIALES",
      "EL MIRASOL",
      "LOS TRONCOS",
      "AGOTE",
      "MERCEDES",
      "LA TABLADA",
      "CUARTEL XVI",
      "CUARTEL XV",
      "CUARTEL XII",
      "SAN JACINTO",
      "SAN JORGE",
      "TOMAS JOFRE",
      "GOWLAND",
      "CUARTEL XIX",
      "LA VERDE",
      "PURICELLI",
      "GOLDNEY",
      "MIRA PAMPA",
      "VILLA SENA",
      "FORTIN OLAVARRIA",
      "ESTANCIA LA HAYDEE",
      "CERRITO",
      "CONDARCO",
      "ROOSEVELT",
      "RODEO CHICO",
      "COLONIA EL BALDE",
      "GONZALEZ MORENO",
      "VALENTIN GOMEZ",
      "SAN MAURICIO",
      "SUNDBLAD",
      "SANSINENA",
      "AMERICA",
      "EL PENSAMIENTO",
      "STEGMANN",
      "CORONEL FALCON",
      "LARTIGAU",
      "LA PALOMA",
      "CHELFORO",
      "ESTACION LAS LOMAS",
      "RESERVA",
      "EL GAVILAN",
      "LAS MOSTAZAS",
      "LA NORIA",
      "CORONEL PRINGLES",
      "KRABBE",
      "PILLAHUINCO",
      "DON ALFREDO",
      "LA VIRGINIA",
      "LAGUNA DEL MOLLE",
      "OJO DE AGUA",
      "LA AMALIA",
      "SAN MANUEL",
      "SAN FELIPE",
      "EL DIVISORIO",
      "INDIO RICO",
      "LA LEGUA",
      "LA FORTUNA",
      "LA ALFALFA",
      "EL DESCANSO",
      "LA COLORADA",
      "LA LUISA",
      "ARROYO DE LUNA",
      "CAPITAN SARMIENTO",
      "VILLA CORONEL JOSE M. ZAPIOLA",
      "VILLA LYNCH",
      "VILLA MARIA IRENE DE LOS REMEDIOS DE ESCALADA",
      "VILLA PARQUE PRESIDENTE FIGUEROA ALCORTA",
      "VILLA GODOY CRUZ",
      "VILLA GREGORIA MATORRAS",
      "BILLINGHURST",
      "VILLA BALLESTER",
      "VILLA YAPEYU",
      "VILLA GENERAL EUGENIO NECOCHEA",
      "VILLA PARQUE SAN LORENZO",
      "VILLA GENERAL JOSE TOMAS GUIDO",
      "VILLA AYACUCHO",
      "VILLA GRANADEROS DE SAN MARTIN",
      "VILLA JOSE LEON SUAREZ",
      "VILLA MARQUES ALEJANDRO MARIA DE AGUADO",
      "VILLA BERNARDO MONTEAGUDO",
      "VILLA GENERAL JUAN G. LAS HERAS",
      "VILLA LIBERTAD",
      "VILLA MAIPU",
      "VILLA GENERAL ANTONIO J. DE SUCRE",
      "VILLA CHACABUCO",
      "VILLA SAN ANDRES",
      "CIUDAD DEL LIBERTADOR GENERAL SAN MARTIN",
      "VILLA JUAN MARTIN DE PUEYRREDON",
      "CIUDAD JARDIN EL LIBERTADOR",
      "BARRIO PARQUE GENERAL SAN MARTIN",
      "PEREZ MILLAN",
      "VILLA RAMALLO",
      "RAMALLO",
      "ZINO",
      "LA INDEPENDENCIA",
      "MARELLI",
      "LOS TOLDOS",
      "EL JUPITER",
      "EL TONELERO",
      "SAN CARLOS",
      "EL PARAISO",
      "LA FERIA",
      "MANANTIALES CHICOS",
      "LAS BAHAMAS",
      "HERRERA",
      "VILLA GENERAL SAVIO",
      "REAL AUDIENCIA",
      "EL ZORRO",
      "EL 80",
      "HINOJALES",
      "CAMARON CHICO",
      "LAS LECHUZAS",
      "CHAPALAUQUEN",
      "CASALINS",
      "PILA",
      "EL VENADO",
      "LOS TOLDOS",
      "DEMARIA",
      "LAS CHILCAS",
      "LA LIMPIA",
      "EL SARTEN",
      "LA REFORMA",
      "EL ALEGRE",
      "LA VICTORIA",
      "EL TRIGO",
      "PLAZA MONTERO",
      "DOCTOR DOMINGO HAROSTEGUY",
      "LAS FLORES",
      "PAGO DE ORO",
      "LA BLANQUEADA",
      "EST LA GRACIELA",
      "SANTA INES",
      "CUARTEL VII",
      "PARDO",
      "LA COLONIA",
      "EL MOSQUITO",
      "EL TROPEZON",
      "VILELA",
      "EL TORO",
      "PIAMMISTEGUY",
      "EL DESPUNTE",
      "ESTRUGAMOU",
      "ESCUELA AGRARIA",
      "CUARTEL VIII",
      "EL GUALICHO",
      "LA CAPILLA",
      "CORONEL BOERR",
      "LA CUBANA",
      "EL ZORRO",
      "SOL DE MAYO",
      "ROSAS",
      "LA ANGELITA",
      "CLARAZ",
      "LAS CALAVERAS",
      "LA MAGNOLIA",
      "SEMILLERO BUCK",
      "CAMPOMAR",
      "MOJON DEL PALO",
      "NECOCHEA",
      "JUAN N. FERNANDEZ",
      "LA LITA",
      "CALANGUEYU",
      "LA NEGRA",
      "LA LUISA",
      "RAMON SANTAMARINA",
      "NICANOR OLIVERA",
      "LA GALIA",
      "COSTA BONITA",
      "VILLA ZAGALA",
      "EL TIGRE",
      "QUEQUEN",
      "LUMB",
      "ENERGIA",
      "SAN JOSE (VILLA DIEGO)",
      "EL PALOMAR",
      "SAN CALA",
      "BARRIO RUTA 24 KM. 10",
      "LA CHOZA",
      "C.C. BOSQUE REAL",
      "CRUCE RUTAS 6 Y 24",
      "HOSPITAL SOMMER",
      "CUARTEL II",
      "BARRIO RUTA 24 KILOMETRO 10",
      "GENERAL RODRGUEZ",
      "BARRIO MORABO",
      "CUARTEL IV",
      "DE ARIAS",
      "AZUL",
      "ARROYO DE LOS HUESOS",
      "MATADEROS",
      "CAMPOMAR",
      "LA MANTEQUERIA",
      "ARIEL",
      "LA PEQUEÑA",
      "LOS 4 CAMINOS",
      "PABLO ACOSTA",
      "SIEMPRE AMIGOS",
      "SHAW",
      "EL DESTIERRO",
      "MIRAMONTE",
      "16 DE JULIO",
      "SAN PEDRO",
      "LA PROTEGIDA",
      "LA SOFIA",
      "SAN JOSE",
      "CACHARI",
      "MARTIN FIERRO",
      "VICENTE PEREDA",
      "LA ANGELITA",
      "LA MATILDE",
      "LAS CORTADERAS",
      "LA JUANITA",
      "MANANTIALES DE PEREDA",
      "CAMPO MIREZTKY",
      "ATALAYA",
      "LA ISABELITA",
      "LA VERDE",
      "LA CHUMBEADA",
      "LOS ANGELES",
      "NIEVES",
      "LA COLORADA",
      "VILLA LAZA",
      "CHILLAR",
      "LA PRIMAVERA",
      "LAS ROSAS",
      "PARISH",
      "SANTA CLARA",
      "CUARTEL XV",
      "BARRIO EL TALADRO",
      "SAN ANTONIO",
      "ESTANCIA LA PRIMAVERA",
      "LA NORIA",
      "GOBERNADOR UDAONDO",
      "VILLA VISSIR",
      "URIBELARREA",
      "ALEJANDRO PETION",
      "LOS ALAMOS",
      "LA TAPIE",
      "EL DESLINDE",
      "LAS PALMITAS",
      "LA LEONOR",
      "CAÑUELAS",
      "SANTA ROSA",
      "BARRIO BELGRANO",
      "VICENTE CASARES",
      "MAXIMO PAZ",
      "LA DORITA",
      "COLONIA SANTA MARIA",
      "LA SOFIA",
      "COLONIA MAURICIO",
      "MAURICIO HIRSCH",
      "ORDOQUI",
      "MOCTEZUMA",
      "SANTO TOMAS",
      "BELLOCQ",
      "CADRET",
      "LAS CHACRAS",
      "EL BILLAR",
      "CENTENARIO",
      "CARLOS CASARES",
      "HORTENSIA",
      "SMITH",
      "COLONIA LA PIEDRA",
      "EL SEPTIMO",
      "GOBERNADOR ARIAS",
      "CUARTEL V",
      "VILLA RICCIO",
      "LA CLEMENCIA",
      "VILLA ESPERANZA",
      "LA ALICIA",
      "VILLA CAMPI",
      "EREZCANO",
      "VILLA CANTO",
      "GENERAL ROJO",
      "SAN NICOLAS DE LOS ARROYOS",
      "CAMPOS SALLES",
      "LA EMILIA",
      "CONESA",
      "SANTA ELVIRA",
      "LAGUNA LOS DIFUNTOS",
      "LAS ARMAS",
      "YAMAHUIDA",
      "EL CHAJA",
      "SEGUROLA",
      "MONSALVO",
      "MAIPU",
      "SANTO DOMINGO",
      "SANTA TERESITA",
      "SANTA ISABEL",
      "SAN SIMON",
      "INGENIERO PABLO NOGUES",
      "AREA DE PROMOCION EL TRIANGULO",
      "INGENIERO ADOLFO SOURDEAUX",
      "GRAND BOURG",
      "TORTUGUITAS",
      "LOS POLVORINES",
      "VILLA DE MAYO",
      "LA BLANQUEADA",
      "MAGDALA",
      "FRANCISCO MADERO",
      "LAS JUANITAS",
      "EL CRUCE",
      "EL RECADO",
      "ANCON",
      "JUAN JOSE PASO",
      "GNECCO",
      "LA JOSEFA",
      "INOCENCIO SOSA",
      "EL AGRO",
      "PEDRO GAMEN",
      "MONES CAZON",
      "CAPITAN CASTRO",
      "PEHUAJO",
      "COLONIA CARLOS ARIAS",
      "EL RANCHITO",
      "ASTURIAS",
      "SAN BERNARDO",
      "CONDE CAZON",
      "NUEVA PLATA",
      "ABEL",
      "CUARTEL SEGUNDO",
      "ALVAREZ",
      "SAN ESTEBAN",
      "CURUCHET",
      "EL OMBU",
      "SANTA ROSA",
      "CAMPO ARECHAVAL",
      "SAMBOROMBON",
      "DOMSELAAR",
      "ALEJANDRO KORN",
      "SAN VICENTE",
      "MARIANO BENITEZ",
      "RANCAGUA",
      "GORNATTI",
      "LA VIOLETA",
      "ACEVEDO",
      "ARROYO DEL MEDIO",
      "LA VANGUARDIA",
      "MANANTIALES",
      "MANANTIALES CHICOS",
      "ESTANCIA SAN RAFAEL",
      "TAMBO NUEVO",
      "SANTA ROSA",
      "FRANCISCO AYERZA",
      "CAMPO BUENA VISTA",
      "FONTEZUELA",
      "MANUEL OCAMPO",
      "CAMPO URRUTIA",
      "VILLA ANGELICA",
      "MAGUIRRE",
      "GUERRICO",
      "PINZON",
      "CAMINO A LA VIOLETA KM 4",
      "ARROYO DULCE",
      "LA MAGDALENA",
      "MARIANO H.  ALFONZO",
      "JUAN ANCHORENA",
      "ORTIZ BASUALDO",
      "PERGAMINO",
      "JUAN A. DE LA  PEÑA",
      "CAMPO ROTH",
      "VILLA SAN JOSE",
      "MANANTIALES GRANDES",
      "CAMPO URQUIZA",
      "CUARTEL V",
      "MORENO",
      "PASO DEL REY",
      "LA REJA",
      "TRUJUI",
      "FRANCISCO ALVAREZ",
      "PUNTA ALTA",
      "B.N.I.M BATERIAS",
      "CAMPO ESCUDERO",
      "PAGO CHICO",
      "BALNEARIO PEHUEN CO",
      "CORONEL ROSALES",
      "VILLA GENERAL ARIAS",
      "CAMPO SAN VICENTE",
      "BAJO HONDO",
      "LAS OSCURAS",
      "VILLA DEL MAR",
      "CALDERON",
      "BALSA",
      "LA DOROTEA",
      "CUARTEL II",
      "SANTA MARTA",
      "LA ESMERALDA",
      "PASICOTT",
      "CARLOS SALAS",
      "CUARTEL V",
      "SANTA MARIA",
      "EL MORITO",
      "LOS AROMITOS",
      "CORONEL MARTINEZ DE HOZ",
      "LA VICTORIA",
      "EL TRIUNFO",
      "ARENAZA",
      "SAN FRANCISCO",
      "CUARTEL VI",
      "LA CONCORDIA",
      "LA PERGAMINERA",
      "LINCOLN",
      "CUARTEL III",
      "13 DE ABRIL",
      "ESTACION SAN JUAN",
      "ROBERTS",
      "TRIUNVIRATO",
      "CUARTEL IV",
      "ACCESO RICALDI",
      "SAN GREGORIO",
      "LA ARGENTINA",
      "LA DELIA",
      "BERMUDEZ",
      "ESTACION LA UNION",
      "BAYAUCA",
      "PASTEUR",
      "VIGILANCIA",
      "LAS TOSCAS",
      "MEDIA LUNA",
      "PORVENIR",
      "ESTACION LA CHACRA",
      "SALALE",
      "LOS ANDES",
      "SAN CARLOS",
      "ANCALO",
      "NUEVA SUIZA",
      "FLORENTINO AMEGHINO",
      "CUARTO LUNA",
      "ESTACION LA ISLETA",
      "EDUARDO COSTA",
      "BLAQUIER",
      "EL RINCON",
      "LA FLORIDA",
      "LA RINCONADA",
      "MONASTERIO",
      "EL DESTINO",
      "LA JOSEFINA",
      "LA BELEN",
      "ATILIO PESSAGNO",
      "MANUEL J. COBO - LEZAMA",
      "EL ARBOLITO",
      "EL PALOMAR",
      "CASTELAR",
      "HAEDO",
      "MORON",
      "VILLA SARMIENTO",
      "BELEN DE ESCOBAR",
      "GARIN",
      "EL CAZADOR",
      "LOMA VERDE",
      "INGENIERO MASCHWITZ",
      "SECCION ISLAS",
      "MATHEU",
      "MAQUINISTA F. SAVIO ESTE",
      "LOS TALAS",
      "BERISSO",
      "BARRIO EL CARMEN (ESTE)",
      "VILLA ARGÑELLO",
      "VILLA NUEVA",
      "VILLA ZULA",
      "VILLA PROGRESO",
      "VILLA PORTEÑA",
      "ISLA PAULINO",
      "BARRIO BANCO PROVINCIA",
      "VILLA INDEPENDENCIA",
      "BARRIO UNIVERSITARIO",
      "LA HERMOSURA",
      "VILLA DOLORES",
      "VILLA SAN CARLOS",
      "VILLA LYNCH PUEYRREDON",
      "SAN EMILIO",
      "LA PROTECTORA",
      "PAULA",
      "LA MERCED",
      "MIRAMAR",
      "CAMPO CREADO",
      "EL SOMBRERITO",
      "UNIDAD PENAL DE URDAMPILLETA",
      "LA CAROLINA",
      "URDAMPILLETA",
      "SANTA MARIA",
      "EL CABILDO",
      "LA VIZCAINA",
      "30 DE DICIEMBRE",
      "SAN CARLOS DE BOLIVAR",
      "JUAN F. IBARRA",
      "SAN LUIS",
      "PIROVANO",
      "EL PORVENIR",
      "CAMPO LANDO",
      "AVELLANEDA",
      "BOSCABEL",
      "SAN ANDRES",
      "VALLIMANCA",
      "VILLA SANZ",
      "LA MATILDE",
      "EL 43",
      "MARSIGLIO",
      "CAMPO CAPECCE",
      "MARIANO UNZUE",
      "HALE",
      "LOS 4 VIENTOS",
      "PARADA ORLANDO",
      "CHENAUT",
      "CAPILLA DEL SEÑOR",
      "PARADA ROBLES",
      "ETCHEGOYEN",
      "LOS CARDALES",
      "ESTACION LA LATA",
      "RUTA 193 KM 28,5",
      "LA ROSADA",
      "GOBERNADOR ANDONAEGUI",
      "ARROYO DE LA CRUZ",
      "DIEGO GAYNOR",
      "EL REMANSO",
      "CARLOS LEMEE",
      "PAVON",
      "ACCESO A GOBERNADOR ANDONAEGUI",
      "EL CHIRIPA",
      "LOS FLAMENCOS",
      "LOS AROMOS",
      "FORTIN ESPERANZA",
      "LOS CHUCAROS",
      "COLONIA S S DEL VALLE",
      "EL DESTINO",
      "EL PELUDO",
      "LA MARIA LUISA",
      "EMMA",
      "GENERAL ALVEAR",
      "EL PARCHE",
      "SANTA ISABEL",
      "LA BRAVA",
      "LA MOROCHA",
      "LA PALOMA",
      "EL TABARE",
      "VILLA SERRANA LA GRUTA",
      "SOMBRA DE TORO",
      "LA QUERENCIA",
      "FORTIN CHACO",
      "FUERTE ARGENTINO",
      "TORNQUIST",
      "EL PILAR",
      "LA ESTHER",
      "NAVIDAD",
      "SAUCE CHICO",
      "RODOLFO FUNKE",
      "BERRAONDO",
      "SALDUNGARAY",
      "TRES PICOS",
      "CHOIQUE",
      "LOS CHILENOS",
      "ESTOMBA",
      "PELICURA",
      "CHASICO",
      "NUEVA ROMA",
      "DIQUE PASO PIEDRAS",
      "VILLA VENTANA",
      "SIERRA DE LA VENTANA",
      "ISLAS",
      "BARRIO SAAVEDRA",
      "CUARTEL V",
      "RUTA 9 KM 103",
      "LIMA",
      "ESCALADA",
      "ATUCHA",
      "ISLA BOTIJA",
      "LA PESQUERIA",
      "COUNTRY CLUB EL CASCO",
      "LAS CUATRO ESQUINAS",
      "EL TATU",
      "ZARATE",
      "LAS PALMAS",
      "VEDIA",
      "TRIGALES",
      "SANTA MARIA",
      "ALBERDI VIEJO",
      "LOS ALFALFARES",
      "EL RETIRO",
      "LA PERMANENTE",
      "LA ESPERANZA",
      "LA CLARITA",
      "ESTACION LAS BALAS",
      "EL DORADO",
      "JUAN BAUTISTA ALBERDI",
      "CAMPO MENDIZABAL",
      "LEANDRO N. ALEM",
      "FORTIN ACHA",
      "LA COLONIA",
      "BARRIO GRANADEROS",
      "CAÑADA DE ROCA",
      "LEZICA Y TORREZURI",
      "CARLOS KEEN",
      "SUCRE",
      "OLIVERA",
      "ALASTUEY",
      "JOSE MARIA JAUREGUI",
      "OPEN DOOR",
      "LUJAN",
      "TORRES",
      "VILLA FLANDRIA NORTE (PUEBLO NUEVO)",
      "CLUB DE CAMPO LOS PUENTES",
      "SAN ELADIO",
      "POLO DE LUJAN",
      "CORTINES",
      "BARRIO LAS CASUARINAS",
      "PUEBLO NUEVO",
      "COUNTRY CLUB LAS PRADERAS",
      "LAS LILAS",
      "VILLA FLANDRIA SUR (EST. JAUREGUI)",
      "AGUAS VERDES",
      "SANTA TERESITA",
      "LAS TONINAS",
      "MAR DEL TUYU",
      "MAR DE AJO NORTE",
      "LUCILA DEL MAR",
      "SAN CLEMENTE DEL TUYU",
      "MAR DE AJO",
      "SAN BERNARDO",
      "ALEGRE",
      "VILLANUEVA",
      "SAN GREGORIO",
      "LA PALOMA",
      "FALCONE",
      "LA SOLEDAD",
      "LA PEPITA",
      "LA CAÑADA",
      "LAS ACACIAS",
      "BARRIO RIO SALADO",
      "LA BLANQUEADA",
      "LA POSTA",
      "VILLA MARTINEZ",
      "LA CHANCLETA",
      "LOMA VERDE",
      "KILOMETRO 70",
      "DANTAS",
      "DE LA LLAVE",
      "LA TAHONA NUEVA",
      "LOS MERINOS",
      "RANCHOS",
      "LA ANDORRA",
      "LOMA PARTIDA",
      "COLONIA MARTIN FIERRO",
      "CHAPALEOFU",
      "LA COLORADA",
      "EL ESCONDITE",
      "MIRANDA",
      "EL CHALAR",
      "SANTA ADELA",
      "EL BONETE",
      "SAN ALBERTO",
      "EL GUALICHO",
      "RAUCH",
      "LOS MELLIZOS",
      "LA UNION",
      "COLONIA LANGUEYU",
      "DURAZNO CHICO",
      "LA DORMIDA",
      "SAN JOSE",
      "LAS NEGRAS",
      "CUARTEL I",
      "LOS GALPONES",
      "BOCA DE TIGRE",
      "MARTIN COLMAN",
      "LA FLORIDA",
      "LOMA NEGRA",
      "LOS COPETES",
      "CUARTEL VIII",
      "INDACOCHEA",
      "SAN CARLOS",
      "PASAJE EL PALOMAR",
      "EL PORVENIR",
      "GOROSTIAGA",
      "BENITEZ",
      "SANTA ISABEL",
      "PALEMON HUERGO",
      "SAN SEBASTIAN",
      "SECCION PRIMERA QUINTAS",
      "CUARTEL III",
      "PUENTE LAGO",
      "RAMON BIAUS",
      "WITTE",
      "LA RICA",
      "LA ARMONIA",
      "EMILIO AYARZA",
      "LA CARLOTA",
      "DE LUCA",
      "CHIVILCOY",
      "HENRY BELL",
      "LA UNION",
      "CUARTEL VI",
      "LA COLORADA",
      "CAMPO DE BARDENGO",
      "MOQUEHUA",
      "PICHEUTA",
      "CAMPO ZACARDI",
      "LAS CAÑAS",
      "ISLAS",
      "RIO CARABELAS",
      "ARROYO PAY CARABI",
      "CARUPA",
      "ISLAS DEL DELTA",
      "VICTORIA",
      "ARROYO DURAZNO",
      "VILLA JARDIN",
      "ARROYO LAS CAÑAS",
      "SAN FERNANDO",
      "ARROYO BORCHES",
      "2° SECCION DE ISLAS",
      "VIRREYES",
      "LA BARQUITA",
      "PARANA MINI",
      "ISALAS DE SAN FERNANDO",
      "3° SECCION DE ISLAS",
      "VILLA ALSINA",
      "SAENZ VALIENTE",
      "LA TORTUGA",
      "BARADERO",
      "EL TRIANGULO",
      "CAÑADA DE LOS TOROS",
      "ISLA LOS LAURELES",
      "LA BELLACA",
      "LA PALOMA",
      "COLONIA SUIZA",
      "EL CABALLITO CHICO",
      "IRINEO PORTELA",
      "EL CABALLITO",
      "EL MARTILLO",
      "SANTA COLOMA",
      "CAMINO A VILLA ALSINA",
      "VUELTA DE LOS PASTOS",
      "CAÑADA GRANDE",
      "CUARTEL V",
      "LA COLORADA",
      "BARRIOS LISANDRO DE LA TORRE Y SANTA MARTA",
      "ALAMBRADO DE FIERRO",
      "EL TROPEZON",
      "MARCOS PAZ",
      "BARRIO SANTA ROSA",
      "EL MARTILLO",
      "VILLA GOBERNADOR UDAONDO",
      "ITUZAINGO SUR",
      "ITUZAINGO CENTRO",
      "CUARTEL VI",
      "LA ANITA",
      "BARRIO LOS HORNOS",
      "CAMPO EGLI",
      "CAMPO TOZZI",
      "CUARTEL VII",
      "ELVIRA",
      "RUTA PROVINCIAL 41 KM 168",
      "EL BALCON",
      "JOSE SANTOS AREVALO",
      "LAGUNA DE LOBOS",
      "SALVADOR MARIA",
      "LAS CHACRAS",
      "CUARTEL VIII",
      "LAS GARZAS",
      "EL ARAZA",
      "LA RINCONADA",
      "LOBOS",
      "ANTONIO DELGADO",
      "ZAPIOLA",
      "ANTONIO CARBONI",
      "EL HINOJO",
      "EL FAISAN",
      "SANTOS UNZUE",
      "PATRICIOS",
      "GERENTE CILLEY",
      "LA AMALIA",
      "CAMPO LISAZO",
      "CAMBACERES",
      "LA CORONA",
      "EL TEJAR",
      "FAUZON",
      "GALO LLORENTE",
      "MARCELINO UGARTE",
      "12 DE OCTUBRE",
      "BACACAY",
      "CORBETT",
      "NORUMBEGA",
      "ALFREDO DEMARCHI",
      "MOREA",
      "LAS PIEDRAS",
      "MULCAHY",
      "LOS PARAISOS",
      "LA AURORA",
      "LA BLANQUEADA",
      "DUDIGNAC",
      "MANUEL B. GONNET",
      "EL JABALI",
      "EL CHAJA",
      "EL ESPARTILLAR",
      "LA CENTRAL",
      "VILLA GENERAL FOURNIER",
      "SAN JUAN",
      "KILOMETRO 234",
      "EL SOCAVON",
      "CARLOS MARIA NAON",
      "COLONIA LA RURAL",
      "9 DE JULIO",
      "LA HORMIGA",
      "ALFEREZ SAN MARTIN",
      "VILLA OLGA",
      "COCHRANE",
      "GRÑNBEIN",
      "LOS MIRASOLES",
      "VILLA ESPORA",
      "INGENIERO WHITE",
      "VILLA ELISA",
      "PUERTO GALVAN",
      "VILLA BORDEAU",
      "POSTA ROLANDO",
      "BAHIA BLANCA",
      "CABILDO",
      "GENERAL DANIEL CERRI",
      "LA CARRINDANGA",
      "SAN JOSE",
      "ALDEA ROMANA",
      "LA COLORADA",
      "ESTACION LOS INGLESES",
      "GENERAL LAVALLE",
      "LA VICTORIA",
      "LA ISOLINA",
      "PAVON",
      "LAS VIOLETAS",
      "CABRERA",
      "LA HUERTITA",
      "LA TABLADA",
      "LA COPETA",
      "COLONIA LAS MARGARITAS",
      "SANTA RITA",
      "LA LARGA",
      "ENRIQUE LAVALLE",
      "ARBOLITO",
      "SAN ALFREDO",
      "ANDANT",
      "LOUGE",
      "MOURAS",
      "LA MANUELA",
      "SANTA CLARA",
      "CORONEL MARCELINO FREYRE",
      "LA LARGA",
      "MASUREL",
      "ARBOLEDAS",
      "DAIREAUX",
      "SALAZAR",
      "LA LINDA",
      "LA PROSPERIDAD",
      "LA ARMONIA",
      "LURO",
      "EL TORO",
      "ENCINA",
      "ESTEBAN DE LUCA",
      "JUSTET",
      "LA MANUELA",
      "LA TROCHA",
      "TRES ALGARROBOS",
      "LOS ALAMOS",
      "DRYSDALE",
      "COLONIA SERE",
      "TIMOTE",
      "HUSARES",
      "CAMPO MERLO",
      "LA ARGENTINA",
      "SAN MARTIN",
      "HEREFORD",
      "EL RETIRO",
      "SANTA INES",
      "CURARU",
      "BELLA VISTA",
      "LA DIANA",
      "CARLOS TEJEDOR",
      "TIMOTE CHICO",
      "TAPIALES",
      "CIUDAD EVITA",
      "GREGORIO DE LAFERRERE",
      "RAMOS MEJIA",
      "LA TABLADA",
      "ALDO BONZI",
      "VIRREY DEL PINO",
      "VILLA LUZURIAGA",
      "ISIDRO CASANOVA",
      "RAFAEL CASTILLO",
      "VILLA EDUARDO MADERO",
      "SAN JUSTO",
      "20 DE JUNIO",
      "GONZALEZ CATAN",
      "LOMAS DEL MIRADOR",
      "PUESTO COLORADO",
      "PUEBLITOS",
      "PANELO",
      "SANTIAGO GARBARINI",
      "LUCAS MONTEVERDE",
      "EL MATE",
      "NORBERTO DE LA RIESTRA",
      "SOLACHE",
      "GOBERNADOR UGARTE",
      "SAN RAMON",
      "ARAUJO",
      "ANDERSON",
      "SAN MARCELO",
      "MAMAGUITA",
      "ERNESTINA",
      "VALDES",
      "LA TRIBU CHICA",
      "DEL VALLE",
      "AGUSTIN MOSCONI",
      "FORTIN MULITAS",
      "EL CLAVO",
      "HUETEL",
      "VILLA MARTA",
      "SAN ENRIQUE",
      "LA LLOSA Y EL MATE",
      "LA CANTORA",
      "BAUDRIX",
      "LA PALMA",
      "EL CHIMBORAZO",
      "ISLAS",
      "25 DE MAYO",
      "EL SOSIEGO",
      "PEDERNALES",
      "MARTIN BERRAONDO",
      "LAS MERCEDES",
      "AREA CINTURON ECOLOGICO",
      "GERLI",
      "SARANDI",
      "WILDE",
      "CRUCESITA",
      "PIÑEYRO",
      "AVELLANEDA",
      "DOCK SUD",
      "VILLA DOMINICO",
      "EL AMANECER",
      "LA DELIA",
      "ARROYO BURGOS",
      "SAN FRANCISCO",
      "LA BRANQUEADA",
      "EL NACIONAL",
      "MONTE LAVALLE",
      "LAS SARITAS",
      "LA LUISA",
      "LA NELIDA",
      "VIÑA",
      "TODD",
      "ARRECIFES",
      "EL CONTADOR",
      "BRISAS ALEGRES",
      "LA LOMA",
      "LAPRIDA",
      "TRES CARDOS",
      "PUEBLO NUEVO",
      "LAS HERMANAS",
      "VOLUNTAD",
      "COLONIA ARTALEJOS",
      "SANTA ELENA",
      "LA SALADA",
      "PUEBLO SAN JORGE",
      "ACHALAY",
      "LA TIGRA",
      "LA FLORENTINA",
      "LA ROTONDA",
      "LOS JACINTOS",
      "ARCE HERMANOS",
      "EL SAUCE",
      "SABBI",
      "VELLOSO",
      "CROTTO",
      "EL COMBATE",
      "SAN BERNARDO",
      "EL TUYUTI",
      "LA PALOMA",
      "CAMPODONICO",
      "YERBAS",
      "EL CASTELLANO",
      "LA PROTEGIDA",
      "EUFEMIO UBALLES",
      "EL MIRADOR",
      "ALTONA",
      "EL RETIRO",
      "QUINTAS DE TAPALQUE",
      "TAPALQUE",
      "SANTA MARTA",
      "SANTA ROSA",
      "COVELLO",
      "EL TRIANGULO",
      "FELIPE SOLA",
      "ESTELA",
      "RIVADEO",
      "LA ROSALIA",
      "VIBORAS",
      "BORDENAVE",
      "LA ANGELITA",
      "VILLA CASTELAR",
      "EL CARDAL",
      "SAN GERMAN",
      "GENERAL RONDEAU",
      "17 DE AGOSTO",
      "ARROYO SECO",
      "VILLA IRIS",
      "PUAN",
      "AZOPARDO",
      "TRES CUERVOS",
      "DARREGUEIRA",
      "LOPEZ LECUBE",
      "RUTA NACIONAL 5 KM 502",
      "LA PUA",
      "ESTACION LA CAUTIVA",
      "PELLEGRINI",
      "DE BARY",
      "BOCAYUVA",
      "PEHUELCHES",
      "COLONIA SARMIENTO",
      "ZONA RURAL DE PELLEGRINI",
      "LAS TRES MARIAS",
      "MONTE DEL TORDILLO",
      "DOLORES",
      "LAS MARGARITAS",
      "LOS SAUQUITOS",
      "LA SELVA",
      "LA VASCA",
      "EST. PANELO",
      "SOL DE MAYO",
      "AL VER VERAS",
      "DOS TALAS",
      "SEVIGNE",
      "LOMAS DE SALOMON",
      "LOMA DE ROLDAN",
      "ASCENSION",
      "ESTACION ARENALES",
      "FERRE",
      "ARRIBEÑOS",
      "COLONIA SAN MARTIN",
      "LA TRINIDAD",
      "GENERAL ARENALES",
      "CAMPO ALVEAR",
      "LA PINTA",
      "HAM",
      "DESVIO KM 95",
      "COLONIA LAS MERCEDES",
      "DELGADO",
      "SANTA ANA",
      "LA ANGELITA",
      "ROBLES",
      "LOZANO",
      "MAGNASCO",
      "LA FE",
      "GRANJA BLANCA",
      "SPERATTI",
      "MARRE",
      "VILLARS",
      "LA CHOZA",
      "GENERAL HORNOS",
      "GENERAL LAS HERAS",
      "PLOMER",
      "ENRIQUE FYNN",
      "LA DELFINA",
      "ACHAVAL",
      "ZAVALIA",
      "BAIGORRITA",
      "LOS BOSQUES",
      "CUARTEL II",
      "LA CARMEN",
      "QUIRNO COSTA",
      "LA BELLACA",
      "LOS TOLDOS",
      "LOS HUESOS",
      "LA RINCONADA",
      "SAN EMILIO",
      "CHANCAY",
      "EL MONASTERIO",
      "LOS DOS AMIGOS",
      "SAN JOSE",
      "VAGUES",
      "PUENTE CASTEX",
      "SAN ANTONIO DE ARECO",
      "LA ROSADA",
      "EL MORO",
      "CAMINO DE YAMEO",
      "EL TROPEZON",
      "VILLA LIA",
      "DUGGAN",
      "LA FE",
      "CRISOL",
      "SAN PABLO",
      "LA INVENCIBLE",
      "SANTA ISABEL",
      "CAMPO BLANCO",
      "SANTA INES",
      "SALTO",
      "SANTA ROSA",
      "ARROYO DULCE",
      "INES INDART",
      "GAHAN",
      "TACUARI",
      "EL HARAS",
      "LAS MULAS",
      "COLONIA EL RINCON",
      "BERDIER",
      "MONROE",
      "LA ISABEL",
      "EL LUCERO",
      "LA LECHUZA",
      "JOSE JUAN ALMEYRA",
      "LA RAPIDA",
      "ANASAGASTI",
      "TORRES",
      "CUARTEL IX",
      "INGENIERO WILLIAMS",
      "LA ESTRELLA",
      "LOS VASQUITOS",
      "SOL DE MAYO",
      "NAVARRO",
      "GONZALEZ RISOS",
      "LA BLANQUEADA",
      "LOS POZOS",
      "LAS MARIANAS",
      "RINGUELET",
      "LOS NOGALES",
      "KILOMETRO 83",
      "RUTA NACIONAL 200 KM 96",
      "EL FAISAN",
      "VILLA MOLL",
      "BARRIO RUTA SOL",
      "LA PLATA",
      "VILLA ELISA",
      "BARRIO LAS QUINTAS",
      "VILLA ELVIRA",
      "JOSE HERNANDEZ",
      "COUNTRY CLUB EL RODEO",
      "TRANSRADIO",
      "CITY BELL",
      "ARANA",
      "TOLOSA",
      "LOMAS DE COPELLO",
      "RINGUELET",
      "VILLA MONTORO",
      "RUFINO DE ELIZALDE",
      "JOSE MELCHOR ROMERO",
      "LA CUMBRE",
      "LA PROVIDENCIA",
      "BARRIO EL CARMEN (OESTE)",
      "MANUEL B. GONNET",
      "ARTURO SEGUI",
      "JOAQUIN GORINA",
      "ISLA MARTIN GARCIA",
      "LOS HORNOS",
      "IGNACIO CORREAS",
      "LISANDRO OLMOS",
      "VILLA GARIBALDI",
      "ABASTO",
      "VILLA PARQUE SICARDI",
      "BARRIO LAS MALVINAS",
      "POBLET",
      "ESQUINA NEGRA",
      "ANGEL ETCHEVERRY",
      "BARRIO GAMBIER",
      "EL RETIRO",
      "ALVAREZ JONTE",
      "LA VIRUTA",
      "ESTANCIA SAN RAMON",
      "BASE AERONAVAL DE PUNTA INDIO",
      "CHIRRAMBERRO",
      "VERONICA",
      "LAS TAHONAS",
      "LUJAN DEL RIO",
      "PUNTA PIEDRAS",
      "PUNTA INDIO",
      "MONTE VELOZ",
      "RANCHO BARRETO",
      "LAS PALMAS",
      "COLONIA TORNQUIST",
      "PIPINAS",
      "MICAELA CASCALLARES",
      "LA JOSEFINA",
      "LA SORTIJA",
      "EL CARRETERO",
      "LIN CALEL",
      "HUESO CLAVADO",
      "DUNAMAR",
      "EL TRIANGULO",
      "LA CONSTANCIA",
      "LA POLONIA",
      "RUTA 3 KM 489",
      "PUENTE CARUCHO",
      "LA VICTORIA",
      "LA MANGA",
      "BALNEARIO ORENSE",
      "COPETONAS",
      "TRES ARROYOS",
      "RETA",
      "RUTA 3 KM 490",
      "ORENSE",
      "CLAROMECO",
      "PUENTE SUBMARINO PERAL",
      "LA HORQUETA",
      "SAN MAYOL",
      "VILLA RODRIGUEZ",
      "COLONIA SAN JUAN DE BELLOCQ",
      "LAS VAQUERIAS",
      "SAN FRANCISCO DE BELLOCQ",
      "GENERAL LA MADRID",
      "RAULET",
      "LAS BANDURRIAS",
      "PONTAUT",
      "LA COLINA",
      "EL LUCERO",
      "SANTA ISABEL",
      "LIBANO",
      "LAS NENAS",
      "LASTRA",
      "LAS MARTINETAS",
      "ESTANCIA DON PEDRO",
      "SAN PEDRO",
      "VILLA LA ARCADIA",
      "EL 27",
      "SAN ANSELMO",
      "ESTANCIA LOLEN",
      "OMBU",
      "LA URUGUAYA",
      "SAN CARLOS",
      "PASMAN",
      "LAS GOLONDRINAS",
      "LA VENTURA",
      "SANTA MARIA",
      "EL TRIUNFO",
      "CASCADAS",
      "D'ORBIGNY",
      "CUARTEL VII",
      "HUANGUELEN",
      "SANTA ANA",
      "ZENTENA",
      "PASO DE LOS CHILENOS",
      "SANTA TRINIDAD",
      "LA PRIMAVERA",
      "LA REMONTA",
      "CORONEL SUAREZ",
      "CURA MALAL",
      "PERALTA",
      "EL RELINCHO",
      "SAN JOSE",
      "VILLA GESELL",
      "MAR AZUL",
      "MAR DE LAS PAMPAS",
      "SANTA ANA",
      "EL DESTINO",
      "LOS HUESOS",
      "SAN LORENZO",
      "LA VASCONIA",
      "LOS MIMBRES",
      "SANTA TERESA",
      "PINAR DE LA SIERRA",
      "SAN ANTONIO",
      "LA ROSADA",
      "LAS NUMANCIAS",
      "LA PORTEÑA",
      "TANDIL",
      "EL REMANSO",
      "HARAS GENERAL LAVALLE",
      "LA PASTORA",
      "BASE AEREA TANDIL",
      "LA UNION",
      "LA PACIFICA",
      "COLONIA MARIANO MORENO",
      "FULTON",
      "EL SOLCITO",
      "DE LA CANAL",
      "LA PESQUERIA",
      "AZUCENA",
      "ARROYO SECO",
      "GARDEY",
      "MARIA IGNACIA",
      "EL CENTINELA",
      "IRAOLA",
      "EL CARMEN",
      "EL GALLO",
      "EL TROPEZON",
      "FLORENCIO VARELA",
      "VILLA SANTA ROSA",
      "GOBERNADOR JULIO A. COSTA",
      "VILLA BROWN",
      "VILLA SAN LUIS",
      "LA CAPILLA",
      "BOSQUES",
      "INGENIERO JUAN ALLAN",
      "ESTANISLAO SEVERO ZEBALLOS",
      "VILLA VATTEONE",
      "GENERAL PIRAN",
      "EL JAGUEL",
      "LA BALIZA",
      "VIVORATA",
      "CAMET NORTE",
      "EL DESTINO",
      "RUTA 11 KM 480",
      "LAS ROSAS",
      "MAR CHIQUITA",
      "SANTA CLARA DEL MAR",
      "NAHUEL RUCA",
      "ESQUINA ARGUAS",
      "LOMA VERDE",
      "FRENTE MAR",
      "LA TEHUELCHE",
      "RUTA 11 KM 475",
      "LA CALETA",
      "LA ALDEA",
      "LA ARMONIA",
      "SANTA ELENA",
      "RUTA 55 KM 135",
      "ATLANTIDA",
      "PLAYA DORADA",
      "EL ESPINILLO",
      "MAR DE COBO",
      "CORONEL VIDAL",
      "CALFUCURA",
      "EL PORVENIR",
      "JUAN BAUTISTA",
      "LA SULTANA",
      "EL HINOJAL",
      "FAIR",
      "LANGUEYU",
      "LA LLEGADA",
      "CUARTEL II",
      "LAS CHILCAS",
      "SAN JOSE",
      "ESTACION NAVAS",
      "LOMA DE SANDERS",
      "SAN PASTOR",
      "UDAQUIOLA",
      "LA POSTA",
      "EL CARMEN",
      "LA LIMPIA",
      "LA FLORIDA",
      "OTEGUI",
      "LA BELGICA",
      "LA BLANQUEADA",
      "ESTANCIA LANGUEYU",
      "SAN IGNACIO",
      "LA CONSTANCIA",
      "ESQUINA LARUMBE",
      "SAN LAUREANO",
      "SAN JUSTO",
      "EL CHEFORO",
      "LAS ARMAS",
      "LA PROTEGIDA",
      "POZO DEL FUEGO",
      "EL BOQUERON",
      "SOLANET",
      "LAS PAJAS",
      "AYACUCHO",
      "CANGALLO",
      "CHACRAS DE BALESTRA",
      "LA GARITA",
      "LAS LAGUNAS",
      "ESTACION JUNCALITO",
      "LAS PIEDRAS",
      "LA CORVINA",
      "EL MONTE",
      "EL CENTINELA",
      "EL MEDANO",
      "LAS VIBORAS",
      "GENERAL CONESA",
      "VILLA ROCH",
      "CARLOS BEGUERIE",
      "LA QUERENCIA",
      "LA REFORMA",
      "EL CARDALITO",
      "LA PAZ CHICA",
      "LA PAZ",
      "EL GRAMILLAL",
      "EL DESCANSO",
      "BELLA VISTA",
      "ROQUE PEREZ",
      "SAN JOSE",
      "PASO SAN JUAN",
      "EL PAJON",
      "LA GLORIA",
      "JUAN ATUCHA",
      "JUAN TRONCONI",
      "LA ARGENTINA",
      "SAN MARTIN DEL DULCE",
      "EL SEXTO",
      "LOS MEDANOS",
      "SANTIAGO LARRE",
      "LAS TUNAS",
      "EL ARBOLITO",
      "LA MERCED"
    ]
  },
  {
    "nombre": "Catamarca",
    "localidades": [
      "LA FALDA DE SAN ANTONIO",
      "EL HUECO",
      "LA TERCENA",
      "LA CARRERA",
      "POMANCILLO",
      "VILLA LAS PIRQUITAS",
      "COLLAGASTA",
      "SAN JOSE",
      "POMANCILLO OESTE",
      "POMANCILLO ESTE",
      "SAN ANTONIO",
      "ALTO EL BOLSON",
      "LAS CUEVAS",
      "CORRAL BLANCO",
      "LAGUNA BLANCA",
      "BARRANCA LARGA",
      "VILLA VIL",
      "LAS JUNTAS",
      "LA SALVIA",
      "EL RODEO",
      "LA SOLEDAD",
      "LAMPACITO",
      "EL RECREO",
      "FUERTE QUEMADO",
      "SANTA MARIA",
      "CASPICHANGO",
      "EL CAJON",
      "LA OVEJERIA",
      "EL PUESTO",
      "LAS MOJARRAS",
      "EL CERRITO",
      "LORO HUASI",
      "RECREO",
      "OVEJERIA",
      "QUIROS",
      "ANCASTILLO",
      "PALO PARADO",
      "ANJULI",
      "EL VALLECITO",
      "LA RENOVACION",
      "SAN ANTONIO",
      "LAS ESQUINAS",
      "CABALLA",
      "LA BARRANQUITA",
      "PUERTA DE CORDOBA",
      "POZANCONES",
      "LA CERRILLADA",
      "PAMPA POZO",
      "EL TALA",
      "BAVIANO",
      "LA ALBIGASTA",
      "RIO CHICO",
      "SANTA ROSA",
      "LAS IGUANAS",
      "ESTACION KILOMETRO 1017",
      "LAS PALMITAS",
      "LA PARADA",
      "ICAÑO",
      "LAS TOSCAS",
      "LAS TEJAS",
      "BALDE DE LA PAMPA",
      "POMAN",
      "EL PAJONAL",
      "LOS CIENAGOS",
      "ILOGA",
      "LOS POZOS",
      "EL PANTANILLO",
      "EL SAUCE",
      "VILISMAN",
      "EL ALTO",
      "RIO DE AVILA",
      "TINTIGASTA",
      "LOS ALAMOS",
      "LOS CORRALES",
      "LA HUERTA",
      "SAUCE HUACHO",
      "OYOLA",
      "BELLA VISTA",
      "INFANZON",
      "GUAYAMBA",
      "LOS PEDRAZA",
      "ALTO DE LAS JUNTAS",
      "ACONQUIJA",
      "EL LINDERO",
      "LA MESADA",
      "LAS PAMPITAS",
      "AGUA DE LAS PALOMAS",
      "BUENA VISTA",
      "EL PUCARA",
      "EL ESPINILLO",
      "CONDOR HUASI",
      "PUNTA DEL AGUA",
      "RIO POTRERO",
      "EL ALAMITO",
      "LOS BAZAN",
      "LOS ANGELES NORTE",
      "COLONIA DEL VALLE",
      "PUESTO DE RUA",
      "LA PARAGUAYA",
      "HUILLAPIMA",
      "LOS CHAÑARITOS",
      "LOS ANGELES SUR",
      "SISI HUASI",
      "EL BAÑADO",
      "LOS POCITOS",
      "COLONIA NUEVA CONETA",
      "SAN PABLO",
      "CONETA",
      "MIRAFLORES",
      "EL PORTEZUELO",
      "EL BAÑADO",
      "ANTAPOCA",
      "LOS ARBOLITOS",
      "SAN ISIDRO",
      "SANTA CRUZ",
      "SANTA ROSA",
      "AGUA COLORADA",
      "POZO DEL MISTOL",
      "LAS ESQUINAS",
      "VILLA DOLORES",
      "SUMALAO",
      "LAS TEJAS",
      "POLCOS",
      "HUAYCAMA",
      "LA PUNTILLA",
      "TALAMAYO",
      "LA REPRESA",
      "BARRIO ARTAZA",
      "HUACO",
      "BELEN",
      "LAS LOMAS",
      "LUNA AGUADA",
      "AMPUJACO",
      "EL POZO",
      "LOS MOLLES",
      "SAN FRANCISCO",
      "LOS MOGOTES",
      "EL COMEDERO",
      "EL MOJON",
      "LA MAJADA",
      "IPIZCA",
      "AMANA",
      "CONCEPCION",
      "SAN JOSE",
      "LA FALDA",
      "EL SAUCE",
      "NAVAGUIN",
      "ANCASTI",
      "ANQUINCILA",
      "POTRERO DE LOS CORDOBA",
      "EL HUAYCO",
      "LA CANDELARIA",
      "CASA ARMADA",
      "RIO CHICO",
      "TACANA",
      "LAS JUNTAS",
      "RINCO DE IPIZCA",
      "YERBA BUENA",
      "EL TALITA",
      "EL QUEBRACHAL",
      "LA ESTANCITA",
      "LOS BULACIOS",
      "EL TACO",
      "POZO LINDO",
      "SAN PEDRO",
      "TRAMPASACHA",
      "CONCEPCION",
      "TELARITOS",
      "CAPAYAN",
      "EL MILAGRO",
      "EL QUEMADO",
      "CARRANZA",
      "LAS ANIMAS",
      "LA LIBERTAD",
      "EL CARRIZAL",
      "BALDE DE LA PUNTA",
      "SAN MARTIN",
      "ADOLFO E. CARRANZA",
      "PUESTO NUEVO",
      "LAS PALMAS",
      "LAS BREAS",
      "CHUMBICHA",
      "LA HIGUERA",
      "TIERRA VERDE",
      "LAS LAJAS",
      "VILLA DE BALCOZNA",
      "PALO LABRADO",
      "SUMAMPA",
      "LA MERCED",
      "MONTE POTRERO",
      "SAN ANTONIO",
      "EL BASTIDOR",
      "LA VIÑA",
      "VILLA COLLANTES",
      "SANTA BARBARA",
      "EL ROSARIO",
      "AMADORES",
      "BARRO NEGRO",
      "LA BAJADA",
      "SAN FERNANDO",
      "SAN FERNANDO NORTE",
      "EL EJE",
      "EL DURAZNO",
      "CAMPO DE LAS CALIVAS",
      "PUERTA DE CORRAL QUEMADO",
      "EL TOLAR",
      "LOCONTE",
      "JACIPUNCO",
      "SAN NICOLAS",
      "EL MILAGRO",
      "PORTILLO CHICO",
      "SAN PEDRO",
      "LA ANTIGUA",
      "EL CERRITO",
      "ESQUIU",
      "SAN AGUSTIN",
      "RIO DE LA DORADA",
      "PALO CRUZ",
      "EL CHAGUARAL",
      "LA SUERTE",
      "SANTO DOMINGO",
      "EL AYBAL",
      "EL BOSQUECILLO",
      "POZO DE LA ORILLA",
      "SANTA LUCIA",
      "LA QUINTA",
      "MARIA ELENA",
      "RECREO",
      "ESTACION KILOMETRO 969",
      "SAN ISIDRO",
      "EL CERCADO",
      "LA ZANJA",
      "RIO DEL MISTOLITO",
      "RAMBLONES",
      "EL DIVISADERO",
      "LA HORQUETA",
      "GARAY",
      "LA DORADA",
      "EL ROSARIO",
      "SAN SALVADOR",
      "LAS FLORES",
      "PALO CRUZ DE ABAJO",
      "SAN RAFAEL",
      "PALO SANTO",
      "EL DIQUE",
      "EL CLERIGO",
      "SAN BERNARDO",
      "EL MISTOLITO",
      "CASA DE PIEDRA",
      "LA GUARDIA",
      "EL QUIMILO",
      "SANTA MARTA",
      "EL JUMEAL",
      "EL BAÑADO",
      "EL MORENO",
      "LA HORQUETA DE ARRIBA",
      "SAN LORENZO",
      "SAN MIGUEL",
      "SAN JOSE",
      "LAS TUNAS",
      "DOS POCITOS",
      "POZO DEL BAJO",
      "LAS CAÑAS",
      "PUESTO DEL MEDIO",
      "SAN PEDRO",
      "LAS HIGUERITAS",
      "LAVALLE",
      "SALAUCA",
      "BAÑADO DE OVANTA",
      "CORTADERAS",
      "POZO DEL CAMPO",
      "AMPOLLA",
      "ALTA GRACIA",
      "CAMPO ALEGRE",
      "EL QUEBRACHITO",
      "SAN PEDRO",
      "LA ISLA",
      "BANDA DE LUCERO",
      "CACHIYUYO",
      "COSTA DE REYES",
      "SANTA CRUZ",
      "LOS BALVERDIS",
      "LA AGUADITA",
      "VINQUIS",
      "TINOGASTA",
      "VILLA LUJAN",
      "LAS HIGUERITAS",
      "EL SALADO",
      "EL PUESTO",
      "EL PUEBLITO",
      "COPACABANA",
      "ANILLACO",
      "VILLA SAN ROQUE",
      "RIO COLORADO",
      "CERRO NEGRO",
      "CORDOBITA",
      "LOS PALACIOS",
      "SANTA ROSA",
      "LA PUNTILLA",
      "LAS CHACRAS",
      "LOS ROBLEDOS",
      "EL DURAZNO",
      "SAN MIGUEL",
      "PUERTA GRANDE",
      "LOS ALTOS",
      "LA BAJADA",
      "EL ABRA",
      "LOS TRONCOS",
      "ALIJILAN",
      "MANANTIALES",
      "MONTE REDONDO",
      "LOS MOLLES",
      "CUCHINOQUE",
      "CHAQUIAGO",
      "AMANAO",
      "HUACO",
      "ANDALGALA",
      "LA AGUADA",
      "MINA CAPILLITAS",
      "EL COLEGIO",
      "BARRANCA MOLLE",
      "VIS VIS",
      "LA ISLA",
      "EL QUEMADO",
      "AGUA VERDE",
      "EL POTRERO",
      "CHOYA",
      "EL TALA",
      "SAN FERNANDO DEL VALLE DE CATAMARCA",
      "LA CALERA",
      "LA GRUTA",
      "EL PANTANILLO",
      "VILLA SAN JOSE",
      "LA AGUADA",
      "SAN ANTONIO",
      "LONDRES",
      "LORO HUASI",
      "COLPES",
      "ISLA LARGA",
      "LA PUERTA",
      "HUAYCAMA",
      "LA PUERTA SUD",
      "POZO DE PIEDRA",
      "LA ESTANCIA",
      "PIEDRA LARGA",
      "LAS VALLAS",
      "LAS BARRANCAS",
      "CONDOR HUASI",
      "LAS GRANADILLAS",
      "LA TOMA",
      "LAS JUNTAS",
      "LA AGUADA DE LA TOMA",
      "EL CAJON",
      "PAPA CHACRA",
      "HUASI CIENAGA",
      "CULAMPAJA",
      "CUESTA DE VICUÑA PAMPA",
      "ZARCITO",
      "LA CUESTA",
      "MINAS DE CULAMPAJA",
      "CORRAL QUEMADO",
      "RODEO GERVAN",
      "SAN JOSE VILLA",
      "LA HOYADA",
      "SAN JOSE BANDA",
      "CHAÑAR PUNCO",
      "SAN JOSE NORTE",
      "LOS SALTOS",
      "PALO SECO",
      "PALOMA YACO",
      "MEDANITOS",
      "QUEBRADA DE JUJUY",
      "EL DESMONTE",
      "YAPES",
      "FAMABALASTO",
      "AMPAJANGO",
      "LA LOMA",
      "CASA DEL CAMPO",
      "EL VOLCAN",
      "AGUA AMARILLA",
      "LA QUEBRADA",
      "CASA DE PIEDRA",
      "ENTRE RIOS",
      "PUNTA DE BALASTO",
      "FAMATANCA",
      "ANDALHUALA",
      "EL TESORO",
      "PAJANGUILLO",
      "LA PUNTILLA",
      "LOS CERRILLOS",
      "RIO DE LAS CASAS VIEJAS",
      "LOS TALAS",
      "LAS CHACRITAS",
      "LOS CASTILLOS",
      "CHUCHUCARUANA",
      "HUMAYA",
      "SINGUIL",
      "LOS VARELA",
      "EL BOLSON",
      "LAS QUINUAS",
      "ANTOFALLITA",
      "ANTOFAGASTA DE LA SIERRA",
      "LAS CUEVAS",
      "EL PEÑON",
      "LOS NACIMIENTOS",
      "INCAHUASI",
      "ANTOFALLA",
      "LA CIENAGA REDONDA",
      "CARACHI PAMPA",
      "MUTQUIN",
      "COLANA",
      "APOYACO",
      "COLPES",
      "LA PERLA",
      "ZAPICRUZ",
      "GUANACO YACO",
      "LAS CASITAS",
      "EL POTRERO DE SAUJIL",
      "RINCON",
      "SIJAN",
      "PIPANACO",
      "SAN MIGUEL",
      "TUCUMANAO",
      "SAUJIL",
      "MADERERA SAN ANTONIO",
      "JOYANGO",
      "SAN JOSE DE COLPES",
      "CHISTIN",
      "PUERTA DE SAN JOSE",
      "EL CARRIZAL",
      "LA CIENAGA DE ABAJO",
      "LA CIENAGA DE ARRIBA",
      "LA CIENAGA",
      "LA AGUADITA",
      "ASAMPAY",
      "HUALFIN",
      "RIO DE LAS CUEVAS",
      "LOS NACIMIENTOS",
      "QUEBRADA DE HUALFIN",
      "FARALLON NEGRO",
      "LA TUNA",
      "ALBIGASTA",
      "ACHALCO",
      "LOS MORTEROS",
      "LOS OSORES",
      "AYAPASO",
      "TAPSO",
      "PUERTA DE MOLLE YACO",
      "LA CALERA",
      "CIENAGA GRANDE",
      "RIO GRANDE",
      "LAS PAPAS",
      "MEDANITOS",
      "LA CHILCA",
      "CORRAL DE PIEDRA",
      "LA BANDA",
      "FIAMBALA",
      "PALO BLANCO",
      "EL RETIRO",
      "LA CIENAGA",
      "LA PUERTA DE TATON",
      "CASA DE ALTO",
      "ANTINACO",
      "TATON",
      "CHUQUISACA",
      "AGUA NEGRA",
      "PUNTA DEL AGUA",
      "LA RAMADITA",
      "LA SOLEDAD",
      "SAUJIL",
      "PAMPA BLANCA"
    ]
  },
  {
    "nombre": "Chaco",
    "localidades": [
      "LA ESCONDIDA",
      "KILOMETRO 548",
      "COLONIA EL CACIQUE LLORON",
      "LEGUA 41",
      "GANCEDO",
      "LA BOLSA",
      "PAMPA LA PORTEÑA",
      "CORZUELA NORTE",
      "SAN ANTONIO",
      "COLONIA JUAN LAVALLE",
      "PAMPA ZAPPA",
      "COLONIA SAN LORENZO",
      "CAMPO CANTON",
      "PAMPA ALSINA",
      "CORZUELA",
      "ENRIQUE URIEN",
      "LA VIRUELA",
      "LA MANUELA",
      "LA CARLOTA",
      "EL PALMAR",
      "GUEMES",
      "LA ARMONIA",
      "EL QUEBRACHO",
      "LOTE 126",
      "EL DESCANSO",
      "LA GRINGA",
      "LOS CIENAGOS",
      "4 DE FEBRERO",
      "LOS PEREYRAS",
      "TORRE DEL MIRADOR",
      "MONTE CASEROS",
      "POZO EL ZAPALLAR",
      "EL MOJO",
      "CRUCE PEÑALOZA",
      "LAS MARGARITAS",
      "ROSALES",
      "CENTRAL NORTE",
      "POZO DE LA PAVA",
      "LAS CUATRO BOCAS",
      "EL MILAGRO",
      "LOS PLACERES",
      "POZO DE LA MULA",
      "MANANTIALES",
      "LA ESMERALDA",
      "POZO DEL NEGRO",
      "BALBUENA",
      "MIRAFLORES",
      "EL RETIRO",
      "CAMPO LA CHINA",
      "LA MEDIA LUNA",
      "1° DE MAYO",
      "PASO DE LA CRUZ",
      "LOTE 76",
      "SANTA VICTORIA",
      "PALO MARCADO",
      "TECHAT",
      "LOTE 71",
      "LAS PUERTAS",
      "POZO LA GRINGA",
      "EL CAÑON",
      "LAS HACHERAS",
      "LOS QUIRQUINCHOS",
      "YAPEYU",
      "LA CHEOGUE",
      "NUEVA UNION",
      "BAJADA ALTA",
      "EL ALGARROBO",
      "BAJO HONDO",
      "EL QUEBRACHO BALEADO",
      "SAN LORENZO",
      "LOS ROSALES",
      "EL ESPINILLO",
      "NUEVA POMPEYA",
      "LAPACHITO",
      "COLONIAS UNIDAS",
      "COLONIA ABORIGEN CHACO",
      "COLONIA ABORIGEN",
      "PUERTO EVA PERON",
      "LA ESTELA",
      "CORONEL DU GRATY",
      "EL CABURE",
      "LOS FORTINES",
      "COLONIA LA AVANZADA",
      "CAMPO UGARTE",
      "EL PALMAR",
      "LAS GOLONDRINAS NORTE",
      "COLONIA LA COLORADA",
      "GOLONDRINAS SUR",
      "SELVAS DEL RIO DE ORO",
      "CAMPO ANTONIELI",
      "LOMA FLORIDA",
      "LA EDUVIGIS",
      "LA BLANCA",
      "LA TEXTIL",
      "RESERVA FISCAL",
      "LOTE 51",
      "LOTE 18",
      "EL PALMAR",
      "BARRANQUERAS",
      "COLONIA SURIZ",
      "LAGUNA BLANCA",
      "LA CLOTILDE",
      "COLONIA GENERAL URQUIZA",
      "COLONIA N. AVELLAN",
      "EL TABACAL",
      "COLONIA JOSE MARMOL",
      "PUEBLO CLODOMIRO DIAZ",
      "COLONIA LA CHAQUEÑA",
      "COLONIA PEGOURIEL",
      "MESON DE FIERRO",
      "LOTE 11",
      "LOTE 88",
      "EL PASTORIL",
      "COLONIA JUAN JOSE PASO",
      "LOTE 20",
      "VILLA ANGELA",
      "COLONIA PASTORIL",
      "COLONIA BRANDSEN SUR",
      "COLONIA BRANDSEN NORTE",
      "GUAYAIBI",
      "COLONIA HIPOLITO VIEYTES",
      "COLONIA SANTA ELENA",
      "PRESIDENCIA DE LA PLAZA",
      "CUATRO ARBOLES",
      "FORTIN AGUILAR",
      "LOTE 19",
      "VILLA BERTHET",
      "LOTE 15",
      "LOTE 5",
      "LOTE 21",
      "LOTE 20",
      "LOTE 18",
      "LOTE 17",
      "COLONIA SAN MIGUEL",
      "MARGARITA BELEN",
      "COSTA INE",
      "COLONIA AMADEO",
      "LA LEONESA",
      "QUIA",
      "RINCON DE LUNA",
      "MAIPU",
      "RINCON DEL ZORRO",
      "LAPACHO",
      "COLONIA BENITEZ",
      "BARRIO DE LOS PESCADORES",
      "PUENTE SAN PEDRO",
      "CAMPO ROSSI",
      "ISLA ANTEQUERA",
      "TRES HORQUETAS",
      "LOTE 1",
      "LAGUNA LIMPIA",
      "CAMPO PHILIPON",
      "MAKALLE",
      "NAPENAY",
      "LOTE 27",
      "ITIN",
      "EL ÑANDUBAY",
      "COLONIA TAÑIGO II",
      "EL JACARANDA",
      "LOTE 14",
      "LOTE 40",
      "TAÑIGO",
      "COLONIA PUERTA DEL LEON SUR",
      "COLONIA JACARANDA II",
      "COLONIA CAMPO HERMOSO",
      "EL TIZON",
      "LOTE 33",
      "LOTE 15",
      "HERMOSO CAMPO",
      "COLONIA PUERTA DEL LEON",
      "LOTE 19",
      "ESTACION GENERAL OBLIGADO",
      "VILLA JALON",
      "KILOMETRO 519",
      "PUERTO TIROL",
      "UNITAN",
      "LA LUCINDA",
      "CAMPO MEDINA",
      "PRESIDENCIA ROCA",
      "CAMPO NUEVO",
      "PAMPA CHICA",
      "EL PALMAR CHICO",
      "PATO REAL",
      "PAMPA NARDELLI",
      "EL 42",
      "LOTE 20",
      "RIO MUERTO",
      "EL BOQUERON",
      "LAS GOMAS",
      "COLONIA VELEZ SARSFIELD",
      "ESTACION KILOMETRO 884",
      "PAMPA PALANGANA",
      "PAMPA LAGLAIVE",
      "LOTE 12 CHICO",
      "LOTE 18",
      "EL 50",
      "LA LLAVE",
      "2 DE ABRIL",
      "EL MARTILLO",
      "TOUNDAIAN",
      "PAMPA DEL GALLO",
      "ESTACION KILOMETRO 841",
      "LOTE 10",
      "TRES ISLETAS",
      "CABA ÑARO",
      "LA PELIGROSA",
      "COLONIA TACURUZAL",
      "PAMPA SENA",
      "PAMPA GHAN",
      "LA MATANZA",
      "EL AGUACERITO",
      "LA CURVA",
      "EL MONTE QUEMADO CHICO",
      "EL QUEMADO GRANDE",
      "LA MEDIA LUNA",
      "COLONIA PAMPA ALELAL",
      "EL 45",
      "PAMPA AGUARA",
      "LA RINCONADA",
      "CAMPO WINTER",
      "CAMPO LA AURORA",
      "EL SOMBRERITO",
      "COLONIA SAN ISIDRO",
      "LOTE 540",
      "CAMPO PITTERI",
      "PUERTO ZAPALLAR",
      "TRES BANDERAS",
      "LA PALMIRA",
      "EL LUNAR",
      "COLONIA ZAPALLAR NORTE",
      "PUESTO EXPEDICION",
      "LOTE 92",
      "COLONIA OESTE",
      "COSTA GUAYCURU",
      "GENERAL JOSE DE SAN MARTIN",
      "LEGUA 131",
      "CAMPO ROFFO",
      "LOTE 532",
      "BUENA VISTA",
      "SIETE ARBOLES",
      "EL CORRENTOSO",
      "COLONIA ESPERANZA",
      "CAMPO BLANCO",
      "CAMPO ARAOZ",
      "LAGUNA LOBO",
      "EL FISCALITO",
      "COLONIA ALCALA",
      "COLONIA SAN FRANCISCO",
      "LOTE 551",
      "VILLA JARDIN",
      "RINCON DEL RIO DE ORO",
      "LOS PALMARES",
      "COLONIA BARANDA",
      "RESISTENCIA",
      "LA QUERENCIA",
      "COLONIA TACUARI",
      "EL SALADO",
      "COLONIA GENERAL ARENALES",
      "LOTE 24",
      "PAMPA OMBU",
      "LOTE 39",
      "COLONIA LA TAMBORA",
      "EL RINCON",
      "PAMPA VERDE",
      "PASO DEL OSO",
      "LOS BLANQUIZALES",
      "COLONIA TRES PALMAS",
      "COLONIA URIBURU",
      "LA LOMITA",
      "COLONIA LA LOLA",
      "LA ESPERANZA",
      "COLONIA BLAS PARERA",
      "PAMPA BANDERA",
      "PUEBLO VIEJO",
      "LOTE 38",
      "COLONIA GUALTIERI",
      "SANTA MARTA",
      "LOTE 22",
      "CAMPO RIAÑO",
      "EL MARTILLO",
      "EL TOTORAL",
      "MACHAGAI",
      "NAPALPI",
      "COLONIA GENERAL LAMADRID",
      "LOMA ALTA",
      "LA DORILA",
      "PARALELO 28",
      "EL SALADILLO",
      "COLONIA PALMIRA",
      "LAS MERCEDES",
      "KILOMETRO 34",
      "BASAIL",
      "PLAYA FORD",
      "ARBOL SOLO",
      "ESTANCIA DON OVIDIO",
      "COTE LAI",
      "ESTANCIA EL 38",
      "NUEVA YORK",
      "SANTA RITA",
      "LA SARA",
      "LOTE 34",
      "SAN LUIS",
      "EL INDIO",
      "EL LEBRETON",
      "CHACO PORA",
      "URUNDEL",
      "LA PINTA",
      "CASTELLI",
      "SANTA LUCIA",
      "EL VALLE",
      "SAN JOSE",
      "SAN ANTONIO",
      "9 DE JULIO",
      "EL QUINTO",
      "LOS MAGOS",
      "LAS CARPAS",
      "MADRE DE DIOS",
      "SAN MARTIN",
      "LA ILUSION",
      "SOL DE MAYO",
      "LUJAN",
      "LA AGUADA",
      "SANTA AGUEDA",
      "LOS TOBAS",
      "TACO POZO",
      "EL PARAISO",
      "ALTA ESPERANZA",
      "SANTA ELENA",
      "LA PROVIDENCIA",
      "SAN AGUSTIN",
      "LA CHINA",
      "LA PALOMA",
      "LIBERTAD",
      "POZO HONDO",
      "EL BRASIL",
      "LA ARGENTINA",
      "SAN TELMO",
      "LOS TIGRES",
      "LAS FLORES",
      "PRIMAVERA",
      "SANTA CRUZ",
      "KILOMETRO 27",
      "EL PINTADO",
      "EL ROSILLO",
      "OJO DE AGUA",
      "PUERTO VILELAS",
      "EL NARANJITO",
      "ISLA SOTO",
      "SANTA ROSA",
      "LA TRANQUILIDAD",
      "RIO MUERTO",
      "LAS DELICIAS",
      "PALO BLANCO",
      "LOS FRENTONES",
      "CUATRO BOCAS",
      "EL ARENAL",
      "PAMPA QUIMILI",
      "COLONIA WELBERS SUR",
      "CAMPO MARCELINO UGARTE",
      "GENERAL CAPDEVILA",
      "PAMPA JUANITA",
      "LA RALERA",
      "EL SILENCIO",
      "LOTE 30",
      "CONCEPCION DEL BERMEJO",
      "PAMPA VIRGEN",
      "PAMPA CUVALO",
      "PAMPA EL MANGRULLO",
      "PAMPA GRANDE",
      "COLONIA PAMPA UNION",
      "COLONIA PAMPA BOLSA SUR",
      "PAMPA PEREYRA",
      "LA ENTRERRIANA",
      "COLONIA LA FLORIDA",
      "CIERVO PETISO",
      "VICENTINI",
      "FONTANA",
      "VILLA ORO",
      "PALMAR NORTE",
      "COLONIA BRAVO",
      "MESON DE FIERRO",
      "COLONIA SAN ANTONIO",
      "PAMPA GALVAN",
      "PAMPA GONZALEZ",
      "PINEDO VIEJO",
      "LAS LEONAS",
      "PAMPA DOROTIER",
      "PAMPA SCHMIDT",
      "GENERAL PINEDO",
      "LA PICADA",
      "EL PALMAR",
      "PAMPA LANDRIEL",
      "CAMPO GRANDE",
      "EL PARAISO",
      "NUEVA POBLACION",
      "ALTO ALEGRE",
      "PASO DE LOS LIBRES",
      "GENERAL ROCA",
      "POZO DEL SAPO",
      "POZO EL TOBA",
      "LAGUNA ARAUJO",
      "LA SALVACION",
      "EL PALO SANTO 2",
      "POZO DEL MATACO",
      "LA ENSENADA",
      "SAN JUANCITO",
      "MONTEVIDEO",
      "LA FLOJERA",
      "LA FIDELIDAD",
      "EL TRIUNFO",
      "SANTA MARIA",
      "M. KOLBAS",
      "SANTO DOMINGO",
      "EL PALO SANTO",
      "POZO DE LOS SURIS",
      "POZO DEL GATO",
      "SANTO TOMAS",
      "POZO DEL GRIS",
      "EL POLENON",
      "LA ENTRADA",
      "LOS MADREJONES",
      "EL RECREO",
      "PALO FLOJAL",
      "LA NACION",
      "BAJOS DE ALVARADO",
      "LA MESADA",
      "CALIFORNIA",
      "EL ATENTO",
      "LA FORTUNA",
      "LA BARRACA",
      "POZO DEL SALADO",
      "POZO LA OSCA",
      "LAS BLANCAS",
      "FUERTE ESPERANZA",
      "NUEVO",
      "LOTE 3",
      "LOTE 25",
      "LOTE 23",
      "SAMUHU",
      "LOTE 14",
      "LOTE 8",
      "LOTE 4",
      "COLONIA EL TOBA",
      "LA CHIQUITA NORTE",
      "PRESIDENCIA ROQUE SAENZ PENA",
      "PAMPA GALPON",
      "LOTE XVII",
      "PAMPA GAMBA",
      "PAMPA ALEGRIA",
      "COLONIA CERVEZA HELADA",
      "PAMPA LOCA",
      "COLONIA PAMPA ALEGRIA",
      "COLONIA BAJO HONDO CHICO",
      "BAJO HONDO GRANDE",
      "LA POBLADORA",
      "LA MASCOTA",
      "COLONIA BAJO HONDO",
      "COLONIA NAPENAY",
      "ENSANCHE NORTE",
      "COLONIA SARMIENTO",
      "COLONIA RIVADAVIA",
      "EL TOROLTAY",
      "ZAPARINQUI",
      "EL JURAMENTO",
      "PAMPA LOS BEDOGNI",
      "SIMBOLAR",
      "EL ÑANDU",
      "CAMPO FLORIDO",
      "PAMPA TOLOSA CHICA",
      "PAMPA NUEVA",
      "LA GLORIA",
      "LAS DELICIAS",
      "POZO COLORADO",
      "PAMPA SAN MARTIN",
      "MONTE REDONDO",
      "CAMPO BEDOGNI",
      "CAMPO DE MAYO",
      "EL RINCON DICHOSO",
      "EL CUARENTA Y CUATRO",
      "LA SOLEDAD",
      "LAS VERTIENTES",
      "PAMPA ALMIRON",
      "PUERTA NEGRA",
      "JUAN JOSE CASTELLI",
      "LA GERONIMA",
      "PAMPA TOLOSA",
      "MIRAMAR",
      "LOS MILAGROS",
      "EL DESTIERRO",
      "COLONIA MONTE QUEMADO",
      "PAMPA CASTRO",
      "LA SELVA",
      "EL ESCONDIDO",
      "MONTE QUEMADO",
      "POZO DE LA TUNA",
      "OLLA QUEBRADA",
      "EL TELASCO",
      "COLONIA LA FLORIDA GRANDE",
      "EL PARAISAL",
      "SAN MANUEL",
      "LA NUEVA UNION",
      "LA MORA",
      "RIO MUERTO CRUZ",
      "LA INDIANA",
      "CAMPO DEL ALTO",
      "POZO DEL BAYO",
      "POZO DEL TORO",
      "LA FLORIDA",
      "LA RINCONADA",
      "VIBORAS BLANCAS",
      "EL ÑANDUBAY",
      "SAN VICENTE",
      "COSTA RICA",
      "PAMPA LA CRUZ",
      "SAN AGUSTIN",
      "TOLDERIAS",
      "LA ESPERANZA",
      "LAS MARAVILLAS",
      "EL GRAMILLAR",
      "EL ASUSTADO",
      "BELLA VISTA",
      "PASO SOSA",
      "ALBERDI",
      "SAN LUIS",
      "LOS POTREROS",
      "EL CORREDERO",
      "EL COLCHON",
      "SAN JOSE",
      "LAS PALOMAS",
      "LA ARGENTINA",
      "EL ALGARROBAL",
      "EL ESTANQUE",
      "PAMPA MACHETE",
      "EL PALOMO",
      "EL ZANJON",
      "LA UNION",
      "SANTA CARMEN",
      "LAS TUNILLAS",
      "EL PROGRESO",
      "LA BOLSA",
      "COLONIA CRUCE VIEJO",
      "LA CHOZA",
      "COLONIA POPULAR",
      "ARROYO SALADILLO",
      "PUERTO BASTIANI",
      "LOTE 149",
      "LA SABANA",
      "HAUMONIA",
      "HORQUILLA",
      "KILOMETRO 25",
      "CHARADAI",
      "RIO TAPENAGA",
      "ESTANCIA LAS UNIDAS",
      "QUIJANO",
      "LA VERDE",
      "COLONIA EL 54",
      "MAKALLE VIEJO",
      "SALTO DE LA VIEJA",
      "TRES CEIBOS",
      "LA PASTORIL",
      "LEGUA  54",
      "LOTE 6",
      "LOTE 7",
      "CAPITAN SOLARI",
      "LOTE 20",
      "CAMPO NOVO",
      "CAMPO GRANDE",
      "COLONIA MIXTA",
      "CAMPO QUIJANO",
      "KILOMETRO 575",
      "ESTANCIA LA FORTUNA",
      "MONGAY",
      "LIMITA",
      "LAS PALMAS",
      "LA ISLA",
      "EL PUERTO",
      "EL PALMAR",
      "CANCHA LARGA",
      "LOTE 9",
      "COLONIA LA DIFICULTAD",
      "PASO DEL OSO",
      "PAJARO BLANCO",
      "LOTE 21",
      "LAS GARCITAS",
      "CAMPO DEL BLANCO",
      "INDIO MUERTO",
      "COLONIA EL CACIQUE",
      "COLONIA ELISA",
      "INGENIERO BARBET",
      "COLONIA MARIANO SARRATEA",
      "LOTE 13",
      "LOTE 9",
      "LOTE 29",
      "AVIA TERAI",
      "LOTE 8",
      "LOTE 14",
      "PAMPA VERDE",
      "PAMPA LA DESATINADA",
      "PAMPA DEL INFIERNO",
      "PAMPA HERMOSA",
      "COLONIA GENERAL LAVALLE",
      "PAMPA SOMMER",
      "PAMPA BARRERA",
      "PAMPA PAEZ",
      "PAMPA AVILA",
      "CHARATA",
      "PAMPA CABRERA",
      "PAMPA MORENO",
      "PAMPA CEJAS",
      "EL FISCO",
      "TRES ESTACAS",
      "COLONIA GENERAL NECOCHEA",
      "PAMPA ROLDAN",
      "PAMPA DEL CIELO",
      "PAMPA GALVAN",
      "LAS TOLDERIAS",
      "LAGUNA DEL SARGENTO",
      "PAMPA MATADERO",
      "INDIA MUERTA",
      "2 DE MAYO",
      "LOS CERRITOS",
      "PAMPA LEGUIZAMON",
      "COLONIA GENERAL NECOCHEA",
      "PAMPA BRUGNOLI",
      "EL TRIANGULO",
      "LA SELVA",
      "PAMPA CASTRO",
      "RECOVECO",
      "CAMPO CANTON",
      "PAMPA SAN MARTIN",
      "PAMPA DEL ZORRO",
      "EL ESTERO",
      "EL PUCA",
      "PAMPA GOMEZ",
      "LAS BREÑAS",
      "PAMPA SUAREZ",
      "LA ESTERLINA",
      "PAMPA HERMOSA",
      "CURVA DE NOVOA",
      "PAMPA SANDI",
      "EL ARENAL",
      "LOTE NORASSI",
      "LOS ARENALES",
      "COLONIA JUAN LAVALLE",
      "PAMPA MITRE",
      "LAS PIEDRITAS",
      "PAMPA CARNEVALE",
      "PAMPA IPORA GUAZU",
      "SANTA ELENA",
      "SANTA JUSTINA",
      "EL ÑANDUBAY",
      "COLONIA EL URUNDAY",
      "LAS AJENAS",
      "CAMPO LAS PUERTAS",
      "COLONIA CAMPO DEL BANCO",
      "COLONIA JACARANDA SUR",
      "SANTA SYLVINA",
      "TARTAGAL",
      "LOS BARRILES",
      "LA ZANJA",
      "EL CEBILAR",
      "WICHI",
      "EL COLORADO",
      "LA ESTACION",
      "CAMPO NOGUERA",
      "MOLLE MARCADO",
      "POZO DEL TALA",
      "TRES POZOS",
      "EL QUEBRACHAL",
      "EL TIMBO",
      "BAJO VERDE",
      "EL BALLADO",
      "POZO DEL ANTA",
      "SANTA RITA",
      "VINALITO",
      "LAGUNITA",
      "LAGUNA AYARDE",
      "POZO EL GALLO",
      "POZO DEL CINCUENTA",
      "BOLSA GRANDE",
      "GENERAL MITRE",
      "POZO DEL TIGRE",
      "CORRALITO",
      "FORTIN BELGRANO",
      "EL SAUZAL",
      "POZO CERCADO",
      "LAS FLORES",
      "LA INVERNADA",
      "LA COSTOSA",
      "POZO LA BREA",
      "EL SAUZALITO",
      "POZO LARGO",
      "DIEZ DE MAYO",
      "LOTE 39",
      "FORTIN LAVALLE",
      "PUERTO LAVALLE",
      "COLONIA EL ALAZAN",
      "BERLIN",
      "VILLA RIO BERMEJITO",
      "EL CRUCE",
      "TRES MOJONES OESTE",
      "TRES MOJONES ESTE",
      "VENADOS GRANDES",
      "ESTANCIA EL AGUARAY",
      "COLONIA CABEZA DE TIGRE",
      "CHOROTIS",
      "TRES MOJONES",
      "EL ATAJITO",
      "ISLA DEL CERRITO",
      "LOTE FISCAL 16",
      "LOMA ALTA",
      "GUAYCURU",
      "LAS ROSAS",
      "CABRAL CUE",
      "SAN CARLOS",
      "GENERAL VEDIA",
      "TACUARI",
      "EL RETIRO",
      "LOTE 11",
      "LA CUCHILLA",
      "LOTE 12",
      "LA TIGRA",
      "COLONIA DOMINGO MATHEU",
      "LOTE 13",
      "LOTE 5",
      "LOTE 10",
      "LOTE 1",
      "LA SIRENA",
      "SAN BERNARDO",
      "LOTE 6",
      "PAMPA ALMIRON",
      "KILOMETRO 62",
      "PAMPA OCULTA",
      "CAMPO LARGO",
      "LOTE 49",
      "FORTIN LAS CHUÑAS",
      "LOTE 33",
      "LOTE 50",
      "CUARTA LEGUA",
      "CAMPO ALEMANY",
      "LA LEONOR",
      "LOTE 4",
      "COLONIA TRES LAGUNAS",
      "LOTE AGRICOLA 82",
      "TRES LAGUNAS",
      "FORTIN BROWN",
      "COLONIA EL CIERVO",
      "PUEBLO VIEJO",
      "SANTA RITA",
      "LA LOMA",
      "CAMPO LOS TOROS",
      "LAS CHUÑAS",
      "COLONIA OMBU",
      "LOTE 96",
      "EL SALVAJE",
      "PAMPA DEL INDIO",
      "CANCHA LARGA",
      "EL TACURUZAL",
      "SANTOS LUGARES",
      "COLONIA MIXTA",
      "LAS BRAVAS",
      "NUEVA POBLACION",
      "COLONIA BLAS PARERA",
      "QUITILIPI",
      "LA TAMBORA",
      "VILLA EL PALMAR",
      "COLONIA EL PARAISAL",
      "RESERVA FERROCARRIL",
      "ESTACION LA CHIQUITA",
      "PAMPA BANDERA",
      "CACIQUE DOMINGA",
      "PAMPA LEGUA CUATRO",
      "COLONIA GENERAL PAZ",
      "COLONIA TACURUZAL",
      "PAMPA VERDE",
      "LA MATANZA",
      "EL ZANJON",
      "CAMPO FELDMAN",
      "BAJO HONDO CHICO",
      "PAMPA ESPERANZA",
      "COLONIA URIBURU",
      "PUERTO BERMEJO NUEVO",
      "TRES HORQUETAS",
      "PUERTO BERMEJO VIEJO",
      "COLONIA SAN EDUARDO",
      "COLONIA MIRASOL"
    ]
  },
  {
    "nombre": "Chubut",
    "localidades": [
      "CARRENLEUFU",
      "LAGO BLANCO",
      "28 DE JULIO",
      "CAMPAMENTO VILLEGAS",
      "EL RINCON",
      "EL BLANCO",
      "EL CAJON",
      "CHOLILA",
      "VILLA LAGO RIVADAVIA",
      "ALDEA APELEG",
      "LAGO ROSARIO",
      "TREVELIN",
      "LOS CIPRESES",
      "ALDEA ESCOLAR",
      "COLONIA 16 DE OCTUBRE",
      "EPUYEN",
      "EL COIHUE",
      "LAGO EPUYEN",
      "RESERVA AREA PROTEGIDA EL DORADILLO",
      "QUINTA EL MIRADOR",
      "PUERTO MADRYN",
      "GUALJAINA",
      "FRONTERA DE RIO PICO",
      "PASO DEL SAPO",
      "CUSHAMEN CENTRO",
      "BARRIO GASODUCTO",
      "BARRIO MILITAR - AEROPUERTO MILITAR",
      "BARRIO RESTINGA ALI",
      "BARRIO MANANTIAL ROSALES",
      "BARRIO CASTELLI",
      "ASTRA",
      "BARRIO CALETA CORDOVA",
      "BARRIO CIUDADELA",
      "COMODORO RIVADAVIA",
      "BARRIO PROSPERO PALAZZO",
      "BARRIO GÜEMES",
      "KM. 11 - CUARTELES",
      "DIADEMA ARGENTINA",
      "BARRIO LAPRIDA",
      "BARRIO RODRIGUEZ PEÑA",
      "BARRIO VILLA S.U.P.E.",
      "BARRIO SAAVEDRA",
      "KM. 8 - DON BOSCO",
      "BARRIO SARMIENTO",
      "ACCESO NORTE",
      "BARRIO CALETA OLIVARES",
      "KM. 5 - PRESIDENTE ORTIZ",
      "KM. 3 - GENERAL MOSCONI",
      "BARRIO 25 DE MAYO",
      "GOBERNADOR COSTA",
      "RIO MAYO",
      "ALTO RIO MAYO",
      "PLAYA MAGAGNA",
      "RAWSON",
      "PLAYA UNION",
      "CAMARONES",
      "CHACAY OESTE",
      "TALAGAPA",
      "CHACAY ESTE",
      "MALLIN GRANDE",
      "CHASICO",
      "BUENOS AIRES CHICO",
      "EL MAITEN",
      "CABO RASO",
      "MALASPINA",
      "GARAYALDE",
      "LOS ALTARES",
      "FACUNDO",
      "RADA TILLY",
      "BRYN GWYN",
      "GAIMAN",
      "LA ANGOSTURA",
      "EL HOYO",
      "PAMPA DEL CASTILLO",
      "BAHIA BUSTAMANTE",
      "HOLDICH",
      "EL TREBOL",
      "RIO CHICO",
      "EL TORDILLO",
      "DOLAVON",
      "TECKA",
      "TRELEW",
      "LOMA GRANDE",
      "DROFA GABETS",
      "DROFA DULOG",
      "FOFO CAHUEL",
      "EL PORTEZUELO",
      "EL MIRADOR",
      "EL TURBIO",
      "EL MAYOCO",
      "LELEQUE",
      "COSTA DE CHUBUT",
      "RIO CHICO",
      "LAGO FONTANA",
      "ALTO RIO SENGUER",
      "SARMIENTO",
      "CHACRAS DE SARMIENTO",
      "PIO PIO",
      "CERRO CONDOR",
      "CANQUEL",
      "TORO HOSCO",
      "EL PAJARITO",
      "EL SOMBRERO",
      "LAS PLUMAS",
      "FLORENTINO AMEGHINO",
      "DIQUE FLORENTINO AMEGHINO",
      "CARHUE NIYEO",
      "TAQUETREN",
      "COLELACHE",
      "RIO PICO",
      "BAJO DEL GUALICHO",
      "PUNTA DELGADA",
      "EL RIACHO SAN JOSE",
      "ARROYO VERDE",
      "PUNTA NORTE",
      "ALDEA EPULEF",
      "COLAN CONHUE",
      "BAJADA DEL DIABLO",
      "ZANJON MADRE",
      "RIO CHICO",
      "EL MIRASOL",
      "ALTO DE LAS PLUMAS",
      "ENTRE RIOS",
      "LAS GOLONDRINAS",
      "LA ISLA",
      "CERRO RADAL",
      "LAGO PUELO",
      "ALDEA BELEIRO",
      "NUEVA LUBECKA",
      "EL MOLLE",
      "PASO DE INDIOS",
      "PAMPA DE AGNIA",
      "COSTA DEL GUALJAINA",
      "PIEDRA PARADA",
      "BUEN PASTO",
      "VILLA FUTALAUFQUEN",
      "ESQUEL",
      "RIO PERCEY",
      "NAHUEL PAN",
      "GAN GAN",
      "PAMPA NEGRA",
      "LOS MANANTIALES",
      "GASTRE",
      "DOCTOR RICARDO ROJAS",
      "CERRO CENTINELA",
      "YALA LAUBAT",
      "BLANCUNTRE",
      "LAGUNITA SALADA",
      "EL ESCORIAL",
      "EL CORCOVADO SUR",
      "CORCOVADO",
      "LOS TAMARISCOS",
      "PASO MORENO",
      "PASTOS BLANCOS",
      "PUERTO PIRAMIDE",
      "JOSE DE SAN MARTIN",
      "TELSEN"
    ]
  },
  {
    "nombre": "C.A.B.A.",
    "localidades": [
      "MATADEROS",
      "PARQUE AVELLANEDA",
      "LINIERS",
      "CABALLITO",
      "SAN CRISTOBAL",
      "BALVANERA",
      "PARQUE CHACABUCO",
      "FLORES",
      "VILLA URQUIZA",
      "VILLA PUEYRREDON",
      "COGHLAN",
      "SAAVEDRA",
      "VILLA SANTA RITA",
      "VILLA GENERAL MITRE",
      "VILLA DEL PARQUE",
      "VILLA DEVOTO",
      "PALERMO",
      "FLORESTA",
      "VILLA REAL",
      "VILLA LURO",
      "VERSALLES",
      "VELEZ SARSFIELD",
      "MONTE CASTRO",
      "COLEGIALES",
      "NUÑEZ",
      "BELGRANO",
      "RECOLETA",
      "BOEDO",
      "ALMAGRO",
      "PARQUE CHAS",
      "VILLA ORTUZAR",
      "VILLA CRESPO",
      "CHACARITA",
      "AGRONOMIA",
      "PATERNAL",
      "RETIRO",
      "MONSERRAT",
      "SAN NICOLAS",
      "PUERTO MADERO",
      "CONSTITUCION",
      "SAN TELMO",
      "VILLA SOLDATI",
      "VILLA RIACHUELO",
      "VILLA LUGANO",
      "BOCA",
      "BARRACAS",
      "NUEVA POMPEYA",
      "PARQUE PATRICIOS"
    ]
  },
  {
    "nombre": "Corrientes",
    "localidades": [
      "LAVALLE",
      "PUERTO VIEJO",
      "LA LOMA",
      "RINCON DE SANTA LUCIA",
      "RINCON DE SOTO",
      "EL SOMBRERO",
      "LA MARTA",
      "SAN GREGORIO",
      "SAN ISIDRO",
      "PASO SAN JUAN",
      "PASO LOS ANGELES",
      "ISLA TALAR",
      "LA CUCUCHA",
      "BUENA ESPERANZA",
      "STELLA MARIS",
      "SAN MARTIN",
      "EL QUEBRACHO",
      "ESTANCIA SANTA RITA",
      "CAMPO MORATO",
      "SAN ANTONIO",
      "RINCON DEL PAGO",
      "INVERNADA",
      "PAGO DE LOS DESEOS",
      "COLONIA 3 DE ABRIL",
      "COLONIA CAROLINA",
      "COLONIA ISABEL VICTORIA",
      "VILLA OLIVARI",
      "COLONIA PANDO",
      "COLONIA CECILIO ECHEVERRIA",
      "CAZADORES CORRENTINOS",
      "ALGARROBAL",
      "CERNA",
      "COSTA SANTA LUCIA",
      "9 DE JULIO",
      "COLONIA JUAN RAMON VIDAL",
      "CAVIA CUE",
      "COSTA CHICA",
      "TRES CRUCES",
      "MEDIO",
      "EMPEDRADO LIMPIO",
      "INDIO MUERTO",
      "COSTA GRANDE",
      "LAGUNITA",
      "ESPINALLAR",
      "PASO LOVERA",
      "ALBARDONES",
      "RAMONES",
      "ORATORIO",
      "SANTOS LUGARES",
      "ARROYO PONTON",
      "CAMPO GRANDE",
      "AGUIRRE CUE",
      "LOMAS DE GALARZA",
      "EL POLLO",
      "PEICHOTO CUE",
      "MALOYAS",
      "CHAÑAR",
      "ESQUIVEL CUE",
      "CERRUDO CUE",
      "COLONIA LLANO",
      "SAN LUIS DEL PALMAR",
      "TACUARAL",
      "MONTE GRANDE",
      "SAN ANTONIO",
      "PUERTO TALA",
      "ESTACION TORRENT",
      "PELON ARROYO",
      "ESTACION MANUEL DERQUI",
      "PASO QUINTANA",
      "ARROYO SOLIS",
      "ARROYO EL SOMBRERO",
      "EL POLLO ESTE",
      "COSTA DE EMPEDRADO",
      "COSTA GRANDE",
      "COLONIA SANZ",
      "SAN JUANCITO",
      "RINCON DEL MADREGON",
      "SAN LORENCITO",
      "OCANTO CUE",
      "EMPEDRADO",
      "SANTA ROSA",
      "COLONIA BROUGNES",
      "CAMPO GRANDE",
      "PEHUAJO",
      "RINCON DEL SOMBRERO",
      "COLONIA IMPARCIALES",
      "VILLA SAN ISIDRO",
      "EL POLLO",
      "RINCON DE EMPEDRADO",
      "LOMAS DE EMPEDRADO",
      "REAL CUE",
      "AHOMA SUR",
      "BERNACHEA",
      "EL CARRIZAL",
      "SAN JOSE",
      "SALINAS GRANDE",
      "CAMPO VALLEJOS",
      "LAGUNA SIRENA",
      "GOBERNADOR JUAN E. MARTINEZ",
      "COLONIA GOBERNADOR GALLINO",
      "CASUALIDAD",
      "PALERMO",
      "MONTE FLORIDO",
      "EL BONETE",
      "ENSENADITA",
      "RIACHUELO SAN JOSE",
      "ENSENADA GRANDE",
      "PUERTO GONZALEZ",
      "SAN COSME",
      "SANTO DOMINGO",
      "RINCON DE LUNA",
      "LOS LAPACHOS",
      "LOMA ALTA",
      "CONCEPCION",
      "PAIRIRI",
      "YUQUERI",
      "CARAMBOLA",
      "YAJARAVE",
      "PASO LUCERO",
      "ESPINILLOS",
      "ARROYO CAABI",
      "BATEL",
      "ORATORIO",
      "RODEO PORA",
      "PASO BATALLA",
      "PASO ITU",
      "LAS PALMITAS",
      "PANCHO CUE",
      "ALVEAR",
      "ALTAMIRA",
      "SANTA ROSA",
      "AGUAPEY",
      "PIRAYU",
      "ARROYO MENDEZ",
      "SANTA ANA",
      "SANTA ISABEL",
      "FRONTERA",
      "COLONIA JUAN PUJOL",
      "TIMBOY",
      "PUISOYE",
      "PALMAR GRANDE",
      "FERNANDEZ",
      "COLONIA SAN GREGORIO",
      "COLONIA BUENA VISTA",
      "COLONIA MOCORETA",
      "PIEDRITAS",
      "MOCORETA",
      "COLONIA SAN ANDRES",
      "COLONIA SAN MARTIN",
      "AYALA CUE",
      "LA FLECHA",
      "LOMA ALTA",
      "VILLA SAN RAMON",
      "ALGARROBAL",
      "CAPILLITA",
      "CERRITO",
      "LOMA VILLANUEVA",
      "TIMBO CORA",
      "TALATY",
      "VILLANUEVA",
      "PASO FLORENTIN",
      "EL ZAPALLO",
      "NUESTRA SEÑORA DEL ROSARIO DE CAA CATI",
      "YACAREY",
      "SANTA RITA",
      "RINCON GUAZU",
      "GUAYU",
      "VILLA LA PALMIRA",
      "ITATI",
      "SCORZA CUE",
      "ESTANCIA SAN BENITO",
      "EL ABRA",
      "COLONIA GENERAL FERRE",
      "CRUZ DE LOS MILAGROS",
      "CEBOLLAS",
      "LOMAS ESTE",
      "CARRIZAL NORTE",
      "LOMAS NORTE",
      "LOMAS SUR",
      "MUCHAS ISLAS",
      "LAS GARZAS",
      "COLONIA PROGRESO",
      "ISLA ALTA",
      "RAICES NORTE",
      "BELLA VISTA",
      "JUAN DIAZ",
      "DESMOCHADO",
      "RINCON SANTA MARIA",
      "BUENA VISTA",
      "PUERTO VALLE",
      "ISLA APIPE CHICO",
      "CAA CARAI",
      "LIBERTAD",
      "ITUZAINGO",
      "PASO MORENO",
      "TABAY",
      "EL PINDO",
      "SANTA TERESITA",
      "ESTANCIA SANTA RITA",
      "EL PROGRESO",
      "SAN JUAN",
      "TAPEBICUA",
      "SANTA LIBRADA",
      "LOS FLOTADORES",
      "SANTO DOMINGO",
      "CHACRAS NORTE",
      "EL CARMEN",
      "SARANDI",
      "BUENA VISTA",
      "SANTA BARBARA",
      "SANTA CATALINA",
      "SAN ANTONIO",
      "LA FLORESTA",
      "TRANQUERA CADENA",
      "EL ROSARIO",
      "ESQUINA",
      "GUAYQUIRARO",
      "CAMPO PERNIZZA",
      "LA DORITA",
      "CAMPO LA EMILIA",
      "EL CERRO",
      "SAN FERNANDO",
      "PICADA AMARA",
      "MALVINAS SUR",
      "MALVINAS NORTE",
      "ARROYO SORO",
      "RINCON DE SARANDI",
      "PASO HU",
      "SANTA MARIA",
      "INGA",
      "TRES MOJONES",
      "CAMPO ROMERO",
      "ABRA GUAZU",
      "VILLA ROSA",
      "COLONIA BONZON",
      "COLONIA 2 DE ABRIL",
      "PEDRO R. FERNANDEZ",
      "ESTACION SANTIAGO ALCORTA",
      "KILOMETRO 137",
      "IBAHAY",
      "ANGOSTURA",
      "ARERUNGUA",
      "ITA IBATE",
      "AYUI",
      "LINCONIA",
      "LOS ANDES",
      "BONPLAND",
      "SANTA ANA",
      "COLONIA CARLOS PELLEGRINI",
      "CAMBA TRAPO",
      "ESTANCIA OVECHA RATY",
      "COLONIA SAN JUSTO",
      "ESTANCIA SAN VICENTE",
      "LA CRIOLLA",
      "SAN ALONSO",
      "JESUS CUE",
      "LOS ARROYOS",
      "LAS MARIAS",
      "ESPINILLO",
      "EL ALTILLO",
      "CAILAR CUE",
      "GOBERNADOR IGR.VALENTIN VIRASORO",
      "CAABI POI",
      "MONTE CASEROS",
      "PARADA LABOUGLE",
      "TACUABE",
      "PASO VALLEJOS",
      "CAMPO GENERAL AVALOS",
      "ITACUMBU",
      "DOS VIAS",
      "TIMBOY",
      "FORTUNA",
      "PUERTO CEIBO",
      "DESAGUADERO",
      "INGENIO PRIMER CORRENTINO",
      "RIACHUELO BARDECI",
      "SANTA ANA",
      "IBATE PORA",
      "LAS FLORES",
      "SANTA ROSA (RURAL)",
      "LA SELVA",
      "SAN AGUSTIN",
      "COLONIA CAIMAN",
      "SAN ANTONIO",
      "AQUINO",
      "BATARA",
      "EL CARMEN",
      "SANTA ROSA",
      "LA MANSION",
      "SALADAS",
      "PAGO ARIAS",
      "SAN FRANCISCO",
      "PAGO ALEGRE",
      "LOMAS",
      "ANGUA COSTA SANTA LUCIA",
      "CASUARINAS",
      "ARROYITO",
      "SAN LORENCITO",
      "ANGUA",
      "COLONIA OFICIAL SARGENTO JUAN B. CABRAL",
      "PASO NARANJITO",
      "SANTO DOMINGO",
      "BUENA VISTA",
      "RINCON DE VENCES",
      "MALOYITAS",
      "LOMAS DE VALLEJOS",
      "PASITO",
      "LOS VENCES",
      "COSTA SUD MALOYAS",
      "RINCON DE ZALAZAR",
      "VILLA LIBERTAD",
      "ROSADO GRANDE",
      "COLONIA LA ELISA",
      "COLONIA LAUREL",
      "ARROYO PARAISO",
      "SANTA ANGELICA",
      "LUJAN",
      "SAN ROQUE",
      "ESTANCIA BUENA VISTA",
      "ARROYO GONZALEZ",
      "SANTO DOMINGO",
      "YAZUCA",
      "LA MARIA",
      "SAN LORENZO",
      "ARROYO CEIBAL",
      "RINCON DE AMBROSIO",
      "RINCON DE SAN LORENZO",
      "PUNTA IFRAN",
      "YATAYTI CALLE",
      "COSTA BATEL",
      "PUENTE BATEL",
      "PASO LOPEZ",
      "EL CERRITO",
      "OMBUCITO",
      "LA FLORIDA",
      "NUEVA ESPERANZA",
      "BAÑADO YATAY",
      "QUIYATI",
      "LAS PALMAS",
      "SAN SALVADOR",
      "PASO DE LOS LIBRES",
      "PALMAR",
      "LA AMELIA",
      "SAN JOAQUIN",
      "REMANSO",
      "AGUAPE",
      "YAPEYU",
      "MARIANO I. LOZA",
      "MALEZAL",
      "PERUGORRIA",
      "PASO TALA",
      "VACA PASO",
      "LA LATA",
      "AGUAY",
      "ARROYO SECO",
      "PALMITAS",
      "OSCURO",
      "CHAVARRIA",
      "TACUARITAS",
      "SAENZ VALIENTE",
      "COLONIA BUEN RETIRO",
      "JUAN PUJOL",
      "TRES BOCAS",
      "ARROYO MOTA",
      "COLONIA SAN FRANCISCO",
      "YATAY",
      "ESTANCIA LA CAUTIVA",
      "VACA CUA",
      "MARIA CARAPE",
      "ARROYO MAROTE",
      "PAGO LARGO",
      "CURUZU CUATIA",
      "PEDRO DIAZ COLODRERO",
      "BAIBIENE",
      "PASO DE LAS PIEDRAS",
      "EL CHAÑAR",
      "COLONIA PAIRIRI",
      "SARANDI",
      "MARIA CHICA",
      "ESTANCIA SAN JUAN",
      "AVALOS",
      "SAN AGUSTIN",
      "EMILIO R. CONI",
      "TIERRA COLORADA",
      "TRES BOCAS DEL YATAY",
      "ARROYO PORTILLO",
      "GARAY",
      "EL CEIBO",
      "TUNITAS",
      "RINCON DE TUNAS",
      "CAPITAN JOAQUIN MADARIAGA",
      "ESPINILLO",
      "URRUTIA",
      "COLONIA LIEBIG'S",
      "SANTOS LUGARES",
      "LA CACHUERA",
      "LAS LOMAS",
      "KILOMETRO 517",
      "PLAYADITO",
      "DOS HERMANAS",
      "NARANJITO",
      "TIMBOCITO",
      "TORO RATAY",
      "LA CONCEPCION",
      "ESTANCIA SANTA CLARA",
      "MARIA LUISA",
      "RINCON DEL OMBU",
      "BOQUERON",
      "RINCON TRANQUERA GENERAL",
      "PASO PUCHETA",
      "YUQUERI",
      "RINCON DEL SOCORRO",
      "PAY UBRE CHICO",
      "CALLEJON",
      "IRUPE",
      "RINCON DE YAGUARY",
      "TUNITA",
      "SAN DIONISIO",
      "UGUAY",
      "ITA CORA",
      "MERCEDES",
      "SANTA CATALINA",
      "SANTA JUANA",
      "GUAYAIBI",
      "ARROYO GRANDE",
      "AGUACERITOS",
      "RAMADA PASO",
      "RINCON YURUBI",
      "SANTA ELVIRA",
      "TATACUA",
      "COLONIA TATACUA",
      "CUAY GRANDE",
      "LOS BRETES",
      "VIROCAY",
      "SANTO TOME",
      "GOMEZ CUE",
      "CUAY CHICO",
      "SAN GABRIEL",
      "CORONEL DESIDERIO SOSA",
      "CONCEPCION",
      "ESTANCIA SAN PEDRO",
      "GAMBAI",
      "GALARZA",
      "ESTACION CAZA PAVA",
      "ATALAYA",
      "COLONIA GOBERNADOR RUIZ",
      "LAUREL",
      "HORMIGUERO",
      "MBOCAYA",
      "SANTA BARBARA",
      "SANTA SIXTA",
      "COLONIA MADARIAGA",
      "CURUZU LAUREL",
      "SAN NICOLAS",
      "SAN MIGUEL",
      "SILVERO CUE",
      "ROQUE CUE",
      "ESTANCIA DOS HERMANAS",
      "SANTA LUCIA",
      "LA BOLSA",
      "VILLA AQUINO",
      "COLONIA MARTINEZ",
      "COLONIA SAN JOSE",
      "NARANJITO",
      "VILLA CORDOBA",
      "PARADA PUCHETA",
      "PASO LEDESMA",
      "SAN ANTONIO",
      "SAN ISIDRO",
      "LOS PINOS",
      "VALENCIA",
      "YAHAPE",
      "BERON DE ASTRADA",
      "TATARE",
      "ISLA SOLA",
      "CASUALIDAD",
      "PUNTA MARUCHA",
      "SAN PEDRO",
      "SAN FRANCISCO",
      "COLONIA PUCHETA",
      "SOLEDAD",
      "SAN JORGE",
      "ISLA LA JOSEFINA",
      "ESTANCIA DON RAUL",
      "VILLA LEONOR",
      "RINCON DE GOMEZ",
      "LOS CEIBOS",
      "EL TRANSITO",
      "PUNTA BATEL",
      "MARUCHAS",
      "LAS MERCEDES",
      "MANANTIALES",
      "COSTA BATEL",
      "PARANACITO",
      "COLONIA PROGRESO",
      "BATEL ARAUJO",
      "GOYA",
      "COLONIA ELENITA",
      "BUENA VISTA",
      "PTO. BOCA",
      "ESTANCIA RINCON DE LUNA",
      "BATEL",
      "SAN RAMON",
      "SANTILLAN",
      "VILLA LUJAN",
      "PAGO REDONDO",
      "REMANSO",
      "COLONIA MERCEDES COSSIO",
      "SANTA ROSA",
      "COLONIA PORVENIR",
      "MARUCHITAS",
      "LUJAN",
      "SANTA MARIA",
      "MORA",
      "EL CERRITO",
      "COLONIA TIMBO",
      "LAGUNA PUCU",
      "COCALITO",
      "COLONIA SAUCE",
      "ISLA EL TALAR",
      "CORRIENTES",
      "PIRAYUI",
      "PASO MARTINEZ",
      "LAGUNA PAIVA",
      "LAGUNA SOTO",
      "LAGUNA BRAVA",
      "LA COSTA",
      "LAS CHISPAS",
      "JOSE RAFAEL GOMEZ",
      "VELOSO",
      "CHACRAS",
      "SANTA TERESA",
      "ISIPOYU",
      "COSTA SAN LORENZO",
      "SAN JUAN",
      "MBURUCUYA",
      "LOMA ALTA",
      "SANTA ANA",
      "PUNTA GRANDE",
      "BLANCO CUE",
      "MANANTIALES",
      "LA YERBA",
      "PASO AGUIRRE",
      "ESTINGANA",
      "BUENA VISTA",
      "GUAVIRAVI",
      "LOS EUCALIPTOS",
      "PASO BERMUDEZ",
      "LOMA ALTA",
      "SAN PEDRO",
      "RINCON DEL SAUCE",
      "ARROYO HORQUETA",
      "CONCEPCION",
      "SAUCE",
      "FRANCISCO GOMEZ",
      "RINCON DE ANIMAS",
      "SAN MARTIN",
      "SAN RAMON",
      "MALEZAL",
      "LA ESTRELLA",
      "OVEJITA",
      "PUNTA DE ORO",
      "SAN CARLOS",
      "MONTE HERMOSO",
      "COSTA RIO PARANA",
      "EL RINCON",
      "PASO DE LA PATRIA",
      "COSTA TOLEDO",
      "PUERTO ARAZA",
      "RIACHUELO",
      "SAN CAYETANO",
      "SAN RAMON",
      "SAN JUAN TADEO",
      "COLONIA LIBERTAD",
      "PARADA ACUÑA",
      "ESTACION LIBERTAD",
      "BARRANQUERITAS",
      "SAN JUAN LOMA",
      "LORETO",
      "ARROYO BALMACEDA",
      "BASTIDORES",
      "SANTA MARIA",
      "ESTANCIA SAN CARLOS",
      "AGUAPEY",
      "TRES CERROS",
      "LOMA ALTA",
      "ALEN CUE",
      "SAN GABRIEL",
      "EL OREJANO",
      "EL CHAQUITO",
      "LA HORQUETA",
      "COSTA GUAVIRAVI",
      "BLANCO CUE",
      "HORQUETA DE GUAVIRAVI",
      "YACARE",
      "ISOQUI",
      "LA CRUZ",
      "SAN EDUARDO",
      "CAPITA MINI",
      "CUENCA",
      "FELIPE YOFRE",
      "GARRUCHOS",
      "COLONIA UNION",
      "SAN JUAN",
      "SAN HORACIO",
      "CORONEL ABRAHAM SCHWEIZER",
      "LIBERTADOR",
      "PASO LALLANA",
      "PUEBLO LIBERTADOR",
      "LAGUNA ITA",
      "PASO CEJAS",
      "LAS CUCHILLAS",
      "LA RINCONADA",
      "AQUINO",
      "CAMPO BORDON",
      "ARROCERA PAPELHA",
      "LA CASUALIDAD",
      "HERLITZKA",
      "RINCON DE NAVARRO",
      "RINCON DE MEZA",
      "LAGUNA NEGRA",
      "ESTANCIA GARABATA",
      "RIACHUELITO",
      "LOMAS DE GONZALEZ",
      "LOMAS DE AGUIRRE",
      "RINCON DE LA MERCED"
    ]
  },
  {
    "nombre": "Córdoba",
    "localidades": [
      "LAS CHACRAS",
      "LOS CADILLOS",
      "VILLA QUILINO",
      "QUILINO",
      "MOGOTES ASPEROS",
      "OJO DE AGUA",
      "ESTANCIA DE GUADALUPE",
      "SAN FELIPE",
      "TRES LOMAS",
      "LA ARGENTINA",
      "LABORDE",
      "BELL VILLE",
      "COLONIA COMPIANI",
      "SAN ROQUE",
      "CERRO PELADO",
      "AMBOY",
      "EL MOJON",
      "EL GUANACO",
      "LA MAZA",
      "SANTA CATALINA",
      "LA PIEDRA BLANCA",
      "AGUA DE ORO",
      "POZO DE MOLINA",
      "POZO DEL SIMBOL",
      "EL JORDAN",
      "LA BARRANCA",
      "POZO DE LAS OLLAS",
      "PUNTA DEL MONTE",
      "LA VICTORIA",
      "SAN MIGUEL",
      "ALTO DE FIERRO",
      "SANTA ISABEL",
      "LA PENCA",
      "SAN ANTONIO",
      "LA VICTORIA OESTE",
      "CAMPO GRANDE",
      "LA VICTORIA (E)",
      "SALSACATE",
      "VILLA VISO",
      "CASA BLANCA",
      "TANINGA",
      "PUEBLO VIEJO",
      "SAN EUSEBIO",
      "LAS LAGUNITAS",
      "LA TIGRA",
      "COLONIA LA VERDE",
      "COLONIA MARCOS SASTRE",
      "CAMPO LOS CORRALITOS",
      "COLONIA EL DORADO",
      "CAMPO LOS ALGARROBOS",
      "COLONIA LA CONCORDIA",
      "SAN MELITON",
      "CAYUQUEO",
      "CAMPO COSTA",
      "COLONIA LA UNION",
      "LA HERRADURA",
      "SAN SEVERO",
      "CAMPO SANTA RITA",
      "COLONIA 10 DE MAYO",
      "COLONIA EL BALQUIN",
      "COLONIA EL PIQUILLIN",
      "COLONIA CORRAL DEL BAJO",
      "CAMPO LAS CHACRAS",
      "CUATRO CAMINOS",
      "POTRO MUERTO",
      "EL UCLE",
      "CORRAL DEL BAJO",
      "CAMPO VIONNET",
      "COLONIA PICO CHACO",
      "RAMON J. CARCANO",
      "COLONIA LA LOLA",
      "COLONIA LA CELINA",
      "COLONIA EL DESCANSO",
      "CNIA NORTE",
      "COLONIA ESPERANZA",
      "COLONIA CORRAL DE GUARDIA",
      "CAMPO SANTA ELENA",
      "COLONIA LA LEONCITA",
      "CAMPO SAN ELIAS",
      "CAMPO LA LUISITA",
      "CAMPO LOS GALGOS",
      "CAMPO CRESPO-P/BALLESTERS",
      "CAMPO YANZI",
      "COLONIA SANTA RITA",
      "LUCA",
      "LEONES",
      "LAS CHACRAS",
      "EL VERGEL",
      "ESTACION COLONIA TIROLESA",
      "EL QUEBRACHAL",
      "COLONIA LOS ALGARROBOS",
      "LA CORINA",
      "COLONIA RIO CHICO",
      "COLONIA TIROLESA",
      "SANTA ELENA",
      "LA PUERTA",
      "LOZADA",
      "SALSIPUEDES",
      "LA ESTANCITA",
      "EL PUEBLITO",
      "LA PUERTA",
      "PINTOS",
      "EL ROSARIO",
      "LA CUMBRE",
      "SAN IGNACIO (LOTEO VELEZ CRESPO)",
      "SANTA MONICA",
      "SANTA ROSA DE CALAMUCHITA",
      "ARROYO SECO",
      "LOS CHAÑARITOS",
      "LOS TALARES",
      "LA RANCHERITA",
      "VILLA HUIDOBRO",
      "MANFREDI",
      "CUESTA BLANCA",
      "DEAN FUNES",
      "VILLA DEL PRADO",
      "CAVANAGH",
      "BUENA VISTA",
      "SAN GERONIMO",
      "LAS PEÑAS",
      "CAMPO SCARAFIOCCA",
      "COLONIA GARZON",
      "CAMPO EL CHILO",
      "CAMPO FIORETTA",
      "CAPILLA GARZON",
      "CAMPO PEROTTI",
      "COLONIA LOLA",
      "CAMPO CAPRIVI",
      "LAS PETACAS",
      "CAMPO LAS SELVAS",
      "CAMPO SAN ALFREDO",
      "CAMPO MACAGNO",
      "CAMPO ROSSI",
      "CAMPO BERTOGLIO",
      "CUESTA DEL RIO",
      "COLONIA BELLA VISTA",
      "CAMPO NIGRO SUR",
      "CAMPO JANON",
      "CAMPO NIGRO NORTE",
      "CAMPO LA ROSA",
      "COLONIA SANTA CATALINA",
      "CAMPO DEL BEL",
      "CAMPO MARENGO",
      "PUENTE LAS SELVAS",
      "COLONIA LOS TAMARINDOS",
      "CAMPO BOAGLIO",
      "CAMPO BATTISTON",
      "SAN ESTEBAN",
      "SALDAN",
      "TICINO",
      "ISLA VERDE",
      "SINSACATE",
      "CARNERILLO",
      "CARNERILLO",
      "CERRO COLORADO",
      "LOS ZORROS",
      "ARROYO LOS PATOS",
      "TORO PUJIO",
      "ALEJO LEDESMA",
      "MONTE MAIZ",
      "GUATIMOZIN",
      "ONAGOITY",
      "VILLA SANTA EUGENIA",
      "ALPA CORRAL",
      "LAS JUNTURAS",
      "EL BRETE",
      "EL SIMBOLAR",
      "EL TROPIEZO",
      "PIQUILLIN",
      "CAMINIAGA",
      "CERRO COLORADO",
      "CAÑADA DEL SAUCE",
      "TALA CRUZ",
      "LOS CHARCOS",
      "ALTO DE LOS QUEBRACHOS",
      "LA RINCONADA",
      "LOS EUCALIPTOS",
      "EL ZAPALLAR",
      "ESTANCIA MARULL",
      "CAMPO ALEGRE",
      "EL CRISPIN",
      "AGUA DE ORO",
      "GENERAL ROCA",
      "COLONIA V. AGUERO",
      "COLONIA VICENTE AGUERO",
      "TRANSITO",
      "VILLA DEL TRANSITO",
      "LUTTI",
      "LOS VALLECITOS",
      "CARAHUASI",
      "EL ESPINILLO",
      "LAS ACEQUIAS",
      "VILLA OESTE",
      "VILLA NUEVA",
      "SAN PEDRO NORTE",
      "LA LAGUNA",
      "BARRIO SANTA ISABEL",
      "CAPILLA DEL MONTE",
      "PAMPAYASTA NORTE",
      "CAMPO ASINARI",
      "SAN PEDRO DE GUTEMBERG",
      "GUTEMBERG",
      "GENERAL FOTHERINGHAM",
      "PORTEÑA",
      "KILOMETRO 691",
      "MONTECRISTO",
      "MEDIA LUNA SUR",
      "CAPITAN GENERAL BERNARDO O`HIGGINS",
      "LAS TOSCAS",
      "SAN RAFAEL",
      "SANTA MARIA",
      "BALDE DE LA MORA",
      "SAN MIGUEL",
      "LA LINEA",
      "SAN VICENTE",
      "LA REDUCCION",
      "EL CADILLO",
      "VILLA CURA BROCHERO",
      "CHANCANI",
      "LAS PALMAS",
      "EL POTRERO",
      "JAIME PETER",
      "CHUÑA",
      "COLONIA BARGE",
      "CASTRO URDIALES",
      "ROSALES",
      "LAS GRAMILLAS",
      "CAPILLA DEL CARMEN",
      "EL DURAZNO",
      "RIO DEL DURAZNO",
      "VILLA YACANTO",
      "CAÑADA DE MACHADO",
      "BENGOLEA",
      "LA QUINTA",
      "EL RASTREADOR",
      "VILLA TRONQUILS",
      "LAS CALERAS",
      "TOSQUITAS",
      "PUEBLO ITALIANO",
      "EL SALTO",
      "LOS HOYOS",
      "SANTO DOMINGO",
      "LA COSTA",
      "CAÑADA DE LUQUE",
      "ESTACION LUXARDO",
      "PLAZA LUXARDO",
      "CABALANGO",
      "LAS VERTIENTES",
      "LAGUNA LARGA",
      "ARROYO CABRAL",
      "MATTALDI",
      "LA PAMPA",
      "CHARRAS",
      "PILAR",
      "JESUS MARIA",
      "ONCATIVO",
      "PLAZA VIDELA",
      "COLONIA VIDELA",
      "SAN JOAQUIN",
      "VILLA PASTORA",
      "CIUDAD DE LOS NIÑOS",
      "PARQUE NORTE",
      "1 DE AGOSTO",
      "JUAREZ CELMAN",
      "VILLA LOS LLANOS",
      "VILLA EL FACHINAL - PARQUE NORTE - GUIÑA",
      "ALMIRANTE BROWN",
      "GUIÑAZU NORTE",
      "PEDRO E. VIVAS",
      "KILOMETRO 658",
      "LAS SALADAS",
      "LA CARBONADA",
      "CAMPO BUENA ESPERANZA",
      "SAN ANTONIO NORTE",
      "BAJO GRANDE",
      "BAJO CHICO",
      "SOCAVONES",
      "RIO DEL MEDIO",
      "COSME SUR",
      "LA MARIA VIRGINIA",
      "LA ACEQUIECITA",
      "TRES POZOS SUD",
      "COSME NORTE",
      "BUENA VISTA",
      "LOS TAJAMARES",
      "ROSARIO DEL SALADILLO",
      "PUESTO DE FIERRO",
      "LOS TRONCOS",
      "LOS GUINDOS",
      "EL ALCALDE",
      "CAMPO RAMALLO",
      "EL BAGUAL",
      "POZO DE LA LOMA",
      "PASO DEL SAUCE",
      "LA COLORADA",
      "BAJO HONDO",
      "NUEVA ANDALUCIA",
      "PUESTO DE AFUERA",
      "CAPILLA DE DOLORES",
      "MONTE DEL ROSARIO",
      "BARRANCA COLORADA",
      "COLONIA EL FORTIN",
      "LAS ACACIAS",
      "COLONIA SAN RAFAEL",
      "LOS CASTAÑOS",
      "EL QUEBRACHO",
      "LAS AVERIAS",
      "BUEY MUERTO",
      "LA VUELTA",
      "SANTA ISABEL",
      "CHACRAS NORTE",
      "PUESTO PUCHETA",
      "LAS HERAS",
      "ISLA LARGA",
      "CHACRAS SUR",
      "COLONIA LA ARGENTINA",
      "ESPERANZA",
      "EL CARRIZAL",
      "LOS ALVAREZ",
      "LAS BANDURRIAS",
      "LAS PALMITAS",
      "POZO DE LA ESQUINA",
      "EL MANANTIAL SUR",
      "BOCA DEL RIO",
      "ISLA VERDE",
      "INRIVILLE",
      "EL TIO",
      "LOS CISNES",
      "CAMPO AGÑERO",
      "VILLA ASCASUBI",
      "CAMPO CAFFARATTI",
      "CAMPO PICATTO",
      "SANTA ROSA DE RIO PRIMERO",
      "OLIVA",
      "ORDOÑEZ",
      "VILLA CARLOS PAZ",
      "SANTA CRUZ DEL LAGO",
      "DESPEÑADEROS",
      "GENERAL CABRERA",
      "GENERAL BALDISSERA",
      "COLONIA ITURRASPE",
      "EL ALTO",
      "ANISACATE",
      "COSTA AZUL",
      "EMBALSE",
      "EL QUEBRACHO",
      "SAIRA",
      "CHILIBROSTE",
      "MATORRALES",
      "COLONIA EL ACEQUION",
      "ALTO ALEGRE",
      "CAMPO SANTA TERESA",
      "CORONEL BAIGORRIA",
      "MARULL",
      "CAPILLA VIEJA",
      "FALDA DE LOS REARTES",
      "VILLA GENERAL BELGRANO",
      "CERRO HERMOSO",
      "LAS HIGUERAS",
      "VILLA SARMIENTO",
      "LA PLAYOSA",
      "LA PLAYA",
      "LUCIO V. MANSILLA",
      "TALAINI",
      "COLONIA BISMARCK",
      "ADELIA MARIA",
      "WENCESLAO ESCALANTE",
      "RIO SEGUNDO",
      "VILLA EL TALA",
      "MONSALVO",
      "LA CASCADA",
      "VILLA ALPINA",
      "CERRO CHAMPAQUI",
      "ARROYO SAN ANTONIO",
      "EL CANO",
      "SOL DE MAYO",
      "LA DORMIDA",
      "ATOS PAMPA",
      "LAS LAGUNITAS",
      "COLONIA LAS PICHANAS",
      "LAS VARAS",
      "CHAJAN",
      "COSQUIN",
      "OLAEN",
      "QUEBRADA DE LUNA",
      "BOSQUE ALEGRE",
      "EL CARRIZAL",
      "PUESTO RAMALLO",
      "LA PAQUITA",
      "LAS ISLETILLAS",
      "CINTRA",
      "SAN ROQUE",
      "CASSAFFOUSTH",
      "CAMPO MINETTI",
      "CAMPO SCARAMUZZA",
      "CAMPO LOS MATORRALES",
      "ORATORIO DE PERALTA",
      "COLONIA NORTE",
      "COLONIA DOS HERMANAS",
      "CAMPO CAROLINI",
      "LA LAGUNILLA",
      "CAMPO MARTOLINO",
      "CAMPO LA SIRENA",
      "COSTA DEL CARMEN",
      "LA RAMADA",
      "CAMPO EL POLVORIN",
      "COLONIA ADELA",
      "A. DE ALVAREZ N° 1",
      "COSTA ALEGRE",
      "ARROYO DE ALVAREZ NRO 2",
      "COLONIA SAN JOSE DE AGUAS COLORADAS",
      "CAMPO LOS TRES ARBOLES",
      "CORRAL DE ARROYO",
      "CAMPO BAUDIN",
      "LA REPRESA",
      "CAMPO DANIELE",
      "SAN JOSE",
      "CAMPO FICHETTI",
      "CAMPO LA RAMADA",
      "CAMPO LA ANGELINA",
      "PASO DE VELEZ",
      "POZO DE LAS YEGUAS",
      "CAMPO MARCHAND",
      "CAMPO YAÑEZ",
      "CAMPO ASINARI",
      "LA ISLA",
      "LA RIBERA",
      "RINCON VIEJO",
      "LAGUNILLA",
      "CAMPO FALCO",
      "CAMPO EL TACO",
      "SANTA MARIA DE PUNILLA",
      "MALLIN",
      "VILLA SAN JOSE",
      "SIMBOLAR",
      "ASSUNTA",
      "RINCON",
      "VILLA LAGO AZUL",
      "VILLA SANTA CRUZ DEL LAGO",
      "GENERAL DEHEZA",
      "VILLA LA BOLSA",
      "LOS HORNILLOS",
      "DOS ARROYOS",
      "EL PANTANILLO",
      "BERROTARAN",
      "LOS ROMEROS",
      "CONLARA",
      "LOS GIGANTES",
      "PUESTO PEDERNERA",
      "RIO TIU MAYU",
      "PAMPAYASTA SUR",
      "VILLA ROSSI",
      "LUQUE",
      "AGUA DEL MOLLE",
      "COPACABANA",
      "MONTE RALO",
      "CORONEL MOLDES",
      "VILLA GIARDINO",
      "LOS TRONCOS",
      "VILLA GUTIERREZ",
      "MORRISON",
      "LA POSTA",
      "LAS PERDICES",
      "ELENA",
      "JAMES CRAIK",
      "COLONIA ROCHA",
      "COLONIA STABILE",
      "MODESTINO PIZARRO",
      "EL CAMPITO",
      "LA NACIONAL",
      "COLONIA WHITE",
      "PEGASANO",
      "COLONIA LOS CEIBOS",
      "ESTACION LECUEDER",
      "COLONIA SANTA CATALINA",
      "CAMPO SAN JUAN",
      "ESTANCIA LA COLORADA",
      "DE LA SERNA",
      "ESTANCIA LA VANGUARDIA",
      "INGENIERO MALMEN",
      "VILLA MODERNA",
      "EL PAMPERO",
      "ESTANCIA LA PACIFICA",
      "LOS ALFALFARES",
      "COLONIA LA JUANITA",
      "ESTANCIA LA MARGARITA",
      "LA PENCA",
      "CAMPO LA ADELA",
      "CARRILOBO",
      "CORRAL QUEMADO",
      "VILLA PARQUE SIQUIMAN",
      "UCACHA",
      "MI GRANJA",
      "EL BARREAL",
      "SAN MIGUEL",
      "SAN MARTIN",
      "POZO NUEVO",
      "RAYO CORTADO",
      "CHARBONIER",
      "LAS RABONAS",
      "AGUA DE RAMON",
      "PIEDRITA BLANCA",
      "EL CHACHO",
      "CRUZ DEL EJE",
      "RIO HONDO",
      "LA GLORIA",
      "LA VENTANA",
      "MINA CLAVERO",
      "GIULO CESARE",
      "PUENTE DEL CURA",
      "SAN FRANCISCO",
      "PLAZA SAN FRANCISCO",
      "CAPILLA DE SITON",
      "LOS CEDROS",
      "CORRALITO",
      "RIO PRIMERO",
      "OBISPO TREJO",
      "CAMILO ALDAO",
      "ZURI POZO",
      "EL QUEBRACHAL",
      "DOMINGUITO",
      "BAÑADO DE SOTO",
      "RAFAEL GARCIA",
      "CAMPO NOVARINO",
      "COLONIA MOLLES",
      "COLONIA EL OVERO",
      "CAMPO LAS LONJAS",
      "CAMPO SANTA FLORINDA",
      "COLONIA MAIZALES-LEONES",
      "COLONIA LOS VASCOS",
      "COLONIA ERMILA",
      "CAMPO LABORDE",
      "LA CAROLINA",
      "COLONIA ARMANDO",
      "COLONIA EL CHAJA",
      "COLONIA GARIBALDI",
      "CAMPO EVANGELIST",
      "CAMPO NATA",
      "CAMPO LA ALBINA",
      "COLONIA EL DORADO",
      "COLONIA CALCHAQUI",
      "COLONIA CARLOS CASADO",
      "CAMPO GAUCHO NUEVO",
      "COLONIA LUIS VELEZ",
      "COLONIA REGERNSBURGER",
      "BARRIO LA FORTUNA",
      "CAMPO CARLITOS",
      "COLONIA JERUSALEN",
      "CAMPO GERBAUDO",
      "COLONIA VEINTICINCO",
      "CAMPO EL ZORRO",
      "COLONIA MACKEY",
      "BALNEARIA",
      "COLONIA ALMADA",
      "LAS BAJADAS",
      "SOCONCHO",
      "PASO DEL DURAZNO",
      "PASO DEL DURAZNO",
      "LOS POZOS",
      "LAS PLAYAS",
      "SUCO",
      "PACHECO DE MELO",
      "PINCEN",
      "CALCHIN OESTE",
      "MIRAMAR",
      "VILLA AMANCAY",
      "RIO GRANDE",
      "PANAHOLMA",
      "POZO DEL TIGRE",
      "GENERAL PAZ",
      "IDIAZABAL",
      "COLONIA SANTA MARIA",
      "COLONIA PROSPERIDAD",
      "PUEBLO COMECHINGONES",
      "VILLA SAN ESTEBAN",
      "SAN JOSE",
      "VILLA LOS PATOS",
      "EL PERCHEL",
      "PALOMA POZO",
      "CIENAGA DE BRITOS",
      "TRES ARBOLES",
      "EL SALTO",
      "CANTERAS QUILPO",
      "CANTERAS DE QUILPO",
      "LAS OLLAS",
      "LA BREA",
      "REPRESA DE MORALES",
      "EL DURAZNAL",
      "EL PUESTITO",
      "PICHANAS",
      "EL BARRIALITO",
      "LAS CHACRAS",
      "LOS ESCALONES",
      "SANTA ANA",
      "PIEDRAS ANCHAS",
      "ORO GRUESO",
      "EL RINCON",
      "LOS LEONES",
      "LA PUERTA",
      "TABAQUILLO",
      "EL SALADITO",
      "BAJO LINDO",
      "MAJADA DE SANTIAGO",
      "MANDALA",
      "IGLESIA VIEJA",
      "MESA DE MARIANO",
      "LAS TAPIAS",
      "LA LAGUNA",
      "HUANCHILLAS",
      "TANCACHA",
      "ITALO",
      "RIO BAMBA",
      "ESQUINA",
      "RANGEL",
      "TRES ESQUINAS",
      "PUNTA DEL AGUA",
      "RANQUELES",
      "MARCOS JUAREZ",
      "SATURNINO MARIA LASPIUR",
      "ALEJANDRO ROCA",
      "VILLA LA RIVERA",
      "VILLA QUILLINZO",
      "LA AGUADITA",
      "EL BARRIAL",
      "PIEDRAS ANCHAS",
      "PINAS",
      "CERRO BOLA",
      "LOS MORTERITOS",
      "MEDIA NARANJA",
      "PUESTO DEL GALLO",
      "PASO VIEJO",
      "LA RINCONADA",
      "NEGRO HUASI",
      "LAS CAÑADAS",
      "LAS PEÑAS",
      "SANTIAGO TEMPLE",
      "JUAN BAUTISTA ALBERDI",
      "LOS MORTERITOS",
      "BAJO DE CORRALES",
      "AMBUL",
      "ALTO GRANDE",
      "EL MIRADOR",
      "ALTOS DE CHIPION",
      "RODEO VIEJO",
      "LA AGUADA",
      "LAS ALBAHACAS",
      "VILLA PARQUE SANTA ANA",
      "MI VALLE",
      "CAMPOS DEL VIRREY",
      "ARROYO ALGODON",
      "SAN MARCOS",
      "SEEBER",
      "HUERTA GRANDE",
      "EUFRASIO LOZA",
      "SAN IGNACIO",
      "SANTA MAGDALENA",
      "SANTA EUFEMIA",
      "POZO DEL TIGRE",
      "SAN FRANCISCO DEL CHAÑAR",
      "SANTA ANA",
      "LOS CERRILLOS",
      "VIAMONTE",
      "COLONIA MONTE DE LOS GAUCHOS",
      "MONTE DE LOS GAUCHOS",
      "LA CARLOTA",
      "COLONIA VALTELINA",
      "CRUZ ALTA",
      "CHAZON",
      "RIO DE BUSTOS",
      "VILLA TULUMBA",
      "LAS JUNTAS",
      "SOCAVONES",
      "LA MAJADILLA",
      "LOS CERRILLOS",
      "COLONIA SAN BARTOLOME",
      "EL EJE DE CANDELARIA",
      "VILLA CANDELARIA NORTE",
      "SAN LUIS",
      "FALDA DEL CARMEN",
      "BARRIO LAS QUINTAS",
      "VALLE ALEGRE",
      "TUCLAME",
      "BELLA VISTA",
      "VILLA DE SOTO",
      "LOS MOLLES",
      "ALTO RESBALOSO - EL BARRIAL",
      "VILLA DE LAS ROSAS",
      "RODEO DE PIEDRA",
      "QUEBRADA DE LOS POZOS",
      "EL VALLE",
      "VILLA LA VIÑA",
      "LAS CHACRAS",
      "EL PUEBLITO",
      "LABOULAYE",
      "SAN ROQUE DEL LAGO",
      "BIALET MASSE",
      "LA CAUTIVA",
      "SAN PEDRO",
      "SAN SEBASTIAN",
      "EL BORDO",
      "LOS CALLEJONES",
      "GENERAL LEVALLE",
      "R. DE LA CRUZ OESTE",
      "CERRO SAN LORENZO",
      "HUERTA VIEJA",
      "SAN JOSE",
      "RIO DE LOS SAUCES",
      "SAN FRANCISCO",
      "VILLA SAN LORENZO",
      "CAMPO BARA",
      "CAMPO OJO DE AGUA",
      "HERNANDO",
      "COLONIA LAS CUATRO ESQUINAS",
      "POZO DEL MOLLE",
      "SAN ERNESTO",
      "LAS CORTADERAS",
      "CAMPO LA CALERA",
      "CHAÑARITOS",
      "LA BARRANQUITA",
      "LAS TAPIAS",
      "PUNTA DEL AGUA",
      "SAN BERNARDO",
      "CAMPO LA AGUADA",
      "LA GILDA",
      "CAMPO LOS JAGUELES SUD",
      "SANTA FLORA",
      "COLONIA LA MADERA",
      "EL POTOSI",
      "COLONIA EL CARMEN",
      "GENERAL SOLER",
      "CAMPO ZANON",
      "COLONIA LA TERCERA",
      "CAMPO DE LA TORRE",
      "RIO SECO",
      "COLONIA 25 DE MAYO",
      "LA ESPERANZA",
      "CAROLINA",
      "LOS MOLLES",
      "COLONIA EL TORO",
      "LAGUNA SECA",
      "COLONIA LA PROVIDENCIA",
      "COLONIA ORCAVI",
      "CAMPO LEOFU",
      "CAMPO MARTINELLI",
      "LAS GAMAS",
      "COLONIA LA PINTA",
      "VILLA HERMINIA",
      "PUERTA COLORADA",
      "COLONIA LA ESCONDIDA",
      "BAYADA NUEVA",
      "LA SARA",
      "LOS JAGÑELES",
      "COSTA DEL TAMBO",
      "LA INVERNADA",
      "PUENTE LOS MOLLES",
      "COLONIA SANTA ROSA",
      "COLONIA LA ARGENTINA",
      "CAMPO SANTA MARIA",
      "TEGUA",
      "TRES POZOS",
      "LOS POZOS",
      "COLONIA LA PICHONA",
      "EL CANO",
      "ESPINILLO",
      "ESTACION ACHIRAS",
      "ESPINILLAL",
      "LA LAGUNILLA",
      "COLONIA LA NUEVA",
      "SANTA RITA",
      "COLONIA NUEVA SAMPACHO",
      "VUELTA DE LA CAÑADA",
      "LAGUNA OSCURA",
      "CAMPO ESNAOLA",
      "LAS ENSENADAS",
      "CUATRO VIENTOS",
      "SAN AMBROSIO",
      "LA BRIANZA",
      "LAS CINCO ESQUINAS",
      "PAUNERO",
      "SAN BARTOLOME",
      "LA PRIMAVERA",
      "LA CAROLINA",
      "LA HIGUERA",
      "VILLA CORAZON DE MARIA",
      "MALVINAS ARGENTINAS",
      "LA CUMBRECITA",
      "VILLA BERNA",
      "EL POTRERILLO",
      "ALTA GRACIA",
      "LA DONOSA",
      "VILLA BUENA ESPERANZA",
      "NOETINGER",
      "SAN TIBURCIO",
      "LAS JARILLAS",
      "LA TABLADA",
      "PIEDRITAS ROSADAS",
      "LAS OSCURAS",
      "LA GUANACA",
      "LA MUDANA",
      "LA AGUADITA",
      "EL CADILLO",
      "LOS QUEBRACHITOS",
      "LA SIERRITA",
      "EL QUEMADO",
      "BALDE DE LA ORILLA",
      "LA PATRIA",
      "LOS MOLLES",
      "MOGIGASTA",
      "LOS MEDANITOS",
      "COLONIA ANITA",
      "PLAZA DE MERCEDES",
      "ALCIRA",
      "SANTA TERESA",
      "COLONIA CAROYA",
      "VILLA DEL ROSARIO",
      "COLONIA DOS HERMANOS NORTE",
      "COLONIA MONTE GRANDE",
      "COLONIA MIRAMAR",
      "COLONIA LAS PALMERAS",
      "COLONIA GENERAL DEHEZA",
      "LA COLONIAL",
      "CAMPO CALLERIO",
      "COLONIA 10 DE JULIO",
      "COLONIA EL SAUCE",
      "COLONIA BEIRO ESTE",
      "COLONIA FREYRE NORESTE",
      "COLONIA MAUNIER NORTE",
      "COLONIA PALO LABRADO",
      "COLONIA MADRESELVA",
      "CAMPO LAS VIBORAS",
      "COLONIA MAUNIER CENTRO",
      "ARROYO DE LOS LEONES",
      "CAMPO LOPEZ",
      "COLONIA EL MILAGRO OESTE",
      "CAMPO LA SALADA",
      "COLONIA FRONTERA SUR",
      "EL PORVENIR",
      "EL DESQUITE",
      "COLONIA LA TRINCHERA",
      "COLONIA SANTA RITA",
      "LA QUEMADA-TRANSITO",
      "LAS CAÑITAS",
      "COLONIA MILESSI",
      "COLONIA NUEVA FRANCIA",
      "COLONIA CEFERINA",
      "ARROYO DE ALVAREZ",
      "CAMPO LOS PORTEÑOS",
      "SAN ANTONIO",
      "PAMPA DEL MERCADO",
      "COLONIA EUGENIA",
      "COLONIA MAUNIER SUR",
      "COLONIA MONTE TALA",
      "PLAYA GRANDE",
      "TRINCHERA",
      "CAMPO 25 DE MAYO",
      "COLONIA EL TRABAJO",
      "CAMPO LAVALLE",
      "ABRA DEL MANZANO",
      "COLONIA FREYRE NOROESTE",
      "COLONIA SAN RAFAEL",
      "COLONIA SEVERINA",
      "JERONIMO CORTES",
      "SAN BARTOLOME",
      "COLONIA FRONTERA NORTE",
      "COLONIA EL MILAGRO ESTE",
      "COLONIA LAVARELLO",
      "SANTA ROSA",
      "FRONTERA NORTE",
      "COLONIA DOS HERMANOS",
      "LOS QUEBRACHITOS",
      "CAMPO LOS TERCERANOS",
      "PUNTA DEL AGUA",
      "CAMPO LOS ZORROS",
      "COLONIA AMALIA",
      "COLONIA LA TAPERITA",
      "LAS DELICIAS",
      "LA CORTADERA",
      "COLONIA UNIDAD",
      "CABITUYO",
      "LA VICTORIA",
      "ESTACION KILOMETRO 581",
      "EL PINO",
      "PUERTA LOS MONTES",
      "CAMPO LA SOLEDAD",
      "COLONIA NUEVA UDINE",
      "LOMA DE LOS INDIOS",
      "COLONIA COYUNDA",
      "COLONIA BEIRO NORTE",
      "LA TOSCANITA",
      "PLAZA BRUNO",
      "COLONIA LAS LOMAS",
      "POZO SALADO",
      "POZO DEL MORTERO",
      "CHALACEA",
      "POZO DEL MORO",
      "SACANTA",
      "MAYU SUMAJ",
      "VILLA MARIA",
      "VILLA ALBERTINA",
      "LAS PLAYAS",
      "LOS SAUCES",
      "SAN MARCOS SIERRA",
      "LA BANDA",
      "LA CONSTANCIA",
      "SAN JAVIER Y YACANTO",
      "COUNTRY SAN ISIDRO",
      "LA MORADA",
      "VILLA ALLENDE",
      "COUNTRY CHACRAS DE LA VILLA",
      "SAN FERNANDO",
      "NICOLAS BRUZZONE",
      "LA CRUZ",
      "DIQUE CHICO",
      "MALENA",
      "PUNTA DEL AGUA",
      "SERRANO",
      "SAN CLEMENTE",
      "PASO DE LA PAMPA",
      "COLONIA MARINA",
      "CAMPO LA CHANTADA",
      "CAMPO MAYOL",
      "COLONIA LA LEGUA",
      "COLONIA DOLORES",
      "COLONIA ALTO VERDE",
      "BARRETO",
      "COLONIA CAMPO ALBANO",
      "LA CREMERIA",
      "CAMPO SAN JUAN",
      "COLONIA MAIPU",
      "CAMPO LA ZULEMA",
      "MANANTIALES",
      "COLONIA MARIA ANGELINA",
      "COLONIA SANTO TOMA",
      "OLMOS",
      "CAMPO ANCHORENA",
      "COLONIA SANTA CLARA",
      "COLONIA LA FLORIDA",
      "PAVIN",
      "COLONIA LA MONONA",
      "COLONIA LAS MERCEDITAS",
      "COLONIA GRANJA LA CELINA",
      "COLONIA SAN JOSE",
      "COLONIA SANTA PAULA",
      "VILLA CONCEPCION DEL TIO",
      "COLONIA BREMEN",
      "EL MANZANO",
      "CANTERAS EL SAUCE",
      "VILLA ELISA",
      "CAMPO LA REDENCION",
      "VILLA LOS AROMOS",
      "VILLA FLOR SERRANA",
      "TANTI",
      "RIO CUARTO",
      "LA ESQUINA",
      "COLONIA M. JUAREZ CELMAN",
      "LOS SURGENTES",
      "TALA HUASI",
      "SAN BASILIO",
      "IMPIRA",
      "SAGRADA FAMILIA",
      "DIEGO DE ROJAS",
      "CANDELARIA SUR",
      "NINTE",
      "CAMPO COLUMBO",
      "LOS ALGARROBITOS",
      "LAS ASTILLAS",
      "PIEDRAS GRANDES",
      "LA FALDA",
      "PASCANAS",
      "SEBASTIAN ELCANO",
      "LA POBLACION",
      "SAN CARLOS MINAS",
      "SAUCE DE LOS QUEVEDOS",
      "AGUA DEL CRESPIN",
      "MESA DE MARIANO",
      "LOS BARRIALES",
      "NINALQUIN",
      "LAS CORZUELAS",
      "UNQUILLO",
      "CANALS",
      "ISLETA CABRAL",
      "LA MARGARITA",
      "PEDANIA YUCAT",
      "CAMPO LA ALEJANDRA",
      "ANA ZUMARAN",
      "SANTA VICTORIA",
      "SANTA RITA",
      "LAS MOJARRAS",
      "CAYUQUEO",
      "SAN JOSE",
      "LA HERRADURA",
      "CAMPO LOS PRADOS",
      "CAMPO EL CHATO",
      "SALADILLO",
      "COLAZO",
      "SAN ISIDRO",
      "LOS HORMIGUEROS",
      "LOS CHAÑARITOS",
      "COLONIA MARIA GODEKEN",
      "COLONIA ITALIANA",
      "CAMPO MURPHY",
      "COLONIA SICK",
      "PARQUE CALMAYO",
      "SANTA CATALINA",
      "HIPOLITO BOUCHARD",
      "SAN HUBERTO",
      "EL HUAYCO",
      "LAS CALLES",
      "ASCOCHINGA",
      "LA GRANJA",
      "LOS MOLLES",
      "LOS REARTES",
      "SAN ANTONIO",
      "GUANACO MUERTO",
      "EL ABRA",
      "SANTO DOMINGO",
      "LA LAGUNA",
      "CACHI YACO",
      "EL ZAPALLAR",
      "EL PANTANO",
      "LA PLAZA",
      "SANTO DOMINGO",
      "SANTA MARIA",
      "LOMA BLANCA",
      "CAMPO ALEGRE",
      "LA PROVIDENCIA",
      "EL CACHI",
      "LA MAJADILLA",
      "MONTE BUEY",
      "VILLA DEL PARQUE (VILLA RUMIPAL)",
      "SOLAR DE LOS MOLINOS",
      "VILLA CIUDAD PARQUE LOS REARTES (3Ñ SECCION)",
      "VILLA CIUDAD PARQUES LOS REARTES (1Ñ SECCION)",
      "VILLA CIUDAD PARQUE LOS REARTES",
      "VILLA DE POCHO",
      "LOS MANANTIALES",
      "LA GUARIDA",
      "LA PAZ",
      "EL MANANTIAL",
      "LOS MATES",
      "LAS CHACRAS",
      "QUEBRACHO LADEADO",
      "LOMA BOLA",
      "CRUZ CAÑA",
      "LA RAMADA",
      "CASEROS ESTE",
      "LA ARABIA",
      "LA ARCADIA",
      "TOLEDO",
      "KILOMETRO 15",
      "LA ESTANCIA",
      "CHAÑAR VIEJO",
      "BARRIO VILLA DEL PARQUE",
      "VILLA CIUDAD DE AMERICA",
      "SAN IGNACIO (LOTEO SAN JAVIER)",
      "CASEROS CENTRO",
      "POTRERO DEL ESTADO",
      "ALTO DEL DURAZNO",
      "BOUWER",
      "SAN LORENZO",
      "LAS MARAVILLAS",
      "LA CESIRA",
      "PIEDRAS BLANCAS",
      "EL DIQUECITO",
      "LA CALERA",
      "CASA BAMBA",
      "LA MESADA",
      "DUMESNIL",
      "SERREZUELA",
      "LAS ABRAS",
      "EL QUICHO",
      "CACHIYUYO",
      "EL DIECISEIS",
      "SAN AGUSTIN",
      "DEVOTO",
      "SILVIO PELLICO",
      "BALLESTEROS",
      "ETRURIA",
      "JUSTINIANO POSSE",
      "ALICIA",
      "WASHINGTON",
      "SAN JOSE DE LA DORMIDA",
      "ALTO DE FLORES",
      "ALDEA SANTA MARIA",
      "SANTA ELENA",
      "VILLA REDUCCION",
      "EL BALDECITO",
      "PIEDRA PINTADA",
      "VILLA DOLORES",
      "LAS ENCRUCIJADAS",
      "LA PRIMAVERA",
      "ANA ZUMARAN",
      "LA SERRANITA",
      "LOS MOLINOS",
      "VILLA SAN MIGUEL",
      "BARRIO NUEVO RIO CEBALLOS",
      "PAJAS BLANCAS",
      "RIO CEBALLOS",
      "EL ARAÑADO",
      "CAÑADA DE RIO PINTO",
      "EL SAUCE",
      "ALTO SIERRA",
      "LA BISMUTINA",
      "GUASAPAMPA",
      "NONO",
      "CIENAGA DE ALLENDE",
      "LOS ALGARROBOS",
      "OJO DE AGUA",
      "LA MAJADA",
      "LA FRANCIA",
      "EL CALLEJON NORTE",
      "RIO TERCERO",
      "CAMPO GIODA",
      "LOS POTREROS",
      "QUEBRACHO HERRADO",
      "EL MANANTIAL",
      "PIEDRA BLANCA",
      "ALTAUTINA",
      "LA CORTADERA",
      "PACHANGO",
      "TASNA",
      "LAGUNAS VERDES",
      "QUEBRACHO SOLO",
      "LAS OSCURAS",
      "LA COCHA",
      "VILLA RAFAEL BENEGAS",
      "SANTA TERESITA",
      "SANTA CATALINA",
      "EL VOLCAN",
      "LA CONCEPCION",
      "SAN MARTIN",
      "MUSSI",
      "EL PONIENTE",
      "LOS CERROS",
      "LOS ESPINILLOS",
      "SEGUNDA USINA",
      "COSTASACATE",
      "COLONIA SAN EUGENIO",
      "COLONIA SANTA CLARA",
      "RUIZ DIAZ DE GUZMAN",
      "COLONIA SANTA ROSA",
      "ESTANCIA LA MARGARITA",
      "VIVERO",
      "COLONIA LA PROVIDENCIA",
      "FRAY CAYETANO RODRIGUEZ",
      "ESTANCIA LA EMILIA",
      "CAMPO AMPURDAN",
      "LA RAMADA",
      "COLONIA FABRICA N° 3",
      "COLONIA SANTA ANA",
      "COLONIA EL GUANACO",
      "COLONIA SANTA CRISTINA",
      "GUARDIA VIEJA",
      "COLONIA SAN MIGUEL",
      "SALGUERO",
      "LAS TRES COLONIAS UNIDAS",
      "EST. EL PARAISO",
      "COLONIA EL ARBOL",
      "LA AMALIA",
      "COLONIA EL NOY",
      "LAGUNA DEL MONTE",
      "ARROYITO",
      "LA CURVA",
      "EL FUERTECITO",
      "LAS TAPIAS",
      "LAGUNA DE ANSENUZA",
      "LOMAS DEL TROZO",
      "LA PARA",
      "LA CANDELARIA",
      "CRUZ DE CAÑA",
      "CHAÑARITOS N° 2",
      "TALA CAÑADA",
      "TALA CAÑADA",
      "SAGRADA FAMILIA",
      "RUMI HUASI",
      "CIENAGA DEL CORO",
      "PIEDRAS AMONTONADAS",
      "LA MESILLA",
      "SAUCE GRANDE",
      "RARA FORTUNA",
      "VALLE DE ANISACATE",
      "OLAETA",
      "SAN ANTONIO DE ARREDONDO",
      "SANTA ROSA",
      "SAN ANTONIO",
      "LAS JARILLAS",
      "CHUÑA HUASI",
      "RODEITO",
      "SAN ANTONIO DE LITIN",
      "PUESTO DE CASTRO",
      "MONTE LEÑA",
      "VILLA SARMIENTO",
      "CASA GRANDE",
      "VILLA VALERIA",
      "HUINCA RENANCO",
      "LA ESPERANZA",
      "EL VENCE",
      "BAJO HONDO",
      "LAS MARAVILLAS",
      "LAS ARRIAS",
      "EL PEDACITO",
      "VILLA DEL TOTORAL",
      "LA MAZA",
      "EL RODEO",
      "CORDOBA",
      "LA FLORESTA",
      "VILLA LA QUEBRADA",
      "VILLA ESQUIU",
      "EL GATEADO",
      "CORONEL OLMEDO",
      "JARDIN ARENALES",
      "LOS QUEBRACHOS",
      "LA BOCA DEL RIO",
      "JOSE DE LA QUINTANA",
      "VILLA SAN ISIDRO - JOSE DE LA QUINTANA",
      "FREYRE",
      "SAMPACHO",
      "MENDIOLAZA",
      "LA TORDILLA",
      "RODEO GRANDE",
      "TOSNO",
      "RIO SECO",
      "EL FORTIN",
      "SAN JORGE",
      "SAN LORENZO",
      "LAS BANDURRIAS",
      "MACHA",
      "PUESTO DEL ROSARIO",
      "LOS COMETIERRA",
      "SANTA MARIA",
      "LA TUNA",
      "BELEN",
      "SAN SALVADOR",
      "LOS CHAÑARES",
      "COLONIA HOGAR",
      "BARRANCA YACO",
      "LA MAZA",
      "SAN PELLEGRINO",
      "SAN ISIDRO",
      "MULA MUERTA",
      "EL RINCON",
      "PUESTO SAN JOSE",
      "EST. SAN JUAN",
      "LA AGUADA",
      "LA PAZ",
      "SANTA CATALINA",
      "LA ESTRECHURA",
      "AUSONIA",
      "SANABRIA",
      "LAS VARILLAS",
      "LEGUIZAMON",
      "PASCO",
      "MORTEROS",
      "MEDIA LUNA NORTE",
      "TINOCO",
      "DALMACIO VELEZ",
      "CHUCUL",
      "VALLE HERMOSO",
      "DIAZ",
      "CAPILLA DE LOS REMEDIOS",
      "BENJAMIN GOULD",
      "ACHIRAS",
      "COLONIA SAN PEDRO",
      "COLONIA PUEYRREDON",
      "VICUÑA MACKENNA",
      "POTRERO DE GARAY",
      "GOLPE DE AGUA",
      "LOS ESPINILLOS",
      "CAPILLA DEL CARMEN",
      "ARIAS",
      "VILLA CERRO AZUL",
      "CALCHIN",
      "LOS COCOS",
      "EL CORCOVADO - EL TORREON",
      "VILLA RUMIPAL",
      "ESTANCIA VIEJA",
      "LA PALESTINA",
      "COTAGAITA",
      "BRINCKMANN",
      "LA CONCEPCION",
      "LAS PALMAS",
      "OLIVARES DE SAN NICOLAS",
      "ESQUINA DEL ALAMBRE",
      "COLONIA ROMANA",
      "CAMPO EL CABURE",
      "CHACRAS DE TIO PUJIO",
      "TIO PUJIO",
      "GRANJA LA MARGARITA",
      "PEDANIA YUCAT P/TIO PUJIO",
      "COLONIA SANTA RITA",
      "VILLA FONTANA",
      "PUNTA DEL ARROYO",
      "EL TOSTADO",
      "SANTA RITA",
      "ALMAFUERTE",
      "CHURQUI CAÑADA",
      "CORRAL DE BUSTOS",
      "SAN CARLOS",
      "EL PERCHEL",
      "EL TUSCAL",
      "LAS MASITAS",
      "LAS PALMAS",
      "LA TOMA",
      "CHIPITIN",
      "POZO SOLO",
      "TOTORALEJOS",
      "EL BARRIAL",
      "SANTA CRUZ",
      "ALTO VERDE",
      "PUESTO VIEJO",
      "INTI HUASI",
      "LA ANGOSTURA",
      "PUESTO DE CEJAS",
      "ISLA LARGA",
      "CAÑADA DEL TALA",
      "EL DURAZNO",
      "LOS ALAMOS",
      "LOS POZOS",
      "VILLA COLIMBA",
      "SAN BERNARDO",
      "LA CIENEGUITA",
      "LOS SAUCES",
      "SAN ANTONIO",
      "CRUZ MOJADA",
      "ONGAMIRA",
      "VILLA ALICIA",
      "EL QUEBRACHO",
      "LAS MANZANAS",
      "LA BARRANCA",
      "LAS TUSCAS",
      "SAUCE CHIQUITO",
      "ESTANCIA SAN MIGUEL",
      "PUESTO NUEVO",
      "LA BOTIJA",
      "VILLA ALBERTINA",
      "BAJO ALEGRE",
      "LA CANTERA",
      "LOS RUICES",
      "TODOS LOS SANTOS",
      "HUASCHA",
      "SAN PEDRO DE TOYOS",
      "LOS TARTAGOS",
      "ARBOL BLANCO",
      "EL MOLINO",
      "ISCHILIN",
      "LA LINEA",
      "ISCHILIN VIEJO",
      "LOS MISTOLES",
      "VILLA DE MARIA",
      "ATAHONA",
      "LA ISLA",
      "LA PAISANITA",
      "SARMIENTO",
      "AGUA DE LAS PIEDRAS",
      "LOS CONDORES",
      "BANDA SUD",
      "DEL CAMPILLO",
      "COLONIA VIGNAUD",
      "PIEDRA PINTADA",
      "SAUCE ARRIBA",
      "VILLA DEL DIQUE",
      "EL PORTEZUELO",
      "LUYABA",
      "GUANACO BOLEADO",
      "LA TRAVESIA",
      "TRAVESIA",
      "SAN ISIDRO",
      "VILLA EL CHACAY",
      "TRES POZOS",
      "TIMON CRUZ",
      "MAQUINISTA GALLINI",
      "AGUA HEDIONDA",
      "SAN JOSE DE LAS SALINAS",
      "ISLA DE SAN ANTONIO",
      "MELO",
      "BALLESTEROS SUR",
      "AVELLANEDA",
      "JUAN GARCIA",
      "EL ESTANQUE",
      "VILLA RIO ICHO CRUZ",
      "CAUSANA",
      "MALAGUEÑO",
      "FALDA DEL CAÑETE",
      "VILLA SIERRAS DE ORO",
      "TIERRA ALTA",
      "SAN NICOLAS",
      "LA PERLA",
      "TEJAS TRES",
      "BARRIO GILBERT (1° DE MAYO)",
      "MILENICA",
      "YOCSINA",
      "PUNTA DE AGUA",
      "BULNES",
      "LA BATEA",
      "SAN AGUSTIN",
      "VILLA SANTA RITA"
    ]
  },
  {
    "nombre": "Entre Ríos",
    "localidades": [
      "LOS CONQUISTADORES",
      "GENERAL GALARZA",
      "SAN RAMIREZ",
      "NUEVA VIZCAYA",
      "ENRIQUE CARBO",
      "ALARCON",
      "GENERAL RACEDO",
      "COLONIA LA SARITA",
      "RINCON LUCAS SUD",
      "COLONIA PEREIRA",
      "COLONIA SAN ANSELMO",
      "MOLINO DOLL",
      "COLONIA OFICIAL 16",
      "COLONIA AYMAN",
      "BANDERITAS",
      "COLONIA LA BERTA",
      "COLONIA SAN LORENZO",
      "COLONIA LA MARTA",
      "DIEGO LOPEZ",
      "COLONIA LA LATA",
      "COLONIA SANTA LUCIA",
      "COLONIA OFICIAL 18",
      "LAS MULITAS",
      "ARROYO SEPULTURA",
      "ARROYO LAS LECHIGUANAS",
      "PASTOR BRITOS",
      "RINCON DEL GATO",
      "PERDICES",
      "DISTRITO PERDICES",
      "ÑANCAY",
      "LA PROVIDENCIA",
      "COLONIA EL SAUCESITO",
      "CRUCESITAS",
      "ORO VERDE",
      "ARROYO CORRALITO",
      "ALDEA SANTA ROSA",
      "ARROYO GRANDE",
      "COLONIA OFICIAL N° 5",
      "COLONIA SAN MARTIN",
      "ESTANCIA LA SILVIA",
      "COLONIA SAGASTUME",
      "COLONIA SAN RAMON",
      "SAN CIPRIANO",
      "LAS ACHIRAS",
      "LOS CEIBOS",
      "DISTRITO CHILCAS",
      "DISTRITO HINOJAL",
      "RINCON DEL DOLL",
      "MONTOYA",
      "COLONIA ADIVINOS",
      "EL CHAJARI",
      "COLONIA PUENTE DEL GUALEG",
      "COLONIA LAS PEPAS",
      "COLONIA SANTA ROSA",
      "SAN MIGUEL",
      "COLONIA NUEVA SAN MIGUEL",
      "PUNTA DEL MONTE",
      "DISTRITO TALA",
      "COLONIA REFFINO",
      "ESTACION YUQUERI",
      "LOMA LIMPIA",
      "EL GATO",
      "COLONIA OFICIAL Nº 13",
      "GONZALEZ CALDERON",
      "LAS TOSCAS",
      "CRUCESITAS TERCERA",
      "DISTRITO COSTA URUGUAY SUR",
      "MONTE REDONDO",
      "LAS TUNAS",
      "SAUCE SUD",
      "LA JUANITA",
      "LA JAULA",
      "COLONIA ENSAYO",
      "COLONIA SANTA ELOISA",
      "VILLA DEL ROSARIO",
      "ALDEA SAN JUAN",
      "COLONIA EL CLAVO",
      "ALTAMIRANO SUR",
      "SOSA",
      "COLONIA LA GLORIA",
      "COLONIA LA PAZ",
      "COLONIA PERFECCION",
      "CONCEPCION DEL URUGUAY",
      "ARROYO URQUIZA",
      "TALITA",
      "COLONIA SANTA ANA",
      "DISTRITO MOLINO",
      "GENERAL ALMADA",
      "FEBRE",
      "DISTRITO MONTOYA",
      "COLONIA LA PERLA",
      "COLONIA SANTA MARGARITA",
      "COLONIA CAÑADA GRANDE",
      "SAN VICTOR",
      "ESTACION PALO A PIQUE",
      "COLONIA SAN MIGUEL",
      "PUEBLO CAZES",
      "LAS PIEDRAS",
      "PARANA",
      "VILLA URANGA",
      "BAJADA GRANDE",
      "GENERAL CAMPOS",
      "PASO BRAVO",
      "LAGUNA BENITEZ",
      "VILLA URQUIZA",
      "LOS AROMOS",
      "LA BALSA",
      "LA ARGENTINA",
      "DISTRITO CEIBAS",
      "EL EMPALME",
      "EL SALADERO",
      "EL SAUCE",
      "ARROYO HONDO",
      "ESQUINA",
      "COLONIA RIVADAVIA",
      "VILLAGUAY",
      "ESTACION PALAVECINO",
      "COSTA LAS MASITAS",
      "GUALEYANCITO",
      "DISTRITO PEHUAJO SUD",
      "DISTRITO PEHUAJO NORTE",
      "DISTRITO CEIBAS",
      "TRES ESQUINAS",
      "COLONIA STAUBER",
      "COLONIA LAS PIEDRAS",
      "COLONIA ITALIANA",
      "ESTANCIA EL REFUGIO",
      "PEDERNAL",
      "COLONIA SANTA ISABEL",
      "JUBILEO",
      "SANTA ANA",
      "COLONIA ENSANCHE SAUCE",
      "COLONIA LAS FLORES",
      "IRAZUSTA",
      "COLONIA 25 DE MAYO",
      "ALCARAZ",
      "BARRAGAN",
      "EL CIMARRON",
      "ALDEA SAN ISIDRO",
      "ANTELO",
      "COLONIA SAN ERNESTO",
      "COLONIA PUNTAS DEL GUALEGUAYCHU",
      "RINCON DEL VILLAGUAY",
      "COLONIA ESPINDOLA",
      "VILLAGUAY ESTE",
      "COLONIA SAN JORGE",
      "COLONIA LA GERONIMA",
      "COLONIA LA ROSADA",
      "COLONIA SAN VICENTE",
      "PICADA BERÓN",
      "EL YESO",
      "EL CARMEN",
      "EL GUAYABO",
      "EL ACHIRAL",
      "LUCAS NORTE",
      "EL CURUPI",
      "DISTRITO COSTA DE NOGOYA",
      "PUERTA DE CRESPO",
      "ALDEA ANDREOLI",
      "MIÑONES",
      "CUATRO BOCAS",
      "COLONIA BELGRANO",
      "HERNANDARIAS",
      "PUERTO VIBORAS",
      "CERRITO",
      "PUEBLO MORENO",
      "PUEBLO GENERAL PAZ",
      "LAS TUNAS",
      "COLONIA WALTER MOSS",
      "COLONIA LA ARMONIA",
      "TABOSSI",
      "PASO BLANCO",
      "MOJONES NORTE",
      "EL PALENQUE",
      "COLONIA CRESPO",
      "CARMONA",
      "COLONIA SAN JUAN",
      "COLONIA LA ESPERANZA",
      "COLONIA LA LLAVE",
      "ALGARROBITOS",
      "CAMPO MICHELOUD",
      "COLONIA OFICIAL 21",
      "VILLA ADELA",
      "CAMBA PASO",
      "BENITO LEGEREN",
      "LAS TEJAS",
      "VILLA ZORRAQUIN",
      "CONCORDIA",
      "DOS HERMANAS",
      "LAS MERCEDES",
      "COLONIA 3 DE FEBRERO",
      "COLONIA TABOADA",
      "CAMPO JOURBET",
      "PUEBLO BRUGO",
      "COLONIA LA JOYA",
      "LIBAROS",
      "ESTACION ESCRIÑA",
      "HOCKER",
      "LAS PAJITAS",
      "ESTACION RAICES",
      "DISTRITO RAICES",
      "COLONIA OFICIAL 2",
      "CUCHILLA REDONDA",
      "DISTRITO CUCHILLA REDONDA",
      "URDINARRAIN",
      "COLONIA LA FLORIDA",
      "BARRANCAS COLORADAS",
      "EL PUEBLITO",
      "COLONIA OFICIAL 17",
      "COLONIA SANTA MARIA",
      "FORTUNA",
      "COLONIA VIRARO",
      "ALDEA EIGENFELD",
      "CEIBAS",
      "GUAYAQUIL",
      "COLONIA ARGENTINA",
      "PASO DE LAS PIEDRAS",
      "ALDEA VALLE MARIA",
      "ALDEA SAN FRANCISCO",
      "COLONIA SAN SALVADOR",
      "SAN SALVADOR",
      "SANTA ANITA",
      "COLONIA TUYUTI",
      "VILLA FONTANA",
      "COLONIA AVELLANEDA",
      "NOGOYA",
      "EL REDOMON",
      "PASO DEL GALLO",
      "LA QUERENCIA",
      "COLONIA URQUIZA",
      "YAROS",
      "GUALEGUAYCHU",
      "PUERTO UNZUE",
      "SARANDI",
      "GUALEYAN",
      "VILLA PARANACITO",
      "ARROYO BRAZO CHICO",
      "ARROYO MERLO",
      "BRAZO LARGO",
      "ARROYO SANTOS GRANDE",
      "ARROYO NEGRO",
      "ARROYO GRANDE",
      "SAGASTUME",
      "DISTRITO ISLETAS",
      "ISLETAS",
      "LUCAS GONZALEZ",
      "ALDEA SAN SIMON",
      "LAS GUACHAS",
      "SAUCE NORTE",
      "ATENCIO",
      "LA TE",
      "SAN JOSE DE FELICIANO",
      "GOBERNADOR ECHAGUE",
      "COLONIA SAUCE NORTE",
      "ESTACION DON GONZALO",
      "RAMBLONES",
      "CARPINCHORI",
      "LA CALANDRIA",
      "VILLA SAN MARCIAL",
      "COLONIA NUEVA ITATI",
      "COLONIA LA BLANQUITA",
      "LAGUNA LARGA",
      "COLONIA CONDOR",
      "ZENON ROCA",
      "LUCAS SUD",
      "COLONIA NUEVA ALEMANIA",
      "COLONIA SAN GREGORIO",
      "COLONIA BERRO",
      "COLONIA LA CHUNGA",
      "COLONIA LA MORA",
      "MOJONES SUR",
      "EL TIGRE",
      "LOS TASES",
      "SAUCE MEDIO",
      "SAN BENITO",
      "PASO DE LA ARENA",
      "COSTA DE MULAS",
      "MULAS GRANDES",
      "PUEBLO GENERAL BELGRANO",
      "DON CRISTOBAL",
      "PUERTO ALGARROBO",
      "COLONIA SAN LUIS",
      "PASO POTRILLO",
      "LA CLARITA",
      "COLONIA SAN PASCUAL",
      "COLONIA SAN JUSTO",
      "DIAMANTE",
      "STROBEL",
      "ESTACION LAZO",
      "LA VERBENA",
      "VIBORAS",
      "PUEBLO NUEVO",
      "BASAVILBASO",
      "ALDEA SPATZENKUTTER",
      "EL CERRO",
      "COLONIA CELINA",
      "COLONIA SANTA JUANA",
      "COLONIA OFICIAL 25",
      "XX DE SETIEMBRE",
      "INGENIERO MIGUEL SAJAROFF",
      "COLONIA SANTA ELENA-COLONIABAYLINA",
      "EL CORCOVADO",
      "COLONIA AVIGDOR",
      "CAPIVARA",
      "LAS GURISAS",
      "BASUALDO",
      "LA ESMERALDA",
      "RINCON DE MESA",
      "NUEVA ESCOCIA",
      "EL RAMBLON",
      "QUEBRACHO",
      "RAMBLONES",
      "COLONIA SAN EMILIO",
      "COLONIA SANTAFESINA",
      "CAMPO MASSINE",
      "SEGUI",
      "COLONIA CADEL",
      "SAN PEDRO",
      "EL CARUMBE",
      "LAS ACHIRAS",
      "CONSCRIPTO BERNARDI",
      "TEZANOS PINTO",
      "GENERAL GUEMES",
      "RINCON SANTA MARIA",
      "VILLA SAN JUSTO",
      "PILOTO AVILA",
      "LA PAZ",
      "ALDEA SALTO",
      "VIALE",
      "ALDEA GRAPSCHENTAL",
      "MOLINO DOLL",
      "PUEBLO BELLOCQ",
      "COLONIA LA GAMA",
      "COLONIA MANSILLA",
      "GOBERNADOR MANSILLA",
      "CAMPOS SANCHEZ",
      "PIEDRAS BLANCAS",
      "CAMPO REBECHI",
      "LA OLLITA",
      "RAICES OESTE",
      "EL TROPEZON",
      "ALDEA DIAZ",
      "CANTINA BONALDO",
      "EL MALAGUEÑO",
      "COLONIA LA MATILDE",
      "VILLA ELISA",
      "COLONIA VAZQUEZ",
      "COLONIA EL CARMEN",
      "COLONIA GOBERNADOR CRESPO",
      "COLONIA MEROU",
      "COLONIA PEÑA",
      "SAN RAMON",
      "COLONIA EL TROMPO",
      "MANDISOVI",
      "HASENKAMP",
      "ESPINILLO",
      "SIR LEONARD",
      "COLONIA NUEVA MONTEVIDEO",
      "ROCAMORA",
      "ESTANCIA LA ESTRELLA",
      "COLONIA ALMADA",
      "COLONIA J. FINK",
      "DISTRITO CHAÑAR",
      "MOREIRA",
      "ARROYO CHAÑAR",
      "CARRASCO",
      "ALDEA SAN ANTONIO",
      "PASO MEDINA",
      "EL CHAÑAR",
      "MOLINO PUBLICO",
      "LA SELVA",
      "ESTAQUITAS",
      "COLONIA BUENA VISTA",
      "EL TALITA",
      "MACIA",
      "ESTACION LA HIERRA",
      "GUARDAMONTE",
      "ALDEA BRASILERA",
      "PARAJE LA VIRGEN",
      "VILLA MANTERO",
      "COLONIA BARREROS",
      "ISLA JUANICO",
      "COLONIA LUCIENVILLE",
      "DISTRITO MOSCAS",
      "COLONIA GENACITO",
      "LAS DELICIAS",
      "EL RINCON",
      "SAUCE SUR",
      "FEDERAL",
      "COLONIA SANTA LUISA",
      "LA PICADA",
      "FAUSTINO M. PARERA",
      "COLONIA GOBERNADOR BASAVILBASO",
      "LA TACUARA",
      "LAGUNA DEL PESCADO",
      "ARANGUREN",
      "COLONIA ALGARROBITOS",
      "ALGARROBITOS SEGUNDO",
      "EL QUEBRACHO",
      "MEDANOS",
      "CAMPO MUJICA",
      "MARIA GRANDE",
      "ESTACION CAMPS",
      "DURAZNO",
      "EL GUINEO",
      "ALTAMIRANO NORTE",
      "COLONIA 3 DE FEBRERO",
      "COLONIA GENERAL URQUIZA",
      "COLONIA EL PANTANOSO",
      "1 DE MAYO",
      "RINCON DE NOGOYA",
      "PUERTO ESQUINA",
      "LOS CERROS",
      "VILLA LIBERTADOR SAN MARTIN",
      "ESTACION PUIGGARI",
      "COSTA GRANDE",
      "SAN JAIME DE LA FRONTERA",
      "COLONIA OFICIAL 9",
      "COLONIA ALVEAR",
      "ALDEA PROTESTANTE",
      "PASO DE ALONSO",
      "GUALEGUAY",
      "PUERTO RUIZ",
      "VILLA ALVAREZ",
      "DISTRITO YESO",
      "CHACABUCO",
      "EL CHIMANGO",
      "PUERTO CONSTANZA",
      "ESTACION LIBERTADOR GENERAL SAN MARTIN",
      "PUERTO PERAZZO",
      "IBICUY",
      "SAUCE MONTRULL",
      "COLONIA SANTA TERESITA",
      "PRONUNCIAMIENTO",
      "GENERAL RAMIREZ",
      "ROSARIO DEL TALA",
      "SANTA MARGARITA DEL GENA",
      "COLONIA SANTA ZELMIRA",
      "HERRERA",
      "CAMPO LA VIRGINIA",
      "COLONIA RINCON DEL GENA",
      "ESTANCIA LOS PARAISOS",
      "CAMPO PARERA",
      "HERNANDEZ",
      "DISTRITO SAUCE AL NORTE",
      "EL TROPEZON",
      "ARROYO OBISPO",
      "DISTRITO PUEBLO PRIMERO",
      "DISTRITO RAICES AL SUD",
      "PUEBLO LIEBIG'S",
      "LA ENCIERRA",
      "EL GRAMILLAL",
      "COLONIA SAN JUAN",
      "ALDEA SAN JUAN",
      "CRESPO",
      "LOMA NEGRA",
      "LOS CHARRUAS",
      "LAS MOSCAS",
      "CAMPO FURLAN",
      "ALDEA SANTA MARIA",
      "ANTONIO TOMAS",
      "ALDEA SAN RAFAEL",
      "CAMPO ZIEGLER",
      "COLONIA SAN PEDRO",
      "SAN GUSTAVO",
      "CAMPO LACORAZA",
      "HARAS GENERAL URQUIZA",
      "DISTRITO CLE",
      "CUATRO MANOS",
      "DISTRITO VIZCACHA",
      "LA CUADRA",
      "DISTRITO ALBARDON",
      "DISTRITO SAUCE",
      "TRES BOCAS",
      "COLONIA EL PARAISO",
      "ALDEA SANTA CELIA",
      "ALDEA SAN ANTONIO",
      "ARROYO BARU",
      "COLONIA IZQUIERDO",
      "DISTRITO COSTA URUGUAY NORTE",
      "BETBEDER",
      "VILLA CLARA",
      "COLONIA GENERAL ROCA",
      "PUEBLO FERRE",
      "ESTACION YERUA",
      "EL OMBU",
      "EL BRILLANTE",
      "SAN JOSE",
      "PERUCHO VERNA",
      "EL COLORADO",
      "ALDEA MARIA LUISA",
      "GENERAL ALVEAR",
      "COLONIA HUGUES",
      "COLONIA PASO PAYSANDU",
      "COLON",
      "ARROYO HONDO",
      "CALABACILLA",
      "COLONIA YERUA",
      "ESTANCIA GRANDE",
      "PUERTO LAS CUEVAS",
      "DISTRITO DOLL",
      "CAMPO VASALLE",
      "ALDEA ASUNCION",
      "DISTRITO JACINTA",
      "DISTRITO CUCHILLA",
      "ESTACION ESTACAS",
      "CUATRO BOCAS",
      "CURTIEMBRE",
      "PUEBLO GENERAL SAN MARTIN",
      "COLONIA SAN MARTIN",
      "COLONIA SEDNA",
      "SANTA ELENA",
      "DISTRITO FELICIANO",
      "ESTANCIA SAN JUAN",
      "ESTACAS",
      "EL SALADO",
      "LOS TALAS",
      "MONTIEL",
      "COLONIA MAXIMO CASTRO",
      "EST. EL TIGRE",
      "PASO TELEGRAFO",
      "ESTANCIA SANTA INES",
      "EL SOLAR",
      "COLONIA SAN CARLOS",
      "COLONIA BERTOZI",
      "COLONIA LA PROVIDENCIA",
      "COLONIA LOS SAUCES",
      "BOVRIL",
      "LARROQUE",
      "LAS TRES ESQUINAS",
      "LAURENCENA",
      "PASO DE LA LAGUNA",
      "COLONIA DESPARRAMADOS",
      "CHAJARI",
      "COLONIA VILLA LIBERTAD",
      "CLODOMIRO LEDESMA",
      "COLONIA AYUI",
      "ARROYO DEL MEDIO",
      "LA ROSADA",
      "PUERTO YERUA",
      "ESTANCIA CENTELLA",
      "EL POTRERO",
      "DISTRITO POTRERO",
      "CAMPICHUELO",
      "COLONIA ELIA",
      "SAUCE PINTO",
      "COLONIA MANDISOVI",
      "COLONIA ALEMANA",
      "EL PINGO",
      "LA COLMENA",
      "UBAJAY",
      "ARROYO CONCEPCION",
      "DISTRITO SEXTO",
      "COLONIA SAN ANTONIO",
      "SAUCE DE LUNA",
      "VILLA GOBERNADOR LUIS F. ETCHEVEHERE",
      "GILBERT",
      "CARRIZAL",
      "DISTRITO CORRALES",
      "DISTRITO QUEBRACHITOS",
      "VILLA LIBERTAD",
      "PAJONAL",
      "LA CRIOLLA",
      "SAN BONIFACIO",
      "LAGO GRANDE",
      "COLONIA SAN HUBERTO",
      "HAMBIS",
      "VILLA DOMINGUEZ",
      "CAMPO TAFAREL",
      "PRIMERA SECCION DE ISLAS",
      "ARROYO PIAGGIO",
      "ARROYO BARRANCOSO",
      "LA INVERNADA",
      "TERCERA SECCION DE ISLAS",
      "CHARIGUE",
      "LAS CUATRO BOCAS",
      "BOCA DE LAS PIEDRAS",
      "ISLA EL PILLO",
      "VICTORIA",
      "COLONIA FLORES",
      "FEDERACION",
      "SALTO GRANDE",
      "COLONIA ENSANCHE",
      "COLONIA EL BIZCOCHO",
      "ALDEA SAN MIGUEL",
      "CAMPO GARCIA",
      "CASEROS",
      "COLONIA MABRAGAÑA",
      "COLONIA PALMAR YATAY",
      "COLONIA SAN FRANCISCO",
      "ALDEA SAN GREGORIO",
      "SUMACA",
      "COLONIA LAS MERCEDES",
      "ESTACION JUAN JORGE",
      "ESTACION ARROYO CLE",
      "OLEGARIO VICTOR ANDRADE",
      "GOBERNADOR SOLA"
    ]
  },
  {
    "nombre": "Formosa",
    "localidades": [
      "SAN ANTONIO",
      "ISLA OCA",
      "COLONIA FORMOSA",
      "LA COLONIA",
      "FORMOSA",
      "POSTA CAMBIO ZALAZAR",
      "LAS BOLIVIANAS",
      "RIO MUERTO",
      "CAMPO DEL MEDIO",
      "LA LINEA",
      "EL REMANSO",
      "PESCADO NEGRO",
      "LAS AVISPAS",
      "AHI VEREMOS",
      "AIBAL EL SILENCIO",
      "LA LAGUNA",
      "LAS MARAVILLAS",
      "VACA PERDIDA",
      "EL QUEMADO",
      "PASO DE LOS TOBAS",
      "LA PALMITA",
      "LAMADRID",
      "ALTO ALEGRE",
      "EL CAVADO",
      "LA TUSCA",
      "EL RETIRO",
      "EL COLORADO",
      "LA PAZ",
      "LAGUNITA",
      "EL CORRALITO",
      "LAGUNA YACARE",
      "LOS YUCHANES",
      "LA PUERTA",
      "BAJO VERDE",
      "EL LECHERON",
      "LA PALIZADA",
      "EL DESPUNTE",
      "SOMBRERO NEGRO",
      "LA SOLEDAD",
      "EL QUIMIL",
      "EL CASTOR",
      "EL PALO SANTO",
      "CORRALITO",
      "LA MOCHA",
      "LOS POCITOS",
      "TRES YUCHAN",
      "EL ESCONDIDO",
      "FORTIN PILCOMAYO",
      "LA PRIMAVERA",
      "LA RINCONADA",
      "LA REPRESA",
      "EL CHURCALITO",
      "EL PARAGUAYO MUERTO",
      "SAN ANTONIO",
      "LAS PALMITAS",
      "LAS VIDALITAS",
      "POZO RAMON",
      "POZO EL ESCONDIDO",
      "EL BAJO",
      "EL PARAISO",
      "EL YACARE",
      "LAS BANDERITAS",
      "EL AIBALITO",
      "SANTA ISABEL",
      "EL AZOTADO",
      "EL SOLITARIO",
      "LA UNION",
      "LA MADRUGADA",
      "SAN CAYETANO",
      "ISLA GARCIA",
      "EL SIMBOLAR",
      "EL BRAGADO",
      "EL CAJON",
      "SUMAYEN",
      "SANTA ROSA",
      "SAN CAMILO",
      "MATIAS GULACSI",
      "LA IGUANA",
      "SAN ISIDRO",
      "LOS CLAVELES",
      "GUADALCAZAR",
      "PALOS BLANCOS",
      "POZO SARGENTO",
      "LA ZANJA",
      "FORTIN PILCOMAYO NUEVO",
      "EL BORDO SANTO",
      "BAJO HONDO",
      "EL CUCHILLO",
      "EL ALAMBRADO",
      "EL LINDERO",
      "LOS GALPONES",
      "PALMA SOLA",
      "PRALINE",
      "ISLA CHICA",
      "CAMPO AZUL",
      "PONCHO QUEMADO",
      "EL COLETO",
      "LAS FLORES",
      "TRES POZOS",
      "LA LIBERTAD",
      "SAN CRISTOBAL",
      "PUERTO CABO IRIGOYEN",
      "POZO DE MOLINA",
      "LOS CIENEGUITOS",
      "EL NARANJO",
      "LA ESQUINA",
      "LAGUNA TRES PACES",
      "PALO MARCADO",
      "EL CHAÑARAL",
      "SANTA RITA",
      "EL CHURCAL",
      "MEDIA LUNA",
      "LA ESPERANZA",
      "IBARRETA",
      "ALGARROBO",
      "JOSE MARIA PAZ",
      "BOQUERON",
      "COLONIA BOUVIER",
      "TRANQUERITA",
      "EL RECODO",
      "COLONIA SUDAMERICANA",
      "MARCA M",
      "CEIBO TRECE",
      "SAN FRANCISCO",
      "SOL DE MAYO",
      "POLVORIN",
      "MARTIN FIERRO",
      "VIRASOL",
      "LUCERO CUE",
      "EL PARAISO",
      "ISLA PUEN",
      "ISLA LEONA",
      "PRESIDENTE AVELLANEDA",
      "COSTA ALEGRE",
      "COLONIA SARMIENTO",
      "COLONIA LOS SANTAFESINOS",
      "LOMA HERMOSA",
      "AURORA",
      "ISLA YOBAI GUAZU",
      "NUEVA MORADA",
      "BUEY MUERTO",
      "COLONIA SAN JUAN",
      "RODEO TAPITI",
      "COLONIA LA PRIMAVERA",
      "PASO ANGELITO",
      "ESPERANZA",
      "ISLA APANDO",
      "RIACHO",
      "SOLEDAD",
      "PUNTA GUIA",
      "VISTA ALEGRE",
      "LOMA TUYUTU",
      "JUAN G. BAZAN",
      "ESTANISLAO DEL CAMPO",
      "ESTACION BOUCHARD",
      "VILLA KILOMETRO 213",
      "BUENA VISTA",
      "SAN FRANCISCO DE LAISHI",
      "LAGUNA GALLO",
      "EL COLORADO",
      "SAN MARTIN I",
      "EL MISTOLAR",
      "LA FLORENCIA",
      "LAS CALAVERAS",
      "EL PICASO",
      "SANTA RITA",
      "EL TREBOL",
      "LA ENSENADA",
      "QUEBRACHO COTO",
      "CAMPO LA CRUZ",
      "EL MILAGRO",
      "VACA MUERTA",
      "TRES PALMITAS",
      "TENIENTE GENERAL ROSENDO M. FRAGA",
      "BOLSA DEL PALOMO",
      "POZO EL YACARE",
      "EL PALMAR",
      "LA ENTRADA",
      "EL ROSILLO",
      "AGUA VERDE",
      "LA SOLEDAD",
      "LA EXTRANJERA",
      "POZO DE LA YEGUA",
      "EL TOTORAL",
      "MONTE RICO",
      "EL POTRERITO",
      "CAMPO BANDERA",
      "CAMPO GRANDE",
      "ISLA VERDE",
      "EL VIOLIN",
      "LA JUNTA",
      "COMUNIDAD ABORIGEN WICHI FWINAFWAS",
      "SANTA TERESA",
      "LA ESPERANZA",
      "POZO DE LOS PATOS",
      "LAS LOLAS",
      "COLONIA SARMIENTO",
      "MOJON DE FIERRO",
      "TRES LAGUNAS",
      "PUEYRREDON",
      "RIACHO NEGRO",
      "EL RECREO",
      "COLONIA PASTORIL",
      "COLONIA SAN ISIDRO",
      "CANDIA",
      "COLONIA SAN ANTONIO",
      "COLONIA EL DORADO",
      "HERTELENDY",
      "PASO POLENTA",
      "POSTA DEL SALADO",
      "GUAYACANTY",
      "ESTERITO",
      "COLONIA LAGUNA GOBERNADOR",
      "TRES MOJONES",
      "LA PLAYA",
      "COLONIA EL NARANJITO",
      "COGORNO",
      "RIACHO LINDO",
      "EL CERRITO",
      "COLONIA CANO",
      "EL MBIGUA",
      "KILOMETRO 100",
      "POTRERO DE LOS CABALLOS",
      "EL ANGELITO",
      "PUERTA MISION",
      "PRESIDENTE YRIGOYEN",
      "ISLA BANCO ORTELLADO",
      "MAGLIETTI",
      "COLONIA YATAY",
      "LA LUISA",
      "KILOMETRO 117",
      "SAN HILARIO",
      "VILLA ESCOLAR",
      "PORTON NEGRO",
      "MISION TACAAGLE",
      "PALO SANTO",
      "SIETE PALMAS",
      "RIACHO HE-HE",
      "PUERTO IRIGOYEN",
      "EL POTRILLO",
      "BANCO PAYAGUA",
      "PALMA SOLA",
      "GENERAL MOSCONI",
      "LAS MERCEDES",
      "SANTA MARIA",
      "LA ESPERANZA",
      "LAS PALMAS",
      "COLONIA TRES MARIAS",
      "LOMA CLAVEL",
      "EL TRIANGULO",
      "SAN ALBERTO",
      "SAN NICOLAS",
      "ZANIN",
      "FRANCESA CUE",
      "ESPERANZA",
      "LA AURORA",
      "AGUA DULCE",
      "COLONIA PRESIDENTE URIBURU",
      "SANTA ELENA",
      "SANTA CATALINA",
      "TRES ESQUINAS",
      "LA QUERENCIA",
      "PUENTE SAN HILARIO",
      "SAN JUAN",
      "COLONIA PRESIDENTE YRIGOYEN",
      "SAN LUIS",
      "MAGLIETTI",
      "EL OMBU",
      "COLONIA ITUZAINGO",
      "MARIA LUISA",
      "EL PERDIDO",
      "ISLA 25 DE MAYO",
      "SAN MARTIN",
      "GUAYCOLEC",
      "SAN CARLOS",
      "SAN PEDRO",
      "EL PELIGRO",
      "SOLEDAD",
      "YAGUARETE",
      "COLONIA DALMACIA",
      "SAN FELIPE",
      "BANCO LA EMILIA",
      "TATANE",
      "POZO DE MAZA",
      "VILLA GENERAL GUEMES",
      "VILLA DEL CARMEN",
      "COLONIA ABORIGEN LA BOMBA",
      "LOTE 27",
      "LA PANTALLA",
      "LAS LOMITAS",
      "MARIANO BOEDO",
      "INGENIERO GUILLERMO N. JUAREZ",
      "POZO DEL TIGRE",
      "GRAN GUARDIA",
      "SAN MARTIN",
      "SAN MARTIN II",
      "PUERTO PILCOMAYO",
      "CLORINDA",
      "BELLA VISTA",
      "LOMA SENES",
      "COLONIA 15",
      "CAMPO ALEGRE",
      "COLONIA RIGONATO",
      "CAMPO SAN RAFAEL",
      "EL CORRALITO",
      "LOMA DEL QUEBRANTO",
      "COLONIA RODA",
      "9 DE JULIO",
      "LOTE 219",
      "LA TOMASA",
      "MONTE LINDO",
      "SAN JOSE",
      "CAMPO HARDY",
      "COLONIA 5 DE OCTUBRE",
      "LA LOMITA",
      "LA PICADITA",
      "SOLEDAD",
      "EL PIQUETE",
      "LA SARITA",
      "COLONIA EL COMIENZO",
      "COLONIA SANTA CRUZ",
      "KILOMETRO 224",
      "COLONIA LA DISCIPLINA",
      "FELDMAN",
      "EL RESGUARDO",
      "CASCO CUE",
      "EL QUEBRANTO",
      "COLONIA EL ALBA",
      "SANTA MARIA",
      "EL SALADILLO",
      "AGENTE LEGUIZAMON",
      "LA CAROLINA",
      "COLONIA PAMPA VILLANUEVA",
      "LA DORA",
      "COLONIA LOMA SENES",
      "ZORRILLA CUE",
      "COLONIA EL DESAGUADERO",
      "PRINCICH",
      "FRANCHI",
      "EL ALGARROBO",
      "LA SIRENA",
      "COLONIA LAS LOMITAS",
      "MERCEDES CUE",
      "COLONIA EL ZAPALLITO",
      "ACOSTA",
      "COSTA RIACHO ALAZAN",
      "EL IBAGAY",
      "SANTA ANA",
      "COLONIA EL OLVIDO",
      "CENTRO FORESTAL PIRANE",
      "POTRERO OCULTO",
      "POTRERO NORTE",
      "EL GATO",
      "COLONIA ITATI",
      "LA VICTORIA",
      "COLONIA EL PALMAR",
      "COLONIA EL PROGRESO",
      "EL SALADO",
      "SAN LUIS",
      "LOTE 9",
      "COPO BLANCO",
      "MURUA",
      "COLONIA LA UNION",
      "LA FLORESTA",
      "KILOMETRO 210",
      "MONTE QUEMADO",
      "EL INDIO",
      "KILOMETRO 142",
      "COLONIA ESPERANZA",
      "LA LOMA",
      "EL BOSQUECILLO",
      "EL POI",
      "COLONIA WEITZEL",
      "LOTE 11",
      "SOLDADO EDMUNDO SOSA",
      "LOTE 108 LADRILLERIA",
      "COLONIA EL CHAJA",
      "ISLA TOLDO",
      "EL COATI",
      "LOTE 17-LEGUA A",
      "RACEDO ESCOBAR",
      "COLONIA EL RINCON",
      "SAN PEDRO",
      "SAN MARTIN",
      "VILLA GENERAL MANUEL BELGRANO",
      "SUBTENIENTE PERIN",
      "PIRANE",
      "POZO DEL MORTERO",
      "COLONIA 20 DE JUNIO",
      "EL DESEMBOQUE",
      "COLONIA LAKA-WICHI",
      "EL SAUCE",
      "COLONIA SANTA ROSA",
      "EL TORDILLO",
      "COLONIA SAN JOSE",
      "EL LEON",
      "LOMA SAN PABLO",
      "EL ALGARROBAL",
      "EL PALMAR",
      "COLONIA SAN JUAN",
      "SAN RAMON",
      "EL DIVISADERO",
      "EL TOTORAL",
      "COLONIA SAN ANTONIO",
      "LOS INMIGRANTES",
      "EL CABURE",
      "EL SIMBOLAR",
      "EL CRUCE",
      "COLONIA TAJEREY",
      "CAMPO DEL CIELO",
      "EL BELLACO",
      "COLONIA SAN ROQUE",
      "SAN JULIAN",
      "EL ESCONDIDO",
      "LA FELICIDAD",
      "MAGALLANES",
      "MONTE ALEGRE",
      "COLONIA LAS CHOYAS",
      "EL RELEVO",
      "LA PALMA",
      "EL CEIBAL",
      "LOS TRES REYES",
      "COLONIA EL CATORCE",
      "LAS HORQUETAS",
      "EL GALLEGO",
      "RIACHO DE ORO",
      "COLONIA ISLA SOLA",
      "COLONIA RECONQUISTA",
      "EL ESTANQUE",
      "EL COATI",
      "EL QUEMADO",
      "COLONIA 14 DE MAYO",
      "EL MARTILLO",
      "OVEJERO",
      "CAMPO ALEGRE",
      "LA SORPRESA",
      "EL OCULTO",
      "SAN LORENZO",
      "TRES POZOS",
      "EL AGUARA",
      "EL CACUY",
      "CACIQUE COQUERO",
      "LA INVERNADA",
      "POZO VERDE",
      "SANTA ELENA",
      "LOS JUBILADOS",
      "TIERRA BLANCA",
      "COLONIA JUANITA",
      "COLONIA CEFERINO NAMUNCURA",
      "SANTA ANA",
      "COLONIA ENSANCHE NORTE",
      "LA RAFAELA",
      "LAGO VERDE",
      "ROJAS",
      "RANERO CUE",
      "SANTA MARIA",
      "LAQTASATANYIE (KM14)",
      "COLONIA DANTE SANDRELLI",
      "CAMPO AZCURRA",
      "KILOMETRO 15",
      "EL RETIRO",
      "COLONIA EL PAVAO",
      "EL TIMBO",
      "COLONIA LA PREFERIDA",
      "LA ESTRELLA",
      "LAGUNA ACEVAL",
      "EL QUEBRACHO",
      "SAN SIMON",
      "LAS MERCEDES",
      "LA RINCONADA",
      "COLONIA SAN PEDRO",
      "SAN LUIS",
      "EL TRASLADO",
      "LA CIERVA",
      "EL YACARE",
      "CAMPO TRES POZOS",
      "LOS LAURELES",
      "MAESTRA BLANCA GOMEZ",
      "SAN MIGUEL",
      "LA PORFIA",
      "MIRANDA",
      "COLONIA NAPENAY",
      "MANSILLA",
      "COLONIA SAN ISIDRO",
      "POZO HONDO",
      "RINCON FLORIDO",
      "POZO REDONDO",
      "LOS COLORADOS",
      "LA PROVIDENCIA",
      "EL PERDIDO",
      "URBANA VIEJA",
      "COLONIA UNION ESCUELA",
      "SANTO DOMINGO",
      "SAN CARLOS",
      "LOS SUSPIROS",
      "PUNTA DE AGUA",
      "POZO DE LOS CHANCHOS",
      "EL COGOIK",
      "LAS MOCHAS",
      "LA VICTORIA",
      "ISLETA",
      "PUERTO LAVALLE",
      "LAS FLORES",
      "CAMPO DE AVIACION",
      "EL PORVENIR",
      "EL DESCANSO",
      "VILLA MARIN",
      "EL TARTAGAL",
      "LOMA CLAVEL",
      "LA MEDIA LUNA",
      "LA SOLEDAD",
      "GENERAL URQUIZA",
      "COLONIA TATANE",
      "COLONIA SAN PABLO",
      "LA PAMPA",
      "COLONIA ALTO ALEGRE",
      "VILLA GENERAL URQUIZA",
      "COLONIA EL SILENCIO",
      "KILOMETRO 503",
      "POZO LARGO",
      "EL MIRADOR",
      "COLONIA EL ENSANCHE",
      "COMUNIDAD LOTE 21",
      "TENIENTE BROWN",
      "COLONIA SIETE QUEBRACHOS",
      "PRIMAVERA",
      "LA UNION",
      "CRUCERO GENERAL BELGRANO",
      "CHICO DOWAGAN",
      "POZO DE LOS MILICOS",
      "LOTE 20 RURAL",
      "POZO DEL CIERVO",
      "PASO NAITE",
      "LAGUNA NAICK-NECK",
      "GENERAL LUCIO V MANSILLA",
      "COLONIA CAMPO VILLAFAÑE",
      "FORTIN SARGENTO 1Ñ LEYES",
      "LAGUNA YEMA",
      "BARTOLOME DE LAS CASAS",
      "COMUNIDAD ABORIGEN BARTOLOME DE LAS CASAS",
      "FORTIN CABO 1Ñ LUGONES",
      "LAGUNA BLANCA",
      "COMANDANTE FONTANA",
      "EL MATADERO",
      "LOS CHIRIGUANOS",
      "HERRADURA",
      "SAN RAMON",
      "VIDAL",
      "COLONIA ABORIGEN",
      "PUESTO RAMONA",
      "JULIO CUE",
      "VILLA RURAL",
      "SALVACION",
      "ISLA AZUL",
      "SAN RAFAEL",
      "SAN CARLOS",
      "VILLA MARIA",
      "LAGUNA TORO",
      "CANDELARIA",
      "VILLA HERMOSA",
      "TOLDO CUE",
      "COLONIA EL CEIBO",
      "LOMA ZAPATU",
      "PUNTA PORA",
      "RINCON GRANDE",
      "COLONIA SANTA ROSA",
      "SAN BLAS",
      "VISTA ALEGRE",
      "APAYEREY",
      "LA ELIDA",
      "CASUALIDAD",
      "LAS MERCEDES",
      "LEON",
      "LORO CUE",
      "SAN BENITO",
      "SAN PABLO",
      "SAN JORGE",
      "BELLA VISTA",
      "VILLA REAL",
      "FLOR DE TUNA",
      "COLONIA 25 DE MAYO",
      "TIMBO",
      "EL POMBERO",
      "LAS VERTIENTES",
      "POZO CABALLO",
      "EL ESTANQUE",
      "EL TUCUMANCITO",
      "POZO CERCADO",
      "EL ALAZAN",
      "MISION SAN ANDRES",
      "EL QUEBRACHO",
      "EL BREAL",
      "EL CHIVIL",
      "EL PALMARCITO",
      "COMUNIDAD 7 DE JUNIO",
      "SANTA TERESA",
      "LAS DELICIAS",
      "EL TRONQUITO",
      "BARRIO EL FAVORITO",
      "PALO SECO",
      "RIO SECO",
      "LAS PALMITAS",
      "LAS CAÑITAS",
      "LA MOCHA",
      "EL DIVISADERO",
      "EL ROSARIO",
      "ISLA DE LUNA",
      "POZO DEL OSO",
      "CAÑADA RICA II",
      "EL SOL",
      "EL SIMBOLAR",
      "MARIA CRISTINA",
      "TRES POZOS",
      "SAN LUIS",
      "VILLA DEVOTO",
      "TRES PALMAS",
      "COMUNIDAD WICHI BARRIO EL COLORADO",
      "EL TABIQUE",
      "EL ALGARROBO",
      "POZO CHARATA",
      "LOTE 1",
      "SAN ISIDRO",
      "EL SILENCIO",
      "LOTE 8",
      "EL ROSADO",
      "CAMPO DEL ACHA",
      "LA TIGRA",
      "COMUNIDAD ABORIGEN WICHI",
      "LA PERDIZ",
      "POZO LA CHIVA",
      "SAN MIGUEL",
      "EL MOLINO",
      "LA BREA",
      "EL TOTORAL",
      "PALMAR LARGO",
      "EL ALAMBRADO",
      "LA HORQUETA",
      "COMUNIDAD WICHI OBLITAJ",
      "SANTA ROSA",
      "LA PAMPA",
      "SAN MARTIN",
      "EL ESPINILLO"
    ]
  },
  {
    "nombre": "Jujuy",
    "localidades": [
      "SAN FRANCISCO DE ALFARCITO",
      "SANTA ANA DE LA PUNA",
      "TUSAQUILLAS",
      "SANTA ANA",
      "TRANCAS",
      "RINCONADILLAS",
      "SALADO",
      "ABDON CASTRO TOLAY",
      "SANTUARIO DE TRES POZOS",
      "TOLARITO",
      "COLONIA SAN JOSE",
      "ALONSO",
      "VOLCAN DE YACORAITE",
      "YACORAITE",
      "HUACALERA",
      "CARCEL",
      "PUNTA CORRAL",
      "COIRURO",
      "AGUA BENDITA",
      "TUMBAYA",
      "TUMBAYA GRANDE",
      "BERMEJITO",
      "LIBERTAD",
      "CALILEGUA",
      "MIRAFLORES",
      "EL PUESTO",
      "LA ESPERANZA",
      "PARAPETI",
      "SAN ANTONIO",
      "SAN JUANCITO",
      "SEVERINO",
      "EL CADILLAL",
      "EL CHAMICAL",
      "LAS PAMPITAS",
      "PERICO",
      "CORONEL ARIAS",
      "BARRIO LA UNION",
      "LA POSTA",
      "BORDO LA ISLA",
      "ARROYO DEL MEDIO",
      "OJO DE AGUA",
      "SANTA CORNELIA",
      "REAL DE LOS TOROS",
      "LAS DELICIAS",
      "PALMA SOLA",
      "VILLA MONTES",
      "ISLA CHICA",
      "SAN ANTONIO",
      "SAN RAFAEL",
      "PAICONE",
      "CIENEGA",
      "SAN JUAN DE ORO",
      "LAGUNILLAS DE FARALLON",
      "MISARRUMI",
      "SAN JUAN DE OROS",
      "SAN JUAN Y MISA RUMI",
      "CUSI CUSI",
      "OJO DE AGUA",
      "SAN JOSE DE CHIJRA",
      "TERMAS DE REYES",
      "SAN SALVADOR DE JUJUY",
      "GUERRERO",
      "LA ALMONA",
      "REYES",
      "JUAN GALAN",
      "TILQUIZA",
      "COCHAGOSTA",
      "RIO GRANDE",
      "QUERA",
      "AGUA DE CASTILLA",
      "QUEBRALEÑA",
      "ABRALAITE",
      "AGUA BLANCA",
      "BELLA VISTA",
      "MANANTIAL",
      "PALMITAS",
      "RIO BLANCO",
      "PAULINA",
      "PUEBLO LEDESMA",
      "AGUA NEGRA",
      "LIBERTADOR GENERAL SAN MARTIN",
      "SANTA ROSA",
      "MOLLE PUNCO",
      "POZO BRAVO",
      "PUERTA DE LIPAN",
      "SALADILLO",
      "COLORADOS",
      "CIENAGA",
      "PUERTA DE COLORADOS",
      "SAN JUAN DE POZO COLORA",
      "AGUADITA",
      "CIENAGA GRANDE",
      "PURMAMARCA",
      "TRES MORROS",
      "PIEDRAS BLANCAS",
      "TUNALITO",
      "EL MORENO",
      "POZO COLORADO",
      "ESTANCIA GRANDE",
      "CASPALA",
      "TILCARA",
      "LOMA LARGA",
      "SAN ANTONIO",
      "ALFARCITO",
      "PUNTA CORRAL",
      "EL PERCHEL",
      "HUICHAIRA",
      "ABRA MAYO",
      "JUELLA",
      "DURAZNOS",
      "YAQUISPAMPA",
      "YALA DE MONTE CARMELO",
      "MOLULO",
      "LA BANDA",
      "PIEDRITAS",
      "BELLA VISTA",
      "DON EMILIO",
      "PALOS BLANCOS",
      "ROSARIO DE RIO GRANDE",
      "MEDANITOS",
      "CATUA",
      "SAN FRANCISCO",
      "ALTO CALILEGUA",
      "SAN ISIDRO",
      "FLEMING",
      "AGUAS CALIENTES",
      "LAS PICHANAS",
      "PILA PARDO",
      "SAN JUAN DE QUILLAQUES",
      "POTRERO",
      "JAMA",
      "MINA PROVIDENCIA",
      "OLAROZ CHICO",
      "LOMA BLANCA",
      "SALAR DE JAMA",
      "CORANZULI",
      "CIENAGA GRANDE",
      "EL TORO",
      "OLAROZ GRANDE",
      "VIZCARRA",
      "RIO GRANDE",
      "EL PORTILLO",
      "CASA PUCA",
      "LA POMA",
      "CASA GRANDE",
      "EL AGUILAR",
      "LOTEO NAVEA",
      "LOS ALISOS",
      "SAN ANTONIO",
      "PUEBLO VIEJO",
      "NUESTRA SEÑORA DEL ROSARIO",
      "LA TOMA",
      "EL CEIBAL",
      "RIO BLANCO",
      "CERRO NEGRO",
      "EL CONDOR",
      "ESCOBAR",
      "LLULLUCHAYOC",
      "CORRAL BLANCO",
      "CAIMANCITO",
      "URUNDEL",
      "DIQUE LA CIENAGA",
      "AVALOS",
      "SAN ANTONIO",
      "EL CARMEN",
      "EL SUNCHAL",
      "SAN LUCAS",
      "PAMPICHUELA",
      "SANTA BARBARA",
      "PUERTA VERDE",
      "VILLA CAROLINA",
      "RODEITO",
      "LAVAYEN",
      "VILLA LAS ROSAS",
      "EL MOLLAR",
      "SAN LUCAS",
      "EL QUEMADO",
      "ARRAYANAL",
      "LA MANGA",
      "OVEJERIA",
      "SALADILLO",
      "CHOLACOR",
      "YAVI CHICO",
      "SAN JOSE",
      "CASTI",
      "CHALCAMAYOC",
      "QUIRQUINCHOS",
      "LARCAS",
      "LA CIENEGA",
      "LA PALCA",
      "SAN LEON",
      "VILLA MARIA",
      "HORNILLOS",
      "LA CRUZ",
      "EL ANGOSTO",
      "PUEBLO VIEJO",
      "TIMON CRUZ",
      "PIZCUNO",
      "MERCO",
      "VIZCACHERAS",
      "MINA EUREKA",
      "EL FILO",
      "ORATORIO",
      "SANTA CATALINA",
      "SAN FRANCISCO",
      "TORO MUERTO",
      "VALLE COLORADO",
      "SANTA ANA",
      "PAMPA BLANCA",
      "PAMPA VIEJA",
      "BARRIOS",
      "CERRO COLORADO",
      "ESQUINA GRANDE",
      "CANGREJOS",
      "CANGREJILLOS",
      "BARRIO EL MILAGRO",
      "ALTO VERDE",
      "MONTERRICO",
      "SAN VICENTE",
      "LOS LAPACHOS",
      "TASTAS",
      "HORNILLOS",
      "BELLA VISTA",
      "MAIMARA",
      "EL FUERTE",
      "LA MENDIETA",
      "SAUZAL",
      "SAN BERNARDO",
      "VOLCAN",
      "BARCENA",
      "CHILCAYOC",
      "QUETA",
      "CASABINDO",
      "RUMI CRUZ",
      "SAUZALITO",
      "TAMBILLOS",
      "PASAJES",
      "ORATORIO",
      "QUINILICAN",
      "RACHAITE",
      "MIRAFLORES DE LA CANDELARIA",
      "SAN JOSE",
      "ENCRUCIJADA",
      "SANTA ROSA",
      "AGUA CHICA",
      "OJO DE AGUA",
      "AGUA CALIENTE DE LA PUNA",
      "SAYATE",
      "COCHINOCA",
      "ABRA PAMPA",
      "TABLADITAS",
      "DONCELLAS",
      "SAN PEDRO",
      "ARROYO COLORADO",
      "PALO HACHADO",
      "EL ACHERAL",
      "TUNALITO",
      "ARROYO DEL MEDIO",
      "SAN JUAN DE DIOS",
      "VINALITO",
      "SANTA RITA",
      "AGUA SALADA",
      "BELLA VISTA",
      "LA LUCRECIA",
      "CHUCALEZNA",
      "CIANZO",
      "QUERAGUA",
      "VALIAZO",
      "CAPLA",
      "SAN ROQUE",
      "CORAYA",
      "UQUIA",
      "CHORRILLOS",
      "APARZO",
      "OCUMAZO",
      "OVARA",
      "CHORCAN",
      "VARAS",
      "PUCARA",
      "PALCA DE VARAS",
      "COCTACA",
      "PALCA DE APARZO",
      "HORNADITAS",
      "HUMAHUACA",
      "RODERO",
      "CALETE",
      "RONQUE",
      "TRES CRUCES",
      "JURANCO",
      "TIPAL",
      "VALLE GRANDE",
      "PUESTO DEL MARQUEZ",
      "MACHO CRUZ",
      "PUEBLO VIEJO",
      "LA REDONDA",
      "POTRERO",
      "ARBOLITO NUEVO",
      "LOMA BLANCA",
      "SANTA ANA",
      "LIVIARA",
      "LOPIARA",
      "RAMALLO",
      "NUEVO PIRQUITAS",
      "MINA PIRQUITAS",
      "OROSMAYO",
      "SALITRE",
      "COYAGUAIMA",
      "PUENTE LAVAYEN",
      "SAUCE GUACHO",
      "SANTA CLARA",
      "LA CIENAGA",
      "SANSANA",
      "SANSANA NORTE",
      "PUEBLO VIEJO",
      "LA QUIACA",
      "TAFNA",
      "MINA 9 DE OCTUBRE",
      "CARAHUNCO",
      "LAS ESCALERAS",
      "PALPALA",
      "EL REMATE",
      "EL BRETE",
      "CENTRO FORESTAL",
      "EL ALGARROBAL",
      "RIO BLANCO",
      "EL PONGO",
      "LOS BLANCOS",
      "EL CUCHO",
      "AGUA BLANCA",
      "SALADILLO",
      "LECHERONAL",
      "RETIRO",
      "LA QUINTA",
      "EL PALMAR",
      "EL PIQUETE",
      "LA AGUADA",
      "PIEDRA NEGRA",
      "SOL DE MAYO",
      "MINA BELGICA",
      "RODEO",
      "CERRILLOS",
      "LA INTERMEDIA",
      "CHOCOITE",
      "PASAJES",
      "ABRA COLORADA",
      "PUMAHUASI",
      "PULPERA",
      "PUNTA DEL AGUA",
      "POZUELOS",
      "GUAYATAYOC",
      "MINA PAN DE AZUCAR",
      "RINCONADA",
      "SANTO DOMINGO",
      "CASA COLORADA",
      "LAGUNA LARGA",
      "RAMADAS",
      "NAZARENO",
      "CARAHUASI",
      "SAN PABLO DE REYES",
      "TIRAXI GRANDE",
      "LAS CAPILLAS",
      "LEON",
      "OCLOYAS",
      "LOZANO",
      "JAIRE",
      "DURAZNAL",
      "OVEJERIA",
      "YERBA BUENA",
      "DESPENSA",
      "LOS NOGALES",
      "TIRAXI",
      "YALA",
      "TESORERO",
      "PAYO",
      "BANANAL",
      "YUTO",
      "EL TALAR",
      "MANANTIALES",
      "PUESTO VIEJO",
      "NEGRA MUERTA",
      "CASILLAS",
      "AZUL PAMPA",
      "MIYUYOC",
      "LA CUEVA",
      "HIPOLITO YRIGOYEN",
      "PUEBLO VIEJO",
      "CONDOR",
      "EL PORVENIR",
      "SIJES",
      "PUESTO SEY",
      "HUANCAR",
      "PASTOS CHICOS",
      "OLACAPATO",
      "SUSQUES",
      "MINA PROVIDENCIA",
      "CASIRA",
      "CALAHOYO",
      "CIENEGUILLAS",
      "PUESTO GRANDE",
      "YOSCABA",
      "RODEO CHICO",
      "PUESTO CHICO",
      "YERBA BUENA",
      "FRAILE PINTADO",
      "LA BAJADA",
      "SAN BORJAS",
      "CHALICAN",
      "MAIZ NEGRO",
      "TORTUGAS"
    ]
  },
  {
    "nombre": "La Pampa",
    "localidades": [
      "LIHUEL CALEL",
      "PUELCHES",
      "CHACHARRAMENDI",
      "VALLE DAZA",
      "OJEDA",
      "ALTA ITALIA",
      "POTRILLO OSCURO",
      "BARRANCAS COLORADAS",
      "SANTA ROSA",
      "CACHIRULO",
      "EL TROPEZON",
      "TOAY",
      "DAMIAN MAISONAVE",
      "PUELEN",
      "MAURICIO MAYER",
      "COLONIA INES Y CARLOTA",
      "REALICO",
      "COLONIA EL DESTINO",
      "WINIFREDA",
      "PARERA",
      "LIMAY MAHUIDA",
      "QUETREQUEN",
      "MIGUEL CANE",
      "BERNARDO LARROUDE",
      "BERNASCONI",
      "SARAH",
      "INTENDENTE ALVEAR",
      "LONQUIMAY",
      "SPELUZZI",
      "GENERAL SAN MARTIN",
      "LUAN TORO",
      "PICHI HUINCA",
      "LAS PIEDRITAS",
      "FALUCHO",
      "INGENIERO FOSTER",
      "LA MARUJA",
      "LOBOCO",
      "CUCHILLO CO",
      "ABRAMO",
      "HUCAL",
      "RANCUL",
      "CHAMAICO",
      "ALPACHIRI",
      "URDANE",
      "ESTANCIA LA NATURAL",
      "QUEMU QUEMU",
      "LA PUMA",
      "ATREUCO",
      "MACACHIN",
      "ESTANCIA EL PAMPERO",
      "COLONIA EL PROVENIR",
      "MONTE NIEVAS",
      "ANZOATEGUI",
      "GAVIOTAS",
      "LA ADELA",
      "DORILA",
      "ALGARROBO DEL AGUILA",
      "REMECO",
      "GUATRACHE",
      "ESTANCIA RUCA PIRE",
      "TRENEL",
      "ESTANCIA EL TIGRE",
      "ESTANCIA LA FAMA",
      "CALEUFU",
      "AGUA DE TORRES",
      "CHOSMALAL",
      "LA HUMADA",
      "EL DURAZNO",
      "CARRO QUEMADO",
      "COLONIA LOS TOROS",
      "SANTA TERESA",
      "ADOLFO VAN PRAET",
      "COLONIA SANTA MARIA",
      "COLONIA CHAPALCO",
      "NAICO",
      "ATALIVA ROCA",
      "GENERAL ACHA",
      "EL CARANCHO",
      "EL VERANEO",
      "UTRACAN",
      "EPU PEL",
      "UNANUE",
      "GAMAY",
      "ESTANCIA SANTA AURELIA",
      "GENERAL PICO",
      "TREBOLARES",
      "ESTANCIA EL PUMA",
      "EL TALA",
      "INGENIERO LUIGGI",
      "RELMO",
      "VICTORICA",
      "IVANOWSKY",
      "CATRILO",
      "COLONIA LA CARLOTA",
      "ARATA",
      "VILLA SAN ROQUE",
      "LOS HORNOS",
      "MARIANO MIRO",
      "CORONEL HILARIO LAGOS",
      "LA REFORMA",
      "GOBERNADOR DUVAL",
      "HUELEN",
      "COLONIA BARON",
      "COLONIA SAN JOSE",
      "EMBAJADOR MARTINI",
      "COLONIA SAN JUAN",
      "GENERAL MANUEL J. CAMPOS",
      "LA LOMA",
      "MIGUEL RIGLOS",
      "COLONIA SAN MIGUEL",
      "CEREALES",
      "LOVENTUE",
      "CONHELO",
      "TOMAS M. ANCHORENA",
      "ROLON",
      "HIDALGO",
      "TELEN",
      "VILLA MIRASOL",
      "LA PUMA",
      "EDUARDO CASTEX",
      "COLONIA LA RAQUEL",
      "BOEUF",
      "CASA DE PIEDRA",
      "VERTIZ",
      "ANGUIL",
      "URIBURU",
      "LA GLORIA",
      "AGUSTONI",
      "ARBOL SOLO",
      "MEDANOS NEGROS",
      "SANTA ISABEL",
      "COLONIA LA PASTORIL",
      "25 DE MAYO",
      "GOBERNADOR AYALA",
      "COLONIA EL SAUZAL",
      "COLONIA CHICA",
      "QUEHUE",
      "RUCANELO",
      "TENIENTE GENERAL EMILIO MITRE",
      "CEBALLOS",
      "PERU",
      "COTITA",
      "COLONIA LA COLORADA CHICA",
      "COLONIA SAN ROSARIO",
      "JACINTO ARAUZ",
      "METILEO",
      "DOBLAS"
    ]
  },
  {
    "nombre": "La Rioja",
    "localidades": [
      "LA ESCALERA",
      "LA TORRECITA",
      "HUACO",
      "VILLA SANAGASTA",
      "ARAUCO",
      "AIMOGASTA",
      "UDPINANGO",
      "LA CAUCHITA",
      "TINOCAN",
      "LA CIMBRITA",
      "TERMAS DE SANTA TERESITA",
      "SAN ANTONIO",
      "ESTACION MAZAN",
      "VILLA MAZAN",
      "BAÑADO DE LOS PANTANOS",
      "MACHIGASTA",
      "LA CANCHITA",
      "LAS FLORES",
      "POLCO",
      "EL GARABATO",
      "SANTA RITA DE LA ZANJA",
      "VILLA CARMELA",
      "SANTA LUCIA",
      "BASE CHAMICAL",
      "ESQUINA DEL NORTE",
      "CHAMICAL",
      "LA RESISTENCIA",
      "EL RETAMO",
      "POZO REDONDO",
      "POZO DE LA VACA",
      "LA AGUADITA",
      "ROSILLO MUERTO",
      "CHULO",
      "EL QUEBRACHAL",
      "EL CARMEN",
      "BELLA VISTA",
      "LAS TALAS",
      "LOS BALDES",
      "LOS BORDOS",
      "EL MOLLAR",
      "LAS AMOLADERAS",
      "BAJO DE LUCAS",
      "SANTA BARBARA",
      "LA CORTADA",
      "LA SERENA",
      "SAN RAFAEL",
      "LOS AGUIRRES",
      "POZO DEL MEDIO",
      "LA COLONIA",
      "MOLLACO",
      "MILAGRO",
      "EL QUEMADO",
      "MOLLACO",
      "SAN RAMON",
      "LAS CORTADERAS",
      "SAN JOSE",
      "SAN ROQUE",
      "LA MARAVILLA",
      "AGUADITA DE LOS PERALTA",
      "LA REPRESA",
      "OLPAS",
      "RIO GRANDE",
      "SAN CRISTOBAL",
      "LA BARRERA",
      "AGUA COLORADA",
      "EL CERCO",
      "LA BANDERITA",
      "LA DORADA",
      "SANTA RITA DE CATUNA",
      "LA RIPIEDRA",
      "LA MARUJA",
      "EL FRAILE",
      "LOS TELLOS",
      "AMBIL",
      "COLONIA ORTIZ DE OCAMPO",
      "EL BARRANCO",
      "LOS BARRIALITOS",
      "TORRECITAS",
      "LA ISLA",
      "LA PLAYA",
      "LOS MISTOLES",
      "ESQUINA GRANDE",
      "BALDE SALADO",
      "LA AGUADITA",
      "SAN PEDRO",
      "LOS ROBLES",
      "ANDOLUCAS",
      "SHAQUI",
      "LAS TALAS",
      "ALPASINCHE",
      "CUIPAN",
      "TUYUBIL",
      "EL RETIRO",
      "CHAUPIHUASI",
      "SALICAS",
      "SAN BLAS",
      "AMUSCHINA",
      "SURIYACO",
      "LA HUERTA",
      "SANTA CRUZ",
      "EL VIRQUE",
      "CORTADERAS",
      "EL SIMBOLAR",
      "CASTRO BARROS",
      "EL BORDO",
      "BAJO HONDO",
      "LA AGUADA",
      "MONTE GRANDE",
      "MONTE NEGRO",
      "SAN ISIDRO",
      "EL CONSUELO",
      "TALA VERDE",
      "NEPES",
      "COLONIA EL CISCO",
      "TALVA",
      "LOMA BLANCA",
      "AGUA COLORADA",
      "OLTA",
      "ESQUINA DEL SUD",
      "S.DE LAS HIGUERAS",
      "CHAÑAR",
      "MIRAFLORES",
      "LOMA ALTA",
      "CORRAL DEL NEGRO",
      "SIERRA DE LOS QUINTEROS",
      "LA FLORIDA",
      "SAN PEDRO",
      "MASCASIN",
      "LA JARILLA",
      "LA LAGUNA",
      "LA AGUADA",
      "EL TOTORAL",
      "EL TALA",
      "ABRA VERDE",
      "MASCASIN",
      "EL RODEO",
      "CASAS VIEJAS",
      "EL POTRERILLO",
      "EL DIVISADERO",
      "LAS TOSCAS",
      "VALLE HERMOSO",
      "SANTA CRUZ",
      "EL ROSARIO",
      "VILLA CASANA",
      "REAL DEL CADILLO",
      "LOS LAGARCITOS",
      "LA CALERA",
      "RODEO GRANDE",
      "LA CONSULTA",
      "SANTA RITA",
      "EL BARRIAL",
      "CHELCOS",
      "AGUA DE AGUIRRE",
      "SAN ISIDRO",
      "LA CALLANA",
      "LOS OROS",
      "AGUA BLANCA",
      "EL CARDON",
      "SAN JOSE",
      "CHEPES",
      "SAN PEDRO",
      "ALTO BAYO",
      "AGUA DE LA PIEDRA",
      "DESIDERIO TELLO",
      "SAN ANTONIO",
      "EL ZAMPAL",
      "MALLIGASTA",
      "LAS HIGUERITAS",
      "SAN MIGUEL",
      "SANTA FLORENTINA",
      "GUANCHIN",
      "MIRANDA",
      "SAÑOGASTA",
      "COLONIA VICHIGASTA",
      "COLONIA MALLIGASTA",
      "ANGUINAN",
      "VICHIGASTA",
      "NONOGASTA",
      "CHILECITO",
      "COLONIA ANGUINAN",
      "TILIMUQUI",
      "LOS SARMIENTOS",
      "SAN NICOLAS",
      "COLONIA CATINZACO",
      "LA PUNTILLA",
      "LA CIENAGA",
      "BOCA DE LA QUEBRADA",
      "VALLE HERMOSO",
      "EL HORNO",
      "POTRERO GRANDE",
      "LA ARMONIA",
      "CASA PINTADA",
      "DISTRITO PUEBLO",
      "LA BANDA",
      "VILLA SAN JOSE DE VINCHINA",
      "JAGUE",
      "ANGULOS",
      "SANTA CRUZ",
      "PLAZA VIEJA",
      "CAMPANAS",
      "SANTO DOMINGO",
      "FAMATINA",
      "BAJO CARRIZAL",
      "ALTO CARRIZAL",
      "EL POTRERILLO",
      "PITUIL",
      "LA CUADRA",
      "ANTINACO",
      "EL JUMEAL",
      "BARRIO DE GALLI",
      "CHAÑARMUYO",
      "BAZAN",
      "SALADILLO",
      "LAS CATAS",
      "ANCHICO",
      "SAN JOSE",
      "EL CANTADERO",
      "LA LANCHA",
      "SAN LORENZO",
      "SIERRA BRAVA",
      "TRAMPA DEL TIGRE",
      "EL ROSARIO",
      "ESTANCIA SAN JOSE",
      "AMPATA",
      "LA CAÑADA",
      "POZO DE LA YEGUA",
      "EL TALA",
      "BAJO HONDO",
      "PUERTO ALEGRE",
      "EL SUNCHAL",
      "EL QUEBRACHO",
      "SAN NICOLAS DEL RECREO",
      "SAN PEDRO",
      "SAN NICOLAS",
      "SANTO DOMINGO",
      "LA RIOJA",
      "LA RAMADITA",
      "SAN BERNARDO",
      "LA ANTIGUA",
      "COLONIA FRUTIHORTICOLA",
      "LA LATA",
      "TALAMUYUNA",
      "SAN RAFAEL",
      "SAN JUAN",
      "CARRIZAL",
      "SAN ANTONIO",
      "SAN MIGUEL",
      "CEBOLLAR",
      "LAS HIGUERILLAS",
      "EL DURAZNILLO",
      "EL BARREAL",
      "VILLA CASTELLI",
      "RIVADAVIA",
      "EL CONDADO",
      "PARECITAS",
      "VILLA UNION",
      "ANCHUMBIL",
      "LA MARAVILLA",
      "EL CARDON",
      "EL CHUSCHIN",
      "PIEDRA PINTADA",
      "LA BREA",
      "LA CIENAGA",
      "MINA DELINA",
      "SAN JOSE",
      "LOS TAMBILLOS",
      "EL MOLLE",
      "VILLA ESTHER",
      "LAS CUEVAS",
      "GUANDACOL",
      "SANTA CLARA",
      "LOS PATILLOS",
      "PASO SAN ISIDRO",
      "AICUÑA",
      "EL FUERTE",
      "EL ZAPALLAR",
      "LOS NACIMIENTOS",
      "LOS PALACIOS",
      "PUERTO ALEGRE",
      "PAGANCILLO",
      "BANDA FLORIDA",
      "SANTA MARIA",
      "EL PORONGO",
      "NACATE",
      "UNQUILLAL",
      "LA CHIMENEA",
      "EL RETAMAL",
      "CASANGATE",
      "LOMA LARGA",
      "TOSQUEA",
      "PORTEZUELO",
      "SAN RAMON",
      "SOLCA",
      "SAN ANTONIO",
      "EL CHORRO",
      "QUEBRADA DEL VALLECITO",
      "LOS BARREALES",
      "SALANA",
      "LOS ALGARROBOS",
      "LAS BARRANCAS",
      "PULUCHAN",
      "MALANZAN",
      "TUANI",
      "SAN RAMON",
      "TRES CRUCES",
      "BALDE DE AMAYA",
      "SAN PEDRO",
      "ATILES",
      "SAN ROQUE",
      "EL POTRERO",
      "LA SUSPENSION",
      "TRES DE MAYO",
      "LA PORFIA",
      "ISLA DEL TIGRE",
      "SIEMPRE VERDE",
      "EL BALDE DE LA VIUDA",
      "LA LOMITA",
      "LAS MALVINAS",
      "VILLA NIDIA",
      "SAN LORENZO",
      "EL ABRA",
      "EL CADILLO",
      "KILOMETRO 14",
      "VILLA LUISA",
      "LA INDUSTRIA",
      "LA ISLA",
      "BAJO HONDO",
      "EL MOSQUITO",
      "EL CALDEN",
      "LA CHILCA",
      "PUESTO LOS CORNEJOS",
      "LA REPRESA",
      "LA REPRESITA",
      "LAS VENTANITAS",
      "ULAPES",
      "AGUAYO",
      "EL MEDANITO",
      "SAN RAFAEL",
      "ALGARROBO GRANDE",
      "CORRAL DE ISAAC",
      "CUATRO ESQUINAS",
      "LA RESERVA",
      "PUESTO DICHOSO",
      "ENTRE RIOS",
      "SANTA ELENA",
      "LA LILIA",
      "EL BUEN RETIRO",
      "SAN SOLANO",
      "VIRGEN DEL VALLE",
      "NUEVA ESPERANZA",
      "PATQUIA VIEJO",
      "LA MESADA",
      "AMANA",
      "LA TORRE",
      "PATQUIA",
      "LOS COLORADOS",
      "PAGANZO",
      "AGUANGO",
      "REPRESA DE LA PUNTA",
      "LOS BALDECITOS",
      "BALDE SAN ISIDRO",
      "EL CHIFLON",
      "SANTA VERA CRUZ",
      "PINCHAS",
      "ISMIANGO",
      "ANJULLON",
      "AGUA BLANCA",
      "LOS MOLINOS",
      "SANTA CRUZ",
      "AMINGA",
      "CHUQUIS",
      "SAN PEDRO",
      "ANILLACO",
      "LAS LOMITAS",
      "PUNTA DE LOS LLANOS",
      "LAS AGUADITAS",
      "LA REPRESITA",
      "AGUADITA DE LOS VALDECES",
      "ALCAZAR",
      "TAMA",
      "BAJO VERDE",
      "TASQUIN",
      "SAN NICOLAS",
      "CHILA",
      "COLOZOCAN",
      "EL MONTE",
      "TUIZON",
      "SANTA TERESA",
      "PACATALA"
    ]
  },
  {
    "nombre": "Mendoza",
    "localidades": [
      "EL MANZANO",
      "LAS CHACRAS",
      "MALARGUE",
      "LA JUNTA",
      "LUANCO",
      "LAS LEÑAS",
      "EL CHACAY",
      "AGUA ESCONDIDA",
      "MINACAR",
      "EL INFIERNILLO",
      "LOS CARRIZALES",
      "EL VATRO",
      "RINCON CHICO",
      "LA SALINILLA",
      "EL ALAMBRADO",
      "CALMUCO",
      "LLANO BLANCO",
      "PATA MORA",
      "RIO GRANDE",
      "LOS CORRALES",
      "EL CARAPACHO",
      "LA VALENCIANA",
      "LOS MOLLES",
      "LA JAULA",
      "CAPIZ",
      "SAN CARLOS",
      "PAREDITAS",
      "CHILECITO",
      "EL PARRAL",
      "PIEDRAS BLANCAS",
      "TRES ESQUINAS",
      "LA CONSULTA",
      "BARRIO EL CEPILLO",
      "PASO DE LAS CARRETAS",
      "EUGENIO BUSTOS",
      "EL CAPACHO",
      "BARRIO CARRASCO",
      "LOS ALAMITOS",
      "VILLA EL CHACON",
      "BARRIO CHIVILCOY",
      "EL DIVISADERO",
      "BUEN ORDEN",
      "MONTECASEROS",
      "BARRIO LA ESTACION",
      "CHAPANAY",
      "BARRIO NTRA. SRA. DE FATIMA",
      "TRES PORTEÑAS",
      "CHIVILCOY",
      "BARRIO LOS CHARABONES",
      "ALTO VERDE",
      "CIUDAD DE SAN MARTIN",
      "EL RAMBLON",
      "BARRIO EMANUEL",
      "VILLA CENTENARIO",
      "EL ESPINO",
      "PALMIRA",
      "NUEVA CALIFORNIA",
      "TRES ESQUINAS",
      "ALTO SALVADOR",
      "COLONIA LAMBARE",
      "VILLA ANTIGUA",
      "CRUZ DEL YUGO",
      "DESAGUADERO",
      "CHAMUSCAO",
      "MAQUINISTA LEVET",
      "LAS CHACRITAS",
      "EL CAMPAMENTO",
      "LA GLORIOSA",
      "CADETES DE CHILE",
      "LA MENTA",
      "LA PAZ",
      "EL LECHUCITO",
      "LAS LAGUNITAS",
      "LA ASUNCION",
      "EL 15",
      "LAS VIOLETAS",
      "EL CARMEN",
      "ARROYITO",
      "EL PLUMERO",
      "INGENIERO GUSTAVO ANDRE",
      "VILLA TULUMAYA",
      "EL RETAMO",
      "ESTACION KILOMETRO 976",
      "BARRIO LA PEGA",
      "BARRIO LOS OLIVOS",
      "EL RETIRO",
      "BARRIO VIRGEN DEL ROSARIO",
      "SAN MIGUEL",
      "BARRIO LA ESPERANZA",
      "3 DE MAYO",
      "COSTA DE ARAUJO",
      "BARRIO LAGUNAS DE BARTOLUZZI",
      "EL FORZUDO",
      "LA POLVOSA",
      "SAN FRANCISCO",
      "LOS SAUCES",
      "EL PARAMILLO",
      "JOCOLI",
      "BARRIO ALTO DEL OLVIDO",
      "BARRIO JOCOLI II",
      "BARRIO LOS JARILLEROS",
      "LAGUNITA",
      "LA HOLANDA",
      "JOCOLI VIEJO",
      "CAPILLA DEL ROSARIO",
      "EL VERGEL",
      "BARRIO LA PALMERA",
      "COLONIA SUR",
      "LA ANGELINA",
      "MORON VIEJO",
      "LA DORMIDA",
      "BARRIO 12 DE OCTUBRE",
      "MORON CHICO",
      "LA BANDERA",
      "GOBERNADOR CIVIT",
      "PARRALES MENDOCINOS",
      "LAS CATITAS",
      "BALDE NUEVO",
      "LA CIENAGUITA",
      "LOMAS BLANCAS",
      "EL ALGARROBO",
      "SANTA ROSA",
      "SAN PEDRO",
      "VILLA CABECERA",
      "LA COSTA",
      "BARRIO MOLINA CABRERA",
      "BALDE DE PIEDRA",
      "BARRIO MARIA AUXILIADORA",
      "TALQUENCA",
      "LOS LOTES",
      "LA JOSEFA",
      "CATITAS VIEJAS",
      "COLONIA SAN JORGE",
      "BANDERITA",
      "LOS COMPARTOS",
      "POSTE DE FIERRO",
      "EL CEIBO",
      "COCHICO",
      "LA MARZOLINA",
      "GENERAL ALVEAR",
      "LA ESCANDINAVA",
      "LA MONTILLA",
      "EL JUNCALITO",
      "CORRAL DE LORCA",
      "LA CALIFORNIA",
      "LA MORA",
      "GOICO",
      "CANALEJAS",
      "OVEJERIA",
      "CARMENSA",
      "KILOMETRO 884",
      "LOS CAMPAMENTOS",
      "BOWEN",
      "USPALLATA",
      "LA UNION",
      "LA CIENEGUITA",
      "EL ZAPALLAR",
      "HORNITO DEL GRINGO",
      "PUENTE DEL INCA",
      "LAS HERAS",
      "EL CHALLAO",
      "CAPDEVILA",
      "VILLAVICENCIO",
      "LA HULLERA",
      "JOCOLI",
      "EL PUESTITO",
      "GUIDO",
      "LAS CORTADERAS",
      "EL PLUMERILLO",
      "EL ALGARROBAL",
      "PANQUEHUA",
      "ESPEJO",
      "POLVAREDAS",
      "BLANCO ENCALADA",
      "LA CASA DEL TIGRE",
      "PUNTA DE VACAS",
      "EL RESGUARDO",
      "LOS PENITENTES",
      "LAS CUEVAS",
      "SALAGASTA",
      "SIERRAS DE ENCALADA",
      "EL BORBOLLON",
      "SANTA ELENA",
      "6A. SECCION",
      "3A. SECCION",
      "8A. SECCION",
      "5A. SECCION",
      "1A. SECCION",
      "2A. SECCION",
      "11A. SECCION",
      "10A. SECCION",
      "7A. SECCION",
      "9A. SECCION",
      "4A. SECCION",
      "BERMEJO",
      "RODEO DE LA CRUZ",
      "DORREGO",
      "JESUS NAZARENO",
      "COLONIA SEGOVIA",
      "CAPILLA DEL ROSARIO",
      "GENERAL BELGRANO",
      "GUAYMALLEN",
      "LAGUNITA",
      "EL SAUCE",
      "LA PRIMAVERA",
      "LOS CORRALITOS",
      "BUENA NUEVA",
      "PEDRO MOLINA",
      "VILLA NUEVA",
      "KILOMETRO 11 (GUAYMALLEN)",
      "SAN FRANCISCO DEL MONTE",
      "PUENTE DE HIERRO",
      "LAS CAÑAS",
      "SAN JOSE",
      "PRESIDENTE SARMIENTO",
      "VILLA MARINI",
      "LAS TORTUGAS",
      "SAN FRANCISCO DEL MONTE",
      "VILLA HIPODROMO",
      "GODOY CRUZ",
      "GOBERNADOR BENEGAS",
      "LOS ALAMOS",
      "BARRANCAS",
      "EL PEDREGAL",
      "ISLA GRANDE",
      "COLONIA JARA",
      "RUSSELL",
      "LUNLUNTA",
      "COLONIA BOMBAL",
      "COQUIMBITO",
      "GENERAL ORTEGA",
      "VILLA TERESA",
      "BARRIO JESUS DE NAZARET",
      "COLONIA IRIGOYEN",
      "GENERAL GUTIERREZ",
      "EL PARAISO",
      "LUZURIAGA",
      "TRES ESQUINAS",
      "VILLA SECA",
      "SANTA BLANCA",
      "SAN ROQUE",
      "RODEO DEL MEDIO",
      "MAIPU",
      "ISLA CHICA",
      "FRAY LUIS BELTRAN",
      "CRUZ DE PIEDRA",
      "GUALTALLARY",
      "ZAPATA",
      "TUPUNGATO",
      "ANCON",
      "EL PERAL",
      "SAN JOSE",
      "CORDON DEL PLATA",
      "OJO DE AGUA",
      "BARRIO BELGRANO NORTE",
      "EL ZAMPALITO",
      "SANTA CLARA",
      "LA ARBOLEDA",
      "VILLA BASTIAS",
      "EL ZAMPAL",
      "LA CARRERA",
      "ESTANCIA PALMA",
      "ESTANCIA LAS CUEVAS",
      "VILLA EL REFUGIO",
      "MAYOR DRUMMOND",
      "POTRERILLOS",
      "PIEDRAS BLANCAS",
      "EL CARRIZAL",
      "VALLE DEL SOL",
      "LA PUNTILLA",
      "BARRIO ADINA I Y II",
      "ANCHORIS",
      "LAS VEGAS",
      "LOS MANANTIALES",
      "COSTA FLORES",
      "NUEVA COLONIA",
      "LUJAN DE CUYO",
      "PERDRIEL",
      "EL SALTO",
      "LA PICADA",
      "UGARTECHE",
      "CACHEUTA",
      "CHACRAS DE CORIA",
      "VISTALBA",
      "CARRODILLA",
      "EL CARMELO",
      "AGRELO",
      "BARRIO PERDRIEL IV",
      "LAS COMPUERTAS",
      "LAS CARDITAS",
      "VILLA SECA",
      "LA REMONTA",
      "AGUA AMARGA",
      "LA PRIMAVERA",
      "EL MANZANO",
      "COLONIA LAS ROSAS",
      "LA RIOJITA",
      "CAMPO LOS ANDES",
      "SAN PABLO",
      "EL TOTORAL",
      "BARRIO SAN CAYETANO",
      "LAS PINTADAS",
      "LOS SAUCES",
      "TUNUYAN",
      "VISTA FLORES",
      "EL ALGARROBO",
      "BARRIO RIVADAVIA",
      "MEDRANO",
      "LA LIBERTAD",
      "BARRIO COOPERATIVA LOS CAMPAMENTOS",
      "SANTA MARIA DE ORO",
      "LA FLORIDA",
      "LA ESPERANZA",
      "ANDRADE",
      "COSTA ANZORENA",
      "REDUCCION DE ABAJO",
      "CUADRO ORTEGA",
      "LOS CAMPAMENTOS",
      "RIVADAVIA",
      "LA CENTRAL",
      "EL MIRADOR",
      "MUNDO NUEVO",
      "LOS ARBOLES",
      "PHILLIPS",
      "ALTO VERDE",
      "JUNIN",
      "ALGARROBO GRANDE",
      "RODRIGUEZ PEÑA",
      "MEDRANO",
      "LOS BARRIALES",
      "MUNDO NUEVO",
      "INGENIERO GIAGNONI",
      "TRES ESQUINAS",
      "LA COLONIA",
      "SALTO DE LAS ROSAS",
      "BARRIO ECHEVERRIA",
      "VILLA ATUEL",
      "CUADRO NACIONAL",
      "SAN RAFAEL",
      "EL CERRITO",
      "LOS CLAVELES",
      "LAS AGUADITAS",
      "LOS SIFONES",
      "RESOLANA",
      "LA TOSCA",
      "ARISTIDES VILLANUEVA",
      "BARRIO PRIMAVERA",
      "LOS PEJES",
      "COLONIA EL USILLAL",
      "RAMA CAIDA",
      "SANTA TERESA",
      "REAL DEL PADRE",
      "LA HORQUETA",
      "EL SOSNEADO",
      "RINCON DEL INDIO",
      "LOS REYUNOS",
      "PIEDRA DE AFILAR",
      "EL ALGARROBAL",
      "LA GUEVARINA",
      "CUADRO BOMBAL",
      "COLONIA COLOMER",
      "COLONIA GELMAN",
      "LA TOMBINA",
      "EL NIHUIL",
      "LAS MALVINAS",
      "COLONIA JAUREGUI",
      "COLONIA RUSA",
      "GUADALES",
      "COLONIA ELENA",
      "25 DE MAYO",
      "MONTE COMAN",
      "LA VASCONIA",
      "LA PICHANA",
      "EL ESCORIAL",
      "BARRIO EL NEVADO",
      "CAPITAN MONTOYA",
      "EL VIDALINO",
      "CUESTA DE LOS TERNEROS",
      "BARRIO EMPLEADOS DE COMERCIO",
      "PEDRO VARGAS",
      "BARRIO LAS ROSAS",
      "LA LLAVE NUEVA",
      "BARRIO INTENDENCIA",
      "PUNTA DEL AGUA",
      "LA LLAVE SUR",
      "JAIME PRATS",
      "GOUDGE",
      "EL VENCEDOR",
      "COLONIA LOPEZ",
      "LA LLAVE",
      "SOITUE",
      "LOS TABLEROS",
      "EL TROPEZON",
      "BARRIO CAMPOS EL TOLEDANO",
      "POBRE DIABLO",
      "LA NORA",
      "VILLA ATUEL NORTE"
    ]
  },
  {
    "nombre": "Misiones",
    "localidades": [
      "3 DE MAYO",
      "GARUHAPE",
      "SAN MIGUEL",
      "PUERTO GARUHAPE",
      "POZO AZUL",
      "NUESTRA SEÑORA DE ITATI",
      "DURAN",
      "TRES VECINOS",
      "FORESTAL (SAN ANTONIO)",
      "SALTO ENCANTADO",
      "TRES CAPONES",
      "LAS TUNAS",
      "SIERRITA SAN JOS",
      "TARANCO",
      "SAN JOSE",
      "COLONIA SAN JOSE",
      "PINDAPOY",
      "PUERTO ESPAÑA",
      "GENERAL URQUIZA",
      "EL DESTIERRO",
      "BARRIO TUNGOIL",
      "PUERTO NUEVO",
      "PUERTO GISELA",
      "SEGUIN",
      "CAMPO VIERA",
      "YAZA",
      "PANAMBI",
      "MOJON GRANDE",
      "CERRO CORA",
      "VILLA VENECIA",
      "LA INVERNADA",
      "LAS QUEMADAS",
      "BELLA VISTA",
      "AZARA",
      "COLONIA APOSTOLES",
      "RINCON DE AZARA",
      "CAPON BONITO",
      "VILLA MARTTOS",
      "OBERA",
      "PICADA VIEJA",
      "GUAYABERA",
      "TRES ESQUINAS",
      "VILLA BARREYRO",
      "EL SALTO",
      "PUERTO SAN ISIDRO",
      "BARRA CONCEPCION",
      "SAN ISIDRO",
      "CONCEPCION DE LA SIERRA",
      "PUERTO SAN LUCAS",
      "CIEN HECTAREAS",
      "EL TIGRE",
      "PAREJHA",
      "CUATRO BOCAS",
      "COLONIA VICTORIA",
      "PROFUNDIDAD",
      "TACUARUZU",
      "9 DE JULIO KILOMETRO 20",
      "VALLE HERMOSO",
      "MARIANO MORENO",
      "9 DE JULIO",
      "PUEBLO NUEVO",
      "AGUARAY GUAZU",
      "PUERTO MADO",
      "MARIA MAGDALENA",
      "NUEVA DELICIA",
      "YACUTINGA",
      "PASTOREO",
      "GOBERNADOR ROCA",
      "ROCA CHICA",
      "OLEGARIO V. ANDRADE",
      "COLONIA ALEMANA",
      "PICADA GALITZIANA",
      "VILLA BONITA",
      "YERBAL VIEJO",
      "PICADA GUARAIPO",
      "BARRIO ESCUELA 633",
      "PICADA INTERNACI",
      "VILLA UNION",
      "CAMPO RAMON",
      "COLONIA GUARAYPO",
      "LAHARRAGUE",
      "BARIO ITA",
      "PUERTO LAHARRAGUE",
      "GUATAMBU",
      "BARRIO GUATAMBU",
      "BARRIO CUATRO BOCAS",
      "MONTECARLO",
      "MARIANO MORENO",
      "MONTEAGUDO",
      "PEPIRI MINI",
      "MARTIN GÑEMES",
      "COLONIA PRIMAVERA",
      "EL SOBERBIO",
      "LA BONITA",
      "ANDRESITO (EL SOBERBIO)",
      "FRAY LUIS BELTRAN",
      "PICADA GUARANI",
      "EL BOTON (EL SOBERBIO)",
      "NUEVA (EL SOBERBIO)",
      "ARROYO BONITO (EL SOBERBIO)",
      "FORTIN MBORORE",
      "PUERTO PENINSULA",
      "PUERTO CANOAS",
      "PUERTO IGUAZU",
      "VILLA ALTA",
      "CATARATAS DEL IGUAZU",
      "YRYAPU",
      "BONPLAND",
      "SAN JAVIER",
      "RINCON DEL GUERRERO",
      "INVERNADA GRANDE",
      "PICADA SAN JAVIER",
      "TRES ESQUINAS",
      "LOS GALPONES",
      "PICADA SUD",
      "PICADA AFRICANA",
      "LEANDRO N. ALEM",
      "EL PORVENIR",
      "NEMESIO PARMA",
      "POSADAS",
      "COLONIA MARTIRES",
      "MARTIRES",
      "EL BARRERITO",
      "SANTA RITA",
      "LA UVA",
      "SAN FRANCISCO DE ASIS",
      "CORONEL PRINGLES",
      "BARRA BONITA",
      "ALBA POSSE",
      "COLONIA ACARAGUA",
      "9 DE JULIO",
      "DOS ARROYOS",
      "ALBERDI",
      "PICADA YACUTINGA",
      "ALMAFUERTE",
      "CORPUS",
      "SANTIAGO DE LINIERS",
      "PICADA BELGRANO",
      "CERRO AZUL",
      "PICADA POLACA",
      "LOS INDIOS",
      "PICADA VASCA",
      "GENERAL ALVEAR",
      "ARROYO PASTORA",
      "LORETO",
      "FLORA",
      "PUERTO TABAY",
      "OASIS",
      "VILLA LIBERTADOR GENERAL SAN MARTIN",
      "COLONIA SOL DE MAY",
      "JARDIN AMERICA",
      "PICADA FLOR",
      "SAN JOSE",
      "PICADA EL MOLINO",
      "LAS MERCEDES",
      "EL PACIFICO (SAN VICENTE)",
      "PUERTO ARGENTINO (SAN VICENTE)",
      "GUIRAY",
      "PICADA SULMA (SAN VICENTE)",
      "PICADA MOJON GRANDE (SAN VICENTE)",
      "COLONIA FLORIDA",
      "EL SOCORRO",
      "SAN VICENTE",
      "EL LUCERO (SAN VICENTE)",
      "FRACRAN",
      "SANTA INES",
      "BARRIO NUEVO GARUPA",
      "GARUPA",
      "SAN JUAN DE LA SIERRA",
      "SANTA MARIA",
      "LA CORITA",
      "CASCABEL",
      "ARROYO SANTA MARIA",
      "CERRO MARTIRES",
      "PUERTO NARANJITO",
      "COLONIA NARANJITO",
      "COLONIA POLANA",
      "VILLA URRUTIA",
      "EL ALCAZAR",
      "1 DE MAYO",
      "EL TIGRE",
      "KILOMETRO 17 (RUTA 8)",
      "CAMPO GRANDE",
      "YERBAL VIEJO",
      "JOSE LUIS",
      "BARRIO DEL LAGO",
      "CANDELARIA",
      "ALDEA ABORIGEN",
      "APARICIO CUE",
      "INVERNADA",
      "VILLA EMMA",
      "SAN IGNACIO",
      "SAN RAFAEL",
      "TEYU CUARE",
      "DOMINGO SAVIO",
      "ARROYO DEL MEDIO",
      "FACHINAL",
      "SAN ANDRES",
      "EL PALMITAL",
      "COLONIA AURORA",
      "PUERTO LONDERO",
      "CHAFARIZ",
      "ALICIA BAJA",
      "LAS LIMAS",
      "COLONIA ALICIA",
      "APARECIDA",
      "SAN CARLOS",
      "COLONIA EL PROGRESO",
      "FLOR DE MAYO",
      "COLONIA ALICIA ALTA",
      "25 DE MAYO",
      "PICADA MALVINAS",
      "EL SALTITO",
      "LA YERBA",
      "TORTA QUEMADA",
      "LIBERTAD",
      "ALBORADA",
      "PICADA RIO URUGUAY",
      "TAMANDUA",
      "COLONIA ORO VERDE",
      "SAN ALBERTO",
      "PUERTO RICO",
      "MBOPICUA",
      "CAPIOVICIÑO",
      "GOBERNADOR LOPEZ",
      "EL CHATON",
      "LA FORTALEZA",
      "PUERTO SANTA ANA",
      "SANTA ANA",
      "LIBERTAD",
      "ALDEA GUAPOY",
      "PUERTO ERRECABORDE",
      "PUERTO LIBERTAD",
      "TIRICA",
      "VILLA COOPERATIVA",
      "PIRAY KILOMETRO 18",
      "PUERTO PIRAY",
      "COLONIA SANTA TERESA",
      "VILLA PARODI",
      "GUARANI",
      "VILLA SOMMER",
      "PICADA YAPEYU",
      "TARUMA",
      "PUERTO CARAGUATAY",
      "MONTE QUEMADO",
      "AVELLANEDA",
      "PUERTO AVELLANEDA",
      "CARAGUATAY",
      "EL BONITO",
      "TACUARA",
      "SANTO PIPO",
      "PUERTO WANDA",
      "TUPI CUA",
      "EL SUSTO",
      "WANDA",
      "PUERTO LEONI",
      "VILLA AKERMAN",
      "COLONIA FLORA",
      "PUERTO MINERAL",
      "HIPOLITO YRIGOYEN",
      "HELVECIA",
      "ROBILLARD CUE (PUERTO ESPERANZA)",
      "PUERTO SEGUNDO",
      "ESPERANZA",
      "CELMAN",
      "PICADA FILANDESA",
      "SAN MARTIN",
      "SAN GOTARDO",
      "CAPIOVI",
      "EL PORVENIR",
      "INVERNADA CHICA",
      "INVERNADA DE ITACARUARE",
      "ITACARUARE",
      "LA ARROCERA",
      "VILLA ROULET",
      "ELDORADO",
      "PUERTO PINARES",
      "PARAISO",
      "CRUCE CABALLERO",
      "PICADA MARIA AUXILIADORA",
      "SAN PEDRO",
      "ALEGRIA",
      "GENTILE",
      "PALMERA BOCA",
      "VILLA DON BOSCO",
      "SANTA ROSA",
      "COLONIA PRIMAVERA",
      "BELLO HORIZONTE",
      "RIO YABOTY",
      "TIRICA",
      "PIÑALITO SUR",
      "TOBUNA",
      "MACACA",
      "NUEVA ESPERANZA (BERNARDO IRIGOYEN)",
      "ASTER",
      "LAS MINAS",
      "CERRO SIETE (SAN ANTONIO)",
      "ALEGRIA",
      "AZOPARDO",
      "SAN ANTONIO",
      "PIÑALITO NORTE",
      "EL CENTRAL (SAN ANTONIO)",
      "VILLA UNION",
      "PARAJE 130",
      "CAMPO ALEGRE",
      "SARACURA (SAN ANTONIO)",
      "BARBACUA (SAN ANTONIO)",
      "CHICO ALFEREZ",
      "FLORENTINO AMEGHINO",
      "PUERTO ROSARIO",
      "PUERTO ANDRESITO",
      "DESEADO",
      "CABUREI",
      "INTEGRACION",
      "28 DE DICIEMBRE",
      "PUERTO DESEADO",
      "COMANDANTE ANDRESITO",
      "CABALLERO (SAN ANTONIO)",
      "PENINSULA",
      "SOBERANIA",
      "11 DE SEPTIEMBRE",
      "ARROYO VERD",
      "MAVALLE PINDAYTI",
      "CUÑA PIRU",
      "PICADA PROPAGANDA",
      "TRES ARROYOS",
      "LAS YERBAS",
      "CUÑA PIRU I",
      "ARAZA",
      "EL CRUCE PINDAYTI",
      "TAMANDUA",
      "ARISTOBULO DEL VALLE",
      "RUIZ DE MONTOYA",
      "PICADA SUECA",
      "VILLA LIBERTAD",
      "COLONIA FINLANDESA",
      "CAA - YARI",
      "ESTACION APOSTOLES",
      "APOSTOLES",
      "EL PARAISO",
      "BARRIO RURAL",
      "EL CRUCE",
      "LA CAPILLA",
      "BARRIO ESCUELA 461",
      "LOS HELECHOS",
      "BAJO PEPIRI",
      "DOS HERMANAS",
      "BERNARDO DE IRIGOYEN",
      "FACUNDO QUIROGA",
      "LAGUNA AZUL",
      "JUAN MANUEL DE ROSAS",
      "NUCLEO II",
      "EL PORTON",
      "DOS DE MAYO NUCLEO I",
      "PUEBLO ILLIA",
      "CASCUDA",
      "INDUMAR",
      "COLONIA MILAGRO",
      "DOS DE MAYO NUCLEO II",
      "DOS DE MAYO NUCLEO III",
      "NUCLEO I",
      "CAINGUAS",
      "SALTITO II",
      "MBORORE",
      "PANAMBI",
      "PANAMBI KILOMETRO 8",
      "MARIANO MORENO",
      "PANAMBI KILOMETRO 15"
    ]
  },
  {
    "nombre": "Neuquén",
    "localidades": [
      "VISTA ALEGRE NORTE",
      "VISTA ALEGRE SUR",
      "BARRIO RUCA LUHE",
      "PILO LIL",
      "GUAÑACOS",
      "LAGO MELIQUINA",
      "SENILLOSA",
      "AGUADA TOLEDO",
      "ARROYITO",
      "CHINA MUERTA",
      "AQUIHUECO",
      "TRICAO MALAL",
      "CANCHA HUINGANCO",
      "CAMPANA MAHUIDA",
      "LONCOPUE",
      "NEUQUEN",
      "COLONIA VALENTINA",
      "EL CHENQUE",
      "PANTANITOS",
      "PIEDRA DEL AGUILA",
      "AUCA MAHUIDA",
      "CAYANTA",
      "LOS CARRIZOS",
      "VILLA DEL NAHUEVE",
      "BELLA VISTA",
      "AÑELO",
      "EL MANZANO",
      "HUINGANCO",
      "BUTALON NORTE",
      "CHARRA RUCA",
      "CUMELEN",
      "CORRENTOSO",
      "VILLA LA ANGOSTURA",
      "CHIMEHUIN",
      "QUECHUQUINA",
      "AUQUINCO",
      "TROMPUL (RAI)",
      "CHAPELCO",
      "LAGO HERMOSO",
      "ESTANCIA SANTA LUCIA",
      "ISLA VICTORIA",
      "NAHUEL HUAPI",
      "LA LIPELA",
      "HUEMUL",
      "SANTA MARIA",
      "ESPEJO",
      "SAUZAL BONITO",
      "TIERRAS BLANCAS",
      "LILEO",
      "LOS MICHES",
      "AGUA DEL OVERO",
      "BELISLE",
      "CASA DE PIEDRA",
      "BAJADA DE LOS MOLLES",
      "EL RINCON",
      "CATATUN",
      "CHACAYCO",
      "CATAN LIL",
      "LA NEGRA",
      "LAPA",
      "MEDIA LUNA",
      "LAS CORTADERAS",
      "COSTA DEL CATAN LIL",
      "ESPINAZO DEL ZORRO",
      "LOS REMOLINOS",
      "EL SALITRAL",
      "EL SAUCE",
      "LA PICAZA",
      "BUTA RANQUIL",
      "AGUADA CHACAYCO",
      "LAGUNA AUQUINCO",
      "RANQUIL VEGA",
      "CARRI LIL",
      "RAHUE",
      "QUILLEN",
      "ABRA ANCHA",
      "CURRUMIL QUILLEN",
      "HARAS PULMARI",
      "QUILCA",
      "LONCO MULA",
      "TAQUIMILAN",
      "TAQUIMILAN ARRIBA",
      "CHACAICO",
      "TAQUIMILAN CENTRO",
      "RANQUILCO",
      "LA GREDA",
      "RAHUECO",
      "TRES CHORROS",
      "HUALCUPEN",
      "COLIPILLI ABAJO",
      "RANQUILON",
      "LONCO LUAN",
      "VILLA PEHUENIA",
      "VILLA UNION",
      "MOQUEHUE",
      "PLOTTIER",
      "PUENTE PICUN LEUFU",
      "PUENTE PICUN LEUFU",
      "COCHICO",
      "LONCO VACA",
      "COYUCO",
      "BAJADA VIEJA",
      "BAJADA DEL AGRIO",
      "AGRIO DEL MEDIO",
      "LOS CHIHUIDOS",
      "RAMON M. CASTRO",
      "SANTO DOMINGO",
      "PASO AGUERRE",
      "MALLEO",
      "ATREUCO ARRIBA",
      "PAIMUN",
      "CONFLUENCIA DEL MALLEO",
      "LOS HELECHOS",
      "NAHUEL MAPE ARRIBA",
      "SAN CABAO",
      "HUILQUI MENUCO",
      "AUCAPAN ABAJO",
      "COSTA DEL MALLEO",
      "ATREUCO (RAI)",
      "NAHUEL MAPI ABAJO",
      "INVERNADA VIEJA",
      "VARVARCO",
      "COLOMICHICO",
      "LAS OVEJAS",
      "CENTENARIO",
      "11 DE OCTUBRE",
      "MARIANO MORENO",
      "COVUNCO CENTRO",
      "LOS HORNOS",
      "BARRANCAS",
      "AGUA CALIENTE",
      "RINCON DE LOS SAUCES",
      "LEUTO CABALLO",
      "TILHUE",
      "LA SALADA",
      "ARROYO BLANCO",
      "LOS MOLLES",
      "CHAPUA",
      "JUNIN DE LOS ANDES",
      "LA RINCONADA",
      "CERRO DE LOS PINOS",
      "PAMPA DEL MALLEO",
      "LOLOG",
      "LAGO LOLOG",
      "SAN MARTIN DE LOS ANDES",
      "PUENTE BLANCO",
      "MALLIN DEL TORO",
      "HUNCAL",
      "HUARENCHENQUE",
      "PICHAIHUE",
      "CAJON DE ALMAZA",
      "QUINTUCO",
      "HUALCUPEN",
      "COVUNCO ARRIBA",
      "AGUADA DEL LUCERO",
      "LOS CATUTOS",
      "MALLIN DEL MUERTO",
      "EL SALITRAL",
      "LONCO LUAN",
      "ZAPALA",
      "LA MATANSILLA",
      "MANZANO AMARGO",
      "PICHI NEUQUEN",
      "CHALLACO",
      "MARI MENUCO",
      "LOMA DE LA LATA",
      "CUTRAL CO",
      "CHACRAS DE MONTE HERMOSO",
      "PLAZA HUINCUL",
      "VILLA TRAFUL",
      "CAVIAHUE",
      "COPAHUE",
      "AGUADA SAN ROQUE",
      "QUILI MALAL",
      "LA PATAGONIA",
      "OCTAVIO PICO",
      "SANTO TOMAS",
      "LA PATAGONIA",
      "COVUNCO ABAJO",
      "LAGUNA BLANCA",
      "BAJADA DE LOS MOLLES",
      "EL CHENQUE",
      "LA AMARGA",
      "LAGUNA MIRANDA",
      "EL MANZANO",
      "PASO DE LOS INDIOS",
      "CARRO QUEBRADO",
      "CODIHUE",
      "PINO HACHADO",
      "MALLIN QUEMADO",
      "LA PATRIA",
      "COVUNCO ABAJO",
      "COVUNCO CENTRO",
      "PINO SOLO",
      "PRIMEROS PINOS",
      "MALLIN DEL RUBIO",
      "LOS ALAZANES",
      "MALLIN DE LOS CABALLOS",
      "EL CHOCON",
      "VILLA EL CHOCON",
      "SAN PATRICIO DEL CHAÑAR",
      "LIMAY CENTRO",
      "VILLA UNION",
      "EL SAUCE",
      "CHORRIACA",
      "COIHUECO",
      "TRAHUNCURA",
      "ANDACOLLO",
      "LA PRIMAVERA",
      "HUARACO",
      "EL CHOLAR",
      "CHOS MALAL",
      "SAIHUEQUE CACIQUE",
      "ALUMINE",
      "CHACRA 8",
      "SAN DEMETRIO",
      "LA BUITRERA",
      "LAS LAJAS",
      "CAEPE MALAL",
      "EL ALAMITO",
      "CHACAY MELEHUE/EL ALAMITO",
      "VILLA DEL CURI LEUVU",
      "LOS MENUCOS",
      "LAS COLORADAS",
      "VILLA PICHI PICUN LEUFU",
      "VILLA RINCON CHICO",
      "HUAIQUIMIL",
      "SAN IGNACIO",
      "ZAINA YEGUA",
      "PIEDRA PINTADA",
      "CORTADERA",
      "HUANTRAICO",
      "HUITRIN",
      "SAN EDUARDO",
      "SIERRA DE HUANTRAICO",
      "EL HUECU",
      "PICUN LEUFU"
    ]
  },
  {
    "nombre": "Río Negro",
    "localidades": [
      "NAUPA HUEN",
      "MAQUINCHAO",
      "CAITA TORO",
      "CHANQUIN",
      "CAMPANA MAHUIDA",
      "ARROYO LOS BERROS",
      "PASO FLORES",
      "CUBANEA",
      "CHIPAUQUIL",
      "PICHI MAHUIDA",
      "LAS GRUTAS",
      "ARROYO VENTANA",
      "BARDA DEL MEDIO",
      "CONTRALMIRANTE CORDERO",
      "PILQUINIYEU",
      "EL TROPEZON",
      "VACA LAUFQUEN",
      "CERRO MESA",
      "ATRAICO",
      "LA ESPERANZA",
      "MINA SANTA TERESITA",
      "VILLA MASCARDI",
      "BARRIO PRESIDENTE PERON",
      "CINCO SALTOS",
      "LA PARRA",
      "INGENIERO JACOBACCI",
      "LAGUNA BLANCA",
      "VILLA CATEDRAL",
      "COLONIA SUIZA",
      "SAN CARLOS DE BARILOCHE",
      "VILLA LOS COIHUES",
      "VILLA LLAO LLAO",
      "VILLA ARELAUQUEN",
      "BARRIO EL PILAR",
      "VILLA CAMPANARIO",
      "PENINSULA SAN PEDRO",
      "BARRIO LA BARDA",
      "BARRIO LA COSTA",
      "INGENIERO LUIS A. HUERGO",
      "GENERAL ENRIQUE GODOY",
      "BARRIO GORETTI",
      "BARRIO LA LOR",
      "BARRIO TRES LUCES",
      "RENTERIA",
      "CUATRO ESQUINAS",
      "COLONIA CURRI LAMUEN",
      "FERRI",
      "BARRIO PUENTE DE MADERA",
      "LA FALDA",
      "LAS PERLAS",
      "BARRIO MARIA ELVIRA",
      "COLONIA CONFLUENCIA",
      "BARRIO EL TREINTA",
      "BARRIO NORTE",
      "TRES LUCES",
      "BARRIO PUENTE 83",
      "CIPOLLETTI",
      "SANTA ROSA",
      "NAHUEL NIYEU",
      "SALITRAL NEGRO",
      "EL CAIN",
      "GUARDIA MITRE",
      "OJOS DE AGUA",
      "LIPETREN",
      "YUQUICHE",
      "DARWIN",
      "RIO CHICO",
      "CATRIEL",
      "LAS BAYAS",
      "PICHI LEUFU",
      "PASO CHACABUCO",
      "PASO MIRANDA",
      "CORRALITO",
      "PASO DE LOS MOLLES",
      "COQUELEN",
      "PICHI LEUFU ABAJO",
      "PILCANIYEU",
      "SEGUNDA ANGOSTURA",
      "COLONIA CHOCORI",
      "BOCA DE LA TRAVESIA",
      "COLONIA LA LUISA",
      "BARRIO PLANTA COMPRESORA DE GAS",
      "EL PORVENIR",
      "COLONIA SAN JUAN",
      "CHELFORO",
      "SANTA LUCIA",
      "MAINQUE",
      "BARRIO LUISILLO",
      "GENERAL CONESA",
      "BARRIO COLONIA CONESA",
      "COLONIA SANTA TERESITA",
      "COLONIA SANTA ROSA",
      "COMICO",
      "CHASICO",
      "TAMBELEN",
      "CLEMENTE ONELLI",
      "ANECON GRANDE",
      "COLONIA EL GUALICHO",
      "SALTO ANDERSEN",
      "EL CUY",
      "TRAPALCO",
      "SAN LORENZO",
      "LA JULIA",
      "COLONIA JOSEFA",
      "NEGRO MUERTO",
      "LA JAPONESA",
      "VILLA LLANQUIN",
      "CHACAY HUARRUCA",
      "EL MONTOSO",
      "EL PORTEZUELO",
      "BARRIO ESPERANZA",
      "COLONIA REIG",
      "COLONIA JULIA Y ECHARREN",
      "RIO COLORADO",
      "JUVENTUD UNIDA",
      "SAN JAVIER",
      "BARRIO LA DEFENSA",
      "CERVANTES",
      "BARRIO PORVENIR",
      "COLONIA FATIMA",
      "AGUADA DE GUERRA",
      "BARRIO DESTACAMENTO",
      "BARRIO PINAR",
      "VALLE VERDE",
      "PEÑAS BLANCAS",
      "ÑORQUINCO",
      "MAMUEL CHOIQUE",
      "DINA HUAPI",
      "ÑIRIHUAU",
      "BARRIO PINO AZUL",
      "GENERAL ROCA",
      "BARRIO EL PETROLEO",
      "BARRIO LA COSTA",
      "BARRIO LA RIBERA - BARRIO APYCAR",
      "BARRIO MOSCONI",
      "BARRIO LAS ANGUSTIAS",
      "PASO CORDOVA",
      "BARRIO FRONTERA",
      "BARRIO CANALE",
      "BARRIO MAR DEL PLATA",
      "BARRIO CHACRA MONTE",
      "PASO CORDOVA",
      "PRIMERA ANGOSTURA",
      "POZO SALADO",
      "MONTE BAGUAL",
      "ZANJON DE OYUELA",
      "SAUCE BLANCO",
      "BAHIA CREEK",
      "LOTEO COSTA DE RIO",
      "LA LOBERIA",
      "LA ENSENADA",
      "VALLE AZUL",
      "PAMPA LINDA",
      "COMALLO ARRIBA",
      "CAÑADON CHILENO",
      "CERRO NEGRO",
      "COMALLO ABAJO",
      "QUEPU NIYEU",
      "SAN CARLOS",
      "EL CHACAY",
      "BARRIO COSTA ESTE",
      "CERRO POLICIA",
      "BARRIO COSTA OESTE",
      "VILLA ALBERDI",
      "VILLA REGINA",
      "BARRIO SANTA RITA",
      "PENINSULA RUCA CO",
      "BAJO SAN CAYETANO",
      "LAMARQUE",
      "COLAN CONUE",
      "VALCHETA",
      "AGUADA CECILIO",
      "TRENETA",
      "MINISTRO RAMOS MEXIA",
      "LOS MENUCOS",
      "EL MANSO",
      "RIO VILLEGAS",
      "EL FOYEL",
      "SIERRA COLORADA",
      "SACO VIEJO",
      "SAN ANTONIO OESTE",
      "PUERTO SAN ANTONIO ESTE",
      "ESTACION EMPALME",
      "LOS ALAMOS",
      "COSTA DEL RIO AZUL",
      "CUESTA DEL TERNERO",
      "LOS REPOLLOS",
      "MALLIN AHOGADO",
      "TRES PUENTES ARRIBA",
      "EL BOLSON",
      "ARROYO QUEMQUEMTREU",
      "BARRIO UNION",
      "GENERAL FERNANDEZ ORO",
      "BARRIO COSTA LINDA",
      "BARRIO ISLA 10",
      "BARRIO UNION",
      "CHIMPAY",
      "COLONIA SANTA GREGORIA",
      "CONA NIYEU",
      "LUIS BELTRAN",
      "VILLA SAN ISIDRO",
      "VILLA MANZANO",
      "BARRIO EL LABRADOR",
      "SARGENTO VIDAL",
      "POMONA",
      "PILAHUE",
      "MENCUE",
      "BLANCURA CENTRO",
      "QUILI MALAL",
      "PALENQUE NIYEU",
      "LA ANGOSTURA",
      "CORONEL BELISLE",
      "COMALLO",
      "PLAYAS DORADAS",
      "SIERRA GRANDE",
      "MINA GONZALITO",
      "PUNTA COLORADA",
      "YAMINUE",
      "EL PASO",
      "EL CONDOR",
      "LA BOCA",
      "VIEDMA",
      "EL JUNCAL",
      "CHOELE CHOEL",
      "ARROYO EL TEMBRAO",
      "SIERRA PAILEMAN",
      "CHAJAIJO",
      "COLONIA CEFERINO NAMUNCURA",
      "INGENIERO OTTO KRAUSE",
      "CHICHINALES",
      "VILLA DEL PARQUE",
      "BARRIO MOÑO AZUL",
      "PILQUINIYEU DEL LIMAY",
      "BARRIO GUERRICO",
      "BARRIO CALLE CIEGA N° 10",
      "BARRIO EMERGENTE",
      "BARRIO BLANCO",
      "BARRIO CALLE CIEGA N° 6",
      "BARRIO EL MARUCHITO",
      "BARRIO LA HERRADURA",
      "ALLEN",
      "PRAHUANIYEU",
      "BARDA COLORADA",
      "LONCO VACA",
      "AGUADA GUZMAN",
      "CHASICO"
    ]
  },
  {
    "nombre": "Salta",
    "localidades": [
      "MOJOTORO",
      "ISLAS DE VAQUEROS",
      "SANTA GERTRUDIS",
      "LA CALDERILLA",
      "LOS SAUCES",
      "LOS PORONGOS",
      "LA CALDERA",
      "EL GALLINATO",
      "CAMPO ALEGRE",
      "SAN JOSE DE AGUILAR",
      "PUCALLPA",
      "LIZOITE",
      "LA SOLEDAD",
      "HORNILLOS",
      "EL PUESTO",
      "LA FALDA",
      "RODEO PAMPA",
      "PUCARA",
      "LA HUERTA",
      "CAMPO LA PAZ",
      "PUEBLO VIEJO",
      "SAN FRANCISCO",
      "SAN JOSE",
      "ABRA DE SANTA CRUZ",
      "SANTA CRUZ",
      "CHORRO",
      "SANTA VICTORIA",
      "ABRA DE SAN ANTONIO",
      "ANTIGAL",
      "LAGUNA",
      "SAN FELIPE",
      "SANTA CRUZ DE AGUILAR",
      "MECOYITA",
      "ACOYTE",
      "RIO PIEDRAS",
      "LUMBRERAS",
      "ARENALES",
      "POTRERILLOS",
      "EL JARDIN",
      "DIVISADERO",
      "YACOCHUYA",
      "EL PASO",
      "LAS CONCHAS",
      "CAFAYATE",
      "SANTA BARBARA",
      "TOLOMBOM",
      "AGUAS BLANCAS",
      "EL BRETE",
      "EL TALA",
      "LOS MOGOTES",
      "FINCA LOS TAPIRES",
      "LOS VIBORONES",
      "EL 93",
      "SAN ROQUE",
      "POZO NUEVO",
      "FINCA EL MILAGRO",
      "SANTA CECILIA",
      "FINCA LA FLORESTA",
      "EL YUCHAN",
      "PUERTA BLANCA",
      "EL TOTORAL",
      "LUJAN",
      "EL CARDITO",
      "LOS LAURELES",
      "SAN NICOLAS",
      "BALBUENA",
      "SAN DAVID",
      "SAN JOSE",
      "ESPERANZA",
      "LA CANDELARIA",
      "SANTA LAURA",
      "SANTA TERESA",
      "JUME POZO",
      "LAGUNA VERDE",
      "EL RETIRO",
      "CENTRO 25 DE JUNIO",
      "RESISTENCIA",
      "EL DESTIERRO",
      "EL POTRERILLO",
      "LA ARGENTINA",
      "SALTA FORESTAL",
      "SAN FELIPE",
      "LAGUNA BLANCA",
      "SAN CRISTOBAL",
      "SAN JORGE",
      "SANTA ANA",
      "BELLA VISTA",
      "SAN ANTONIO",
      "CORONEL OLLEROS",
      "SAN ANDRES",
      "EL SUNCHAL",
      "PILCOMAYO",
      "EL GRITAO",
      "SAN SIMON",
      "EL VALLE (FINCA)",
      "LA UNION",
      "POZO VERDE",
      "EL MANANTIAL",
      "PIQUETE CABADO",
      "EL GUAYACAN",
      "PUESTO DEL MEDIO",
      "CEIBALITO",
      "SAN ALFONSO",
      "LOS BLANCOS",
      "POZO GRANDE",
      "CAMPO REDONDO (PUESTO)",
      "SANTA MARIA",
      "LA LAGUNITA",
      "SAN IGNACIO",
      "POZO LARGO",
      "EL ESTANQUE",
      "VIZCACHERAL",
      "TORO POZO",
      "FINCA EL ALGARROBAL",
      "SANTOS LUGARES",
      "LA POSICION",
      "BELLA FLOR",
      "LUZ DE ANTA",
      "EL 103",
      "LOS POZOS",
      "LAS MERCEDES",
      "JOAQUIN V. GONZALEZ",
      "POZO HALLADO",
      "BUEN LUGAR",
      "INDEPENDENCIA",
      "LA AGUADA",
      "SAN MARTIN",
      "SANTO DOMINGO",
      "EL RECREO",
      "REMANCITO",
      "EL 21",
      "EL YESO",
      "RETIRO",
      "SAN PEDRO",
      "EL JARDIN",
      "SAN BERNARDO",
      "LAS VACAS",
      "EL QUEBRACHALITO",
      "PUESTO LA PROVIDENCIA",
      "LA POBLACION",
      "NOLASCO",
      "FINCA LA MORALEJA",
      "EL DESMONTE",
      "GENERAL PIZARRO",
      "LOMA DE BURRO",
      "LAS AVISPAS",
      "LAS BEBIDAS",
      "ARRAYANAL",
      "LUIS BURELA",
      "LA ESMERALDA",
      "EL PUESTITO (FINCA)",
      "EL REAL",
      "CORRAL QUEMADO",
      "EL CEBILAR",
      "PALO SANTO",
      "AGUA CALIENTE",
      "PALO A PIQUE",
      "EL LINDERO",
      "EL TREMENTINAL",
      "POCOY",
      "RECAREDO",
      "MADREJONES",
      "BARRIO EL JARDIN DE SAN MARTIN",
      "CORONEL CORNEJO",
      "GENERAL MOSCONI",
      "CAMPAMENTO VESPUCIO",
      "SAN TELMO",
      "CHICOANA",
      "SANTA ANA",
      "BARRIO SANTA TERESITA",
      "EL CANDADO",
      "CHIVILME",
      "BELLA VISTA",
      "LAS ANIMAS",
      "ESCOIPE",
      "BARRIO LA ROTONDA",
      "MOLINO DE GONGORA",
      "EL RODEO",
      "EL TIPAL",
      "VILLA FANNY",
      "QUEBRADA DE ESCOIPE",
      "SAN MARTIN",
      "PULARES",
      "EL SIMBOLAR",
      "LA ZANJA",
      "POTRERO DIAZ",
      "LAS MORAS",
      "EL NOGALAR",
      "EL MOLLAR",
      "LA MAROMA",
      "SUNCHAL",
      "AGUA NEGRA",
      "CAMPO LA CRUZ",
      "NAZARENO",
      "SAN F. DE TUCTUCA",
      "BARITU",
      "KELLOTICAR",
      "CUESTA AZUL",
      "LIPEO",
      "SAN JUANCITO",
      "POSCAYA",
      "EL MOLINO DE CUESTA AZUL",
      "BACOYA",
      "SAN MARCOS",
      "EL PABELLON",
      "LA LOMA",
      "CASAS VIEJAS",
      "EL TRAMPEADERO",
      "EL POTRERITO",
      "POZO EL CHAÑAR",
      "LAS JUNTAS",
      "LAS HORQUETAS",
      "POZO EL ANTA",
      "EL NARANJO",
      "LA BREA",
      "TRES DE MAYO",
      "LA TRAMPA",
      "CAPITAN JUAN PAGE",
      "LA RINCONADA",
      "EL MADREJON",
      "SAN ANTONIO",
      "EL ROSARIO",
      "ALTO VERDE",
      "SAN ROQUE",
      "FORTIN BELGRANO",
      "EL PERTIGO",
      "EL CHORRO",
      "EL PUESTO",
      "SAN NICOLAS",
      "LOS BLANCOS",
      "LA PROVIDENCIA",
      "PLUMA DE PATO",
      "BALBUENA",
      "EL QUEBRACHO",
      "EL CARPINTERO",
      "EL ESPINILLO",
      "EL YACON",
      "EL SAUZAL",
      "EL TRASLADO",
      "LAS MARAVILLAS",
      "LA VICTORIA",
      "LOS BALDES",
      "POZO DE ALGARROBO",
      "PALMAR",
      "EL GANSO",
      "BUENA VISTA",
      "EL CAMPAMENTO",
      "LA IGUANA",
      "LA JUNTA",
      "BELLA VISTA",
      "SAN PATRICIO",
      "CORONEL JUAN SOLA",
      "EL PUESTITO",
      "MONTE RICO",
      "LA BOLSA",
      "LAS DELICIAS",
      "LA PALMITA",
      "EL CARANCHO",
      "POZO DEL SAUCE",
      "EL SALADO",
      "LA ELENITA",
      "EL CIENEGO",
      "EL SUNCHAL",
      "LOS NOGALES",
      "LA INVERNADA",
      "EL QUIRQUINCHO",
      "LAS HORQUETASAS",
      "SAN AGUSTIN",
      "LA ENTRADA",
      "EL BOTIN",
      "EL GRITAO",
      "EL PERGAMINO",
      "EL ESCONDIDO",
      "FINCA RESISTENCIA",
      "LA MESADA",
      "EL PORONGAL",
      "FORTALEZA",
      "EL QUEJON",
      "FINCA LA ARGENTINA",
      "LA ENSENADA",
      "EL PARAISO",
      "CAMPO ARGENTINO",
      "POZO EL MULATO",
      "EL AZUL",
      "DOS YUCHANES",
      "PUESTO EL PANCHO",
      "EL RONDADERO",
      "EL COLETO",
      "EL TALAR",
      "LA MORA (FINCA)",
      "MONTEVIDEO",
      "PALO SANTO",
      "EL CORTADERAL",
      "SAN MARTIN",
      "CAMPO ALEGRE",
      "EL DESEMBOQUE",
      "EL TARTAGAL",
      "LA SALVACION",
      "LA ESPERANZA",
      "EL CHIVIL",
      "LOS RANCHITOS",
      "LOS NOQUES",
      "EL SAUCE",
      "EL CEIBAL",
      "EL BORDO",
      "EL PRADO",
      "OVEJERIA",
      "EL GALPON",
      "PRINGLES",
      "LAGUNITA",
      "SANTA ANA",
      "EL ALTAMISQUI",
      "CUCHI POZO",
      "EL VALLECITO",
      "AGUA BLANCA",
      "SAN JOSE DE ORQUERA",
      "POTRERO",
      "EL MOJON",
      "EL GUAYACAN",
      "LOS ROSALES",
      "BAJO GRANDE",
      "LAS VERTIENTES",
      "SALADILLO",
      "EL SAUZAL",
      "ALTO DEL MISTOL",
      "EL BORDO",
      "QUEBRACHO HERRADO",
      "EL PACARA",
      "POBLACION DE ORTEGA",
      "EL PORVENIR",
      "EL TUNAL",
      "CORRAL QUEMADO",
      "PASO DE LAS CARRERAS",
      "LA POBLACION",
      "CAMPO LARGO",
      "EL PAJEAL",
      "PIQUIRENDA",
      "CAPIAZUTI",
      "MACUETA",
      "DIQUE ITIYURO",
      "LA REPRESA",
      "TOBANTIRENDA",
      "SAN FRANCISCO",
      "AGUARAY",
      "TIMBOIRENDA",
      "EL CHILCAR",
      "ACAMBUCO",
      "BOCA DEL TIGRE",
      "SANTA CLARA",
      "MACAPILLO",
      "SAN FRANCISCO",
      "EL VENCIDO",
      "LAGUNITA",
      "LA JORNADA",
      "LAS PIEDRAS",
      "EL QUEBRACHAL",
      "ANTA POZO",
      "SAN MARCOS",
      "TOLLOCHE",
      "EL MOSQUITO",
      "LA LAGUNA",
      "ALTO ALEGRE",
      "SAN RAFAEL",
      "SAN JUAN",
      "EL QUIRQUINCHO",
      "LA BOMBA",
      "SAN TADEO",
      "FLOR DE MAYO",
      "EL PORVENIR",
      "LOS JARDINES",
      "MANGRULLO",
      "SANTA ROSA",
      "EL SIMBOL",
      "NUESTRA SEÑORA DE TALAVERA",
      "MACAPILLO VIEJO",
      "SANTA ELENA",
      "SAN ISIDRO",
      "EL GEOLOGO",
      "EL NORTE",
      "GAONA",
      "ALGARROBAL",
      "EL SALADILLO",
      "CERRO NEGRO",
      "HORNADILLAS",
      "COBRES",
      "CANGREJILLOS",
      "LA POMA",
      "EL RODEO",
      "PISCUNO",
      "CHURCAL",
      "POZO BRAVO",
      "PUEBLO VIEJO",
      "ESQUINA COLORADA",
      "EL CAJON",
      "ESQUINA DE GUARDIA",
      "ESQUINA AZUL",
      "EL TRIGAL",
      "AGUA DE CASTILLA",
      "SALAR DE POCITOS",
      "ACAZOQUE",
      "CHORRILLOS",
      "EL RINCON",
      "TOLAR CHICO",
      "TORON",
      "SAN ANTONIO DE LOS COBRES",
      "OLACAPATO",
      "CARACHI",
      "CORRALITOS",
      "CONDOR HUASI",
      "SANTA ROSA DE LOS PASTOS GRANDES",
      "EL DESIERTO",
      "EL SAUZAL",
      "TONONO",
      "BARRIO EL MILAGRO",
      "MISION CHERENTA",
      "YACUY",
      "YARIGUARENDA",
      "SAN RAMON",
      "TARTAGAL",
      "TRES POZOS",
      "PACARA",
      "MISION KILOMETRO 6",
      "BOBADAL",
      "EL ESCONDIDO",
      "MISION EL CRUCE",
      "ZANJA HONDA",
      "PALO BLANCO",
      "TRANQUITAS",
      "EL RUMICAL",
      "LA MERCED",
      "SUMALAO",
      "VILLA SARMIENTO",
      "LAS TIENDITAS",
      "LAS PIRCAS",
      "SAN AGUSTIN",
      "SAN MIGUEL",
      "EL HUAICO",
      "YERBA BUENA",
      "TUYUNTI",
      "SAUZAL",
      "PROFESOR SALVADOR MAZZA",
      "EL CHORRO",
      "EL OCULTO",
      "PLAYA ANCHA",
      "EL ALGARROBAL",
      "CAMPO DURAN",
      "LOS YACONES",
      "VAQUEROS",
      "LESSER",
      "SECLANTAS",
      "SECLANTAS ADENTRO",
      "ISLA DE CAÑAS",
      "ANIMANA",
      "CORRALITO",
      "SAN ANTONIO",
      "EL BARRIAL",
      "SAN SIMON",
      "EL CARRIL",
      "EL PEDREGAL",
      "LAS GARZAS",
      "LAS BARRANCAS",
      "CALVIMONTE",
      "VAQUERIA",
      "SANTA BARBARA",
      "SAUCE REDONDO",
      "LOS SAUCES",
      "CARAHUASI",
      "ACOSTA",
      "SANTA CLARA",
      "EL SAPO",
      "LAS JUNTAS",
      "GUACHIPAS",
      "COROPAMPA",
      "LA BODEGUITA",
      "EL GALPON",
      "LA FLORIDA",
      "ALEMANIA",
      "PAMPA GRANDE",
      "LOS CASTILLOS",
      "LA COSTA",
      "CINCO DURAZNOS",
      "SANTA ROSA",
      "PUNTA DEL AGUA",
      "METAN VIEJO",
      "EL PASTIADERO",
      "LAS JUNTAS",
      "LOS LAPACHOS",
      "SANTA MARIA",
      "LA AGUADITA",
      "VERA CRUZ",
      "EL GUANACO",
      "NOGALITO",
      "SACHA PERA",
      "SAN JOSE DE METAN",
      "LAS CONCHAS",
      "EL GARABATAL",
      "EL FUERTE",
      "EL REY",
      "PASO DE LA CRUZ",
      "RIO DEL VALLE",
      "LOS NOGALES",
      "LAS VIBORAS",
      "LAS LAJITAS",
      "PANTANILLO",
      "SAN GABRIEL",
      "EL PIQUETE",
      "REINA DEL VALLE",
      "LOS NOQUES",
      "PALERMO",
      "EL GRAMILLAL",
      "CABEZA DE ANTA",
      "MIRAFLORES",
      "ALTO BELLO",
      "FINCA EL MOLLAR",
      "EL LIBANO",
      "EL MOLINO",
      "LA FLORIDA",
      "SALADILLO DE JUAREZ",
      "RIO SECO",
      "ESTANCIA VIEJA DEL REY",
      "OVEJERIA",
      "EL CEIBALITO",
      "SALTA",
      "LA QUESERA",
      "LA HIGUERA",
      "CC LA ALMUDENA",
      "LA TROJA",
      "LA UNION",
      "SAN FRANCISCO",
      "CHAMICAL",
      "CC EL TIPAL",
      "COMPUEL",
      "COCHIYACO",
      "LA PUERTA",
      "BANDA GRANDE",
      "COLOME",
      "CUCHIYACO",
      "MOLINOS",
      "LURACATAO",
      "ALUMBRE",
      "AGUADITA",
      "TACUIL",
      "AMAICHA",
      "EL CHURCAL",
      "SAN LUCAS",
      "SANTA CRUZ",
      "EL LINDERO",
      "LA LAGUNA",
      "EL PESCADERO",
      "SANTA TERESA",
      "LOS NARANJOS",
      "RIVADAVIA",
      "EL TOBA",
      "EL OCULTAR",
      "EL CERCADO",
      "LOS TRES POZOS",
      "EL DIVISADERO",
      "LAS BARRANCAS",
      "PUESTO VIEJO",
      "SAN ANICETO",
      "EL CIELITO",
      "MISION SAN FELIPE",
      "EL MIRADOR",
      "LA UNION",
      "POZO VERDE",
      "MARTIN GARCIA",
      "AGUAS MUERTAS",
      "POZO DEL ZORRO",
      "LA FORTUNA",
      "VILLA PETRONA",
      "LAS BOLSAS",
      "CIERVO CANSADO",
      "EL DESTIERRO",
      "SAN GABRIEL",
      "SAN JOSE",
      "LAS FLORES",
      "EL TIMON",
      "EL MILAGRO",
      "PALMARCITO",
      "EL LECHERON",
      "EL BREAL",
      "TERNERA ATADA",
      "EL YACARE",
      "EL VINALAR",
      "LA SIBERIA",
      "MIRAFLORES",
      "SAN FERMIN",
      "EL AZOTADO",
      "LAS LLAVES",
      "LA TOMA",
      "PELICANO QUEMADO",
      "LA REPRESA",
      "EL COCAL",
      "POZO LARGO",
      "LAS TORTUGAS",
      "EL TOTORAL",
      "LA MEDIA LUNA (FINCA)",
      "TRES POZOS",
      "EL VALLE",
      "BUEN LUGAR",
      "SAN MANUEL",
      "MONTE ALTO",
      "FINCA SANTA ROSA",
      "EL RETIRO",
      "LA SOTA",
      "EL PORVENIR",
      "LA CARNEADA",
      "SANTA ROSA",
      "TRES HORCONES",
      "SAN LUIS",
      "ALMONA",
      "EL CHURCALITO",
      "CANTEROS",
      "SIMBOL YACO",
      "LAS MERCEDES",
      "LA COSTOSA",
      "LA FIRMEZA",
      "EL CHURQUI",
      "ARAGON",
      "LAS CATITAS",
      "LOS CORRALES",
      "LA ALMONA",
      "UNQUILLO",
      "LA SOLEDAD",
      "EL CADILLAL",
      "LOS NOGALES",
      "EL RECREO",
      "LAS LAJAS",
      "SANTA MARIA",
      "ALMIRANTE BROWN",
      "SANTA CRUZ",
      "ANTILLA",
      "PUENTE DE PLATA",
      "COPO QUILE",
      "SANTA ROSA",
      "SAN PEDRO",
      "BELLA VISTA",
      "EL BORDO",
      "EL POTRERO",
      "LA BAJADA",
      "SAN LORENZO",
      "LAS CORTADERAS",
      "POZO BRAVO",
      "TONCO",
      "PIUL",
      "BUENA VISTA",
      "SAN GERONIMO",
      "PAYOGASTA",
      "POTRERO DE PAYOGASTA",
      "CASTELLANOS",
      "LAS COSTAS",
      "LA CIENAGA",
      "VILLA SAN LORENZO",
      "ATOCHA",
      "BARRIO SAN RAFAEL",
      "VALLECITO",
      "LA ARCADIA",
      "SANTA ROSA",
      "PUCARA",
      "LA ANGOSTURA",
      "LA ISLA",
      "EL ARREMO",
      "ANGASTACO",
      "RIO GRANDE",
      "LOS CARDONES",
      "EL CARMEN",
      "LOS SAUCES",
      "CANDADO",
      "COLONIA G",
      "LOS NARANJOS",
      "FINCA EL CEDRAL",
      "SANTA MARIA",
      "TABLADA",
      "ABRA GRANDE",
      "RIO PESCADO",
      "SAN AGUSTIN",
      "PARANI",
      "SAN RAMON DE LA NUEVA ORAN",
      "SAN ANDRES",
      "ANTA MUERTA",
      "SANTA CRUZ",
      "BARRIO EL CONGRESO",
      "BARRIO LOS OLMOS",
      "LA CANDELARIA (FINCA)",
      "CERRILLOS",
      "FINCA LA BLANCA",
      "BARRIO LAS TUNAS",
      "VILLA LOS ALAMOS",
      "BARRIO LOS PINARES",
      "LAS PALMAS (FINCA)",
      "LOS PINOS",
      "LA ISLA",
      "LA FALDA",
      "RODEO COLORADO",
      "PORONGAL",
      "IRUYA",
      "SAN JUAN",
      "LAS CAPILLAS",
      "MANTACILLAS DEL VALLE DELGADO",
      "TRES MORROS",
      "PALCA",
      "COLANZULI",
      "VIZCARRA",
      "VALLE DELGADO",
      "ABRA DE ARAGUYOC",
      "CORTADERAS",
      "LAS TRANCAS",
      "HUAYRA HUASI",
      "CASA GRANDE",
      "VOLCAN HIGUERAS",
      "CAMPO CABRERA",
      "SALA ESCUYA",
      "PUEBLO VIEJO",
      "SAN ANTONIO",
      "ABRA DEL SAUCE",
      "CHIYAYOC",
      "SAN ISIDRO DE IRUYA",
      "EL ALFARCITO",
      "LA MESADA GRANDE",
      "LOS TOLDOS",
      "ARAZAY",
      "LA MISION",
      "LA BODEGA",
      "OSMA",
      "CABRA CORRAL",
      "CORONEL MOLDES",
      "CHURQUI SOLO",
      "MONTEVIDEO",
      "EL SILENCIO",
      "SAN JOSE",
      "EL PESCADITO",
      "LAS CANTORAS",
      "EL ARENAL",
      "GENERAL BALLIVIAN",
      "LAS CATAS",
      "LAS PALMAS",
      "LA BOLSA",
      "EL RETIRO",
      "LA SALVACION",
      "RIO SECO",
      "EL CAMPAMENTO",
      "EL CASTIGADO",
      "CAMPO LIBRE",
      "EL TRASLADO",
      "LA CURTIEMBRE",
      "LOS DESMONTES",
      "EL BREAL",
      "CAMPO EL TIGRE",
      "EL TENIENTE",
      "CORRALITO",
      "EL PUCARA",
      "VILLA MERCEDES (FINCA)",
      "CERRO NEGRO DE TIRAO",
      "LA MERCED DE ARRIBA",
      "CARABAJAL",
      "ROSARIO DE LERMA",
      "LA MERCED DEL ENCON",
      "EL TIMBO",
      "LA ESTRELLA",
      "LA ESQUINA",
      "POZO LA ESQUINA",
      "POZO AZUL",
      "EL MISTOL",
      "EL CARMEN",
      "BELLA VISTA",
      "POZO CERCADO",
      "TRES POZOS",
      "BUENA VISTA",
      "EL QUEBRACHAL",
      "LA PAJA",
      "MARTINEZ DEL TINEO",
      "PICHANAL",
      "BORDO LA ESQUINA",
      "LOS POCITOS",
      "EL TOTORAL",
      "GUAYACAN",
      "CAMPO LARGO",
      "MORTERITO",
      "PALO SANTO",
      "JERONIMO MATORRAS",
      "MANUEL ELORDI",
      "PUESTO DEL MEDIO",
      "LA PROVIDENCIA",
      "ABRA NAVARRO",
      "CHUCULAQUI",
      "VEGA DE ARIZARO",
      "QUEBRADA DEL AGUA",
      "SOCOMPA",
      "TACA TACA",
      "TOLAR GRANDE",
      "CAIPE",
      "SAUCELITO",
      "COLONIA SANTA ROSA",
      "LA MISION",
      "SANTA ROSA DE TASTIL",
      "TACUARA",
      "CAMPO QUIJANO",
      "INCAHUASI",
      "EL PALOMAR",
      "AGUA CHICA",
      "ESTANCIA EL GOLGOTA",
      "INGENIERO MAURY",
      "EL TORO",
      "VILLA ANGELICA",
      "EL POTRERO",
      "EL ALISAL",
      "CHORRILLOS",
      "LA SILLETA",
      "CARRERA MUERTA",
      "LAS CUEVAS",
      "MOROHUASI",
      "EL MOLLAR",
      "PASCHA",
      "SAN BERNARDO DE LAS ZORRAS",
      "LA HOYADA",
      "EL MANZANO",
      "EL ENCON",
      "TRES CRUCES",
      "EL ROSAL",
      "COLONIA NEUROPSIQUIATICA",
      "VALLECITO",
      "CACHI ADENTRO",
      "LAS CUEVAS",
      "PALERMO OESTE",
      "LAS TRANCAS",
      "RUMIHUASI",
      "LAS PAILAS",
      "EL BARRIAL",
      "SAN JOSE DE ESCALCHI",
      "ESCALCHI",
      "EL VALLECITO",
      "PIEDRA DEL MOLINO",
      "COLTE",
      "LAS ARCAS",
      "CACHIPAMPA",
      "PUCARA",
      "RANCAGUA",
      "ESCALCHI ADENTRO",
      "LA PAYA",
      "CACHI",
      "EL TABACAL",
      "HIPOLITO YRIGOYEN",
      "SANTA RITA",
      "LOS NOGALES",
      "LA CUEVA",
      "EL ALGARROBAL",
      "LOS CORRALES",
      "LAS HORQUETAS",
      "EL ZAPALLAR",
      "EL SALADILLO",
      "YAQUIASME",
      "OJO DE AGUA",
      "MADRE VIEJA",
      "AGUA BLANCA",
      "LA TRAMPA (FINCA)",
      "PALOMITAS",
      "GENERAL GUEMES",
      "PUESTO VIEJO",
      "ROSARIO DE LA FRONTERA",
      "LAS DELICIAS",
      "LA BEBIDA",
      "LOS SAUCES",
      "EL PORTEZUELO",
      "LA HOYADA",
      "LA CIENAGA",
      "LOS COLORADOS",
      "SANTA ISABEL",
      "BALBOA",
      "CANTA RANA",
      "LA CARRERA",
      "SAN ISIDRO",
      "BAJADA GRANDE",
      "EL PORVENIR",
      "EL PALOMAR",
      "OJO DE AGUA",
      "LAS MOJARRAS",
      "EL CAJON",
      "LA FEDERACION",
      "SAN FELIPE",
      "LA LAGUNA",
      "LOS CHURQUIS",
      "EL CEIBAL",
      "LA BANDA",
      "ARENAL VIEJO",
      "EL ALGORROBAL",
      "CABAS",
      "LAS MESILLAS",
      "CAMARA",
      "HORCONES",
      "EL NARANJO",
      "POZO VERDE",
      "LA CANDELARIA",
      "SAN ANTONIO",
      "SAN PEDRO DE ARANDA",
      "CEIBAL",
      "MISION TIERRAS FISCALES",
      "LA GRANADA",
      "SANTA FE",
      "TABACO CIMARRON",
      "LA MINA",
      "SENDA HACHADA",
      "LA QUENA",
      "PADRE LOZANO",
      "SAN MARTIN",
      "LA FORTUNA",
      "EL QUEMADO",
      "EL SURI",
      "MONTE CARMELO",
      "VILLA NUEVA",
      "MONTE SECO",
      "SAN ESTEBAN",
      "TUCUMANCITO",
      "POZO BRAVO",
      "LA ISLA",
      "POMPEYA",
      "MISION CHAQUEÑA",
      "CAMPICHUELO",
      "LUNA MUERTA",
      "EL ESPINILLO",
      "LA SOLEDAD",
      "DRAGONES",
      "EL MELONAR",
      "EL CARMEN",
      "PALO SANTO",
      "AGUA BLANCA",
      "LA FLORIDA",
      "LAS YANAS",
      "LA EMBOSCADA",
      "LAS PAVAS",
      "TARTAGALITO",
      "POZO DEL MACHO",
      "ROSARIO",
      "EMBARCACION",
      "SANTILLAN",
      "CARBONCITO",
      "EL TAJAMAR",
      "AGUA LINDA",
      "EL CHIVIL",
      "MEDIA LUNA",
      "HICKMAN",
      "EL SAUCE",
      "LAS CORTADERAS",
      "OVEJERIA",
      "AMBLAYO",
      "PALO PINTADO",
      "SAN LUCAS",
      "RUMIARCO",
      "PAYOGASTILLA",
      "RIO SALADO",
      "SAN FELIPE",
      "SAN RAFAEL",
      "LAS BARRANCAS",
      "SAN CARLOS",
      "SALADILLO",
      "ISONZA",
      "LAS TRAMPAS",
      "LOS RASTROJITOS",
      "TALAPAMPA",
      "LAS CURTIEMBRES",
      "LA VIÑA",
      "LAS LECHUZAS",
      "EL CHURQUI",
      "AMPASCACHI",
      "EL INFIERNILLO",
      "ENTRE RIOS",
      "ALEMANIA",
      "LAS TACANAS",
      "LA ENCRUCIJADA",
      "FINCA SAN NICOLAS",
      "LAS ABRITAS",
      "LA RAMADA",
      "CABEZA DE BUEY",
      "COBOS",
      "BETANIA",
      "CAMPO SANTO",
      "CORONEL MOLLINEDO",
      "EL CARMEN",
      "EL DORADO",
      "LAS FLACAS",
      "SAN LUIS",
      "SAN CAYETANO",
      "APOLINARIO SARAVIA",
      "LA QUINTA",
      "LA PELADA",
      "SAN VICENTE",
      "LA JUNTA",
      "SANTA LUCIA",
      "PALO BLANCO",
      "AGUA SUCIA",
      "EL BORDO (FINCA)",
      "AGUA VERDE",
      "LA CURVITA",
      "POZO EL BRAVO",
      "MAGDALENA",
      "LAS MOJARRAS",
      "POZO BRAVO",
      "SAN M. DE LA CEIBA",
      "MISION SAN LUIS",
      "POZO DEL TORO",
      "AMBERES",
      "LA ESTRELLA",
      "EL PELICANO",
      "EL ROSADO",
      "POZO EL TORO",
      "LA MERCED",
      "EL PALMAR",
      "LA GRACIA",
      "LAS VERTIENES",
      "HITO 1",
      "MONTE CARMELO",
      "ALTO DE LA SIERRA",
      "SANTA ELENA",
      "CAMPO LARGO",
      "SAN MIGUEL",
      "SANTA MARIA",
      "LA PUNTANA",
      "SAN BERNARDO",
      "LA CHINA",
      "POZO EL TIGRE",
      "EL SAUCE",
      "SANTA VICTORIA ESTE",
      "BAJO GRANDE",
      "MISION LA PAZ",
      "LA PAZ",
      "URUNDEL"
    ]
  },
  {
    "nombre": "San Juan",
    "localidades": [
      "VILLA TACU",
      "VILLA BASILIO NIEVAS",
      "LOS PARAMILLOS",
      "ZONDA ARRIBA",
      "PACHACO",
      "DIQUE PACHIMOCO",
      "LA FRONTERA",
      "NIQUIVIL",
      "HUACO",
      "GUALCAMAYO",
      "OTRA BANDA",
      "LA FALDA",
      "CRUZ DE PIEDRA",
      "LA CIENAGA",
      "EL FISCAL",
      "NIQUIVIL VIEJO",
      "INDIO MUERTO",
      "SAN ISIDRO",
      "PANACAN",
      "BELLA VISTA",
      "LA TOMA",
      "EL MEDANO",
      "EL VOLCAN",
      "TAMBERIAS",
      "MOGNA",
      "VILLA MERCEDES",
      "PAMPA VIEJA",
      "SAN JOSE DE JACHAL",
      "LOS PUESTOS",
      "LAS AGUADITAS",
      "BOCA DE LA QUEBRADA",
      "VILLA MALVINAS ARGENTINAS",
      "GRAN CHINA",
      "LAS PIEDRITAS",
      "VILLA BARBOZA",
      "ESTACION SANCHEZ DE LORIA",
      "COLONIA CANTONI",
      "SEGUNDO CUARTEL",
      "BARRIO RUTA 40",
      "VILLA AEROPUERTO",
      "EL ABANICO",
      "QUINTO CUARTEL",
      "VILLA CABECERA",
      "CAMPO DE BATALLA",
      "VILLA ABERASTAIN",
      "BARRIO MUNICIPAL",
      "CARPINTERIA",
      "VILLA NACUSI",
      "LA CALLECITA",
      "VILLA CENTENARIO",
      "LA RINCONADA",
      "LAS CHACRAS MARAYES",
      "POZO DE LOS ALGARROBOS",
      "LAS LIEBRES",
      "BARRIO JUSTO P. CASTRO IV",
      "VILLA INDEPENDENCIA",
      "MARAYES",
      "DIVISORIA",
      "EL RINCON",
      "LAS TALAS",
      "LOS MEDANOS",
      "LA PUNTILLA",
      "LAGUNA SECA",
      "PIE DE PALO",
      "LAS CHACRAS",
      "BERMEJO",
      "VALLECITO",
      "CAUCETE",
      "TIRA LARGA",
      "BARREAL",
      "LA ALUMBRERA",
      "PUCHUZUN",
      "VILLA NUEVA",
      "LA ISLA",
      "COLON",
      "ALCAPARROSA",
      "SOROCAYENSE",
      "TAMBERIAS",
      "VILLA CORRAL",
      "VILLA PITUIL",
      "HILARIO",
      "BELLA VISTA",
      "CALINGASTA",
      "EL LEONCITO",
      "VILLA IBAÑEZ",
      "DIQUE ULLUM",
      "EL CHILOTE",
      "SAN JUAN",
      "LAS CHACRITAS",
      "LA MAJADITA",
      "RINCON CERCADO",
      "COLONIA FIORITO",
      "9 DE JULIO",
      "BAUCHACETA",
      "ZONDA",
      "MONDACA",
      "ACHANGO",
      "IGLESIA",
      "TUDCUM",
      "RODEO",
      "GUARDIA VIEJA",
      "MALIMAN DE ARRIBA",
      "EL RETIRO",
      "MALIMAN DE ABAJO",
      "PISMANTA",
      "BELLA VISTA",
      "FIERRO NUEVO",
      "LAS FLORES",
      "FIERRO VIEJO",
      "ANGUALASTO",
      "TOCOTA",
      "VILLA EL TANGO",
      "EL ENCON",
      "VILLA BORJAS",
      "VILLA SANTA ROSA",
      "LA TRANCA",
      "CUATRO ESQUINAS",
      "TUPELI",
      "LAS CASUARINAS",
      "DIVISORIA",
      "ESTACION PUNTA DEL AGUA",
      "ESTACION ALGARROBO VERDE",
      "POZO DEL SALADO",
      "LA CHIMBERA",
      "VILLA SEFAIR (TALACASTO)",
      "EL ALAMITO",
      "LAS TAPIAS",
      "PUNTA DEL MONTE",
      "VILLA EL SALVADOR",
      "EL BOSQUE",
      "SANTO DOMINGO",
      "BALDES DE LA CHILCA",
      "LA HUERTA",
      "SAN ANTONIO",
      "CHUCUMA",
      "COLONIA LOS VALECIANOS",
      "LA MAJADITA",
      "RINCON CHICO",
      "VILLA SAN AGUSTIN",
      "LOS BALDECITOS",
      "SIERRA DE ELIZONDO",
      "ASTICA",
      "BALDES DEL NORTE",
      "LAS JUNTAS",
      "LOS BRETES",
      "AGUA CERCADA",
      "USNO",
      "BALDE DEL ROSARIO",
      "LOS BERROS",
      "COLONIA SAN ANTONIO",
      "ESTACION COCHAGUAL",
      "LAS LAGUNAS",
      "GUANACACHE",
      "VILLA MEDIA AGUA",
      "CAÑADA HONDA",
      "PEDERNAL",
      "CIENAGUITA",
      "COLONIA FISCAL",
      "SAN CARLOS",
      "DIVISADERO",
      "PUNTA DEL MEDANO",
      "TRES ESQUINAS",
      "MARQUESADO",
      "BARRIO CAMUS",
      "JARDIN DE LOS POETAS",
      "RIVADAVIA",
      "VILLA NUEVA ARGENTINA",
      "BARRIO FORTABAT",
      "LAS PIEDRITAS",
      "SANTA LUCIA",
      "BARRIO BERMEJITO",
      "LA LEGUA",
      "COLONIA RICHET ZAPATA",
      "ALTO DE SIERRA",
      "COLONIA GUTIERREZ",
      "OBISPO ZAPATA",
      "LAS PIEDRITAS",
      "EL TOPON",
      "LAS TAPIAS",
      "FINCA EL SALADO",
      "CAMPO AFUERA",
      "EL RINCON",
      "LA CAÑADA",
      "VILLA AMPACAMA",
      "EL SALADO",
      "VILLA GENERAL SAN MARTIN",
      "TIERRA ADENTRO",
      "EL MOGOTE",
      "VILLA OBSERVATORIO",
      "VILLA PAULA ALBARRACIN",
      "VILLA UNION",
      "VILLA SARMIENTO",
      "CHIMBAS",
      "BARRIO PARQUE IDUSTRIAL",
      "VILLA OBRERA",
      "BARRIO PARQUE INDEPENDENCIA",
      "COLONIA RODAS",
      "VILLA BOLAÑOS",
      "LOS CORREDORES",
      "COLONIA RODAS",
      "COLONIA MEDANO DE ORO",
      "EL MEDANITO",
      "VILLA KRAUSE",
      "RAWSON",
      "VILLA SAN DAMIAN",
      "COLONIA PAN DE AZUCAR",
      "LA PUNTILLA",
      "VILLA SAN MARTIN",
      "VILLA DOMINGUITO",
      "BARRIO SADOP",
      "VILLA DON BOSCO",
      "LOS COMPARTOS",
      "SAN ISIDRO",
      "DOS ACEQUIAS",
      "VILLA EL SALVADOR",
      "BOCA DEL TIGRE"
    ]
  },
  {
    "nombre": "San Luis",
    "localidades": [
      "VILLA MERCEDES",
      "LA RIVERA",
      "DIQUE VULPIANI",
      "LA RIBERA",
      "LA CIENAGA",
      "LAS AGUADAS",
      "TALA VERDE",
      "EL PUESTO",
      "LOS MOLLES",
      "LA TOMA",
      "LOS CAJONES",
      "LAS BARRANCAS",
      "LAS ISLITAS",
      "SANTA ANA",
      "BALDE DE ESCUDERO",
      "LAS PALOMAS",
      "LAS BARRANQUITAS",
      "ESTANCIA GRANDE",
      "ESTANCIA GRANDE",
      "EL DURAZNO",
      "EL ZAPALLAR",
      "LA BREA",
      "LA AGUADA",
      "QUINES",
      "BALCARCE",
      "CORTADERAS",
      "RIOCITO",
      "BALDE DE LA ISLA",
      "PASO DEL REY",
      "PAMPA DEL TAMBOREO",
      "RIO GRANDE",
      "LAS PIRCAS",
      "EL TRAPICHE",
      "LAS LAGUNAS",
      "CAROLINA",
      "LAS ROSAS",
      "MINA LOS CONDORES",
      "SAN ANTONIO",
      "VILLA LARCA",
      "GORGONTA",
      "SANTA CECILIA",
      "EL CALDEN",
      "MOSMOTA",
      "EL MILAGRO",
      "LAS PIEDRITAS",
      "EL MATACO",
      "LAS VIZCACHERAS",
      "SUYUQUE NUEVO",
      "CHARLONE",
      "DONADO",
      "EL CHARABON",
      "LA IRENE",
      "LA FORTUNA",
      "EL MOLLE",
      "JUAN W. GEZ",
      "EL PORTEZUELO",
      "EL RECUERDO",
      "LOS PUQUIOS",
      "CHOSMES",
      "SANTA ROSA",
      "VARELA",
      "LAS GAMAS",
      "DANIEL DONOVAN",
      "PUNTA DEL CERRO",
      "LOS CERRILLOS",
      "PASO DE LAS VACAS",
      "PESCADORES",
      "LAS BARRANCAS",
      "SAN MARTIN DEL ALTO NEGRO",
      "NACION RANQUEL",
      "CAZADOR VIEJO",
      "CAZADOR",
      "ZANJITAS",
      "LA COSTA",
      "JUAN JORBA",
      "BAGUAL",
      "COLONIA URDANIZ",
      "MARTIN DE LOYOLA",
      "COLONIA CALZADA",
      "LA ESTRELLA",
      "EL RODEO",
      "FRISIA",
      "EL AGUILA",
      "LOS OVEROS",
      "NAHUEL MAPA",
      "LA MAROMA",
      "NUEVA CONSTITUCION",
      "LA VERDE",
      "SAN GREGORIO",
      "SALADILLO",
      "EL VOLCAN",
      "LOS ALGARROBOS BLANCOS",
      "SAN LUIS",
      "BOCA DEL TIGRE",
      "TINTITACO",
      "LEANDRO N ALEM",
      "LA MAJADA",
      "POZO DE LOS RAYOS",
      "LA PUNILLA",
      "FORTIN EL PATRIA",
      "NAVIA",
      "VILLA DE PRAGA",
      "EL PARAISO",
      "LA PUERTA",
      "SAN PABLO",
      "LA FLORIDA",
      "LA PRIMAVERA",
      "LOS QUEMADOS",
      "EL RINCON",
      "BALDE VIEJO",
      "EL ZAMPAL",
      "SANTO DOMINGO",
      "SAN MIGUEL",
      "EL BALDECITO",
      "SAN ROQUE",
      "RODEO DE CADENAS",
      "LA AVENENCIA",
      "LA SALVADORA",
      "BALDE DE QUINES",
      "LOMAS BLANCAS",
      "PAMPA GRANDE",
      "EL INJERTO",
      "LOS POZOS",
      "LA TRANCA",
      "EL ALGARROBAL",
      "LA REPRESITA",
      "LAS CHIMBAS",
      "SAN IGNACIO",
      "BALDE RETAMO",
      "MONTE CARMELO",
      "BALDE DE LOS TORRES",
      "SANTA ANA",
      "LAS CLARITAS",
      "BALDE DE AZCURRA",
      "BALDECITO DE LA PAMPA",
      "BALDE DEL CARMEN",
      "LA PLATA",
      "LA BOTIJA",
      "SANTA TERESA",
      "EL BARRIAL",
      "LAS TOSQUITAS",
      "EL VINAGRILLO",
      "LAS LAGUNITAS",
      "SANTA ROSA DE CATANTAL",
      "BELLA VISTA",
      "BALDE ULTIMO",
      "TALITA",
      "EL CALDEN",
      "LA FLORIDA",
      "SANTA ROSA DEL CONLARA",
      "EL DURAZNITO",
      "UNION",
      "LOMITAS",
      "LA LOMITA",
      "LAFINUR",
      "TILISARAO",
      "LA VERTIENTE",
      "9 DE JULIO",
      "EL RINCON",
      "CANDELARIA",
      "LA MODERNA",
      "SANTA MARIA",
      "ALTO PENCOSO",
      "NOGOLI",
      "NASCHEL",
      "BUENA ESPERANZA",
      "FORTUNA",
      "LAS CHACRAS",
      "EL CERRITO",
      "EL ESTANQUITO",
      "LA QUINTA",
      "CARPINTERIA",
      "ARIZONA",
      "LOS MOLLES",
      "PASO GRANDE",
      "SAN MIGUEL",
      "VILLA DEL CARMEN",
      "SAN MARTIN",
      "JUSTO DARACT",
      "VILLA SALLES",
      "PEDERNERA",
      "LIBORIO LUNA",
      "CORONEL ALZOGARAY",
      "LAS MESTIZAS",
      "LAS ISLETAS",
      "SOVEN",
      "CHALANTA",
      "COLONIA DON ANTONIO",
      "VILLA REYNOLDS",
      "LA AGUADA",
      "LA ANGELINA",
      "RIO QUINTO",
      "5TA BRIGADA",
      "EL GUANACO",
      "LA ESQUINA",
      "LA ROSADA",
      "NUEVA ESCOCIA",
      "COUNTRY CLUB LOS CALDENES",
      "CRAMER",
      "CALDENADAS",
      "VILLA DE LA QUEBRADA",
      "LAVAISSE",
      "CARPINTERIA",
      "SAN FRANCISCO DEL MONTE DE ORO",
      "LAS CHACRAS",
      "POZO DEL MOLLE",
      "BEAZLEY",
      "LAS HORQUETAS",
      "RENCA",
      "LAS CHACRAS",
      "EL CHORRILLO",
      "CERRO COLORADO",
      "QUEBRADA DE LOS CONDORES",
      "SAN ROQUE",
      "CRUZ DE PIEDRA",
      "LA SUIZA",
      "POZO CAVADO",
      "EL ALGARROBAL",
      "PUNTA DE LA LOMA",
      "COLONIA ZUBELZU",
      "LOS CONDORES",
      "LA GRAMILLA",
      "SANTA MARTINA",
      "EL TALA",
      "SAN FELIPE",
      "LA CELESTINA",
      "HUEJEDA",
      "ALTO PELADO",
      "NUEVA GALIA",
      "JUAN LLERENA",
      "ANCHORENA",
      "PLANTA DE SANDIA",
      "RINCON DEL CARMEN",
      "GUANACO PAMPA",
      "LA RAMADA",
      "SAN VICENTE",
      "CABEZA DE NOVILLO",
      "OJO DE AGUA",
      "SAN ISIDRO",
      "MANANTIAL",
      "BARRANCA ALTA",
      "PIEDRA BOLA",
      "CONLARA",
      "EL PARAGUAY",
      "LA TOTORA",
      "LA COCHA",
      "CASA DE LOS TIGRES",
      "EL VALLE",
      "POTRERILLO",
      "LOS COMEDEROS",
      "LA HUERTA",
      "SAN FERNANDO",
      "MESILLA DEL CURA",
      "PUERTA COLORADA",
      "PAPAGAYOS",
      "EL RECUERDO",
      "EL CHURRASCO",
      "CONCARAN",
      "EL SIFON",
      "EL SAUCE",
      "LUJAN",
      "POZO DEL CARRIL",
      "CIUDAD DE LA PUNTA",
      "SAN JERONIMO",
      "MERLO",
      "CERRO DE ORO",
      "LOS ARADITOS",
      "SUYUQUE NUEVO",
      "BUEN ORDEN",
      "HUALTARAN",
      "EL DIVISADERO",
      "LAS LAGUNITAS",
      "LOS RAMBLONES",
      "EL PEDERNAL",
      "EL BARRIAL",
      "EL JARILLAL",
      "SAN GREGORIO",
      "EL RECODO",
      "SAN PEDRO",
      "POZO DEL TALA",
      "REPRESA DEL CARMEN",
      "SANTA ROSA DEL GIGANTE",
      "LOMAS BLANCAS",
      "LA AGUADA",
      "ESTANCIA DE AMIEVA",
      "EL TALA",
      "LOS MOLLES",
      "EL ESPINILLO",
      "SAN ANTONIO",
      "EL MOLLE",
      "POZO CAVADO",
      "EL PARAISO",
      "CABEZA DE VACA",
      "BELLA ESTANCIA",
      "SANTA RITA",
      "EL RAMBLON",
      "NARANJO ESQUINO",
      "TORO NEGRO",
      "ARBOL SOLO",
      "EL MILAGRO",
      "EL RETAMAL",
      "LAS PLAYAS",
      "TALITA",
      "POTRERO DE LOS FUNES",
      "DESAGUADERO",
      "JARILLA",
      "SAN JOSE DEL MORRO",
      "LOS QUEBRACHOS",
      "OJO DEL RIO",
      "CERRITO BLANCO",
      "LOS LOBOS",
      "LA ISLA",
      "LA CHILCA",
      "BAJO DE VELIZ",
      "BATAVIA",
      "FRAGA",
      "SALINAS DEL BEBEDERO",
      "BALDE",
      "LA CALERA",
      "INTIHUASI",
      "LA BAJADA",
      "PASO DE LAS CARRETAS",
      "ELEODORO LOBOS",
      "LOMA ALTA",
      "COMANDANTE GRANVILLE",
      "EL ARENAL",
      "EL BALDECITO",
      "VALLE DE PANCANTA",
      "CERROS LARGOS",
      "LA PETRA",
      "CIENAGA DE INTIHUASI",
      "EL MANANTIAL",
      "MARMOL VERDE",
      "CUATRO ESQUINAS",
      "LA TOTORA",
      "VILLA GENERAL ROCA"
    ]
  },
  {
    "nombre": "Santa Cruz",
    "localidades": [
      "EL CHALTEN",
      "CAÑADON SECO",
      "CALETA OLIVIA",
      "FLORIDA NEGRA",
      "BELLA VISTA",
      "EL SALADO",
      "LAS HERAS",
      "MINA 3",
      "HIPOLITO YRIGOYEN",
      "PUERTO DESEADO",
      "COMANDANTE LUIS PIEDRABUENA",
      "LAS TRES HERMANAS",
      "LOS MONOS",
      "ALMA GAUCHA",
      "TEHUELCHES",
      "TRES CERROS",
      "LA LOBERIA",
      "PAMPA ALTA",
      "BAHIA LAURA",
      "GOBERNADOR MOYANO",
      "MINERALES",
      "PIEDRA CLAVADA",
      "CHARLES FUHR",
      "PUNTA BANDERA",
      "EL CERRITO",
      "LA LEONA",
      "GENDARME BARRETO",
      "RINCON",
      "LAGUNA GRANDE",
      "LA BARRANCOSA",
      "ESTANCIA SAN RAMON",
      "KOLUEL KAIKE",
      "FITZ ROY",
      "JARAMILLO",
      "RIO GALLEGOS",
      "PUERTO SAN JULIAN",
      "ROSPENTEK",
      "GOBERNADOR GREGORES",
      "PICO TRUNCADO",
      "TELLIER",
      "28 DE NOVIEMBRE",
      "BAJO CARACOLES",
      "EL TURBIO",
      "LA PENINSULA",
      "LAGO CARDIEL",
      "EL CALAFATE",
      "TRES LAGOS",
      "BELLA VISTA",
      "PUENTE BLANCO",
      "LAS HORQUETAS",
      "ESTANCIA LAS VEGAS",
      "OCHO HERMANOS",
      "CERRO LEON",
      "GAYPON",
      "LA ESPERANZA",
      "ESTANCIA GLENCROSS",
      "CANCHA CARRERA",
      "LE MARCHAND",
      "ESTANCIA EL CONDOR",
      "PUERTO COIG",
      "YACIMIENTOS RIO TURBIO",
      "PUERTO SANTA CRUZ",
      "LOS ANTIGUOS",
      "JULIA DUFOUR",
      "LA ARAGONESA",
      "LA MANCHURIA",
      "EL PORTEZUELO",
      "PERITO MORENO"
    ]
  },
  {
    "nombre": "Santa Fe",
    "localidades": [
      "ORATORIO MORANTE",
      "GODOY",
      "CAMPO LA VICTORIA",
      "CORREA",
      "BERRETTA",
      "ESTACION BERRETA",
      "COLONIA ITURRASPE",
      "COLONIA LA POSTA",
      "AREQUITO",
      "GENERAL LAGOS",
      "SUARDI",
      "CAMPO COLLA",
      "LAS HIGUERITAS",
      "CORONEL RODRIGUEZ",
      "SANTA CLARA DE BUENA VISTA",
      "LAS AVISPAS",
      "LABORDEBOY",
      "GENERAL GELLY",
      "CAMPO FONDATO",
      "CAMPO GHIANO",
      "CAMPO ULLA",
      "EL TREBOL",
      "CAMPO RIBERI",
      "SANTA TERESA",
      "FRANCISCO PAZ",
      "FORTIN ARENALES",
      "CAMPO BONAZOLA",
      "LAS TAPERITAS",
      "LANTERI",
      "CAMPO SIETE PROVINCIAS",
      "FLOR DE ORO",
      "LA BRITANICA",
      "COLONIA TERESA",
      "CAMPO PIAGGIO",
      "MAUA",
      "LA POTASA",
      "DOS ROSAS Y LA LEGUA",
      "CAMPO HARDY",
      "LOS TABANOS",
      "SANTO DOMINGO",
      "CAMPO LA UNION",
      "LOS CARDOS",
      "SANTA MARIA NORTE",
      "PALACIOS",
      "MONIGOTES",
      "PEDRO GOMEZ CELLO",
      "LA CLARA",
      "COLONIA LA OSCA",
      "LA MORA Y PANTANOSO",
      "RAMONA",
      "ESTANCIA LA MARKONIA",
      "LLAMBI CAMPBELL",
      "AROMOS",
      "MONTES DE OCA",
      "CAMPO LOS TRONCOS",
      "SAN ANTONIO DE OBLIGADO",
      "CONSTANZA",
      "LAS PALMAS",
      "LA ESMERALDA",
      "CAMPO MENDOZA",
      "LAS AMINTAS",
      "LOS LAURELES",
      "OBRAJE SAN JUAN",
      "VILLA GUILLERMINA",
      "RAMAL SAN JUAN",
      "NOGHE",
      "EL SALITRAL",
      "GATO COLORADO",
      "CAMPO EL DORMIDO",
      "FORTIN 6",
      "CAMPO CHIODI",
      "ESTACION KILOMETRO 405",
      "COLONIA LOS TRONCOS",
      "LAS PAREJAS",
      "CAMPO ALBERTENGO",
      "CHABAS",
      "LOS QUEBRACHALES",
      "CAMPO DEROTIER",
      "SANTA MARGARITA",
      "VILLA SAN JOSE",
      "COLONIA INDIGENA",
      "COLONIA CRIOLLA",
      "COLONIA SAN IGNACIO",
      "SAN JAVIER",
      "ISLA LAS PALMAS",
      "COLONIA SAN JOSE",
      "COLONIA CALIFORNIA",
      "LAS CAÑAS",
      "MIGUEL ESCALADA",
      "NARE",
      "ESTACION EL CANTOR",
      "CAFFERATA",
      "BARRIO CICARELLI",
      "COLONIA MEDICI",
      "LARGUIA",
      "CAMPO RASETTO",
      "CAMPO ROVETTO",
      "CAMPO BARBERO",
      "TOTORAS",
      "ESTEBAN RAMS",
      "NUEVA ITALIA",
      "POZO BORRADO",
      "EL PIRINCHO",
      "EL TUNALITO",
      "CAMPO CONTARDE",
      "CAMPO LAS MELLIZAS",
      "CAMPO LOS CLAVELES",
      "LAS LIMPIAS",
      "CAMPO EL 51",
      "MARIA SUSANA",
      "CAMPO BAJO LAS LIEBRES",
      "EL RICARDITO",
      "LA DIAMELA",
      "BERNA",
      "CAMPO FURRER",
      "SALADERO CABAL",
      "SALADERO MARIANO CABAL",
      "EL LAUREL",
      "KILOMETRO 101",
      "MONTE FLORES",
      "ARBILLA",
      "ALVEAR",
      "RINCON DEL QUEBRACHO",
      "VILLA SARALEGUI",
      "PETRONILA",
      "MARIA EUGENIA",
      "LA NEGRA",
      "LA CABAÑA",
      "VERA Y PINTADO",
      "LUIS PALACIOS",
      "SANTO TOME",
      "CAMPO JULLIER",
      "PUEBLO MARINI",
      "TOBA",
      "KILOMETRO 12",
      "GUAYCURU",
      "LOTE 127",
      "LA ZULEMA",
      "KILOMETRO 302",
      "CAMPO DONNET",
      "AVENA",
      "SAN MARTIN DE LAS ESCOBAS",
      "CAMPO EL DANUBIO",
      "CAMPO OITANA",
      "VILLA ELOISA",
      "CAMPO LOMA PARTIDA",
      "SAN RICARDO",
      "FUNES",
      "SAN FRANCISCO DE SANTA FE",
      "DIAZ",
      "GRANADERO BAIGORRIA",
      "EL PRADO",
      "RAMAYON",
      "VILLA MERCEDES",
      "ESTANCIA SAN JUAN",
      "VILLA LASTENIA",
      "SAN JUAN",
      "PUERTO ARAGON",
      "BARRANCAS",
      "GOBERNADOR CRESPO",
      "CAMPO LA GERMANIA",
      "CAMPO CALCATERRA",
      "CLASSON",
      "CAMPO EL ENSAYO",
      "CRISPI",
      "COLONIA LAS YERBAS",
      "CAMPO SEVESO",
      "PROVIDENCIA",
      "PAVON",
      "LUCIO  V. LOPEZ",
      "LUCIO V. LOPEZ",
      "CAMPO MEDINA",
      "EL CARAMELO",
      "ALVAREZ",
      "PEYRANO",
      "SAN CARLOS CENTRO",
      "FELICIA",
      "LA ALICIA",
      "AGUARA GRANDE",
      "TIMBUES",
      "VILLA ELVIRA",
      "GESSLER",
      "COLONIA LOS ROBLES",
      "MURPHY",
      "BARRIO MITRE",
      "EMPALME VILLA CONSTITUCION",
      "EL COLORADO",
      "CARRERAS",
      "ZENON PEREYRA",
      "ESTACION KILOMETRO 501",
      "CAMPO LA MALAGUEÑA",
      "PAVON ARRIBA",
      "CAMPO BERNARDI",
      "LOTE 184",
      "SANTA FELICIA",
      "PUEBLO SANTA LUCIA",
      "KILOMETRO 38",
      "CARAGUATAY",
      "ESPIN",
      "LOTE 21",
      "CAMPO ZAMO",
      "KILOMETRO 71",
      "VERA",
      "EL ÑANDUBAY",
      "PUJATO",
      "CAMPO RISSO",
      "CAMPO LEONHARDT",
      "RECONQUISTA",
      "LA LOLA",
      "PUERTO RECONQUISTA",
      "EMPALME SAN CARLOS",
      "DESVIO KM 407",
      "LA ISLETA",
      "VILLA ADELA",
      "ESTACION KILOMETRO 403",
      "VILLA OCAMPO",
      "CAMPO BELLO NORTE",
      "CAMPO EL PIAVE",
      "CAMPO YACCUZZI",
      "CAMPO BELLO SUR",
      "CAMPO PICCOLI",
      "SAN VICENTE",
      "CAMPO FANTIN",
      "SAN CARLOS NORTE",
      "SAN JERONIMO DEL SAUCE",
      "CAMPO LA VIGILANCIA",
      "CAMPO MARINZALDA",
      "CAMPO GIMBATTI",
      "TORTUGAS",
      "CAMPO CHARO",
      "ARRUFO",
      "SAN RAFAEL",
      "LA VANGUARDIA",
      "CAMPO LA ROSARIO",
      "SAN EUGENIO",
      "COLONIA LAS MARGARITAS",
      "MARGARITA",
      "CAMPO  PAVICICH",
      "CAMPO MOLASSI",
      "CAMPO COLNAGHI",
      "LA NICOLOSA",
      "RIVADAVIA",
      "LAS PALMERAS",
      "FRAY LUIS BELTRAN",
      "BOMBAL",
      "CAMPO CUCO",
      "COLONIA RAQUEL",
      "ITUZAINGO",
      "PIAMONTE",
      "LOS MOLINOS",
      "CAMPO FORESSI",
      "SAN GUILLERMO",
      "CERES",
      "AROCENA",
      "BARRIO EL PACAA - BARRIO COMIPINI",
      "COLONIA BELGRANO",
      "COLONIA EL DICHOSO",
      "COLONIA LA HIEDRA",
      "FORTIN ATAHUALPA",
      "COLONIA EL MATE",
      "VILLA MINETTI",
      "ESTANCIA LOS GUASUNCHOS",
      "CAMPO SAN ISIDORO",
      "EMPALME RUTA 91",
      "COLONIA LA AVANZADA",
      "CAMPO GARAY",
      "PUERTO GENERAL SAN MARTIN",
      "BELLA VISTA",
      "PEREZ",
      "VILLA AMERICA",
      "CANDIOTI",
      "EL 94",
      "CAMPO BERLI",
      "CAMPO HUBER",
      "EL GUSANO",
      "COLONIA DURAN",
      "GOLONDRINA",
      "SASTRE",
      "ESTACION KILOMETRO 465",
      "GALVEZ",
      "CASTELLANO PLAZA",
      "CASTELLANOS",
      "COLONIA LA FRANCIA",
      "CAÑADA ROSQUIN",
      "SAN ANTONIO",
      "TACUARENDI",
      "LA HORTENSIA",
      "CAMPO BALLESTEROS",
      "CAMPO TROFFE",
      "CAMPO CHAPINO",
      "VILLA CAÑAS",
      "LOS QUEBRACHOS",
      "SILVA",
      "SAN MIGUEL",
      "AMENABAR",
      "COLONIA FALUCHO",
      "ESTANCIA EL ABOLENGO",
      "CAMPO CULLAK",
      "EL UNO -LA SARITA",
      "CUATRO BOCAS",
      "COLONIA SAN MANUEL",
      "LA VANGUARDIA",
      "LA SARITA",
      "PARAJE SAN MANUEL",
      "LA SELVA",
      "LA CAROLA",
      "IBARLUCEA",
      "ANGELONI",
      "LUCIANO LEIVA",
      "TACURAL",
      "ALDAO",
      "COLONIA EL EMPALME",
      "VENADO TUERTO",
      "LA ESCONDIDA",
      "SAN MARCOS",
      "SAN JOSE DEL RINCON",
      "MONTEFIORE",
      "LA ELSA",
      "GALISTEO",
      "LAGUNA PAIVA",
      "SUNCHALES",
      "COLONIA LA MANUELITA",
      "CAMPO RISTORTO",
      "EL FORTIN",
      "GRUTLY",
      "ISLA VUELTA DEL PARAGUAYO",
      "SANTA FE",
      "MIGUEL TORRES",
      "HUANQUEROS",
      "BALNEARIO LA VERDE",
      "COLONIA ROSA",
      "CAÑADA RICA",
      "SAN JORGE",
      "CAMPO DURANDO",
      "CAMPO EL INJERTO",
      "ÑANDUCITA",
      "COLONIA CELLO",
      "EUSEBIA Y CAROLINA",
      "SANTA CLARA DE SAGUIER",
      "CAMPO RIVAROSSA",
      "CAÑADA OMBU",
      "HUGENTOBLER",
      "PUJATO NORTE",
      "SAN AGUSTIN",
      "CAMPO PERIOTTI",
      "BAJO LAS TUNAS",
      "LOS TRES REYES",
      "COLONIA DOLORES",
      "GABOTO",
      "BALNEARIO MONJE",
      "LA JOSEFINA",
      "CAMPO MARIA ROSA",
      "TARTAGAL",
      "CAMPO DEAN",
      "EL TAJAMAR",
      "COLONIA LUSSINO",
      "BOUQUET",
      "LA CAROLINA",
      "LOS MUCHACHOS - LA ALBORADA",
      "PIÑERO",
      "LA PELADA",
      "MOUSSY",
      "LA VERTIENTE",
      "COLMENA",
      "EL CARMEN DE AVELLANEDA",
      "SANTA ANA",
      "EL TIMBO",
      "AVELLANEDA",
      "PILAR",
      "CARRIZALES",
      "ESMERALDA",
      "PRESIDENTE ROCA",
      "ESTACION PRESIDENTE ROCA",
      "COLONIA CORONDINA",
      "CORONDA",
      "COLONIAS LAS LONJAS",
      "COLONIA LOS PRADOS",
      "VILLADA",
      "CURUPAYTI",
      "FIDELA",
      "RICARDONE",
      "EUSTOLIA",
      "ARMINDA",
      "CAPIVARA",
      "CAMPO MOSCHEN",
      "CAMPO MAGNAGO",
      "CAMPO RAMSEYER",
      "MALABRIGO",
      "KILOMETRO 742",
      "SANTA MARIA CENTRO",
      "CAMPO SAN PEDRO",
      "JUNCAL",
      "CAMPO SPAGNOLO",
      "ARMSTRONG",
      "GODEKEN",
      "ELORTONDO",
      "SANTA EMILIA",
      "SANTA ANITA",
      "LAS PETACAS",
      "ALEJANDRA",
      "LOS JACINTOS",
      "COLONIA LA MARIA",
      "EL PROGRESO",
      "VILLA SAN ANTONIO",
      "EL CEIBO",
      "LOS CORRALITOS",
      "COLONIA ALEJANDRA",
      "LOS CUERVOS",
      "ESTACION EL GAUCHO",
      "ISLA EL ESPINILLO",
      "ROSARIO",
      "CORONEL FRAGA",
      "EL ARAZA",
      "HERSILIA",
      "JACINTO L. ARAUZ",
      "CAMPO STANGAFERRO",
      "KILOMETRO 54",
      "CAMPO FIANT",
      "EL RABON",
      "SA PEREYRA",
      "CANTON DE ZARATE",
      "COLONIA BELGRANO",
      "WILDERMUTH",
      "RECREO",
      "SUSANA",
      "SAN MIGUEL",
      "CAMPO PIACENZA",
      "COLONIA BOSSI",
      "COLONIA MASCIAS",
      "COLONIA SAN JOAQUIN",
      "ELISA",
      "MARIA TERESA",
      "EST. LA BARRANCOSA",
      "EL BAYO",
      "ATALIVA",
      "COLONIA CAVOUR",
      "CAVOUR",
      "BERAVEBU",
      "FUENTES",
      "PORTUGALETE",
      "CAMPO LA CHINGOLA",
      "COLONIAMORGAN",
      "SAN GREGORIO",
      "SOUTOMAYOR",
      "COLONIA LA RINCONADA",
      "CAMPO MUGUETA",
      "JUAN B. MOLINA",
      "LA PICASA",
      "AARON CASTELLANOS",
      "LOS LAPACHOS",
      "ARROYO DEL REY",
      "INGENIERO CHANOURDIE",
      "TRES ISLETAS",
      "TRES BOCAS",
      "ESTACION KILOMETRO 41",
      "ESTANCIA LA SOMBRILLA",
      "LOS AMORES",
      "ESTANCIA EL ÑACURUTU",
      "ESTANCIA EL TOURNE",
      "ESTACION KILOMETRO 302",
      "ESTANCIA LA VIRUELA",
      "LA CAMPANA",
      "CAMPANA",
      "CHRISTOPHERSEN",
      "COLONIA LA ARGENTINA CHICA",
      "PUERTO ARROYO SECO",
      "ARROYO SECO",
      "CASALEGNO",
      "PLAZA SAGUIER",
      "ESTACION SAGUIER",
      "CAMPO AMBROGGIO",
      "FIGHIERA",
      "COLONIA PUJOL",
      "RINCON DEL PINTADO",
      "COLONIA LARRECHEA",
      "ESPERANZA",
      "AMBROSETTI",
      "ACHAVAL RODRIGUEZ",
      "CAMPO LA NIEVA",
      "COLONIA REINA MARGARITA",
      "HUMBERTO PRIMO",
      "COLONIA ROCCIA",
      "CAMPO RODEO CHICO",
      "COLONIA ESCRIBANO",
      "NAVARRO",
      "CORONEL BOGADO",
      "CAPILLA FASSI",
      "EGUSQUIZA",
      "LA PENCA Y CARAGUATA",
      "LA RINCONADA",
      "COLONIA LA MORA",
      "CHOVET",
      "VILLA DIVISA DE MAYO",
      "COLONIA BICHA",
      "SANTURCE",
      "MARCELINO ESCALADA",
      "CAMPO BOTTO",
      "VILLA TRINIDAD",
      "LOS BRETES",
      "CAMPO ANDINO",
      "MONJE",
      "FORTIN CHARRUA",
      "PUEBLO LUIS BERLI",
      "EL 17",
      "EL HISTORICO",
      "PARAJE 29",
      "LOS CHARABONES",
      "EL CAMPANAL",
      "EL CHAÑAR",
      "KILOMETRO 48",
      "FORTIN CHILCAS",
      "FORTIN OLMOS",
      "LOTE 12",
      "MATILDE",
      "PLAZA MATILDE",
      "COLONIA LAS FLORES",
      "CASILDA",
      "COLONIA DESMOCHADO AFUERA",
      "COLONIA CANDELARIA",
      "CACIQUE ARIACAIQUIN",
      "LA PENCA - SAN MARIANO",
      "SAN MARIANO",
      "RAFAELA",
      "CAMPO RUBIOLO",
      "SAN GENARO",
      "SAN GENARO NORTE",
      "VILLA MUGUETA",
      "MAIZALES",
      "CAMPO LA CELIA",
      "LA CABRAL",
      "PALOS NEGROS",
      "SAN FABIAN",
      "YAMANDU",
      "ARROYO AGUIAR",
      "VILLA LAURA",
      "EL 38",
      "SAN ROBERTO",
      "EL PALMAR",
      "CAMPO TALEB",
      "ESTACION KILOMETRO 213",
      "LA GALLARETA",
      "ESTANCIA EL PELUDO",
      "CAMPO ROTELLA",
      "CAMPO GIAUQUE",
      "KM EL 13",
      "CAMPO SAN JOSE",
      "COLONIA SAGER",
      "COLONIA WINGEYER",
      "ROMANG",
      "COSTA DEL TOBA",
      "CAMPO KAUFMANN",
      "CAMPO ALTHAUS",
      "VIRGINIA",
      "THEOBALD",
      "COLONIA ALBERDI",
      "PUEBLO URANGA",
      "SANTA ISABEL",
      "RUNCIMAN",
      "COLONIA SANTA LUCIA",
      "BERNARDO DE IRIGOYEN",
      "CAMPO GENERO",
      "LOS QUIRQUINCHOS",
      "CAMPO CRENNA",
      "LA CLORINDA",
      "CAYASTACITO",
      "GRUTLY NORTE",
      "HIPATIA",
      "LA LUCILA",
      "NELSON",
      "MANUCHO",
      "IRIONDO",
      "RINCON DE AVILA",
      "MARIA JUANA",
      "LAS BANDURRIAS",
      "CAMPO CASTRO",
      "WHEELWRIGHT",
      "MERCEDITAS",
      "VILLA DEL PLATA",
      "VILLA AMELIA",
      "KILOMETRO 28",
      "GUASUNCHO",
      "COLONIA PILOTO",
      "LA RESERVA",
      "CAMPO REDONDO",
      "LOS TABANOS",
      "VILLA ANA",
      "EL AMARGO",
      "VILLA SAN DIEGO",
      "VILLA GOBERNADOR GALVEZ",
      "CORONEL AGUIRRE",
      "GARIBALDI",
      "LANDETA",
      "COLONIALANDETA",
      "CAMPO LA ORIENTAL",
      "CAMPO SANTA ISABEL",
      "COLONIA SAN ANTONIO",
      "LAS ROSAS",
      "ITURRASPE",
      "CAMPO LA PRADERA",
      "CAMPO EL RAFANGO",
      "LA CALIFORNIA",
      "SARGENTO CABRAL",
      "LA EMA",
      "CAMPO LOS BAYOS",
      "LAS CHAÑAS",
      "EL CENTINELA",
      "KILOMETRO 844",
      "EL MOLLE",
      "EL DESCANSO",
      "LA CAUTIVA",
      "SAN BERNARDO",
      "GUADALUPE NORTE",
      "SAN JOSE DE LA ESQUINA",
      "LOS NOGALES",
      "PROGRESO",
      "COLONIA MARGARITA",
      "SAN EUGENIO",
      "NUEVO TORINO",
      "CEPEDA",
      "STEPHENSON",
      "RINCON POTRERO",
      "ARROYO LEYES",
      "RINCON NORTE",
      "SANCTI SPIRITU",
      "CAMPO TARDINI",
      "CAMPO LANGARICA",
      "VERA MUJICA",
      "LOS SALADILLOS",
      "SAN JUSTO",
      "PAIKIN",
      "COLONIA EL FORTIN",
      "ESTANCIA PICHUCO",
      "CAMPO LA PEPITA",
      "ESTANCIA SAN FRANCISCO",
      "SAN CRISTOBAL",
      "CAMPO PUERTA",
      "CAMPO SPERANZA",
      "FLORENCIA",
      "LAS TUNAS",
      "CAPITAN BERMUDEZ",
      "CORONEL ARNOLD",
      "CHAÑAR LADEADO",
      "PUEBLO ESTHER",
      "SALTO GRANDE",
      "COLONIA EL CARMEN",
      "TRAILL",
      "CABAL",
      "ARROYO VERDE",
      "LOS CERRILLOS",
      "CAYASTA",
      "LOS TRES POZOS",
      "KILOMETRO 115",
      "GARABATO",
      "POZO DE LOS INDIOS",
      "ACEBAL",
      "MELINCUE",
      "CAMPO SIERRA",
      "CAMPO ALMENDRA",
      "CAPILLA VOTTERO",
      "JOSEFINA",
      "MAGGIOLO",
      "CAMPO EL RINCON",
      "LA CHISPA",
      "SOLEDAD",
      "HELVECIA SUR",
      "CAMPO DEL MEDIO",
      "COLONIA HELVECIA OESTE",
      "LOS ALGARROBOS",
      "HELVECIA",
      "VILLA CONSTITUCION",
      "BARRIO ARROYO DEL MEDIO",
      "MONTE OSCURIDAD",
      "SAN LORENZO",
      "COLONIA BIGAND",
      "VIDELA",
      "COLONIA SOL DE MAYO",
      "EMILIA",
      "LAS TOSCAS",
      "CAMPO WINKLER",
      "LA CURVA",
      "GREGORIA PEREZ DE DENIS",
      "ZAVALLA",
      "CAMPO LA ELVIRA",
      "ALDAO",
      "COLONIA ANA",
      "SANFORD",
      "CORONEL RODOLFO S. DOMINGUEZ",
      "EL CARMELO",
      "ROLDAN",
      "PLAZA CLUCELLAS",
      "ESTACION CLUCELLAS",
      "CAMPO LA FORTUNA",
      "SAN EDUARDO",
      "ESTHER",
      "CUATRO ESQUINAS",
      "CARMEN DEL SAUCE",
      "LARRECHEA",
      "CASAS",
      "CAMPO CRAVERO",
      "CARCARAÑA",
      "ARROYO CEIBAL",
      "CAMPO SAGER",
      "VILLA SOL DE MAYO",
      "CHAPUY",
      "ESTANCIA LA FLORIDA",
      "LOGROÑO",
      "LAS NORIAS",
      "INDEPENDENCIA",
      "EL TAPIALITO",
      "LAS GARZAS",
      "ISLA GUAYCURU",
      "EL PALMAR",
      "RUEDA",
      "NUEVA LEHMANN",
      "LEHMANN",
      "CAMPO GIACOSSA",
      "CAÑADA DEL UCLE",
      "SAUCE VIEJO",
      "VILLA ADELINA",
      "BELLA ITALIA",
      "PUEBLO MUÑOZ",
      "ESTANCIA LAS AVES",
      "LA HOSCA",
      "CAMPO BARONI",
      "DESVIO KM 213",
      "COLONIA DOÑA MARIANA",
      "EL AROMAL",
      "CALCHAQUI",
      "ESTANCIA SAN PEDRO",
      "SAN WENDELINO",
      "SAN JERONIMO NORTE",
      "SANTA ROSA DE CALCHINES",
      "LOS ZAPALLOS",
      "DIEGO DE ALVEAR",
      "FIRMAT",
      "COLONIA LOS TROJES",
      "LA CAMILA",
      "CAMPO OROÑO",
      "CASTELAR",
      "SOLDINI",
      "ALCORTA",
      "OLIVEROS",
      "VILLA LA RIVERA - OLIVEROS",
      "SAN CARLOS SUD",
      "LAZZARINO",
      "CAMPO MORELLO",
      "ANGELICA",
      "CAMPO BAUDINO",
      "PUEBLO ANDINO",
      "VILLA LA RIVERA - PUEBLO ANDINO",
      "LOMA ALTA",
      "COLONIA LA BLANCA",
      "LA CRIOLLA",
      "LA NEVADA",
      "COLONIA NORTE",
      "MAXIMO PAZ",
      "INTIYACO",
      "COLMENA",
      "LOS LEONES",
      "MONTENEGRO",
      "FLORIDA",
      "CAMPO BORGARELLO",
      "CAMPO CANAVESIO",
      "BAUER Y SIGEL",
      "CAMPO TORRIGLIA",
      "CAMPO CARDINI",
      "CAÑADA DE GOMEZ",
      "CAMPO LAS VASCAS",
      "SAN ESTANISLAO",
      "CAMPO CARBONARI",
      "CAMPO IADANZA",
      "CAMPO MARINSALTA",
      "SERODINO",
      "CENTENO",
      "EL BOSQUE",
      "MARIA LUISA",
      "RABIOLA",
      "CARMEN",
      "LA BRAVA",
      "COLONIA OVEJITA",
      "SAN MARTIN NORTE",
      "ARTEAGA",
      "HUGHES",
      "CAMPO EL MATACO",
      "LA RUBIA",
      "ALBARELLOS",
      "COLONIA SAN JOSE",
      "SAN JOSE",
      "CULULU",
      "CAMPO LA TERESITA",
      "LOS SEMBRADOS",
      "SAN VICENTE",
      "BIGAND",
      "IRIGOYEN",
      "COLONIA ALBERTENGO",
      "CORONEL ROSETTI",
      "RUFINO",
      "TARRAGONA",
      "MACIEL",
      "LA RAMADA",
      "SARMIENTO",
      "INGENIERO BOASSI",
      "SAN MARCELO",
      "CAMPO LA DELIA",
      "CAMPO TAZZIOLI",
      "TEODELINA",
      "CAMPO GERARDO",
      "ESTANCIA SANTA JUANA",
      "COLONIA NUEVA NORTE",
      "HUMBOLDT",
      "COLONIA NUEVA CENTRO",
      "LOPEZ",
      "SAN JERONIMO SUD",
      "CAMPO MARIA TERESA",
      "CARLOS PELLEGRINI",
      "CAMPO LAS MELLIZAS",
      "CAMPO BUSSO",
      "CAMPO NICOLI",
      "CAMPO LA CALEDONIA",
      "BARRIOS ACAPULCO Y VERACRUZ",
      "VILLA JOSEFINA",
      "FRONTERA",
      "AURELIA",
      "AURELIA NORTE",
      "CAMPO UBINO",
      "BUSTINZA",
      "CAMPO MOSCA",
      "SAN BERNARDO",
      "COLONIA TRES REYES",
      "CAMPO BERTONI",
      "VILA",
      "COLONIA EL INCA",
      "TOSTADO",
      "CAMPO PERGOLESI",
      "CAMPO DON BOSCO",
      "CAMPO MARIA ALICIA",
      "EL CACIQUE",
      "TRES POZOS",
      "ESTANCIA EL PALMAR",
      "ANTONIO PINI",
      "CAMPO LA MARUCA",
      "COLONIA50 LOS CHARABONES",
      "LOS CHARABONES",
      "BARRIO CAIMA",
      "DESVIO ARIJON",
      "PARAJE LA COSTA",
      "MONTE VERA",
      "ANGEL GALLARDO",
      "ASCOCHINGA",
      "PARAJE CHACO CHICO",
      "CAMPO CRESPO",
      "FRANCK",
      "COSTA RICA",
      "CAMPO MORZAN",
      "COLONIA EL YAGUARE",
      "MOISES VILLE"
    ]
  },
  {
    "nombre": "Santiago Del Estero",
    "localidades": [
      "CHILCA JULIANA",
      "GARZA",
      "VILLA GENERAL MITRE",
      "CAMPO GALLO",
      "DOÑA LUISA",
      "SABAGASTA",
      "LA DARSENA",
      "SAN RAMON",
      "EL ZANJON",
      "VILLA MATOQUE",
      "GUAMPACHA",
      "VILLA GUASAYAN",
      "POZO DEL TOBA",
      "QUEBRACHO COTO",
      "VILLA ROBLES",
      "SOL DE MAYO",
      "JUANILLO",
      "PUNTA POZO",
      "EL AIBE",
      "ABRA GRANDE",
      "REMES",
      "SAN BENITO",
      "EL DEAN",
      "SAN VICENTE",
      "SANTA CATALINA",
      "SANTA MARIA",
      "CASPI CORRAL",
      "VACA HUAÑUNA",
      "CANAL MELERO",
      "LA SIMONA",
      "LA NENA",
      "TRES CRUCES",
      "YUCHAN",
      "LA NORIA",
      "SAUCE SOLO",
      "AMAMA",
      "VILLA BRANA",
      "LIBERTAD",
      "NEGRA MUERTA",
      "KM 49",
      "CAMPO GRANDE",
      "VILLA MERCEDES",
      "SANTO DOMINGO",
      "AMICHA",
      "LEZCANOS",
      "LOS OVEJEROS",
      "SOTELOS",
      "LOS ROMANOS",
      "VILLA HIPOLITA",
      "VACA HUMAN",
      "TIO POZO",
      "VILLA NUEVA",
      "HUACHANA",
      "SUMAMAO",
      "AHI VEREMOS",
      "POZO DEL ARBOLITO",
      "ROLDAN",
      "SAN ANTONIO",
      "EL HOYON",
      "AHI VEREMOS",
      "EL SAUZAL",
      "ATOJ POZO",
      "VUELTA DE LA BARRANCA",
      "EL CRUCERO",
      "LAS TINAJAS",
      "COLONIA EL SIMBOLAR",
      "LA BANDA",
      "LA BAJADA",
      "SAN CARLOS",
      "INGENIERO FORRES",
      "LOS QUIROGA",
      "POZO HONDO",
      "EL CHARCO",
      "POZANCONES",
      "SAN JUAN",
      "LA VUELTA",
      "SHISHI POZO",
      "25 DE MAYO DE BANEGAS",
      "MONTE REDONDO",
      "SAN DELFIN",
      "PICHANA",
      "SOL DE MAYO",
      "ALTO BELLO",
      "SAN PEDRO",
      "SAN ANTONIO",
      "ESTACION LA PUNTA",
      "EL QUEBRACHO",
      "ANCAJAN",
      "LOS RALOS",
      "EL SALVADOR",
      "RUMI ESQUINA",
      "LA AURORA",
      "SAN JUSTO",
      "MONTE PAMPA",
      "25 DE MAYO",
      "LA LAGUNA",
      "KILOMETRO 55",
      "CERRO CHICO",
      "PUERTA DE CHAVEZ",
      "PALO PARADO",
      "VIVA MERCEDES",
      "LAS BARRANCAS",
      "LAS TEJAS",
      "POZO DEL SIMBOL",
      "SANTA CRUZ",
      "VILLA ADELA",
      "EL PUESTITO",
      "LAS LOMITAS",
      "LA REPRESA",
      "SAN RAFAEL",
      "LA TUSCA",
      "EL DESMONTE",
      "SOBREMONTE",
      "EL CANARIO",
      "SANTA LUCIA",
      "PUNTA DEL MONTE",
      "SAN MIGUEL",
      "POZO DE LA PUERTA",
      "EL MILAGRO",
      "LAS PALMITAS",
      "LUGONES",
      "ESTACION TACAÑITAS",
      "VILLA SALAVINA",
      "VILLA FIGUEROA",
      "VILLA SAN MARTIN",
      "POZO BETBEDER",
      "COLONIA TINCO",
      "TINTINA",
      "TACO POZO",
      "SANTA ROSA",
      "COLONIA LIBANESA",
      "LAGO MUYOJ",
      "PALERMO",
      "BLANCA POZO",
      "PERCAS",
      "SAN ROQUE",
      "SAN JOSE",
      "CAMPO ALEGRE",
      "LA COSTA",
      "COLONIA ISLA",
      "YACASNIOJ",
      "SANTO DOMINGO",
      "COLONIA ALCIRA",
      "BREAYOJ",
      "POZO MOSOJ",
      "PUNTA ISLA",
      "LORO PAMPA",
      "LUJAN",
      "PASO GRANDE",
      "SAN PEDRO",
      "TALA POZO",
      "GRAMILLA",
      "NOVILLO POZO",
      "TOTORA",
      "EL MOLLE",
      "NAVICHA",
      "SAN ANTONIO DE COPO",
      "MANCAPA",
      "SALVIAYOJ",
      "CALOJ",
      "TUSCA POZO",
      "PUNTA CORRAL",
      "SAN ANTONIO",
      "HURMANITA ESTANCIA",
      "PUENTE NEGRO",
      "TALA ATUN",
      "LA AURORA",
      "VILLA RIO HONDO",
      "CORRAL QUEMADO",
      "RUMI POZO",
      "SANTA ROSA",
      "URUTAU",
      "ESTADOS UNIDOS",
      "CABEZA DEL TORO",
      "EL CEIBAL",
      "VINAL POZO",
      "EL PUESTO",
      "RANCHILLOS",
      "MANGA BAJADA",
      "LAVALLE",
      "SAN BERNARDO",
      "LA ESPERANZA",
      "CONSUELO",
      "BELGRANO",
      "MAILIN",
      "EL MILAGRO",
      "LOTE 43",
      "GUAYACAN POZO",
      "SAN JAVIER",
      "LA VIRTUD",
      "LA CANDELARIA",
      "EL 60",
      "VINAL SUNI",
      "PUESTOS UNIDOS",
      "TORO PAMPA",
      "LA SALVACION",
      "ITATI",
      "EL RINCON",
      "COLOMBIA",
      "LUJAN",
      "NUEVA ESPERANZA",
      "LA UNION",
      "DOS ARBOLES",
      "CRUZ BAJADA",
      "LOS TIGRES",
      "BELGICA",
      "TORO POZO",
      "LOS POCITOS",
      "LAS MALVINAS",
      "SAN ISIDRO",
      "LA ARMONIA",
      "LA FIRMEZA",
      "SAN IGNACIO",
      "EL PALMAR",
      "IFIA",
      "EL AEROLITO",
      "BUENOS AIRES",
      "RINCON DEL VALLE",
      "BAHIA BLANCA",
      "PAAJ POZO",
      "SANTO DOMINGO",
      "CAMPO ALEGRE",
      "EL TUNQUELEN",
      "PUESTO CORDOBA",
      "SAN CRISTOBAL",
      "LOS MORTEROS",
      "ISKOY POZO",
      "LOTE 40",
      "SAN JOSE",
      "TRES VARONES",
      "EL CORRIDO",
      "LAS LOMAS",
      "CALOJ POZO",
      "PIRUAJ BAJO",
      "LOS POZANCONES",
      "SANTA CRUZ",
      "EL VALLE",
      "RAMIREZ DE VELAZCO",
      "CHAUPI POZO",
      "REAL SAYANA",
      "SAN PEDRO",
      "EL COLORADO",
      "POZUELOS",
      "PUESTO NUEVO",
      "LA FLORIDA",
      "LA RIVERA",
      "SAN RAMON",
      "MILI",
      "CHILCA",
      "LOS PEREYRA",
      "POZO SUMI",
      "LOS ARIAS",
      "COLONIA JAIME",
      "SAUCE BAJADA",
      "EL QUEBRACHAL",
      "LOMITAS",
      "NUEVA INDUSTRIA",
      "LOAJ",
      "HIGUERA CHACRA",
      "EL SOLER",
      "JANTA",
      "BUEY MUERTO",
      "EL REFUGIO",
      "MIRELLA",
      "TRONCOS",
      "MACO",
      "MORCILLO",
      "MEDIA LUNA",
      "SAN NICOLAS",
      "EL CUADRO",
      "LOTE 24",
      "LIMACHE",
      "EL HUAICO",
      "LAS ABRAS",
      "EL ALBARDON",
      "LAS VIBORITAS",
      "QUEBRACHITOS",
      "DOMINGO DE RAMOS",
      "PUESTO DEL MEDIO",
      "SAN MIGUEL",
      "HUACHANA",
      "SAN ANDRES",
      "SAN VICENTE",
      "CAMPO ALEGRE",
      "LA RAMADITA",
      "CORO PAMPA",
      "LA ABRITA",
      "LA HIGUERA",
      "MATARA",
      "VILLA SILIPICA",
      "SIMBOL",
      "PAMPA DE LOS GUANACOS",
      "SUMAMPA",
      "SAN JOSE DEL BOQUERON",
      "ARBOL SOLO",
      "EL ALGARROBAL",
      "EL CERRO",
      "LOS REMANSOS",
      "EL BAJO",
      "CORONEL FERNANDEZ",
      "EL MISTOL",
      "CAMPO DEL CISNE",
      "RAMA PASO",
      "VILLA QUEBRACHOS",
      "TACO POZO",
      "EL ESPARTAL",
      "LA BLANQUITA",
      "BELGRANO",
      "SAN CARLOS",
      "FUERTE VIEJO",
      "LA TRAMPA",
      "SAN FRANCISCO",
      "EL PUEBLITO",
      "EL PARAISO",
      "EL TALAR",
      "CUCHI CORRAL",
      "PUERTA DEL MONTE",
      "SUMAMPA VIEJO",
      "BUENA VISTA",
      "LA YERBA",
      "POZO DEL MONTE",
      "HORCOS TUCUCUNA",
      "GAUCHO DE GUEMES",
      "SAN JUAN",
      "EL AYUDANTE",
      "EL UCLE",
      "CORRAL DEL REY",
      "RIO VIEJO",
      "LA GRANADA",
      "EL DESVIO",
      "14 DE MAYO",
      "ORATORIO",
      "SANTA ANA",
      "EL LAUREL",
      "LA CHICHARRA",
      "LA HIGUERA",
      "LOS ALGARROBOS",
      "TERMAS DE RIO HONDO",
      "ICAÑO",
      "TOMAS YOUNG",
      "NUEVA FRANCIA",
      "VILMER",
      "LAPRIDA",
      "TAPSO",
      "HERRERA",
      "BANDERA",
      "WEISBURD",
      "COLONIA ALPINA",
      "SAN PEDRO",
      "RAPELLI",
      "CUQUERO",
      "NUEVA ESPERANZA",
      "CUATRO ESQUINAS",
      "SAN JOSE",
      "EL REMANSO",
      "LA UNION",
      "JUMIAL GRANDE",
      "LA INGRATA",
      "SAN ANTONIO",
      "TRES POZOS",
      "CRUZ CHICA",
      "TORO POZO",
      "SAN ISIDRO",
      "TACANITAS",
      "EL PORVENIR",
      "EL FISCO/LOTE48",
      "EL BAJO",
      "LA OVEJA",
      "AGUSTINA LIBARONA",
      "EL CORRIDO",
      "CHAÑARITO",
      "ESTECO",
      "HOYO CERCO",
      "INGRATA SUR",
      "VINAL VIEJO",
      "CAMPO VERDE",
      "ESTEROS",
      "CAMPO BANDERA",
      "EL SIMBOL",
      "LA PALOMA",
      "SANTA MARIA SALOME",
      "LA DELIA",
      "CAMPO ALEGRE",
      "TACO POZO",
      "EL AIBAL",
      "LA MANGA",
      "LAS CARPAS",
      "MONTE RICO",
      "SANTA ROSA",
      "EL VALLE",
      "AHI VEREMOS",
      "SAN FRANCISCO",
      "ANCA OVERA",
      "MONTEVIDEO",
      "NOQUEOJ",
      "POZO SALADO",
      "CORONEL MANUEL L. RICO",
      "EL MAJAN",
      "MILAGROS",
      "RANCHITOS",
      "SOL DE MAYO",
      "LA FRONTERA",
      "VILLA PALMAR",
      "LAS PERFORACIONES",
      "LA CAMBICHA",
      "MANINIOJ",
      "EL YUNCHANCITO",
      "SALADILLO",
      "POZO GRANDE",
      "LA FORTUNA",
      "POZO LIMPIO",
      "LA SARITA",
      "SAN LUIS",
      "RIO MUERTO",
      "INGRATA NORTE",
      "SANTA CRUZ",
      "EL MILAGRO",
      "VILLA UNION",
      "9 DE JULIO",
      "CAMPO DE LEONES",
      "NEGRA MUERTA",
      "CRUZ DEL NORTE",
      "EL CARDONAL",
      "EL CERRO",
      "RUMI POZO",
      "LA SOLEDAD",
      "PUERTA DE LOS CERROS",
      "LA AGUADITA",
      "ALGARROBO",
      "EL ARBOL",
      "PUERTA DE LOS RIOS",
      "LA CHIRQUITA",
      "PIEDRA BLANCA",
      "AMIMAN",
      "MINGUECHO",
      "EL BARRIAL",
      "POZO DEL GARABATO",
      "BAEZ",
      "CAMPO ALEGRE",
      "AMBARGASTA",
      "LOMITAS BLANCAS",
      "EL BAJO",
      "25 DE MAYO",
      "AMOLADERAS",
      "SANTA MARIA",
      "KILOMETRO 88",
      "SANTO DOMINGO",
      "KILOMETRO 96",
      "BALBUENA",
      "SAN JUAN",
      "SAN PEDRO",
      "CHACRAS",
      "LA ESPERANZA",
      "EL  MOLINO",
      "LA ISLA",
      "TALA YACU",
      "ONCAN",
      "INTI HUASI",
      "LAS MANGAS",
      "SURI POZO",
      "PAMPA GRANDE",
      "POZO GRANDE",
      "LAS CHACRAS",
      "LA CRUZ",
      "AGUA BLANCA",
      "LA ESTANCIA",
      "AÑATUYA",
      "PALOMAR",
      "PUESTO DE SAN ANTONIO",
      "LOMA GRANDE",
      "POZO CAVADO",
      "ANTILO",
      "DOLORES",
      "LA PUERTA",
      "PALMA POZO",
      "ABRA GRANDE",
      "LOS POSITOS",
      "LA MESADA",
      "EL MOJON",
      "SANTO DOMINGO",
      "SAN LORENZO DE LOS SAYAGOS",
      "PUESTO DEL MEDIO",
      "SAN ANTONIO DE LOS CACERES",
      "NUEVA ESPERANZA",
      "RODEO DE SORIA",
      "LA ESTANCITA",
      "LOMAS DE ZAMORA",
      "SANTA ROSA",
      "TIPIRO",
      "EL PUESTITO",
      "LOS CARDOZOS",
      "MORALES",
      "UPIANITA",
      "SAN CRISTOBAL",
      "HUAICO HONDO",
      "TUNAS PUNCO",
      "SAN LORENZO",
      "CHURQUI",
      "YANDA",
      "SAN JOSE",
      "ESTACION INGENIERO EZCURRA",
      "EL BARRIAL",
      "MAL PASO",
      "MACO",
      "PAMPA MUYOJ",
      "LA CANDELARIA",
      "7 DE ABRIL",
      "AGUA AZUL",
      "VILLA NUEVA",
      "LAS PUERTAS",
      "EL ROSADO",
      "TRES BAJOS",
      "LA MESADA",
      "EL GUAPO",
      "SAN CARLOS",
      "LOMAS BLANCAS",
      "TACKO YURAJ",
      "EL PORVENIR",
      "PUESTO NUEVO",
      "MONTE QUEMADO",
      "LA CAÑADA",
      "SIETE ARBOLES",
      "SAN SERAFIN",
      "SANTA MARIA DE LAS CHACRAS",
      "LA OVEJERIA",
      "EL ARENAL",
      "TACO PUNCO",
      "SAN ISIDRO",
      "QUEBRACHO ESQUINA",
      "LA BOLSA",
      "TUSCA BAJADA",
      "SANTA CRUZ",
      "EL BORDO",
      "EL CAJON",
      "VILLA ESTELA",
      "YUCHANCITO",
      "EL CAMBIADO",
      "SANTA FELISA",
      "LA MANGA",
      "LAS CHACRAS",
      "EL SOCORRO",
      "LA COSTOSA",
      "QUIMILIOJ",
      "TORO HUMAN",
      "EL CORRALITO",
      "PAMPA SUNI",
      "NUEVO SIMBOLAR",
      "CORRAL QUEMADO",
      "SAN ROQUE",
      "LA REACCION",
      "PAMPA POZO",
      "EL SALADILLO",
      "TRES VARONES",
      "EL QUEMADO",
      "LOS CERROS",
      "SAN GREGORIO",
      "LOS CERCOS",
      "VINAL POZO",
      "LA FLORIDA",
      "LA BLANCA",
      "LAS LAJAS",
      "EL DIABLO",
      "EL SAUCE",
      "POZO NUEVO",
      "EL REMATE",
      "SAN RAMON",
      "MONTE POTRERO",
      "ALGARROBAL VIEJO",
      "BABILONIA",
      "EL AZUL",
      "EL OJITO",
      "EL ROSARIO",
      "AGUA AMARGA",
      "TRES QUEBRACHOS",
      "TACO BAJADA",
      "LA FORTUNA",
      "SAN JAVIER",
      "PUESTO DEL ANGEL",
      "LAS LOMAS",
      "TACO  POZO",
      "SANTIAGO DEL ESTERO",
      "MAQUITO",
      "QUIMILI",
      "FORTIN INCA",
      "CUATRO BOCAS",
      "ANTAJE",
      "PALO NEGRO",
      "SAUZAL",
      "ESTACION TABOADA",
      "ARDILES",
      "VILLA ATAMISQUI",
      "SELVA",
      "MEDELLIN",
      "VERON",
      "EL CANDELARIO",
      "NAVARRO",
      "GUERRA",
      "LOS CERRILLOS",
      "RUBIA PASO",
      "EL SIMBOLAR",
      "ANGA",
      "CAMPOS DE CEJAS",
      "LA BAJADA",
      "BORDO PAMPA",
      "NUEVA LOMA",
      "LA CENTELLA",
      "CHIRA",
      "TACO ISLA",
      "CARRETA PASO",
      "SAN NICOLAS",
      "SANTA ROSA",
      "EL ALBARDON",
      "BARRANCAS",
      "YACU HURMANA",
      "SANTA LUCIA",
      "PUENTE DEL SALADILLO",
      "MALOTA",
      "MISTOL POZO",
      "CHAÑAR SINUCHAY",
      "LOMAS BLANCAS",
      "LA RAMADA",
      "EL CADILLAL",
      "SAN JAVIER",
      "TUSCA POZO",
      "RINCON GRANDE",
      "LA GUANACA",
      "LAS CEJAS",
      "TORO POZO",
      "SAN JOSE",
      "EL PALOMAR",
      "POLEO POZO",
      "EL FISCO DE FATIMA",
      "SAN CRISTOBAL",
      "LOS SANTILLAN",
      "CEJA POZO",
      "BAJO ALEGRE",
      "BUEN LUGAR",
      "SAN MIGUEL",
      "PUESTO LIBERTAD",
      "SAN FELIX",
      "ISCA YACU",
      "BAJO HONDO",
      "SAN GREGORIO",
      "SAN ANTONIO",
      "ISCA YACU SEMAUL",
      "EL PACARA",
      "LOS TUNALES",
      "LAS ZANJITAS",
      "LA COSTOSA",
      "LA BLANCA",
      "UTURUNGO",
      "MISTOL PUESTO",
      "SURI POZO",
      "EL RINCON",
      "POZO LINDO",
      "HUMAITA",
      "LA FORTUNA",
      "LOS RALOS",
      "EL GUAPO",
      "SAN PEDRO",
      "EL BAGUAL",
      "EL CHURQUI",
      "SAN ANDRES",
      "SAN BARTOLO",
      "LILO VIEJO",
      "PATAY",
      "LA CAÑADA",
      "MALBRAN",
      "LOS JURIES",
      "LAS DOLORES",
      "TRES LAGUNAS",
      "LAS PALMITAS",
      "LOS TABLEROS",
      "ASPIRANTE",
      "EL DESTINO",
      "ISLA BAJA",
      "DONADEU",
      "COLONIA LIBERTAD",
      "EL OSO",
      "COLONIA HERMELINDA",
      "TRONCO BLANCO",
      "TRES POZOS",
      "EL AIBAL",
      "EL PALMAR",
      "CAMPO CONTARDI",
      "QUEBRACHITOS",
      "LAS PROMESAS",
      "LA PROVIDENCIA",
      "EL TROPEZON",
      "NUEVA ESPERANZA",
      "CHOYA",
      "SIMBOLAR",
      "CHAÑAR POZO DE ABAJO",
      "ISLA DE LOS SOTELOS",
      "LOS MIRANDA",
      "LOS CASTILLOS",
      "LOMA DEL MEDIO",
      "LA NUEVA DONOSA",
      "PALMA REDONDA",
      "ARAGONES",
      "SAN PABLO",
      "EL MANANTIAL",
      "LOS QUEBRACHOS",
      "BAHOMA",
      "CHARCO VIEJO",
      "EL PORVENIR",
      "TAQUELLO",
      "EL CHARCO",
      "DIQUE FRONTAL",
      "ISLA DE ARAGONES",
      "CHAÑAR POZO DE ARRIBA",
      "ABRITA GRANDE",
      "LA FLORIDA",
      "SAN CARLOS",
      "LAS ABRAS",
      "PUESTO DEL SAUZAL",
      "LAS CEJAS",
      "CHAUCHILLAS",
      "LA SOLEDAD",
      "CASILLA DEL MEDIO",
      "CAÑADA DE ROBLES",
      "CAÑADA DEL MONTE",
      "LAS PALMERAS",
      "GRAMILLA VIEJA",
      "ALGARROBALES",
      "LA AGUADA",
      "VILLA TURISTICA DEL EMBALSE",
      "GALEANO",
      "SANTA FELIZA",
      "BARRIALITO",
      "MANSUPA",
      "LORO HUASI",
      "SOTELILLOS",
      "RODEO DE VALDEZ",
      "VILLA GIMENEZ",
      "CHAÑAR POZO DEL MEDIO",
      "SALADILLO",
      "LA RESERVA",
      "PUESTO NUEVO",
      "TALA POZO",
      "POZO GRANDE",
      "BREA PUÑUNA",
      "AMAPOLA",
      "EL BOBADAL",
      "LAS DELICIAS",
      "PUEBLO PABLO TORELO",
      "EL CUADRADO",
      "VILELAS",
      "LOS GALLEGOS",
      "QUIMILI",
      "TIO POZO",
      "SUNCHO POZO",
      "SHILLPI",
      "BARRIAL ALTO",
      "PAMPA ATUN",
      "SAN JOSE",
      "LA BLANCA",
      "QUIMILIOJ",
      "CHEEJ",
      "SAN JUAN",
      "MAJADAS",
      "POZO MOSOJ",
      "BREA POZO VIEJO",
      "PERCHIL BAJO",
      "LA HIGUERA",
      "TACOYOJ",
      "PERCAS",
      "LA VERDE",
      "PUESTITO",
      "TRES JAZMINES",
      "DIASPA",
      "EL MSITOL",
      "GRAMILLA",
      "GRAMILLA",
      "SANTOS LUGARES",
      "SANTO DOMINGO",
      "LA INVERNADA SUD",
      "AVERIAS",
      "SANTA MARIA",
      "SANTA ANA",
      "SAN JOSE",
      "DOS HERMANAS",
      "EL CACHI",
      "NUEVA COLONIA",
      "SAN VICENTE",
      "COLONIA ALPINA",
      "SAN ROQUE",
      "SANTA CATALINA",
      "LA TAPA",
      "HUILLA CATINA",
      "PUEBLO NUEVO",
      "LA PACIENCIA",
      "PUNITAYOJ",
      "LOMAS BLANCAS",
      "EL NEGRITO",
      "LUJAN",
      "CAMPO VERDE",
      "CARDON ESQUINA",
      "MACHAGUAY HUANCHINA",
      "SANTA ROSA",
      "PUESTO DE MENA",
      "LA LOMA",
      "EL VIZCACHERAL",
      "LOTE LA CAÑADA",
      "SAN PABLO",
      "MONTE REDONDO",
      "SAN SALVADOR",
      "SAN ANTONIO",
      "VINAL ISLA",
      "MINERVA",
      "MADERAS",
      "KILOMETRO 30",
      "TUSCA POZO",
      "AGUAS COLORADAS",
      "CARTAVIO",
      "YACU HICHACUNA",
      "CALLEJON BAJADA",
      "LA BARROSA",
      "CAMPO Y CIELO",
      "JUME ESQUINA",
      "LA RAMADA",
      "LA ESPERANZA",
      "EL QUEMADO",
      "LA GUARDIA",
      "SAN JORGE",
      "SAN ANDRES",
      "EL TABLEADO",
      "SAN FELIPE",
      "NUEVA ESPERANZA",
      "KILOMETRO CERO",
      "PAMPA MUYOJ",
      "QUIMILIOJ",
      "EL PIRUCHO",
      "COLONIA TOTORILLAS",
      "JUMIALITO",
      "JUMIAL GRANDE",
      "LA CANDELARIA",
      "TORO POZO",
      "POZO CAVADO",
      "EL ALBARDON",
      "SANTA RITA",
      "TABLADA DEL BOQUERON",
      "SAN FELIX",
      "FERNANDEZ",
      "ESTACION ROBLES",
      "TIERRA DEL ESTE",
      "SAN JOSE",
      "MERCEDES",
      "SAN FRANCISCO",
      "LINCHO",
      "TRES MOJONES",
      "SANTA LUCIA",
      "25 DE MAYO",
      "EL ARBOLITO",
      "LOTE 48",
      "ROVERSI",
      "STAYLE",
      "SAN FELIPE",
      "EL CARMEN",
      "LA CURVA",
      "HERNAN MEJIA MIRAVAL",
      "ARMONIA",
      "SANTA RITA",
      "SANTA JUSTINA",
      "TINAJERAYOJ",
      "VILLA PETOCHA",
      "SAN ANTONIO",
      "HASSE",
      "EL PERTIGO",
      "LOTE 115",
      "EL HOYO",
      "CATAMARCA",
      "EL PRADO",
      "AEROLITO",
      "SANTA ROSA",
      "LOTE L 3",
      "LA FORTUNA",
      "MUYUSKA",
      "OBRAJE MARIA ANGELICA",
      "EL TANQUE",
      "MAGDALENA",
      "SAN NICOLAS",
      "PAMPA CHARQUINA",
      "SAN CARLOS",
      "DONADEU",
      "SAN RAMON",
      "PALOMAR",
      "EL ROSARIO",
      "LAS DOS A",
      "LEDESMA",
      "COLONIA ARBOL BLANCO",
      "FLORESTA",
      "DOLORES",
      "SURI POZO",
      "LOS MILAGROS",
      "LA NOMBRADA",
      "LA ESPERANZA",
      "LA MAGDALENA",
      "LA PALOMA",
      "TRINIDAD",
      "ARBOL BLANCO",
      "PAMPA POZO",
      "CELESTINA",
      "LOTE 87",
      "DOS HERMANAS",
      "LA PAMPA",
      "VILLA MATILDE",
      "ALHUAMPA",
      "LOTE 31",
      "EL FISCO",
      "SANTOS LUGARES",
      "SANTA TERESITA",
      "SAN MARTIN",
      "POZO BARRANCAYOJ",
      "CHILCAN",
      "AMPA",
      "QUIMILI",
      "OSO HUANCHINA",
      "SAN ANTONIO",
      "OVEJERIA",
      "PAAJ RODEO",
      "SAN MARCOS",
      "VILLA MATARA",
      "AZOGASTA",
      "LA FALDA",
      "SAN PEDRO",
      "COLONIA SIEGEL",
      "PAMPA MUYOJ",
      "CONCEPCION",
      "CONCHAYOJ",
      "EL MOJON",
      "AVERIAS",
      "SACHAYOJ",
      "LOS ALDERETES",
      "EL BARRIALITO",
      "NUEVA LUJAN",
      "NUEVA LIBANO",
      "ISLA CORRAL",
      "MONTE BELLO",
      "COLONIA MARIA LUISA",
      "CUYOJ",
      "JUMI POZO",
      "VACA MUERTA",
      "LA FALDA",
      "RUBIA MORENO",
      "CERRILLOS",
      "BAYO MUERTO",
      "TRAMO 16",
      "EL OJO DE AGUA",
      "LOS ACOSTA",
      "ACOSTA",
      "SURI POZO",
      "SAN ANTONIO",
      "SIETE ARBOLES",
      "TACOYOJ",
      "LA CAPILLA",
      "SAN ISIDRO",
      "EL FAVORITO",
      "PAMPA MAYO",
      "LOS GOMEZ",
      "COLONIA GAMARA",
      "LA QUISCA",
      "MISTOLITO",
      "TABLA REDONDA",
      "BAJO GRANDE",
      "PALMARES",
      "LOS GALLARDO",
      "LAS CHACRAS",
      "SAN NICOLAS",
      "TRAMO 20",
      "LAS ABRAS",
      "ARDILES DE LA COSTA",
      "EL POLEAR",
      "QUITA PUNCO",
      "EL ALAMBRADO",
      "CARA PUJIO",
      "LOS ANGELES",
      "COLONIA ARGENTINA",
      "SANTA ELENA",
      "SAN LORENZO",
      "TRAMO 26",
      "SAN JAVIER",
      "SAN JUAN",
      "ALTO POZO",
      "LA LOMA",
      "EL BARRIAL",
      "LA GRANJA",
      "ESQUINA POZO",
      "SAN ANDRES",
      "LOS DIAZ",
      "LOS SORIA",
      "PUESTO DEL MEDIO",
      "AHI VEREMOS",
      "BAJO HONDO",
      "PALMITAS",
      "PALOS QUEMADOS",
      "JUMIALITO",
      "EL CARMEN",
      "GUAYCURU",
      "PALMITA DE GEREZ",
      "SAN JOSE",
      "SAN FELIPE",
      "EL PUENTE",
      "QUISHCA",
      "HUYAMAMPA",
      "COLONIA SAN JUAN",
      "BREA POZO",
      "CASARES",
      "EL PERAL",
      "SAN DIONISIO",
      "CODO VIEJO",
      "TASIGASTA",
      "LOMITAS",
      "COLLERA HUARCANA",
      "PALOMA",
      "SIMBOL POZO",
      "JUMI POZO",
      "PUESTO DEL ROSARIO",
      "EL DORADO",
      "BREA LOMA",
      "EL PERU",
      "LOS TOLOZOS",
      "SOCONCHO",
      "PUERTA GRANDE",
      "LOS PERALTAS",
      "ANCOCHA",
      "GUANACO SOMBRIANA",
      "VENTURA PAMPA",
      "SAUCIOJ",
      "CHILCA LA LOMA",
      "SANTA ISABEL",
      "BELTRAN",
      "EL ARENAL",
      "SOL DE JULIO",
      "COLONIA DORA",
      "CAÑADA ESCOBAR",
      "LAVALLE",
      "LOS NUÑEZ",
      "EL CABURE",
      "VINARA",
      "ESTACION ATAMISQUI",
      "LOTES 33-37-40-42",
      "LOTES 46 A 48",
      "VILLA LOS POCITOS",
      "SAN PABLO",
      "VILLA ABREGU",
      "SELVA NEGRA",
      "BUEN PASO",
      "POZO HERRERA",
      "SUNCHO POZO DEL TRIUNFO",
      "LOS POCITOS",
      "SAN JOSE",
      "MIEL DE PALO",
      "SUNCHO POZO ALTO",
      "ESTACION LAS GAMAS",
      "LA HUERTA",
      "LOTE 15",
      "OBRAJE MAILIN",
      "SANTA ANA",
      "LOTES 1 A 9",
      "LA PIAMONTESA",
      "LOTES 25 A 29",
      "SANAVIRONES",
      "SELVA BLANCA",
      "CAMPO LAGAR",
      "POZO DEL MEDIO",
      "SUNCHO POZO",
      "KILOMETRO 454",
      "LA SALAMANCA",
      "SANTA ELENA",
      "LOTE 42",
      "LOS LINARES",
      "EL MALACARA",
      "VILLA CAROLINA",
      "TACO ATUN",
      "TRES POZOS",
      "LA PAULINA",
      "CAMPO TOLEDO",
      "CLODOMIRA",
      "SUNCHO CORRAL",
      "LA INVERNADA",
      "BANDERA BAJADA",
      "FRIAS",
      "MONTE QUEMADO",
      "LOS PIRPINTOS",
      "VILLA OJO DE AGUA",
      "ARGENTINA",
      "VILLA MAILIN",
      "ARRAGA",
      "EL APEADERO",
      "LOTE 63",
      "COLONIA JOSEFINA",
      "LOJLO",
      "LOTE 59",
      "SAN PEDRO",
      "POZO GRANDE",
      "BAJO HONDO",
      "EL 20",
      "EL DESVIO",
      "LOTE 69",
      "LAS PALMERAS",
      "EL CARRETEL",
      "LOTE 28",
      "POZO DEL TIGRE",
      "EL SALADILLO",
      "PUENTE BAJADA",
      "LA ESTANCIA",
      "MONTE REDONDO",
      "SAN LUIS",
      "LOTE 110",
      "LA PAMPA",
      "KILOMETRO 477",
      "RINCON DEL SALADILLO",
      "LAS LOMAS",
      "TARUY",
      "RODEO BAJADA",
      "CAMPO DEL CIELO",
      "LOTE 29 CHICO",
      "CALLEJON BAJADA",
      "CHICHILLAL",
      "EL QUEMADO",
      "SANTA MARIA",
      "LOTE 32 LA RESERVA",
      "GUARDIA ESCOLTA",
      "LA VICTORIA",
      "EL AROMITO",
      "COLONIA LA VICTORIA",
      "COLONIA MACKINLAY",
      "LA FEDERACION",
      "LA HUANACA",
      "DOS PROVINCIAS",
      "LOS ENCANTOS",
      "NUEVA CERES",
      "LA ROMELIA",
      "LOS PORONGOS",
      "PARAJE 12",
      "EL GALPON",
      "PUERTA GRANDE",
      "SAN ANTONIO",
      "SANTA ROSA",
      "EL QUIMIL",
      "EL PORVENIR",
      "MORON",
      "LA CALERA",
      "MEDIO MUNDO",
      "LOS CERRILLOS",
      "LAS CHACRAS",
      "VILLA ROSA",
      "SAN LUIS",
      "TRES CERROS",
      "EL TABLEADO",
      "EL SIMBOLAR",
      "POZO CAVADO",
      "LAS JUNTAS",
      "EL TAJAMAR",
      "SAN LORENZO",
      "LUJAN",
      "EL CADILLO",
      "SAN JOSE",
      "EL MANGRULLO",
      "SANTA BARBARA",
      "MISTOL MUYOJ",
      "LA CHILCA",
      "PAMPA POZO",
      "LA BREITA",
      "PARANA",
      "PUESTO DEL MEDIO",
      "SAN RAMON",
      "POZANCON",
      "LAS TALITAS",
      "LOS TELARES",
      "VILLA LA PUNTA",
      "RIO PINTO",
      "VILLA VIEJA",
      "LA DORMIDA",
      "MORAMPA",
      "LA RESBALOSA",
      "SAN GREGORIO",
      "DIENTE DEL ARADO",
      "PUESTO DE BELTRAN",
      "MONTE REDONDO",
      "BELTRAN",
      "SAN JOSE",
      "TOTORA PAMPA",
      "JUMI POZO",
      "LA REVANCHA",
      "CRUCESITAS",
      "SANTA BARBARA",
      "TACANAS",
      "ISLA VERDE",
      "AYUNCHA",
      "VENTURA PAMPA",
      "PUESTO DE JUANES",
      "SAN JUAN",
      "POZO VERDE",
      "POZO CIEGO",
      "KILOMETRO 83",
      "PUNUA",
      "LA MELEADA"
    ]
  },
  {
    "nombre": "Tierra Del Fuego",
    "localidades": [
      "USHUAIA",
      "PUERTO DARWIN",
      "PRADERA DEL GANSO",
      "PUERTO LEITH",
      "PUERTO ARGENTINO",
      "GRYTVIKEN",
      "SAN SEBASTIAN",
      "ESTANCIA SARA",
      "CULLEN",
      "EL PARAMO",
      "DESTACAMENTO DECEPCION",
      "BASE BELGRANO II",
      "DESTACAMENTO PETREL",
      "BASE ESPERANZA",
      "DESTACAMENTO MELCHIOR",
      "BASE SAN MARTIN",
      "BASE PRIMAVERA",
      "BASE BROWN",
      "BASE ORCADAS",
      "DESTACAMENTO CAMARA",
      "BASE MATIENZO",
      "BASE MARAMBIO",
      "BASE CARLINI",
      "RIO GRANDE",
      "LAGUNA ESCONDIDA",
      "TOLHUIN"
    ]
  },
  {
    "nombre": "Tucumán",
    "localidades": [
      "VILLA TERCERA",
      "EX INGENIO LOS RALOS",
      "LAS MERCEDES",
      "VILLA RECASTE",
      "CAMPO LA FLOR",
      "MUYO",
      "ALPACHIRI",
      "LAS LENGUAS",
      "EL MOLINO",
      "COCHUNA",
      "LA CALERA",
      "LAS PAVAS",
      "SIMOCA",
      "SOLDADO MALDONADO",
      "LOS PEREYRA NORTE",
      "GASTONA",
      "FINCA LEON CORNET",
      "GASTONILLA",
      "LA HIGUERA",
      "LAS FALDAS",
      "FINCA LA FALDA",
      "ARCADIA",
      "LOS ROBLES",
      "SAN JOSE DE FLORES",
      "LA CIENAGA",
      "RINCON DE BALDERRAMA",
      "ACHERAL",
      "ALTO DE LEIVA",
      "LAS TACANAS",
      "LA CIENAGA",
      "LA BOLSA",
      "EL INFIERNILLO",
      "TAFI DEL VALLE",
      "LOS CUARTOS",
      "RODEO GRANDE",
      "EL RINCON",
      "LA ANGOSTURA",
      "LA JUNTA",
      "ESQUINA DEL VALLE",
      "OJO DE AGUA",
      "SANTA CRUZ",
      "LAS CARRERAS",
      "EL MOLLAR",
      "EL CORTADERAL",
      "ROMERA POZO",
      "MIXTA",
      "LOS CAMPEROS",
      "LOMA VERDE",
      "PUMA POZO",
      "LAS MERCEDES",
      "SANTA ROSA DE LEALES",
      "AGUA AZUL",
      "LOS NOGALITOS",
      "EL NOGALITO",
      "PUNTA DEL MONTE",
      "POTRERO DE LAS TABLAS",
      "MUNDO NUEVO",
      "EL DURAZNILLO",
      "MALA MALA",
      "INGENIO SAN PABLO",
      "EX INGENIO ESPERANZA",
      "INGENIO LA FLORIDA",
      "EL FORTIN",
      "LA FLORIDA",
      "EL TALAR",
      "EL PARAISO",
      "VILLA BURRUYACU",
      "MONTE BELLO",
      "LAS ANIMAS",
      "CHASQUIVIL",
      "SAN JOSE DE CHASQUIVIL",
      "ANCAJULI",
      "CONDOR HUASI",
      "TUSCA POZO",
      "AGUA DULCE",
      "ESTACION CACHI YACO",
      "ORAN",
      "LAGUNA BLANCA",
      "VILLA SAN JAVIER",
      "EL CORTE",
      "BARRIO SAN JOSE III",
      "EX INGENIO SAN JOSE",
      "YERBA BUENA - MARCOS PAZ",
      "BARRIO LOMAS DE TAFI",
      "BARRIO LOS POCITOS (LAS TALITAS)",
      "LA AGUADITA",
      "BARRIO EL CRUCE",
      "BARRIO MUTUAL SAN MARTIN",
      "LOS NOGALES",
      "CEVIL POZO",
      "EX INGENIO LUJAN",
      "BARRIO AEROPUERTO",
      "COLONIA LA BONARIA",
      "BALDERRAMA SUR",
      "YERBA BUENA",
      "EL JARDIN",
      "LA RAMADITA",
      "LOS SOSA",
      "LAS MESADAS",
      "EL NARANJAL",
      "MONTE GRANDE",
      "LA COCHA",
      "ALTO DE LA COCHA",
      "VILLA NUEVA",
      "EL PORVENIR",
      "LA POSTA",
      "CASAS VIEJAS",
      "POZO DE LA ESQUINA",
      "SUR DE TREJOS",
      "LA JUNTA",
      "SUR DE LAZARTE",
      "NUEVA TRINIDAD",
      "EL DURAZNO",
      "EL PACARA",
      "SANTA ISABEL",
      "NIOGASTA",
      "SANTA ANA",
      "VILLA CLODOMIRO HILERET",
      "LA CUCHILLA",
      "VACAHUASI",
      "EL TIPAL",
      "EL NOGALITO",
      "AGUA NEGRA",
      "VILLA PADRE MONTI",
      "LAS LAJITAS",
      "LA RINCONADA",
      "ALTO DE MEDINA",
      "RIO DEL NIO",
      "BELICHA",
      "BELICHA HUAICO",
      "YUCUMANITA",
      "GASTONA SUR",
      "GASTONA NORTE",
      "EL CARMEN",
      "COLONIA SAN JOSE",
      "LOS PORCELES",
      "SAN ANDRES",
      "SAN JOSE DE LA COCHA",
      "MANCHALA",
      "SAN JOSE DE BUENA VISTA",
      "ENTRE RIOS",
      "RIO COLORADO",
      "EL BRACHO",
      "EL CEVILAR",
      "MONTEROS",
      "TALA POZO",
      "PIEDRABUENA",
      "LA TUNA",
      "VILLA DOLORES",
      "SAN MIGUEL",
      "SANTA ROSA",
      "LA UNION",
      "LA VERDE",
      "LA SOLEDAD",
      "LA VIRGINIA",
      "VILLA MARIA",
      "EL ONCE",
      "PUESTO DEL MEDIO",
      "ESCABA DE ARRIBA",
      "ESCABA DE ABAJO",
      "EL MOLLAR",
      "SARGENTO MOYA",
      "BLANCO POZO",
      "RAFAELA POZO",
      "LAS CEJAS",
      "BARRIO SAN FELIPE",
      "SANTA BARBARA",
      "LOS AGUIRRE",
      "PUENTE EL MANANTIAL",
      "EL MILAGRO",
      "LA ESPERANZA",
      "LA TRINIDAD",
      "SAN CARLOS",
      "COUNTRY JOCKEY CLUB",
      "CURVA DE LOS VEGAS",
      "CEVIL REDONDO",
      "VILLA CARMELA",
      "EL NARANJITO",
      "AGUA DULCE",
      "SAN VICENTE",
      "FAVORINA",
      "LA TALA",
      "PASO DE LA PATRIA",
      "PUERTA ALEGRE",
      "EL TRIUNFO",
      "GARMENDIA",
      "PAJA COLORADA",
      "LA RINCONADA",
      "EL MANANTIAL",
      "BARRIO ARAUJO",
      "EL CHAÑAR",
      "TAQUELLO",
      "BOCA DEL TIGRE",
      "EL ESPINILLO",
      "TACO PALTA",
      "LA MARTA",
      "LOS POCITOS",
      "TAFI VIEJO",
      "VILLA LAS FLORES",
      "BARRIO PARADA 14",
      "BARRIO U.T.A. II",
      "LA PICADA",
      "BENJAMIN PAZ",
      "EL BRETE",
      "ARAGON",
      "LAS JUNTAS",
      "LAS ARCAS",
      "LEOCADIO PAZ",
      "VILLA DE TRANCAS",
      "TUNA SOLA",
      "EL SAUCE",
      "SAN ISIDRO",
      "LA ESPERANZA",
      "EL SIMBOLAR",
      "SAN JOSE",
      "AMAICHA DEL LLANO",
      "EL MOLLAR",
      "BELLA VISTA",
      "SAN RAMON",
      "COLONIA SOBRECASAS",
      "ARSENAL MIGUEL DE AZCUENAGA",
      "DIAG. NORTE - LUZ Y FUERZA - LOS POCITOS",
      "VILLA MARIANO MORENO - EL COLMENAR",
      "MANUEL GARCIA FERNANDEZ",
      "LA BOLSA",
      "MEDINA",
      "SAN RAMON",
      "LOS JUAREZ",
      "ALTO VERDE",
      "CORTADERAS",
      "MONTE RICO VIEJO",
      "CARRETA QUEMADA",
      "LA FLORIDA",
      "VILLA QUINTEROS",
      "LOS ROJOS",
      "NARANJO ESQUINA",
      "YAQUILO",
      "CAMPO BELLO",
      "LA CALERA",
      "DONATO ALVAREZ",
      "JUAN BAUTISTA ALBERDI",
      "CASPINCHANGO",
      "SANTA LUCIA",
      "SAN JAVIER",
      "VICLOS",
      "EL QUIMIL",
      "EL MOJON",
      "LA HOYADA",
      "RACO",
      "SAN JOSE DE RACO",
      "ALTO DE ANFAMA",
      "LAS TIPAS",
      "SAN JAVIER",
      "ANFAMA",
      "ATAHONA",
      "AMPATA",
      "ALTO DE LAS LECHUZAS",
      "CEJAS DE AROCA",
      "QUILMES",
      "RINCON DE QUILMES",
      "LARA",
      "COLALAO DEL VALLE",
      "LA FRONTERITA",
      "PICHAO",
      "ANJUANA",
      "EL ARBOLAR",
      "ESTACION ARAOZ",
      "TRES POZOS",
      "LAS TUSQUITAS",
      "LA RINCONADA",
      "BALDERRAMA",
      "ESTACION MANUELA PEDRAZA",
      "TENIENTE BERDINA",
      "LOS CORDOBA",
      "RIO CHICO",
      "AMPIMPA",
      "SALAS",
      "CALIMONTE",
      "YASYAMAYO",
      "LOS ZAZOS",
      "TIO PUNCO",
      "AMAICHA DEL VALLE",
      "EL CARMEN",
      "EL TIO",
      "LA HOYADA",
      "EL PASO",
      "ESTACION CRUZ DEL NORTE",
      "GENERAL PAZ",
      "COLOMBRES",
      "SAN MIGUELITO",
      "POZO DEL ALTO",
      "EL CERCADO",
      "EL CHURQUI",
      "SANTA CRUZ",
      "EL RODEO",
      "TUSCA PAMPA",
      "LA CRUZ DE ARRIBA",
      "LA RAMADA",
      "LA CRUZ",
      "MACOMITAS",
      "SAN JOSE DE MACOMITAS",
      "ERIN",
      "ESQUINA",
      "MANCOPA",
      "ESQUINA DEL LLANO",
      "MANCOPA CHICO",
      "PUEBLO VIEJO",
      "EL POTRERILLO",
      "BAJASTINE",
      "QUEBRACHITO",
      "HUASA PAMPA SUR",
      "LAZARTE",
      "PALOMINOS",
      "LA REINA",
      "MONTEAGUDO",
      "LOS AMAYA",
      "ARROYO ATAHONA",
      "LOS PEREZ",
      "EL SUNCHAL",
      "BARRIO SAN JORGE",
      "LAS CORZUELAS",
      "MARIÑO",
      "TRANQUITAS",
      "EL NARANJO",
      "EL SUNCHAL",
      "LAS TALAS",
      "FINCA TINA",
      "CHILCAS",
      "PAMPA POZO",
      "LA RUDA",
      "LAGUNA DE ROBLES",
      "EL CASTORAL",
      "POZO GRANDE",
      "7 DE ABRIL",
      "LOS QUEMADOS",
      "SAN ANTONIO",
      "VIZCACHERAL",
      "VILLA DE LEALES",
      "LAS TALITAS",
      "VILLA CHICLIGASTA",
      "YACUCHIRI",
      "LAS JUNTAS",
      "ARBOL SOLO",
      "CARBON POZO",
      "BAJO GRANDE",
      "RANCHILLOS",
      "EL PUESTO",
      "LAGUNA LARGA",
      "LA ESPERANZA",
      "AMUMPA",
      "ARBOLES GRANDES",
      "LOS RUIZ",
      "BARRANCAS",
      "LA LOMA",
      "LAS ANIMAS",
      "LOS SAUCES",
      "LOS RANCHILLOS",
      "LAS LOMITAS",
      "DOS POZOS",
      "SOL DE MAYO",
      "LAMADRID",
      "LOS CERCOS",
      "ESTACION LA ENCANTADA",
      "VILLA FIAD - INGENIO LEALES",
      "SAN NICOLAS",
      "QUILMES",
      "PALA PALA",
      "LOS SUELDOS",
      "TIMBO NUEVO",
      "EL CADILLAL",
      "TIMBO VIEJO",
      "ALTA GRACIA",
      "LAS SALINAS",
      "LAS CEJAS",
      "PAMPA MAYO",
      "EL OVAL",
      "GUEMES",
      "SAN AGUSTIN",
      "COLONIA MAYO - BARRIO LA MILAGROSA",
      "LOS PEREZ",
      "FINCA MAYO",
      "LOLITA",
      "LOMA DE CIUDACITA",
      "CIUDACITA",
      "NUEVA ESPERANZA",
      "TAFICILLO",
      "EL CADILLAL",
      "LA REDUCCION",
      "SAN RAFAEL",
      "LULES",
      "EL CEIBAL",
      "POTRERO GRANDE",
      "TECOTEX",
      "LA BOLSA",
      "AGUA SALADA",
      "LOS HERRERA",
      "EL CARMEN",
      "YALAPA",
      "LOS BRITOS",
      "MONTE BELLO",
      "PUESTO CHICO",
      "LOS DIAZ",
      "CARANCHO POZO",
      "LA FLORIDA",
      "EL GUARDAMONTE",
      "CAMPO AZUL",
      "LOS PUESTOS",
      "LA ENCRUCIJADA",
      "MOLLE POZO",
      "EL CHURQUI",
      "VILLA BELGRANO",
      "TALAMUYO",
      "SAN MIGUEL DE TUCUMAN",
      "PACARA",
      "BANDA DEL RIO SALI",
      "PACARA PINTADO",
      "LASTENIA",
      "LOS RIOS",
      "INGENIO SANTA BARBARA",
      "SANTA ROSA",
      "EL TUSCAL",
      "COLONIA SANTA BARBARA",
      "SAN MIGUEL",
      "AGUILARES",
      "MONTE REDONDO",
      "LA TIPA",
      "EL RODEO",
      "LOS SARMIENTOS",
      "LOS BULACIOS",
      "RIO SECO",
      "EL SACRIFICIO",
      "LA INVERNADA",
      "ALTO DEL PUESTO",
      "EL NOGAL",
      "LA SALVACION",
      "EL ZAPALLAR",
      "EL MISTOL",
      "EL PARAISO",
      "LA CHILCA",
      "POZO VERDE",
      "EL DURAZNO",
      "EL JARDIN",
      "LA IGUANA",
      "LOS MISTOLES",
      "LOS MOLLES",
      "PUESTO DEL MEDIO",
      "RAMOS",
      "EL QUEBRACHITO",
      "PAEZ",
      "POZO HONDO",
      "EL SIMBOL",
      "PUESTO LOS PEREZ",
      "VILLA PUJIO",
      "CAMPO BELLO",
      "LA FLORIDA",
      "SANTA ROSA",
      "EL PUESTITO",
      "TACO RALO",
      "EL CORRALITO",
      "YANIMAS",
      "PILCO",
      "HUASA PAMPA",
      "ORAN",
      "YONOPONGO",
      "ISLA SAN JOSE",
      "PUEBLO INDEPENDENCIA",
      "AMBERES",
      "CAMPO VOLANTE",
      "BUENA VISTA OESTE",
      "BUENA VISTA",
      "LA LAGUNITA",
      "VIPOS",
      "EX INGENIO NUEVA BAVIERA",
      "EL CRUCE",
      "KILOMETRO102",
      "SAN GABRIEL DEL MONTE",
      "AGUA BLANCA",
      "CUMBRE EL MATADERO",
      "SANTA CLARA",
      "SAN GABRIEL",
      "BARRIO CASA ROSADA",
      "CAMPO DE HERRERA",
      "INGENIO FRONTERITA",
      "MONTE GRANDE",
      "BARRIO OESTE",
      "FAMAILLA",
      "ESTACION PADILLA",
      "LA RINCONADA",
      "ILTICO",
      "ILTICO",
      "CONCEPCION",
      "SAN ROQUE",
      "EL TAJAMAR",
      "EL SINQUIAL",
      "TARUCA PAMPA",
      "LA TOMA",
      "VILLA BENJAMIN ARAOZ",
      "RUMI PUNCO",
      "HUACRA",
      "AGUA BLANCA",
      "REQUELME",
      "SAN JOSE",
      "EL PUESTITO DE ARRIBA",
      "EL OBRAJE",
      "POZO CAVADO",
      "TALA PAMPA",
      "EL PUESTITO",
      "EL PUESTO",
      "SAN PEDRO MARTIR",
      "PUESTO LOS VALDEZ",
      "EL MOLLAR",
      "LA TUNA",
      "SAN ANTONIO DE PADUA",
      "PUEBLO VIEJO",
      "CAPITAN CACERES",
      "YACUCHINA",
      "SAN PEDRO DE COLALAO",
      "REARTE SUR",
      "HUALINCHAY",
      "REARTE",
      "CHULCA",
      "ZARATE",
      "SAN FERNANDO",
      "ZARATE SUR",
      "ZARATE NORTE",
      "RODEO GRANDE",
      "SAN VICENTE",
      "GONZALO",
      "CHOROMORO",
      "TICUCHO",
      "POTRERO GRANDE",
      "LA HIGUERA",
      "EL CORTE",
      "ALDERETES",
      "LAS PIEDRITAS",
      "LOS GUTIERREZ",
      "BOCA DEL TIGRE",
      "LOS DIAZ",
      "BARRANQUERAS",
      "CAMPO GRANDE",
      "CHACRAS VIEJAS",
      "TORO MUERTO",
      "ALTO DEL PUESTO",
      "GRANEROS",
      "ICHIPUCA",
      "TACO RODEO",
      "CASAS VIEJAS"
    ]
  }
]

export const paisesSudamericanos = [
  { value: "", title: "PAIS *" },
  { value: "Argentina", title: "Argentina" },
  { value: "Bolivia", title: "Bolivia" },
  { value: "Brasil", title: "Brasil" },
  { value: "Chile", title: "Chile" },
  { value: "Paraguay", title: "Paraguay" },
  { value: "Perú", title: "Perú" },
  { value: "Uruguay", title: "Uruguay" }
];